import { j as s, $ as hi, a as ui, b as pi, c as mi, d as gi, e as fi, g as bi, i as xi, n as L, O as yi, k as Bs, l as Hs, w as $n, Z as _i, H as Ci, m as Rn, o as yt, p as lo, r as gr, q as wi, t as Ws, W as vi, u as Si, A as Ii, F as Di, v as fr, x as br, y as Ms, z as xr, B as On, C as ki, D as Ti, E as ji, G as Ni, I as Fi, J as Pi, K as yr, L as Ri, M as Ei } from "./vendor-CUhpvfY-.js";
import f from "classnames";
import { memo as Kn, forwardRef as $, PureComponent as D, useState as V, useCallback as F, useEffect as Z, cloneElement as rn, isValidElement as Pt, Component as _t, Children as Rt, createRef as O, createContext as Bt, useRef as G, useMemo as U, useContext as Gt, Fragment as Qt, useImperativeHandle as je, createElement as Li, lazy as Ai, Suspense as $i, useReducer as Oi } from "react";
import { I as N, T as A, w as an, r as js, B as at, a as tn, b as Bi, E as zs, e as Hi } from "./emoji-DZcJJbOG.js";
import { c as ST, f as IT, d as DT, i as kT } from "./emoji-DZcJJbOG.js";
import { useKey as _r, useMount as Ne, useUnmount as Zt, useUpdateEffect as Xt, useToggle as Wi, useSetState as Mi, useClickAway as Cr, useEvent as ln, usePrevious as en, useDebounce as zi } from "react-use";
import j from "moment-timezone";
import { v4 as nn } from "uuid";
import { noop as Vi } from "ts-essentials";
import { a as jT } from "./svg-CHPuwvwO.js";
import Ki from "react-dom";
const Ui = "h-button--button__root", qi = "h-button--button__normal", Gi = "h-button--button__large", Yi = "h-button--button__primary", Xi = "h-button--button__active", Qi = "h-button--button__label", Zi = "h-button--button__secondary", Ji = "h-button--button__tertiary", ta = "h-button--button__danger", ea = "h-button--button__disabled", na = "h-button--button__loading", sa = "h-button--button__withLabel", oa = "h-button--button__slot", ra = "h-button--button__content", Ct = {
  root: Ui,
  normal: qi,
  large: Gi,
  primary: Yi,
  active: Xi,
  label: Qi,
  secondary: Zi,
  tertiary: Ji,
  danger: ta,
  disabled: ea,
  loading: na,
  withLabel: sa,
  slot: oa,
  content: ra
}, X = Kn(
  $(function({
    children: t,
    className: e,
    type: n = "button",
    variant: o = "primary",
    size: r = "normal",
    icon: a,
    slotStart: l,
    slotEnd: c,
    active: d = !1,
    isLoading: h = !1,
    loadingIndicator: u = /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "3", wrap: "nowrap", color: "inherit", children: "Loading..." }),
    label: p,
    styleText: m = !0,
    disabled: g = !1,
    onClick: b,
    ...x
  }, y) {
    const _ = f(
      {
        [Ct.root]: !0,
        [Ct[o]]: !0,
        [Ct[r]]: !0,
        [Ct.active]: d,
        [Ct.disabled]: g,
        [Ct.loading]: h,
        [Ct.withLabel]: !c && !!p
      },
      e
    );
    return /* @__PURE__ */ s.jsx(
      "button",
      {
        ...x,
        type: n,
        className: _,
        onClick: g ? void 0 : b,
        disabled: g,
        ref: y,
        children: h ? u : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          (l || a) && /* @__PURE__ */ s.jsx("span", { className: Ct.slot, children: a ? /* @__PURE__ */ s.jsx(N, { name: a }) : l }),
          (m || t) && /* @__PURE__ */ s.jsx("span", { className: Ct.content, children: m ? /* @__PURE__ */ s.jsx(
            A.Paragraph,
            {
              as: "span",
              variant: "3",
              wrap: "nowrap",
              color: "inherit",
              children: t
            }
          ) : t }),
          p && /* @__PURE__ */ s.jsx(
            A.Paragraph,
            {
              as: "span",
              variant: "4",
              wrap: "nowrap",
              color: "inherit",
              className: Ct.label,
              children: p
            }
          ),
          c && /* @__PURE__ */ s.jsx("span", { className: Ct.slot, children: c })
        ] })
      }
    );
  })
), ia = "h-button-navigationButton--navigationButton__root", aa = {
  root: ia
}, xk = ({
  className: i,
  navigate: t,
  onClick: e,
  ...n
}) => {
  const o = (r) => {
    e?.(r), t();
  };
  return /* @__PURE__ */ s.jsx(
    X,
    {
      ...n,
      variant: n.variant ?? "tertiary",
      onClick: o,
      className: f(i, aa.root)
    }
  );
}, la = "h-spinner--spinner__root", ca = {
  root: la
};
class Un extends D {
  render() {
    const { className: t, size: e, color: n, trackColor: o, bgColor: r, ...a } = this.props, l = f(
      {
        [ca.root]: !0
      },
      t
    ), c = typeof e == "number" ? e : 32, d = typeof e == "number" ? `${c}px` : "32px", h = `${Math.max(Math.floor(c / 8), 1)}px`, u = {
      height: d,
      width: d,
      borderWidth: h
    };
    return o && o.length && (u.borderColor = o), n && n.length && (u.borderTopColor = n), r && r.length && (u.backgroundColor = r), /* @__PURE__ */ s.jsx("div", { ...a, style: u, className: l });
  }
}
const da = "h-iconButton--iconButton__root", ha = {
  root: da
}, K = Kn(
  $(function({
    children: t,
    className: e,
    icon: n,
    iconProps: o,
    iconSize: r,
    variant: a = "primary",
    ...l
  }, c) {
    return /* @__PURE__ */ s.jsx(
      X,
      {
        ref: c,
        "aria-label": n,
        ...l,
        variant: a,
        className: f(ha.root, e),
        loadingIndicator: /* @__PURE__ */ s.jsx(Un, { size: 16 }),
        styleText: !1,
        slotStart: /* @__PURE__ */ s.jsx(N, { size: r || 16, name: n, ...o })
      }
    );
  })
), ua = "h-tooltip--tooltip__content", pa = "h-tooltip--tooltip__contentLight", ma = "h-tooltip--tooltip__contentHasHead", ga = "h-tooltip--tooltip__body", fa = "h-tooltip--tooltip__head", ba = "h-tooltip--tooltip__arrow", de = {
  content: ua,
  contentLight: pa,
  contentHasHead: ma,
  body: ga,
  head: fa,
  arrow: ba
}, xa = 400;
function st({
  children: i,
  content: t,
  onOpenChange: e,
  side: n = "top",
  className: o,
  head: r,
  defaultOpen: a,
  alwaysShow: l,
  disabled: c,
  delayDuration: d = xa,
  align: h,
  "aria-label": u,
  wrap: p = "span",
  wrapProps: m,
  requireClick: g,
  light: b,
  ...x
}) {
  const [y, _] = V(
    g ? !1 : void 0
  ), C = F(() => {
    _(!1), window.removeEventListener("click", C);
  }, []);
  Z(() => () => {
    window.removeEventListener("click", C);
  }, [C]);
  const w = hi();
  if (c || !t)
    return /* @__PURE__ */ s.jsx(s.Fragment, { children: i });
  const v = (I) => {
    I.stopPropagation(), window[y ? "removeEventListener" : "addEventListener"](
      "click",
      C
    ), _(!y);
  }, S = f(
    de.content,
    {
      [de.contentHasHead]: !!r,
      [de.contentLight]: b
    },
    o
  );
  return /* @__PURE__ */ s.jsx(ui, { children: /* @__PURE__ */ s.jsxs(
    pi,
    {
      open: y ?? (l ? !0 : void 0),
      defaultOpen: a,
      delayDuration: d,
      "aria-label": u,
      onOpenChange: e,
      children: [
        /* @__PURE__ */ s.jsx(mi, { asChild: !0, children: p !== "none" ? /* @__PURE__ */ s.jsx(
          p,
          {
            onClick: g ? v : void 0,
            ...m,
            ...x,
            children: i
          }
        ) : g && Pt(i) ? rn(i, { onClick: v }) : i }),
        /* @__PURE__ */ s.jsx(gi, { children: /* @__PURE__ */ s.jsx(
          fi,
          {
            id: w,
            side: n,
            sideOffset: 4,
            align: h,
            className: S,
            style: { zIndex: 2147483647 },
            children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              r && /* @__PURE__ */ s.jsx("div", { className: de.head, children: r }),
              /* @__PURE__ */ s.jsx("div", { className: de.body, children: t }),
              /* @__PURE__ */ s.jsx(bi, { className: de.arrow })
            ] })
          }
        ) })
      ]
    }
  ) });
}
const ya = "h-attachment--attachment__root", _a = "h-attachment--attachment__icon", Ca = "h-attachment--attachment__name", os = {
  root: ya,
  icon: _a,
  name: Ca
}, co = {
  /* images */
  jpg: "file-image",
  jpeg: "file-image",
  bmp: "file-image",
  gif: "file-image",
  tiff: "file-image",
  png: "file-image",
  /* video */
  mp4: "file-video",
  m4v: "file-video",
  mpeg: "file-video",
  mov: "file-video",
  avi: "file-video",
  wmv: "file-video",
  webm: "file-video",
  flv: "file-video",
  /* audio */
  wav: "file-audio",
  mp3: "file-audio",
  aiff: "file-audio",
  acc: "file-audio",
  ogg: "file-audio",
  wma: "file-audio",
  flac: "file-audio",
  alac: "file-audio",
  /* documents */
  pdf: "file-pdf",
  csv: "file-csv",
  doc: "file-word",
  docx: "file-word",
  xls: "file-excel",
  xlsx: "file-excel",
  ppt: "file-powerpoint",
  pptx: "file-powerpoint",
  /* archives */
  zip: "file-archive",
  rar: "file-archive",
  arc: "file-archive",
  "7z": "file-archive",
  s7z: "file-archive",
  tar: "file-archive",
  bz2: "file-archive",
  gz: "file-archive"
};
function wa(i) {
  const t = i.split(".").pop()?.toLowerCase();
  return !t || !co[t] ? "file" : co[t];
}
class yk extends D {
  render() {
    const {
      className: t,
      fileName: e,
      label: n,
      onDownload: o,
      onPreview: r,
      isPreviewLoading: a,
      isDownloadLoading: l,
      extraButtons: c,
      ...d
    } = this.props, h = f(
      {
        [os.root]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsxs("div", { ...d, className: h, children: [
      /* @__PURE__ */ s.jsx(
        N,
        {
          className: os.icon,
          name: wa(e),
          size: 24,
          color: "neutral.700"
        }
      ),
      /* @__PURE__ */ s.jsx(
        st,
        {
          content: n || e,
          wrap: "div",
          wrapProps: { className: os.name },
          children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "4", color: "secondary", children: n || e })
        }
      ),
      r && /* @__PURE__ */ s.jsx(
        K,
        {
          isLoading: a,
          variant: "secondary",
          icon: "eye",
          onClick: a ? void 0 : r
        }
      ),
      o && /* @__PURE__ */ s.jsx(
        K,
        {
          isLoading: l,
          variant: "secondary",
          icon: "download",
          onClick: l ? void 0 : o
        }
      ),
      c
    ] });
  }
}
const va = "h-avatar--avatar__root", En = {
  root: va,
  "avatar-24": "h-avatar--avatar__avatar-24",
  "avatar-32": "h-avatar--avatar__avatar-32",
  "avatar-40": "h-avatar--avatar__avatar-40"
}, Sa = {
  24: 16,
  32: 20,
  40: 24
}, Ia = ({
  icon: i,
  size: t,
  color: e = "inherit"
}) => /* @__PURE__ */ s.jsx(N, { name: i, size: Sa[t], color: e }), Da = "h-image--image__image", ka = "h-image--image__error", Ta = "h-image--image__complete", rs = {
  image: Da,
  error: ka,
  complete: Ta
};
class Vs extends _t {
  static defaultProps;
  mounted;
  constructor(t) {
    super(t), this.state = {
      imageSrc: "",
      loadingError: !1,
      loadingComplete: !1
    }, this.onLoad = this.onLoad.bind(this), this.onError = this.onError.bind(this), this.mounted = !0;
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { src: t } = this.props;
    this.handleSource(t);
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(t) {
    const { src: e } = this.props;
    t.src !== e && this.handleSource(t.src);
  }
  componentWillUnmount() {
    this.mounted = !1;
  }
  handleSource(t) {
    typeof t == "string" ? this.setState({
      imageSrc: t
    }) : t().then((e) => {
      this.mounted && typeof e == "string" && this.setState({
        imageSrc: e
      });
    }).catch(() => {
      this.mounted && this.setState({
        loadingError: !0
      });
    });
  }
  onLoad(t) {
    this.setState({
      loadingComplete: !0,
      loadingError: !1
    }), this.props.onLoad?.(t);
  }
  onError(t) {
    this.setState({
      loadingError: !0,
      loadingComplete: !1
    }), this.props.onError?.(t);
  }
  render() {
    const { className: t, src: e, alt: n, ...o } = this.props, { imageSrc: r } = this.state, { loadingError: a, loadingComplete: l } = this.state, c = f(
      {
        [rs.image]: !0,
        [rs.error]: !!a,
        [rs.complete]: !!l
      },
      t
    );
    return /* @__PURE__ */ s.jsx(
      "img",
      {
        ...o,
        className: c,
        onError: this.onError,
        onLoad: this.onLoad,
        src: r,
        alt: n || ""
      }
    );
  }
}
Vs.defaultProps = {
  className: "",
  alt: ""
};
const ja = "h-avatar--imageAvatar__root", Na = {
  root: ja
}, Fa = ({
  src: i,
  alt: t = "avatar"
}) => /* @__PURE__ */ s.jsx(Vs, { src: i, alt: t, className: Na.root }), Pa = "h-avatar--textAvatar__root", Ln = {
  root: Pa,
  "avatar-24": "h-avatar--textAvatar__avatar-24",
  "avatar-32": "h-avatar--textAvatar__avatar-32",
  "avatar-40": "h-avatar--textAvatar__avatar-40"
}, Ra = {
  24: Ln["avatar-24"],
  32: Ln["avatar-32"],
  40: Ln["avatar-40"]
}, Ea = ({ text: i = "", size: t }) => /* @__PURE__ */ s.jsx("div", { className: f(Ln.root, Ra[t]), children: i.trim().split(" ").map(
  (e, n, o) => o.length === 1 ? e : e[0]
).join("").slice(0, 2) }), La = [
  {
    contentColor: "var(--dixa-avatar-content-green)",
    backgroundColor: "var(--dixa-avatar-background-green)"
  },
  {
    contentColor: "var(--dixa-avatar-content-purple)",
    backgroundColor: "var(--dixa-avatar-background-purple)"
  },
  {
    contentColor: "var(--dixa-avatar-content-blue)",
    backgroundColor: "var(--dixa-avatar-background-blue)"
  },
  {
    contentColor: "var(--dixa-avatar-content-orange)",
    backgroundColor: "var(--dixa-avatar-background-orange)"
  },
  {
    contentColor: "var(--dixa-avatar-content-red)",
    backgroundColor: "var(--dixa-avatar-background-red)"
  }
];
class Aa {
  constructor(t) {
    this.colors = t, this.colors = t;
  }
  generate(t) {
    const e = this.getRandomIndex(t);
    return this.colors[e];
  }
  getRandomIndex(t) {
    const e = xi(t);
    return Math.floor(e() * this.colors.length);
  }
}
var tt = /* @__PURE__ */ ((i) => (i.Icon = "Icon", i.Image = "Image", i.Text = "Text", i))(tt || {});
function he(i) {
  return i.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, "");
}
function wt(i) {
  return !!i && i.trim().length !== 0;
}
function $a(i) {
  if (i.icon)
    return {
      type: tt.Icon,
      icon: i.icon,
      backgroundColor: i.color?.backgroundColor,
      iconColor: i.color?.contentColor
    };
  const { user: t } = i;
  if (!t)
    return {
      type: tt.Icon,
      icon: "user-slash"
    };
  if (wt(t.avatar_url))
    return {
      type: tt.Image,
      src: t.avatar_url,
      alt: t.name || t.display_name || t.email || t.phone_number || t.given_name || t.family_name || ""
    };
  if (wt(t.name)) {
    const e = he(t.name.trim()).split(" ");
    if (e.length === 1)
      return {
        type: tt.Text,
        text: e[0]?.[0] ?? ""
      };
    const n = e[0], o = e[e.length - 1];
    return {
      type: tt.Text,
      text: (n?.[0] ?? "") + (o?.[0] ?? "")
    };
  }
  if (wt(t.display_name))
    return {
      type: tt.Text,
      text: he(t.display_name.trim())
    };
  if (wt(t.given_name) && wt(t.family_name))
    return {
      type: tt.Text,
      text: he(t.given_name.trim())[0] + he(t.family_name.trim())[0]
    };
  if (wt(t.given_name) && !wt(t.family_name))
    return {
      type: tt.Text,
      text: he(t.given_name.trim())[0]
    };
  if (!wt(t.given_name) && wt(t.family_name))
    return {
      type: tt.Text,
      text: he(t.family_name.trim())[0]
    };
  if (wt(t.email)) {
    const [e] = t.email.split("@");
    return {
      type: tt.Text,
      text: e.trim()
    };
  }
  return wt(t.phone_number) ? {
    type: tt.Text,
    text: t.phone_number.slice(-2)
  } : t.id ? {
    type: tt.Icon,
    icon: "user-secret"
  } : {
    type: tt.Icon,
    icon: "user-slash"
  };
}
const vt = {
  backgroundColor: "var(--dixa-color-neutral-200)",
  contentColor: "var(--dixa-color-neutral-700)"
}, ho = {
  shopify: {
    backgroundColor: "rgba(148, 190, 69, 0.1)",
    // this is the same as the content color but has opacity
    contentColor: "#94BE45"
  },
  agillic: {
    ...vt,
    contentColor: "#000"
  },
  magento: {
    backgroundColor: "rgba(193, 72, 0, 0.1)",
    contentColor: "#C14800"
  },
  salesforce: {
    backgroundColor: "rgba(3, 161, 224, 0.1)",
    contentColor: "#03A1E0"
  },
  busylight: {
    backgroundColor: "rgba(27, 190, 246, 0.1)",
    contentColor: "#1BBEF6"
  },
  podio: {
    backgroundColor: "rgba(80, 145, 189, 0.1)",
    contentColor: "#5091BD"
  },
  "user-secret": vt,
  "user-slash": vt,
  "map-pin": vt,
  "web-form": vt,
  code: vt,
  history: vt,
  smile: vt,
  key: vt,
  webhooks: vt,
  plug: vt
}, Oa = {
  24: En["avatar-24"],
  32: En["avatar-32"],
  40: En["avatar-40"]
};
class Ba extends D {
  static defaultProps = {
    size: "32",
    colorGenerator: new Aa(La)
  };
  getAvatarChild(t, e) {
    if (t.type === tt.Icon)
      return /* @__PURE__ */ s.jsx(
        Ia,
        {
          size: e,
          icon: t.icon,
          color: t.iconColor
        }
      );
    if (t.type === tt.Image)
      return /* @__PURE__ */ s.jsx(Fa, { src: t.src, alt: t.alt });
    if (t.type === tt.Text)
      return /* @__PURE__ */ s.jsx(Ea, { size: e, text: t.text });
  }
  calculateColor(t) {
    if (t.type === tt.Icon) {
      if (t.backgroundColor && t.iconColor)
        return {
          backgroundColor: t.backgroundColor,
          contentColor: t.iconColor
        };
      if (ho[t.icon])
        return ho[t.icon];
    }
    return t.type === tt.Image ? {
      backgroundColor: "transparent",
      contentColor: "initial"
    } : this.props.user?.id ? this.props.colorGenerator.generate(this.props.user.id.toString()) : this.props.icon ? this.props.colorGenerator.generate(this.props.icon) : t.type === tt.Text ? this.props.colorGenerator.generate(t.text) : this.props.colorGenerator.generate();
  }
  render() {
    const { className: t, size: e } = this.props, n = $a(this.props), o = this.getAvatarChild(n, e), r = this.calculateColor(n);
    return /* @__PURE__ */ s.jsx(
      "div",
      {
        style: {
          backgroundColor: r.backgroundColor,
          color: r.contentColor
        },
        className: f(
          En.root,
          Oa[e],
          t
        ),
        children: o
      }
    );
  }
}
const wr = an(Ba, {
  fallback: null
}), Ha = "h-badge--badge__badge", Wa = "h-badge--badge__badgeSmall", Ma = "h-badge--badge__badgeMedium", za = "h-badge--badge__badgePrimary", Va = "h-badge--badge__badgeSecondary", Ka = "h-badge--badge__badgeSuccess", Ua = "h-badge--badge__badgeInfo", qa = "h-badge--badge__badgeWarning", Ga = "h-badge--badge__badgeError", Ot = {
  badge: Ha,
  badgeSmall: Wa,
  badgeMedium: Ma,
  badgePrimary: za,
  badgeSecondary: Va,
  badgeSuccess: Ka,
  badgeInfo: Ua,
  badgeWarning: qa,
  badgeError: Ga
}, Ya = {
  small: Ot.badgeSmall,
  medium: Ot.badgeMedium
}, Xa = {
  primary: Ot.badgePrimary,
  secondary: Ot.badgeSecondary,
  success: Ot.badgeSuccess,
  info: Ot.badgeInfo,
  warning: Ot.badgeWarning,
  error: Ot.badgeError
}, Qa = "badge";
function _k(i) {
  const { className: t, size: e, variant: n, children: o, ...r } = i, a = f(
    Ot.badge,
    Ya[e],
    Xa[n],
    t
  );
  return /* @__PURE__ */ s.jsx("span", { className: a, ...r, "data-testid": Qa, children: o });
}
const B = $(function({
  flexWrap: t,
  flexDirection: e,
  justifyItems: n,
  justifyContent: o,
  alignItems: r,
  alignContent: a,
  gap: l,
  style: c,
  children: d,
  ...h
}, u) {
  const p = {
    ...t && { flexWrap: t },
    ...e && { flexDirection: e },
    ...n && { justifyItems: n },
    ...o && { justifyContent: o },
    ...r && { alignItems: r },
    ...a && { alignContent: a },
    ...l && { gap: js(l) },
    display: "flex",
    ...c
  };
  return /* @__PURE__ */ s.jsx(at, { ...h, style: p, ref: u, children: d });
}), Za = "h-banner--banner__root", Ja = "h-banner--banner__rootWithClose", tl = "h-banner--banner__iconContainer", el = "h-banner--banner__closeIcon", nl = "h-banner--banner__headline", sl = "h-banner--banner__rootInfo", ol = "h-banner--banner__icon", rl = "h-banner--banner__description", il = "h-banner--banner__rootWarning", al = "h-banner--banner__rootAnnouncement", ll = "h-banner--banner__rootSuccess", cl = "h-banner--banner__rootFail", xt = {
  root: Za,
  rootWithClose: Ja,
  iconContainer: tl,
  closeIcon: el,
  headline: nl,
  rootInfo: sl,
  icon: ol,
  description: rl,
  rootWarning: il,
  rootAnnouncement: al,
  rootSuccess: ll,
  rootFail: cl
}, dl = (i, t) => {
  if (t !== void 0)
    return t;
  switch (i) {
    case "info":
    case "announcement":
      return "info";
    case "warning":
      return "exclamation-triangle-filled";
    case "success":
      return "check-circle-filled";
    default:
      return "close-circle-filled";
  }
}, Ck = ({
  actionSlot: i,
  className: t,
  description: e,
  headline: n,
  icon: o,
  variant: r,
  onClose: a
}) => {
  const l = f(xt.root, t, {
    [xt.rootInfo]: r === "info",
    [xt.rootAnnouncement]: r === "announcement",
    [xt.rootWarning]: r === "warning",
    [xt.rootSuccess]: r === "success",
    [xt.rootFail]: r === "fail",
    [xt.rootWithClose]: a
  }), c = dl(r, o);
  return /* @__PURE__ */ s.jsxs("div", { className: l, children: [
    /* @__PURE__ */ s.jsxs(B, { justifyContent: "center", children: [
      c && /* @__PURE__ */ s.jsx("span", { className: xt.iconContainer, children: /* @__PURE__ */ s.jsx(N, { name: c, size: 16, className: xt.icon }) }),
      /* @__PURE__ */ s.jsxs(B, { flexDirection: "column", children: [
        n && /* @__PURE__ */ s.jsx(
          A.Heading,
          {
            as: "span",
            variant: "heading-3",
            className: xt.headline,
            children: n
          }
        ),
        rn(e, {
          className: xt.description
        })
      ] })
    ] }),
    i ? /* @__PURE__ */ s.jsx(B, { gap: "250", margin: "0 0 0 250", children: i }) : a && /* @__PURE__ */ s.jsx(
      K,
      {
        icon: "close",
        variant: "tertiary",
        className: xt.closeIcon,
        onClick: a
      }
    )
  ] });
}, hl = "h-buttonGroup--buttonGroup__root", ul = "h-buttonGroup--buttonGroup__button", pl = "h-buttonGroup--buttonGroup__buttonWithBorder", ml = "h-buttonGroup--buttonGroup__buttonWithoutBorder", un = {
  root: hl,
  button: ul,
  buttonWithBorder: pl,
  buttonWithoutBorder: ml
}, wk = ({
  className: i,
  children: t,
  variant: e,
  size: n,
  disabled: o
}) => {
  const r = f(un.root, i);
  return /* @__PURE__ */ s.jsx("div", { className: r, role: "group", children: Rt.map(t, (a) => {
    if (!Pt(a))
      return null;
    const l = (e ?? a.props.variant) === "secondary", c = f(a.props.className, {
      [un.button]: !0,
      [un.buttonWithBorder]: l,
      [un.buttonWithoutBorder]: !l
    });
    return rn(a, {
      className: c,
      disabled: o ?? a.props.disabled,
      variant: e ?? a.props.variant,
      size: n
    });
  }) });
}, gl = "h-divider--divider__root", fl = "h-divider--divider__withChildren", bl = "h-divider--divider__horizontal", xl = "h-divider--divider__vertical", is = {
  root: gl,
  withChildren: fl,
  horizontal: bl,
  vertical: xl
}, qn = $(function({
  className: t,
  children: e,
  as: n,
  orientation: o = "horizontal",
  color: r,
  margin: a,
  padding: l,
  ...c
}, d) {
  const h = n ?? (e ? "div" : "hr"), u = f(
    is.root,
    is[o],
    {
      [is.withChildren]: !!e
    },
    t
  ), p = {
    ...c.style,
    ...r ? { "--divider-color": tn(r) } : {},
    ...a ? { margin: js(a) } : {},
    ...l ? { padding: js(l) } : {}
  };
  return /* @__PURE__ */ s.jsx(
    h,
    {
      ...c,
      ref: d,
      className: u,
      style: p,
      children: typeof e == "string" ? /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: e }) : e
    }
  );
}), yl = "h-buttonList--buttonList__buttonList", _l = "h-buttonList--buttonList__inner", uo = {
  buttonList: yl,
  inner: _l
};
let Cl = class extends D {
  render() {
    const { children: t, className: e, ...n } = this.props;
    return /* @__PURE__ */ s.jsx(qn, { as: "li", color: "tertiary", padding: "200 250", ...n, children: t });
  }
};
const wl = "h-buttonList--item__item", vl = "h-buttonList--item__icon", Sl = "h-buttonList--item__button", Il = "h-buttonList--item__buttonDisabled", Dl = "h-buttonList--item__buttonCentered", kl = "h-buttonList--item__checkmark", Tl = "h-buttonList--item__buttonLoading", jl = "h-buttonList--item__buttonContent", Ht = {
  item: wl,
  icon: vl,
  button: Sl,
  buttonDisabled: Il,
  buttonCentered: Dl,
  checkmark: kl,
  buttonLoading: Tl,
  buttonContent: jl
}, Nl = function({
  icon: t,
  children: e,
  className: n,
  isSelected: o,
  isCentered: r,
  isLoading: a,
  isDisabled: l,
  buttonClassName: c,
  buttonProps: d,
  onClick: h,
  ...u
}, p) {
  const m = f(
    {
      [Ht.item]: !0
    },
    n
  ), g = f(
    Ht.button,
    {
      [Ht.buttonCentered]: r,
      [Ht.buttonLoading]: a,
      [Ht.buttonDisabled]: l
    },
    c
  ), b = l ? { tabIndex: -1 } : {};
  return /* @__PURE__ */ s.jsx("li", { ref: p, ...u, className: m, children: /* @__PURE__ */ s.jsxs(
    "button",
    {
      ...b,
      ...d,
      className: g,
      onClick: h,
      children: [
        /* @__PURE__ */ s.jsxs("span", { className: Ht.buttonContent, children: [
          t && /* @__PURE__ */ s.jsx(N, { className: Ht.icon, name: t }),
          /* @__PURE__ */ s.jsx(A.Paragraph, { variant: o ? "1" : "2", children: e })
        ] }),
        o && /* @__PURE__ */ s.jsx(
          N,
          {
            name: "done",
            size: 20,
            color: "neutral.700",
            className: Ht.checkmark
          }
        )
      ]
    }
  ) });
}, Fl = $(Nl);
class po extends D {
  static get Item() {
    return Fl;
  }
  static get Header() {
    return Cl;
  }
  static get Divider() {
    return Pl;
  }
  render() {
    const { children: t, className: e, ...n } = this.props, o = f(
      {
        [uo.buttonList]: !0
      },
      e
    );
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: /* @__PURE__ */ s.jsx("ul", { className: uo.inner, children: t }) });
  }
}
const Pl = () => /* @__PURE__ */ s.jsx(qn, { as: "li", margin: "100 0" }), Rl = "h-checkbox--checkbox__root", El = "h-checkbox--checkbox__rootDisabled", Ll = "h-checkbox--checkbox__rootChecked", Al = "h-checkbox--checkbox__rootIndeterminate", $l = "h-checkbox--checkbox__checkbox", Ol = "h-checkbox--checkbox__input", ue = {
  root: Rl,
  rootDisabled: El,
  rootChecked: Ll,
  rootIndeterminate: Al,
  checkbox: $l,
  input: Ol
};
class cn extends D {
  inputRef;
  constructor(t) {
    super(t), this.inputRef = O();
  }
  componentDidMount() {
    const t = this.inputRef.current;
    t && (t.indeterminate = !!this.props.indeterminate);
  }
  componentDidUpdate(t) {
    const e = this.inputRef.current;
    e && t.indeterminate !== this.props.indeterminate && (e.indeterminate = !!this.props.indeterminate);
  }
  render() {
    const {
      className: t,
      onChange: e,
      id: n,
      name: o,
      checked: r,
      indeterminate: a,
      disabled: l,
      tabIndex: c,
      ...d
    } = this.props, h = f(
      {
        [ue.root]: !0,
        [ue.rootDisabled]: l,
        [ue.rootChecked]: r,
        [ue.rootIndeterminate]: a
      },
      t
    );
    return /* @__PURE__ */ s.jsxs("span", { className: h, "data-testid": "habla-checkbox", ...d, children: [
      /* @__PURE__ */ s.jsx(
        "span",
        {
          role: "checkbox",
          "aria-checked": a ? "mixed" : r,
          className: ue.checkbox
        }
      ),
      /* @__PURE__ */ s.jsx(
        "input",
        {
          id: n,
          type: "checkbox",
          "aria-hidden": "true",
          name: o,
          className: ue.input,
          onChange: e || L,
          checked: r,
          disabled: l,
          ref: this.inputRef,
          tabIndex: c
        }
      )
    ] });
  }
}
const Bl = "h-collapseCard--collapseCard__card", Hl = {
  card: Bl
}, Ks = Bt({
  isOpen: !1,
  onToggle: L
}), Wl = "h-collapseCard--content__content", Ml = "h-collapseCard--content__contentIsOpen", mo = {
  content: Wl,
  contentIsOpen: Ml
};
class zl extends D {
  static displayName = "CollapseCard.Content";
  getRootClassName(t) {
    return f(mo.content, this.props.className, {
      [mo.contentIsOpen]: t
    });
  }
  render() {
    const { children: t, className: e, ...n } = this.props;
    return /* @__PURE__ */ s.jsx(Ks.Consumer, { children: ({ isOpen: o }) => o ? /* @__PURE__ */ s.jsx(
      "ul",
      {
        ...n,
        className: this.getRootClassName(o),
        "data-testid": "content",
        children: t
      }
    ) : null });
  }
}
function Gn(i) {
  return {
    role: "button",
    onClick: i,
    onKeyDown: (t) => {
      t.key === "Enter" && i(t);
    }
  };
}
const Vl = [
  "ArrowLeft",
  "ArrowUp",
  "ArrowRight",
  "ArrowDown",
  " "
], Kl = ["Escape", "Esc"], Yn = (i) => Vl.includes(i), Fe = (i) => Kl.includes(i), Ul = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]",
  '[tabindex]:not([tabindex="-1"]):not([disabled])'
], go = Ul.join(
  ':not([hidden]):not([tabindex="-1"]),'
), vr = Kn(function({
  containerRef: t,
  children: e,
  isActive: n,
  autoFocus: o,
  restoreFocus: r,
  onActiveStateChange: a,
  bringInFocusOnTab: l
}) {
  const c = n !== void 0, d = n === void 0 || n, h = G(null), u = G(
    // type null is needed to make ref mutable.
    d ? document.activeElement : null
  ), p = t || h;
  _r(
    "Tab",
    (b) => {
      if (!d)
        return;
      const x = p.current?.querySelectorAll(go), y = !p.current?.contains(
        b.target instanceof Element ? b.target : null
      );
      if (!x)
        return;
      const _ = x[0], C = x[x.length - 1];
      if (!b.shiftKey && document.activeElement === C || !b.shiftKey && l && y)
        return _?.focus(), b.preventDefault();
      (b.shiftKey && document.activeElement === _ || b.shiftKey && l && y) && (C?.focus(), b.preventDefault());
    },
    void 0,
    [d]
  );
  const m = () => {
    setTimeout(() => {
      o && (o === !0 ? p.current?.querySelector(go)?.focus() : o.current && o.current.focus());
    });
  }, g = () => {
    document.activeElement !== document.body && !p.current?.contains(document.activeElement) || setTimeout(() => {
      r && (r === !0 ? u.current?.focus() : r.current && r.current.focus());
    });
  };
  return Ne(() => {
    c || (m(), a?.(!0));
  }), Zt(() => {
    c || (g(), a?.(!1));
  }), Xt(() => {
    n === !0 ? (u.current = document.activeElement, m()) : n === !1 && g(), a?.(!!n);
  }, [n]), t ? /* @__PURE__ */ s.jsx(s.Fragment, { children: e }) : /* @__PURE__ */ s.jsx("div", { ref: h, children: e });
}), ql = "h-dropdown--dropdown__dropdown", Gl = "h-dropdown--dropdown__dropdownOpen", Yl = "h-dropdown--dropdown__dropdownFromRight", Xl = "h-dropdown--dropdown__dropdownFromBottom", Ql = "h-dropdown--dropdown__dropdownAnimating", Zl = "h-dropdown--dropdown__dropdownFixed", Jl = "h-dropdown--dropdown__loader", tc = "h-dropdown--dropdown__error", ec = "h-dropdown--dropdown__errorIcon", Lt = {
  dropdown: ql,
  dropdownOpen: Gl,
  dropdownFromRight: Yl,
  dropdownFromBottom: Xl,
  dropdownAnimating: Ql,
  dropdownFixed: Zl,
  loader: Jl,
  error: tc,
  errorIcon: ec
};
class Jt extends D {
  dropdownRef;
  timeoutAnimationStart;
  timeoutAnimationEnd;
  static defaultProps = {
    onClose: () => {
    },
    closeOnBlur: !0
  };
  constructor(t) {
    super(t), this.state = {
      fromRight: !1,
      fromBottom: !1,
      fromTop: !1,
      width: null,
      height: null,
      animating: !1
    }, this.timeoutAnimationStart = void 0, this.timeoutAnimationEnd = void 0, this.dropdownRef = O(), this.handleClickOutsideDropdown = this.handleClickOutsideDropdown.bind(this), this.handleFixedScroll = this.handleFixedScroll.bind(this), this.handleOnClose = this.handleOnClose.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this);
  }
  componentDidMount() {
    this.calculatePosition();
  }
  getSnapshotBeforeUpdate() {
    if (this.dropdownRef.current) {
      const t = this.dropdownRef.current.getBoundingClientRect();
      return {
        oldWidth: t.width,
        oldHeight: t.height
      };
    }
    return null;
  }
  componentDidUpdate(t, e, n) {
    const { isOpen: o, isLoading: r, errorMessage: a, fixed: l, closeOnBlur: c } = this.props;
    if (n && (r !== t.isLoading || a !== t.errorMessage)) {
      const d = r !== t.isLoading && r;
      this.animate(n.oldWidth, n.oldHeight, d);
    }
    o && this.calculatePosition(), o !== t.isOpen && (window[o ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutsideDropdown
    ), c && window[o ? "addEventListener" : "removeEventListener"](
      "blur",
      this.handleOnClose
    ), l && window[o ? "addEventListener" : "removeEventListener"](
      "scroll",
      this.handleFixedScroll,
      !0
    ));
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleClickOutsideDropdown), window.removeEventListener("scroll", this.handleFixedScroll), window.removeEventListener("blur", this.handleOnClose), window.clearInterval(this.timeoutAnimationStart), window.clearInterval(this.timeoutAnimationEnd);
  }
  handleOnClose() {
    const { onClose: t } = this.props;
    t();
  }
  animate(t, e, n) {
    if (this.dropdownRef.current) {
      const o = this.dropdownRef.current.getBoundingClientRect();
      this.setState({
        width: t,
        height: e,
        animating: !n
      }), this.timeoutAnimationStart = window.setTimeout(() => {
        this.setState({
          width: o.width,
          height: o.height
        }), this.timeoutAnimationEnd = window.setTimeout(() => {
          this.setState({
            width: null,
            height: null,
            animating: !1
          });
        }, 200);
      });
    }
  }
  handleClickOutsideDropdown(t) {
    if (!this.dropdownRef || !(t.target instanceof Node)) return;
    const { onClose: e } = this.props;
    this.dropdownRef.current && t.target !== this.dropdownRef.current && !this.dropdownRef.current.contains(t.target) && e();
  }
  handleDropdownClick(t) {
    t.stopPropagation();
  }
  handleFixedScroll() {
    this.forceUpdate();
  }
  calculatePosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const t = this.dropdownRef.current.parentElement.getBoundingClientRect(), e = t.left + t.width / 2, n = t.top + t.height / 2, o = window.innerWidth / 2, r = window.innerHeight / 2;
      this.setState({
        fromRight: e > o,
        fromBottom: n > r,
        fromTop: n <= r
      });
    }
  }
  getFixedPosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const { fromRight: t, fromBottom: e, fromTop: n } = this.state, o = this.dropdownRef.current.parentElement.getBoundingClientRect(), r = {};
      return t ? r.right = `${window.innerWidth - o.right}px` : r.left = `${o.left}px`, e && (r.bottom = `${window.innerHeight - o.top}px`), n && (r.top = `${o.top + o.height}px`), r;
    }
    return {};
  }
  render() {
    const {
      className: t,
      children: e,
      onClose: n,
      isOpen: o,
      isLoading: r,
      closeOnBlur: a,
      errorMessage: l,
      fixed: c,
      style: d,
      autoFocus: h,
      restoreFocus: u,
      bringInFocusOnTab: p,
      ...m
    } = this.props, { fromRight: g, fromBottom: b, animating: x, width: y, height: _ } = this.state, C = f(
      {
        [Lt.dropdown]: !0,
        [Lt.dropdownOpen]: o,
        [Lt.dropdownFromRight]: g,
        [Lt.dropdownFromBottom]: b,
        [Lt.dropdownAnimating]: x,
        [Lt.dropdownFixed]: c
      },
      t
    );
    let w = { ...d };
    y && _ && (w.width = `${y}px`, w.height = `${_}px`), c && (w = { ...w, ...this.getFixedPosition() });
    const v = !r && !l;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...m,
        className: C,
        ref: this.dropdownRef,
        style: w,
        onClick: this.handleDropdownClick,
        role: "menu",
        "aria-expanded": o,
        children: [
          r && /* @__PURE__ */ s.jsx("div", { className: Lt.loader }),
          !!l && !r && /* @__PURE__ */ s.jsxs("div", { className: Lt.error, children: [
            /* @__PURE__ */ s.jsx(N, { className: Lt.errorIcon, name: "exclamation" }),
            /* @__PURE__ */ s.jsx("span", { children: l })
          ] }),
          v && /* @__PURE__ */ s.jsx(
            vr,
            {
              containerRef: this.dropdownRef,
              isActive: o,
              autoFocus: h,
              restoreFocus: u,
              bringInFocusOnTab: p,
              children: e
            }
          )
        ]
      }
    );
  }
}
const nc = "h-dropdownButton--dropdownButton__root", sc = "h-dropdownButton--dropdownButton__wrapper", as = {
  root: nc,
  wrapper: sc
}, dn = Bt({
  toggleDropdown: L,
  openDropdown: L,
  closeDropdown: L,
  dropdownOpen: !1
});
class le extends _t {
  buttonWrapperRef;
  buttonRef;
  contextState;
  timeoutId;
  static defaultProps = {
    allowEscClose: !0
  };
  constructor(t) {
    super(t);
    const e = t.show ?? !1;
    this.state = {
      dropdownOpen: e,
      pristine: !0,
      fromBottom: !1
    }, this.timeoutId = null, this.buttonWrapperRef = O(), this.buttonRef = O(), this.handleDropdownToggle = this.handleDropdownToggle.bind(this), this.close = this.close.bind(this), this.open = this.open.bind(this), this.toggle = this.toggle.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.contextState = {
      toggleDropdown: this.toggle,
      openDropdown: this.open,
      closeDropdown: this.close,
      dropdownOpen: e
    };
  }
  componentDidMount() {
    this.props.allowEscClose && this.props.show && window.addEventListener("keydown", this.handleKeyDown, !0), this.setState({ fromBottom: this.shouldDropdownBeAboveButton() });
  }
  componentDidUpdate(t) {
    this.toggleDropdownIfNeeded(t);
  }
  componentWillUnmount() {
    this.props.allowEscClose && window.removeEventListener("keydown", this.handleKeyDown, !0), this.timeoutId && window.clearTimeout(this.timeoutId);
  }
  shouldToggleDropdown(t) {
    return t.show !== this.props.show;
  }
  handleKeyDown(t) {
    Fe(t.key) && this.state.dropdownOpen && (t.stopPropagation(), this.close());
  }
  toggleDropdownIfNeeded(t) {
    this.shouldToggleDropdown(t) && (this.props.show ? this.open() : this.close());
  }
  /**
   * HACK: To get around node and dom types not being compatible and both
   * overloading setTimeout
   *
   * @param callback
   * @param delay
   * @returns
   */
  setTimeout(t, e = 0) {
    return window.setTimeout(t, e);
  }
  handleDropdownToggle() {
    const { dropdownOpen: t } = this.state, e = () => {
      this.timeoutId = this.setTimeout(() => {
        this.toggle(!t);
      });
    }, n = this.shouldDropdownBeAboveButton();
    t ? e() : this.setState(
      { fromBottom: n },
      e
    );
  }
  close() {
    this.toggle(!1);
  }
  open() {
    this.toggle(!0);
  }
  toggle(t) {
    const { allowEscClose: e, onToggle: n } = this.props, { pristine: o, dropdownOpen: r } = this.state, a = t ?? !r;
    this.contextState = { ...this.contextState, dropdownOpen: a }, this.setState({ dropdownOpen: a, pristine: !1 }), e && (a ? window.addEventListener : window.removeEventListener)("keydown", this.handleKeyDown, !0), n?.(a, o);
  }
  shouldDropdownBeAboveButton() {
    const t = this.buttonWrapperRef.current?.getBoundingClientRect();
    return t ? t.bottom > window.innerHeight / 2 : !1;
  }
  renderTheTriggerButton() {
    const {
      icon: t,
      buttonProps: e,
      children: n,
      noArrow: o,
      noStyle: r,
      onMouseEnter: a,
      onMouseLeave: l
    } = this.props, { fromBottom: c } = this.state;
    return r ? /* @__PURE__ */ s.jsx(
      "div",
      {
        ref: this.buttonRef,
        className: e?.className,
        ...e,
        onMouseEnter: a,
        onMouseLeave: l,
        ...Gn(this.handleDropdownToggle),
        children: n
      }
    ) : t && !n ? /* @__PURE__ */ s.jsx(
      K,
      {
        ref: this.buttonRef,
        icon: t,
        variant: "secondary",
        onMouseEnter: a,
        onMouseLeave: l,
        ...e,
        onClick: this.handleDropdownToggle
      }
    ) : /* @__PURE__ */ s.jsx(
      X,
      {
        ref: this.buttonRef,
        icon: t,
        variant: "secondary",
        onMouseEnter: a,
        onMouseLeave: l,
        ...e,
        onClick: this.handleDropdownToggle,
        slotEnd: o ? void 0 : /* @__PURE__ */ s.jsx(N, { name: c ? "angle-up" : "angle-down" }),
        children: n
      }
    );
  }
  render() {
    const {
      className: t,
      children: e,
      icon: n,
      dropdown: o,
      buttonProps: r,
      dropdownProps: a,
      noArrow: l,
      noStyle: c,
      show: d,
      onToggle: h,
      isLoading: u,
      errorMessage: p,
      fixed: m,
      onMouseEnter: g,
      onMouseLeave: b,
      allowEscClose: x,
      destroyOnClose: y,
      ..._
    } = this.props, { dropdownOpen: C, pristine: w } = this.state, v = f({ [as.root]: as.root }, t);
    return /* @__PURE__ */ s.jsx(dn.Provider, { value: this.contextState, children: /* @__PURE__ */ s.jsx("div", { ..._, className: v, ref: this.buttonWrapperRef, children: /* @__PURE__ */ s.jsxs("div", { className: as.wrapper, children: [
      this.renderTheTriggerButton(),
      /* @__PURE__ */ s.jsx(
        Jt,
        {
          restoreFocus: this.buttonRef,
          ...a,
          isOpen: C,
          onClose: this.close,
          isLoading: u,
          errorMessage: p,
          fixed: m,
          children: (C || !w && !y) && o
        }
      )
    ] }) }) });
  }
}
const oc = "h-collapseCard--header__header", rc = "h-collapseCard--header__headerOpen", ic = "h-collapseCard--header__headerHasDropdown", ac = "h-collapseCard--header__title", pn = {
  header: oc,
  headerOpen: rc,
  headerHasDropdown: ic,
  title: ac
};
class lc extends D {
  // It's important to keep the displayName because it's used by the collapseCard
  // To determine the type of it's children
  static displayName = "CollapseCard.Header";
  static defaultProps = {
    title: ""
  };
  getRootClassName(t) {
    const { dropdown: e, className: n } = this.props;
    return f(
      pn.header,
      { [pn.headerOpen]: t, [pn.headerHasDropdown]: !!e },
      n
    );
  }
  render() {
    const {
      children: t,
      className: e,
      title: n,
      avatar: o,
      wrap: r = "nowrap",
      dropdown: a,
      onDropdownToggle: l,
      dropdownTrigger: c,
      ...d
    } = this.props;
    return /* @__PURE__ */ s.jsx(Ks.Consumer, { children: ({ isOpen: h, onToggle: u }) => {
      const p = this.getRootClassName(h);
      return /* @__PURE__ */ s.jsxs(
        "div",
        {
          ...d,
          onClick: u,
          className: p,
          "data-testid": "header",
          children: [
            /* @__PURE__ */ s.jsxs(B, { alignItems: "center", padding: "400 0", children: [
              o,
              /* @__PURE__ */ s.jsx("div", { onMouseDown: (m) => m.stopPropagation(), children: /* @__PURE__ */ s.jsx(
                A.Paragraph,
                {
                  variant: "1",
                  wrap: r,
                  className: pn.title,
                  children: t
                }
              ) })
            ] }),
            /* @__PURE__ */ s.jsxs(B, { alignItems: "center", children: [
              !!a && /* @__PURE__ */ s.jsx(
                le,
                {
                  onClick: (m) => m.stopPropagation(),
                  icon: c ? void 0 : "dots-h",
                  dropdown: a,
                  buttonProps: { variant: "tertiary" },
                  onToggle: l,
                  children: c
                }
              ),
              /* @__PURE__ */ s.jsx(
                K,
                {
                  icon: h ? "angle-down" : "angle-right",
                  variant: "tertiary"
                }
              )
            ] })
          ]
        }
      );
    } });
  }
}
const cc = "h-collapseCard--line__line", dc = "h-collapseCard--line__lineHasLabel", hc = "h-collapseCard--line__value", uc = "h-collapseCard--line__lineHideOverflow", mn = {
  line: cc,
  lineHasLabel: dc,
  value: hc,
  lineHideOverflow: uc
};
class pc extends D {
  render() {
    const { label: t, children: e, className: n, hideOverflow: o, ...r } = this.props, a = f(
      {
        [mn.line]: !0,
        [mn.lineHasLabel]: !!t,
        [mn.lineHideOverflow]: o
      },
      n
    );
    return /* @__PURE__ */ s.jsxs("li", { ...r, className: a, children: [
      t && /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", subdued: !0, wrap: "nowrap", children: t }),
      t ? /* @__PURE__ */ s.jsx("span", { className: mn.value, children: e }) : e
    ] });
  }
}
const mc = "h-collapseCard--readMore__readMore", gc = {
  readMore: mc
};
class fc extends D {
  render() {
    const { onClick: t, url: e, children: n, className: o, ...r } = this.props, a = f({ [gc.readMore]: !0 }, o);
    return e ? /* @__PURE__ */ s.jsx(A.ExternalLink, { ...r, href: e, className: a, children: n }) : /* @__PURE__ */ s.jsx(
      X,
      {
        variant: "secondary",
        ...r,
        onClick: t,
        className: a,
        children: n
      }
    );
  }
}
const bc = "h-collapseCard--status__status", xc = {
  status: bc
};
class yc extends D {
  render() {
    const { children: t, className: e, ...n } = this.props, o = f({ [xc.status]: !0 }, e);
    return /* @__PURE__ */ s.jsx("li", { ...n, className: o, children: t });
  }
}
class _c extends D {
  static defaultProps = {
    isOpen: !1
  };
  constructor(t) {
    super(t), this.handleToggle = this.handleToggle.bind(this);
  }
  static Line = pc;
  static Header = lc;
  static Content = zl;
  static ReadMore = fc;
  static Status = yc;
  handleToggle() {
    this.props.onToggle(!this.props.isOpen);
  }
  isHeader(t) {
    return t?.type?.displayName === "CollapseCard.Header" && Pt(t);
  }
  isContent(t) {
    return t?.type?.displayName === "CollapseCard.Content" && Pt(t);
  }
  getHeaderChildren() {
    return Rt.toArray(this.props.children).filter(this.isHeader);
  }
  getContentChildren() {
    return Rt.toArray(this.props.children).filter(this.isContent);
  }
  getRootClassName() {
    const { className: t } = this.props;
    return f(Hl.card, t);
  }
  render() {
    const { className: t, onToggle: e, isOpen: n, children: o, ...r } = this.props;
    return /* @__PURE__ */ s.jsx(
      Ks.Provider,
      {
        value: { isOpen: n, onToggle: this.handleToggle },
        children: /* @__PURE__ */ s.jsxs("div", { ...r, className: this.getRootClassName(), children: [
          this.getHeaderChildren(),
          this.getContentChildren()
        ] })
      }
    );
  }
}
const Sk = an(_c, {
  fallback: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: "Something went wrong" }) })
}), Cc = "h-collapsible--collapsible__root", wc = "h-collapsible--collapsible__collapsible", vc = "h-collapsible--collapsible__children", ls = {
  root: Cc,
  collapsible: wc,
  children: vc
};
class Ik extends D {
  childrenRef;
  resizeObserver = null;
  constructor(t) {
    super(t), this.childrenRef = O(), this.measureChildrenHeight = this.measureChildrenHeight.bind(this), this.state = {
      childrenHeight: t.isOpen ? "auto" : 0
    };
  }
  componentDidMount() {
    this.measureChildrenHeight(), this.setupResizeObserver();
  }
  componentDidUpdate(t) {
    t.isOpen !== this.props.isOpen && this.measureChildrenHeight(), this.setupResizeObserver();
  }
  componentWillUnmount() {
    this.disconnectResizeObserver();
  }
  setupResizeObserver() {
    this.childrenRef.current && !this.resizeObserver && (this.resizeObserver = new ResizeObserver(() => {
      this.measureChildrenHeight();
    }), this.resizeObserver.observe(this.childrenRef.current));
  }
  disconnectResizeObserver() {
    this.resizeObserver && (this.resizeObserver.disconnect(), this.resizeObserver = null);
  }
  measureChildrenHeight() {
    const t = this.childrenRef.current;
    t && this.setState({
      childrenHeight: t.offsetHeight
    });
  }
  render() {
    const { className: t, header: e, isOpen: n, children: o, ...r } = this.props, { childrenHeight: a } = this.state, l = f(
      {
        [ls.root]: !0
      },
      t
    ), c = {
      maxHeight: n ? a : 0
    };
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: l, children: [
      /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx("div", { children: e }) }),
      !!o && /* @__PURE__ */ s.jsx("div", { style: c, className: ls.collapsible, children: /* @__PURE__ */ s.jsx("span", { className: ls.children, ref: this.childrenRef, children: o }) })
    ] });
  }
}
const Sc = "h-colorPicker--colorPicker__root", Ic = {
  root: Sc
}, Dc = "h-inputWrapper--inputWrapper__root", kc = "h-inputWrapper--inputWrapper__rootDisabled", Tc = "h-inputWrapper--inputWrapper__rootActive", jc = "h-inputWrapper--inputWrapper__rootHasError", Nc = "h-inputWrapper--inputWrapper__rootHasWarning", Fc = "h-inputWrapper--inputWrapper__rootHasSuccess", Pc = "h-inputWrapper--inputWrapper__inputWrapper", Rc = "h-inputWrapper--inputWrapper__rootWithPrefix", Ec = "h-inputWrapper--inputWrapper__rootWithSuffix", Lc = "h-inputWrapper--inputWrapper__suffixesContainer", Ac = "h-inputWrapper--inputWrapper__prefix", $c = "h-inputWrapper--inputWrapper__suffix", Oc = "h-inputWrapper--inputWrapper__prefixDropdownButton", Bc = "h-inputWrapper--inputWrapper__suffixDropdownButton", Hc = "h-inputWrapper--inputWrapper__prefixButton", Wc = "h-inputWrapper--inputWrapper__suffixButton", Mc = "h-inputWrapper--inputWrapper__icon", lt = {
  root: Dc,
  rootDisabled: kc,
  rootActive: Tc,
  rootHasError: jc,
  rootHasWarning: Nc,
  rootHasSuccess: Fc,
  inputWrapper: Pc,
  rootWithPrefix: Rc,
  rootWithSuffix: Ec,
  suffixesContainer: Lc,
  prefix: Ac,
  suffix: $c,
  prefixDropdownButton: Oc,
  suffixDropdownButton: Bc,
  prefixButton: Hc,
  suffixButton: Wc,
  icon: Mc
}, Ns = Bt({
  position: null,
  disabled: !1,
  active: !1,
  status: "success"
}), zc = "inputWrapper";
class Vc extends D {
  renderIcon() {
    const { icon: t } = this.props;
    return t ? /* @__PURE__ */ s.jsx(N, { className: lt.icon, name: t }) : null;
  }
  isButtonAddon(t) {
    return !!t && "type" in t && t.type === "button";
  }
  isCustomAddon(t) {
    return !!t && "type" in t && (!t.type || t.type === "custom");
  }
  renderAddon(t) {
    const e = this.props[t], { disabled: n } = this.props;
    if (!e)
      return null;
    let o;
    if (typeof e != "object" || !("type" in e))
      o = /* @__PURE__ */ s.jsx("div", { className: f(lt[t]), children: e });
    else if (this.isCustomAddon(e))
      o = e.noWrap ? e.value : /* @__PURE__ */ s.jsx("div", { className: lt[t], children: e.value });
    else if (this.isButtonAddon(e)) {
      const {
        className: r,
        disabled: a,
        ...l
      } = e.button;
      o = /* @__PURE__ */ s.jsx(
        K,
        {
          className: f(
            {
              [lt[t]]: !e.noStyle,
              [lt[`${t}Button`]]: !e.noStyle
            },
            r
          ),
          disabled: n || a,
          ...l
        }
      );
    }
    return o;
  }
  getContextValue(t) {
    const { disabled: e, active: n, status: o } = this.props;
    return {
      position: t,
      disabled: !!e,
      active: !!n,
      status: o || "success"
    };
  }
  render() {
    const {
      className: t,
      disabled: e,
      active: n,
      status: o,
      prefix: r,
      suffix: a,
      icon: l,
      children: c,
      innerRef: d,
      ...h
    } = this.props, u = f(
      lt.root,
      {
        [lt.rootActive]: n,
        [lt.rootDisabled]: e,
        [lt.rootHasError]: o === "error",
        [lt.rootHasWarning]: o === "warning",
        [lt.rootHasSuccess]: o === "success",
        [lt.rootWithPrefix]: !!r,
        [lt.rootWithSuffix]: !!a
      },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": zc,
        className: u,
        ref: d,
        ...h,
        children: [
          /* @__PURE__ */ s.jsx(Ns.Provider, { value: this.getContextValue("prefix"), children: this.renderAddon("prefix") }),
          /* @__PURE__ */ s.jsx("div", { className: lt.inputWrapper, children: c }),
          /* @__PURE__ */ s.jsxs("span", { className: lt.suffixesContainer, children: [
            this.renderIcon(),
            /* @__PURE__ */ s.jsx(Ns.Provider, { value: this.getContextValue("suffix"), children: this.renderAddon("suffix") })
          ] })
        ]
      }
    );
  }
}
const Et = $(function(t, e) {
  return /* @__PURE__ */ s.jsx(Vc, { innerRef: e, ...t, children: t.children });
}), Kc = "h-colorPicker-input--colorPickerInput__input", Uc = {
  input: Kc
}, qc = ({
  className: i,
  ...t
}) => /* @__PURE__ */ s.jsx(Et, { prefix: "#", children: /* @__PURE__ */ s.jsx(
  yi,
  {
    className: f(Uc.input, i),
    "aria-label": "Enter hex value",
    placeholder: "Hex value",
    ...t
  }
) }), Gc = "h-colorPicker-presets--colorPickerPresets__root", Yc = {
  root: Gc
}, Xc = "h-colorPicker-presets-preset--colorPickerPreset__root", Qc = "h-colorPicker-presets-preset--colorPickerPreset__rootIsSelected", Zc = "h-colorPicker-presets-preset--colorPickerPreset__rootAlpha", Jc = "h-colorPicker-presets-preset--colorPickerPreset__preset", gn = {
  root: Xc,
  rootIsSelected: Qc,
  rootAlpha: Zc,
  preset: Jc
}, td = ({
  color: i,
  onSelect: t,
  isSelected: e,
  alpha: n,
  className: o
}) => /* @__PURE__ */ s.jsx(
  "li",
  {
    className: f(gn.root, o, {
      [gn.rootIsSelected]: e,
      [gn.rootAlpha]: n
    }),
    children: /* @__PURE__ */ s.jsx(
      "button",
      {
        type: "button",
        "aria-label": i,
        className: gn.preset,
        style: { backgroundColor: i },
        onClick: () => {
          t?.(i);
        }
      }
    )
  }
);
Bs([Hs]);
const ed = ({
  presets: i,
  className: t,
  onChange: e,
  color: n,
  alpha: o,
  ...r
}) => /* @__PURE__ */ s.jsx(
  B,
  {
    as: "ul",
    gap: "200",
    flexWrap: "wrap",
    className: f(Yc.root, t),
    ...r,
    children: i.map((a) => /* @__PURE__ */ s.jsx(
      td,
      {
        onSelect: e,
        color: a,
        isSelected: n === (a.startsWith("#") ? a : $n(a).toHex()),
        alpha: o
      },
      a
    ))
  }
);
Bs([Hs]);
const nd = ({
  onChange: i,
  color: t,
  alpha: e,
  className: n,
  ...o
}) => {
  const r = F((a) => {
    setTimeout(() => {
      i?.($n(a).toHex());
    });
  }, []);
  return e ? /* @__PURE__ */ s.jsx(
    Ci,
    {
      className: n,
      color: $n(t ?? "").toRgbString(),
      onChange: r,
      ...o
    }
  ) : /* @__PURE__ */ s.jsx(
    _i,
    {
      className: n,
      color: t,
      onChange: i,
      ...o
    }
  );
};
Bs([Hs]);
const sd = "colorPickerTestId", Xn = ({
  className: i,
  color: t,
  onChange: e,
  alpha: n,
  children: o,
  ...r
}) => {
  const [a, l] = V();
  return U(() => {
    const c = t?.startsWith("#") ? t : $n(t ?? "").toHex();
    l(c);
  }, [t]), /* @__PURE__ */ s.jsx(
    B,
    {
      flexDirection: "column",
      gap: "250",
      className: f(Ic.root, i),
      "data-testid": sd,
      ...r,
      children: Rt.map(
        o,
        (c) => Pt(c) && rn(c, {
          onChange: e,
          color: a,
          alpha: n,
          ...c.props
        })
      )
    }
  );
};
Xn.Input = qc;
Xn.Sliders = nd;
Xn.Presets = ed;
const od = "h-columns--columns__root", rd = {
  root: od
}, id = "1fr", ad = $(function({ as: t = "div", children: e, className: n, style: o, ...r }, a) {
  const c = Rt.toArray(e).map((d) => d.props.size ?? id).join(" ");
  return /* @__PURE__ */ s.jsx(
    t,
    {
      ...r,
      ref: a,
      className: f(rd.root, n),
      style: { ...o, gridTemplateColumns: c },
      children: e
    }
  );
}), ld = "h-columns-column--column__root", cd = {
  root: ld
}, dd = "h-columns-column-row--columnRow__root", hd = "h-columns-column-row--columnRow__noMinHeight", ud = "h-columns-column-row--columnRow__noVerticalPadding", pd = "h-columns-column-row--columnRow__noHorizontalPadding", md = "h-columns-column-row--columnRow__borderTop", gd = "h-columns-column-row--columnRow__borderBottom", fd = "h-columns-column-row--columnRow__scrollable", bd = "h-columns-column-row--columnRow__slottable", Wt = {
  root: dd,
  noMinHeight: hd,
  noVerticalPadding: ud,
  noHorizontalPadding: pd,
  borderTop: md,
  borderBottom: gd,
  scrollable: fd,
  slottable: bd
}, xd = 1, yd = $(function({
  as: t = "div",
  children: e,
  className: n,
  noVerticalPadding: o,
  noHorizontalPadding: r,
  noMinHeight: a,
  borderTop: l,
  borderBottom: c,
  scrollable: d,
  size: h,
  slottable: u,
  style: p,
  ...m
}, g) {
  const b = f(n, Wt.root, {
    [Wt.slottable]: u,
    [Wt.noVerticalPadding]: u ?? o,
    [Wt.noHorizontalPadding]: r,
    [Wt.borderTop]: l,
    [Wt.borderBottom]: c,
    [Wt.scrollable]: d,
    [Wt.noMinHeight]: a
  });
  return /* @__PURE__ */ s.jsx(
    t,
    {
      ...m,
      ref: g,
      className: b,
      style: {
        ...p,
        flexGrow: h ?? d ? xd : void 0
      },
      children: e
    }
  );
}), _d = "h-columns-column-slot--columnSlot__root", Cd = "h-columns-column-slot--columnSlot__noVerticalPadding", fo = {
  root: _d,
  noVerticalPadding: Cd
}, wd = ({
  children: i,
  className: t,
  noVerticalPadding: e,
  placement: n = "start"
}) => {
  const o = f(fo.root, t, {
    [fo.noVerticalPadding]: e
  });
  return /* @__PURE__ */ s.jsx(
    B,
    {
      alignItems: "center",
      alignSelf: "stretch",
      justifySelf: n,
      className: o,
      children: i
    }
  );
}, mt = ({
  as: i,
  children: t,
  className: e
}) => /* @__PURE__ */ s.jsx(
  B,
  {
    as: i,
    flexDirection: "column",
    className: f(cd.root, e),
    children: t
  }
);
mt.Row = yd;
mt.Slot = wd;
const vd = "h-copyToClipboard--copyToClipboard__copyToClipboard", Sd = "h-copyToClipboard--copyToClipboard__copyToClipboardTooltip", bo = {
  copyToClipboard: vd,
  copyToClipboardTooltip: Sd
};
class Id extends _t {
  timerHandle;
  static defaultProps = {
    tooltip: !0,
    disabled: !1,
    transitionDuration: 2e3,
    clickedProps: {}
  };
  constructor(t) {
    super(t), this.state = { clicked: !1 }, this.handleClick = this.handleClick.bind(this);
  }
  componentWillUnmount() {
    this.timerHandle && clearTimeout(this.timerHandle);
  }
  executeCopy(t) {
    const e = document.body;
    if (!t || !document.body)
      return;
    const n = document.createElement("textarea");
    n.value = t, n.setAttribute("readonly", ""), n.style.position = "absolute", n.style.left = "-9999px", e.appendChild(n), n.select(), document.execCommand("copy"), e.removeChild(n);
  }
  handleClick(t) {
    const { disabled: e, textToCopy: n, transitionDuration: o, onClick: r } = this.props;
    e || (typeof r == "function" && r(t), this.executeCopy(n), this.setState({ clicked: !0 }, () => {
      this.timerHandle = setTimeout(() => {
        this.setState({ clicked: !1 });
      }, o);
    }));
  }
  render() {
    const { className: t, children: e, clickedProps: n, tooltip: o } = this.props, { clicked: r } = this.state, a = f(
      bo.copyToClipboard,
      { [bo.copyToClipboardTooltip]: r && o },
      t
    );
    return /* @__PURE__ */ s.jsx("div", { className: a, children: Rt.map(e, (l) => Pt(l) ? rn(l, {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      onClick: this.handleClick.bind(this),
      ...r ? n : {}
    }) : l) });
  }
}
class Dk extends D {
  render() {
    const { buttonProps: t, ...e } = this.props;
    return /* @__PURE__ */ s.jsx(Id, { ...e, children: /* @__PURE__ */ s.jsx(K, { icon: "copy", variant: "secondary", ...t }) });
  }
}
const Dd = "h-simplePagination--simplePagination__paginationButton", xo = {
  paginationButton: Dd
}, kd = "simplePaginationTestId", Td = ({
  nextButtonClick: i = L,
  previousButtonClick: t = L,
  nextButtonText: e = "Next page",
  previousButtonText: n = "Previous page",
  nextButtonDisabled: o = !1,
  previousButtonDisabled: r = !1,
  nextButtonHidden: a = !1,
  previousButtonHidden: l = !1,
  nextButtonExtraProps: c,
  previousButtonExtraProps: d,
  loading: h = !1,
  loadingText: u = "Loading...",
  ...p
}) => /* @__PURE__ */ s.jsxs("div", { "data-testid": kd, ...p, children: [
  !l && /* @__PURE__ */ s.jsx(
    X,
    {
      disabled: r || h,
      onClick: t,
      variant: "secondary",
      ...d,
      className: f(
        xo.paginationButton,
        d?.className
      ),
      children: h ? u : n
    }
  ),
  !a && /* @__PURE__ */ s.jsx(
    X,
    {
      disabled: o || h,
      onClick: i,
      variant: "secondary",
      ...c,
      className: f(
        xo.paginationButton,
        c?.className
      ),
      children: h ? u : e
    }
  )
] }), Qn = Bt(
  void 0
);
var dt = /* @__PURE__ */ ((i) => (i.Foot = "table-foot", i.Body = "table-body", i.Head = "table-head", i.Row = "table-row", i.PaginationRow = "table-pagination-row", i.Td = "table-body-cell", i.Th = "table-header-cell", i.RowExpansionTrigger = "table-row-expansion-trigger", i.LoadingRow = "table-loading-row", i.LoadingFailedRow = "table-loading-failed-row", i.EmptyRow = "table-empty-row", i))(dt || {});
const jd = "h-table-tfoot--tfoot__root", Nd = "h-table-tfoot--tfoot__rootIsLoading", yo = {
  root: jd,
  rootIsLoading: Nd
}, Sr = Bt(
  void 0
), _o = ({ className: i, children: t, ...e }, n) => /* @__PURE__ */ s.jsx(Qn.Consumer, { children: (o) => o?.status.loading && ["spinner"].includes(o?.loading.loadingStrategy) ? null : /* @__PURE__ */ s.jsx(Sr.Provider, { value: { isTableFoot: !0 }, children: /* @__PURE__ */ s.jsx(
  "tfoot",
  {
    ...e,
    ref: n,
    className: f(
      {
        [yo.rootIsLoading]: o?.status.loading
      },
      yo.root,
      i
    ),
    "data-testid": dt.Foot,
    children: t
  }
) }) }), Fd = Object.assign($(_o), { name: _o.name }), Pd = "h-table-thead--thead__root", Rd = "h-table-thead--thead__rootIsLoading", Co = {
  root: Pd,
  rootIsLoading: Rd
}, Ir = Bt(
  void 0
), wo = ({ className: i, ...t }, e) => /* @__PURE__ */ s.jsx(Qn.Consumer, { children: (n) => {
  const o = f(Co.root, i, {
    [Co.rootIsLoading]: n?.status.loading
  });
  return /* @__PURE__ */ s.jsx(Ir.Provider, { value: { isTableHead: !0 }, children: /* @__PURE__ */ s.jsx(
    "thead",
    {
      ...t,
      ref: e,
      className: o,
      "data-testid": dt.Head
    }
  ) });
} }), Ed = Object.assign($(wo), { name: wo.name }), Pe = (i) => {
  const t = Gt(Qn);
  if (!t)
    throw new Error(
      "TableContext not accessible. Make sure <TableContextReader> is a child of <Table>"
    );
  const e = Gt(Ir) || {
    isTableHead: !1
  }, n = Gt(Sr) || {
    isTableFoot: !1
  };
  return i.children({
    ...t,
    ...e,
    ...n
  });
}, Ld = "h-table-tableFooter--tableFooter__root", Ad = "h-table-tableFooter--tableFooter__rootIsLoading", vo = {
  root: Ld,
  rootIsLoading: Ad
}, So = ({ children: i, className: t, ...e }, n) => /* @__PURE__ */ s.jsx(Pe, { children: ({ status: o }) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ref: n,
    className: f(
      {
        [vo.rootIsLoading]: o.loading
      },
      vo.root,
      t
    ),
    ...e,
    children: i
  }
) }), Us = Object.assign($(So), {
  name: So.name
});
function $d(i) {
  return Rt.toArray(i).reduce(
    (t, e) => {
      const n = e;
      return n.type === Us ? t.footers.push(n) : t.children.push(n), t;
    },
    { children: [], footers: [] }
  );
}
var Bn = /* @__PURE__ */ ((i) => (i.PageNumber = "page-number", i.PrevPageButton = "prev-page-button", i.NextPageButton = "next-page-button", i))(Bn || {});
const Od = "h-pagination--pageNumber__button", Bd = "h-pagination--pageNumber__text", Hd = "h-pagination--pageNumber__textSelected", cs = {
  button: Od,
  text: Bd,
  textSelected: Hd
}, Wd = ({
  number: i,
  isSelected: t = !1,
  onClick: e
}) => {
  const n = f(cs.text, {
    [cs.textSelected]: t
  });
  return /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
    X,
    {
      styleText: !1,
      variant: "tertiary",
      onClick: () => e(i),
      "data-testid": Bn.PageNumber,
      className: cs.button,
      children: /* @__PURE__ */ s.jsx("span", { className: n, children: i })
    }
  ) });
}, Md = "h-pagination--pagination__root", zd = "h-pagination--pagination__pageNumberSeparatorWrapper", Io = {
  root: Md,
  pageNumberSeparatorWrapper: zd
};
class Vd extends _t {
  static defaultProps = {
    pageRangeDisplayed: 6
  };
  constructor(t) {
    super(t), this.handlePageSelect = this.handlePageSelect.bind(this), this.goToPrevPage = this.goToPrevPage.bind(this), this.goToNextPage = this.goToNextPage.bind(this);
  }
  arePropsValid() {
    const { currentPage: t, pageCount: e, pageRangeDisplayed: n } = this.props, o = (r) => !Number.isNaN(r) && Number.isInteger(r) && r > 0;
    return [t, e, n].every(
      o
    );
  }
  thereIsEnoughPagesToRender() {
    return this.props.pageCount > 1;
  }
  getBoundaries() {
    return {
      canGoToPrevPage: this.props.currentPage > 1,
      canGoToNextPage: this.props.currentPage < this.props.pageCount
    };
  }
  goToPrevPage() {
    this.getBoundaries().canGoToPrevPage && this.handlePageSelect(this.props.currentPage - 1);
  }
  goToNextPage() {
    this.getBoundaries().canGoToNextPage && this.handlePageSelect(this.props.currentPage + 1);
  }
  handlePageSelect(t) {
    const { currentPage: e, onPageChange: n } = this.props;
    t !== e && n(t);
  }
  areAllPagedDisplayable() {
    const { pageCount: t, pageRangeDisplayed: e } = this.props;
    return e >= t;
  }
  leadingTruncationIsNeeded() {
    const { start: e } = this.calculateMiddlePagesRange();
    return e - 1 > 1;
  }
  trailingTruncationIsNeeded() {
    const { pageCount: t } = this.props, { start: e, length: n } = this.calculateMiddlePagesRange(), o = e - 1 + n;
    return t - o > 1;
  }
  getMiddlePagesLength() {
    const { pageRangeDisplayed: t } = this.props;
    return t - 2;
  }
  calculateMiddlePagesRange(t) {
    const { pageCount: e, currentPage: n } = this.props, o = Math.max(
      this.getMiddlePagesLength() - (t?.extraPadding ?? 0),
      1
    ), r = o % 2 === 0 ? o / 2 - 1 : Math.floor(o / 2);
    return { start: Rn(
      n - r,
      2,
      e - o
    ), length: o };
  }
  createPageNumbers(t, e = 1) {
    return Array.from({ length: t }, (n, o) => o + e);
  }
  renderPageNumbers(t, e = 1) {
    return this.createPageNumbers(t, e).map(
      (n) => this.renderSinglePageNumber(n)
    );
  }
  renderSinglePageNumber(t) {
    const { currentPage: e } = this.props, n = t === e;
    return /* @__PURE__ */ s.jsx(
      Wd,
      {
        number: t,
        isSelected: n,
        onClick: this.handlePageSelect
      },
      t
    );
  }
  renderAllPages() {
    return this.renderPageNumbers(this.props.pageCount);
  }
  renderGap(t = 0) {
    return /* @__PURE__ */ s.jsx("li", { className: Io.pageNumberSeparatorWrapper, children: /* @__PURE__ */ s.jsx(Bi, { name: "dots-h" }) }, `gap-${t}`);
  }
  renderLeadingTruncation() {
    return this.leadingTruncationIsNeeded() ? [this.renderSinglePageNumber(1), this.renderGap()] : this.renderSinglePageNumber(1);
  }
  renderTrailingTruncation() {
    const { pageCount: t } = this.props;
    return this.trailingTruncationIsNeeded() ? [this.renderGap(), this.renderSinglePageNumber(t)] : this.renderSinglePageNumber(t);
  }
  renderMiddlePageNumbers() {
    if (this.leadingTruncationIsNeeded() && this.trailingTruncationIsNeeded()) {
      const { start: n, length: o } = this.calculateMiddlePagesRange({
        extraPadding: 1
      });
      return this.renderPageNumbers(o, n);
    }
    const { start: t, length: e } = this.calculateMiddlePagesRange();
    return this.renderPageNumbers(e, t);
  }
  renderPages() {
    return this.areAllPagedDisplayable() ? this.renderAllPages() : [
      this.renderLeadingTruncation(),
      this.renderMiddlePageNumbers(),
      this.renderTrailingTruncation()
    ];
  }
  warnAboutBadProps() {
    console.error("Pagination can not render due to bad props", this.props);
  }
  render() {
    const { className: t } = this.props;
    return this.thereIsEnoughPagesToRender() ? this.arePropsValid() ? /* @__PURE__ */ s.jsxs("ul", { className: f(Io.root, t), children: [
      /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
        K,
        {
          icon: "angle-left",
          variant: "tertiary",
          onClick: this.goToPrevPage,
          disabled: !this.getBoundaries().canGoToPrevPage,
          "data-testid": Bn.PrevPageButton
        }
      ) }),
      this.renderPages(),
      /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
        K,
        {
          icon: "angle-right",
          variant: "tertiary",
          onClick: this.goToNextPage,
          disabled: !this.getBoundaries().canGoToNextPage,
          "data-testid": Bn.NextPageButton
        }
      ) })
    ] }) : (this.warnAboutBadProps(), null) : null;
  }
}
const Do = ({ children: i, ...t }, e) => /* @__PURE__ */ s.jsx(Pe, { children: ({ pagination: n }) => !n.paginated || n.pageCount <= 1 ? null : /* @__PURE__ */ s.jsx(Us, { children: /* @__PURE__ */ s.jsx("div", { ref: e, ...t, "data-testid": dt.PaginationRow, children: /* @__PURE__ */ s.jsx(B, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
  Vd,
  {
    currentPage: n.selectedPage,
    pageCount: n.pageCount,
    onPageChange: n.onPageChange,
    pageRangeDisplayed: n.pageRangeDisplayed
  }
) }) }) }) }), Kd = Object.assign($(Do), {
  name: Do.name
}), Ud = "h-table-tbody--tbody__root", qd = "h-table-tbody--tbody__rootIsLoading", Gd = "h-table-tbody--tbody__rootIsLoadingFade", ds = {
  root: Ud,
  rootIsLoading: qd,
  rootIsLoadingFade: Gd
}, Yd = "h-emptyState--emptyState__textWrapper", Xd = "h-emptyState--emptyState__rootSmall", Qd = "h-emptyState--emptyState__rootLarge", hs = {
  textWrapper: Yd,
  rootSmall: Xd,
  rootLarge: Qd
}, Zd = ({
  className: i,
  title: t,
  description: e,
  icon: n = "info",
  iconColor: o = "neutral.500",
  size: r = "large",
  buttonProps: a
}) => {
  const l = f(
    {
      [hs.rootSmall]: r === "small",
      [hs.rootLarge]: r === "large"
    },
    i
  );
  return /* @__PURE__ */ s.jsxs(
    B,
    {
      flexDirection: "column",
      alignItems: "center",
      gap: "300",
      className: l,
      children: [
        n && /* @__PURE__ */ s.jsx(N, { name: n, size: 20, color: tn(o) }),
        /* @__PURE__ */ s.jsxs(
          B,
          {
            flexDirection: "column",
            alignItems: "center",
            gap: "100",
            className: hs.textWrapper,
            children: [
              /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "1", children: t }),
              /* @__PURE__ */ s.jsx(
                A.Paragraph,
                {
                  variant: "2",
                  as: typeof e == "string" ? "p" : "div",
                  children: e
                }
              )
            ]
          }
        ),
        a?.children && /* @__PURE__ */ s.jsx(X, { ...a })
      ]
    }
  );
};
function Jd(i) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": dt.EmptyRow, children: /* @__PURE__ */ s.jsx("td", { colSpan: 100, children: /* @__PURE__ */ s.jsx(B, { justifyContent: "center", alignItems: "center", padding: "500", children: /* @__PURE__ */ s.jsx(Zd, { ...i }) }) }) });
}
function th({
  onRetry: i,
  ...t
}) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": dt.LoadingFailedRow, ...t, children: /* @__PURE__ */ s.jsx("td", { colSpan: 100, children: /* @__PURE__ */ s.jsxs(
    B,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: "Something went wrong..." }),
        i && /* @__PURE__ */ s.jsx(X, { variant: "tertiary", onClick: i, children: "Try again" })
      ]
    }
  ) }) });
}
function eh({
  ...i
}) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": dt.LoadingRow, ...i, children: /* @__PURE__ */ s.jsx("td", { align: "center", colSpan: 100, children: /* @__PURE__ */ s.jsxs(
    B,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ s.jsx(Un, {}),
        /* @__PURE__ */ s.jsx(at, { margin: "300", children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: "Loading..." }) })
      ]
    }
  ) }) });
}
const ko = ({ children: i, className: t, ...e }, n) => /* @__PURE__ */ s.jsx(Pe, { children: ({
  status: { loading: o, loadingFailed: r, onLoadingRetry: a, emptyState: l },
  loading: { loadingStrategy: c }
}) => {
  const d = r && !o, h = ["spinner"].includes(c) ? !o && !d : !d;
  return /* @__PURE__ */ s.jsxs(
    "tbody",
    {
      ...e,
      "data-testid": dt.Body,
      ref: n,
      className: f(
        {
          [ds.rootIsLoading]: o,
          [ds.rootIsLoadingFade]: o && c === "fade"
        },
        ds.root,
        t
      ),
      children: [
        c === "spinner" && o && /* @__PURE__ */ s.jsx(eh, {}),
        d && /* @__PURE__ */ s.jsx(th, { onRetry: a }),
        l && /* @__PURE__ */ s.jsx(Jd, { ...l }),
        h && i
      ]
    }
  );
} }), nh = Object.assign($(ko), { name: ko.name }), sh = "h-table-td--td__root", oh = "h-table-td--td__rootExtraPaddingForFirstChild", rh = "h-table-td--td__rootStickyFooterTd", us = {
  root: sh,
  rootExtraPaddingForFirstChild: oh,
  rootStickyFooterTd: rh
}, To = ({ className: i, children: t, ...e }, n) => /* @__PURE__ */ s.jsx(Pe, { children: ({ rows: o, presentation: r, isTableFoot: a }) => {
  const l = f(
    us.root,
    {
      [us.rootExtraPaddingForFirstChild]: !o.expandableRows,
      [us.rootStickyFooterTd]: r.stickyFooter === !0 && a === !0
    },
    i
  );
  return /* @__PURE__ */ s.jsx(
    at,
    {
      as: "td",
      ref: n,
      className: l,
      ...e,
      "data-testid": dt.Td,
      children: t
    }
  );
} }), ie = Object.assign($(To), { name: To.name }), ih = "h-table-th--th__root", ah = "h-table-th--th__rootSticky", lh = "h-table-th--th__rootShowBG", ch = "h-table-th--th__rootClickable", dh = "h-table-th--th__icon", hh = "h-table-th--th__contentWrapper", uh = "h-table-th--th__tooltip", te = {
  root: ih,
  rootSticky: ah,
  rootShowBG: lh,
  rootClickable: ch,
  icon: dh,
  contentWrapper: hh,
  tooltip: uh
};
class jo extends D {
  context = void 0;
  columnIsInSortableColumns() {
    return this.context?.sorting.sortableColumns?.some(
      (t) => t === this.props.columnId
    ) ?? !0;
  }
  getContextualInfo() {
    const { columnId: t } = this.props, { context: e } = this;
    return {
      sortByThisColumn: e?.sorting.sortStatus?.sortBy === t,
      sortDirection: e?.sorting.sortStatus?.direction,
      columnIsSortable: e?.sorting.sortable && !yt(t) ? this.columnIsInSortableColumns() : !1
    };
  }
  getTheNewSortDirection(t) {
    const { sortByThisColumn: e, sortDirection: n } = this.getContextualInfo(), o = {
      sortBy: t,
      direction: "asc"
    };
    if (!e)
      return o;
    switch (n) {
      // not sorted => make it asc
      case void 0:
        return o;
      // desc sorted => not sorted
      case "desc":
        return null;
      // asc sorted => make it desc
      case "asc":
        return {
          sortBy: t,
          direction: "desc"
        };
      default:
        return o;
    }
  }
  getClickHandler() {
    const { onClick: t } = this.props, { context: e } = this;
    return (n) => {
      const { columnIsSortable: o } = this.getContextualInfo(), { columnId: r } = this.props;
      t?.(n), o && !yt(r) && e?.sorting.onSortChange(this.getTheNewSortDirection(r));
    };
  }
  renderIcon(t) {
    return t ? /* @__PURE__ */ s.jsx(
      N,
      {
        className: te.icon,
        name: t === "asc" ? "sort-up" : "sort-down"
      }
    ) : null;
  }
  warnAboutNoColumnIdProps() {
    console.error(`
      <Table.Th> needs a 'columnId' prop when table is sortable.
      Pass 'columndId: null' prop if you want that column not to be sortable.
    `);
  }
  render() {
    return /* @__PURE__ */ s.jsx(Pe, { children: (t) => {
      this.context = t;
      const { sorting: e, presentation: n } = t;
      e.sortable && this.props.columnId === void 0 && this.warnAboutNoColumnIdProps();
      const {
        className: o,
        children: r,
        tooltip: a,
        columnId: l,
        thRef: c,
        ...d
      } = this.props, { sortByThisColumn: h, columnIsSortable: u, sortDirection: p } = this.getContextualInfo(), m = f(
        te.root,
        {
          [te.rootClickable]: u,
          [te.rootSticky]: n.stickyHeader,
          [te.rootShowBG]: n.headerWithBackground
        },
        o
      ), g = f({
        [te.tooltip]: a
      });
      return /* @__PURE__ */ s.jsx(
        at,
        {
          as: "th",
          ...d,
          ref: c,
          className: m,
          onClick: this.getClickHandler(),
          "data-testid": dt.Th,
          children: /* @__PURE__ */ s.jsxs("span", { className: te.contentWrapper, children: [
            /* @__PURE__ */ s.jsx(st, { content: a, disabled: !a, children: /* @__PURE__ */ s.jsx("span", { className: g, children: r }) }),
            h && this.renderIcon(p)
          ] })
        }
      );
    } });
  }
}
const Fs = Object.assign(
  $(
    function(t, e) {
      return /* @__PURE__ */ s.jsx(jo, { ...t, thRef: e });
    }
  ),
  { name: jo.name }
), ph = (i) => i === !1, mh = "h-table-tr--tr__trHoverable", gh = "h-table-tr--tr__expansionTriggerWrapper", fh = "h-table-tr--tr__expansionTriggerWrapperExpanded", bh = "h-table-tr--tr__checkboxCell", xh = "h-table-tr--tr__checkboxCellExpanded", yh = "h-table-tr--tr__expandedRowContentWrapper", St = {
  trHoverable: mh,
  expansionTriggerWrapper: gh,
  expansionTriggerWrapperExpanded: fh,
  checkboxCell: bh,
  checkboxCellExpanded: xh,
  expandedRowContentWrapper: yh
}, _h = ({
  rowId: i,
  isExpandable: t,
  isExpanded: e,
  onExpansionToggle: n,
  expandableContent: o,
  isSelectable: r,
  isSelected: a,
  onSelect: l,
  isHoverable: c,
  children: d,
  trRef: h,
  ...u
}) => {
  const p = f(u.className, {
    [St.trHoverable]: c
  }) || void 0;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(
      "tr",
      {
        ...u,
        ref: h,
        className: p,
        "data-testid": dt.Row,
        children: [
          t && /* @__PURE__ */ s.jsx(
            ie,
            {
              className: f(St.expansionTriggerWrapper, {
                [St.expansionTriggerWrapperExpanded]: e
              }),
              children: o && /* @__PURE__ */ s.jsx(
                K,
                {
                  variant: "tertiary",
                  icon: e ? "angle-down" : "angle-right",
                  "data-testid": dt.RowExpansionTrigger,
                  onClick: () => {
                    yt(i) || n(i);
                  }
                }
              )
            }
          ),
          r && /* @__PURE__ */ s.jsx(
            ie,
            {
              className: f(St.checkboxCell, {
                [St.checkboxCellExpanded]: e
              }),
              children: /* @__PURE__ */ s.jsx(B, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
                cn,
                {
                  checked: a,
                  name: `selection-trigger-${i}`,
                  id: `selection-trigger-${i}`,
                  onChange: () => {
                    yt(i) || l(i);
                  }
                }
              ) })
            }
          ),
          d
        ]
      }
    ),
    t && e && /* @__PURE__ */ s.jsxs("tr", { "data-testid": dt.Row, children: [
      /* @__PURE__ */ s.jsx(ie, { className: St.expansionTriggerWrapper }),
      r && /* @__PURE__ */ s.jsx(ie, { className: St.checkboxCell }),
      /* @__PURE__ */ s.jsx(
        ie,
        {
          colSpan: Number.MAX_SAFE_INTEGER,
          className: St.expandedRowContentWrapper,
          children: o
        }
      )
    ] })
  ] });
}, Ch = ({
  isExpandable: i,
  children: t,
  trRef: e,
  ...n
}) => /* @__PURE__ */ s.jsxs("tr", { ...n, ref: e, "data-testid": dt.Row, children: [
  i && /* @__PURE__ */ s.jsx(ie, { className: St.expansionTriggerWrapper, children: /* @__PURE__ */ s.jsx("span", {}) }),
  t
] }), wh = ({
  isExpandable: i,
  isSelectable: t,
  allRowsSelected: e,
  allRowsSelectedIndeterminate: n,
  onAllRowsSelect: o,
  children: r,
  trRef: a,
  ...l
}) => /* @__PURE__ */ s.jsxs("tr", { ...l, ref: a, "data-testid": dt.Row, children: [
  i && /* @__PURE__ */ s.jsx(Fs, { className: St.expansionTriggerWrapper, columnId: null, children: /* @__PURE__ */ s.jsx("span", {}) }),
  t && /* @__PURE__ */ s.jsx(Fs, { className: St.checkboxCell, columnId: null, children: /* @__PURE__ */ s.jsx(B, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
    cn,
    {
      checked: e,
      indeterminate: n,
      onChange: o,
      name: "all-rows-selector",
      id: "all-rows-selector"
    }
  ) }) }),
  r
] });
class No extends D {
  context = void 0;
  isRowExpanded(t, e) {
    return t.includes(e);
  }
  hasSelectableRow() {
    const { rowId: t } = this.props;
    return this.context?.rows.selectableRows === !0 && !yt(t);
  }
  hasExpandableRow() {
    const { expandableContent: t, rowId: e } = this.props;
    return this.context?.rows.expandableRows === !0 && !yt(t) && !yt(e);
  }
  shouldRenderRegularTr() {
    return [this.hasExpandableRow(), this.hasSelectableRow()].every(ph);
  }
  rowIdIsPresent(t) {
    return !yt(t);
  }
  render() {
    const { children: t, expandableContent: e, rowId: n, ...o } = this.props;
    return /* @__PURE__ */ s.jsx(Pe, { children: (r) => {
      this.context = r;
      const { rows: a } = r;
      if (r.isTableHead)
        return /* @__PURE__ */ s.jsx(
          wh,
          {
            ...o,
            isExpandable: a.expandableRows,
            isSelectable: a.selectableRows,
            allRowsSelected: a.allRowsSelected,
            allRowsSelectedIndeterminate: a.allRowsSelectedIndeterminate,
            onAllRowsSelect: a.onAllRowsSelect,
            children: t
          }
        );
      if (r.isTableFoot)
        return /* @__PURE__ */ s.jsx(Ch, { ...o, isExpandable: a.expandableRows, children: t });
      const l = yt(n) ? !1 : this.isRowExpanded(a.expandedRows, n), c = yt(n) ? !1 : a.selectedRowIds.includes(n);
      return /* @__PURE__ */ s.jsx(
        _h,
        {
          ...o,
          rowId: n,
          isExpanded: l,
          isSelected: c,
          onSelect: a.onRowSelect,
          isExpandable: a.expandableRows,
          expandableContent: e,
          isSelectable: a.selectableRows,
          onExpansionToggle: a.onExpansionToggle,
          isHoverable: r.presentation.hoverable,
          children: t
        }
      );
    } });
  }
}
const vh = Object.assign(
  $(function(t, e) {
    return /* @__PURE__ */ s.jsx(No, { ...t, trRef: e });
  }),
  { name: No.name }
), Sh = "h-table--table__wrapper", Ih = "h-table--table__wrapperIsFramed", Dh = "h-table--table__wrapperIsLoading", kh = "h-table--table__innerWrapper", Th = "h-table--table__wrapperIsDisabled", jh = "h-table--table__table", pe = {
  wrapper: Sh,
  wrapperIsFramed: Ih,
  wrapperIsLoading: Dh,
  innerWrapper: kh,
  wrapperIsDisabled: Th,
  table: jh
};
class Hn extends D {
  static defaultProps = {
    headerWithBackground: !0,
    stickyHeader: !1,
    stickyFooter: !1,
    framed: !0,
    hoverable: !1,
    loadingStrategy: "spinner"
  };
  constructor(t) {
    super(t), this.state = {
      expandedRows: t.expandableRowsProps?.initiallyExpandedRows ?? []
    }, this.handleExpansionToggle = this.handleExpansionToggle.bind(this);
  }
  static fallback = /* @__PURE__ */ s.jsx(
    B,
    {
      justifyContent: "center",
      alignItems: "center",
      style: { minHeight: "10vh" },
      children: /* @__PURE__ */ s.jsx(A.Paragraph, { children: "Oops! something went wrong..." })
    }
  );
  handleExpansionToggle(t) {
    this.state.expandedRows.includes(t) ? this.setState(({ expandedRows: e }) => ({
      expandedRows: e.filter((n) => n !== t)
    })) : this.setState(({ expandedRows: e }) => ({
      expandedRows: [...e, t]
    }));
  }
  getContextValue() {
    const {
      props: {
        headerWithBackground: t,
        stickyHeader: e,
        stickyFooter: n,
        sortingProps: o,
        paginationProps: r,
        selectableRowsProps: a,
        expandableRowsProps: l,
        loading: c,
        loadingFailed: d,
        onLoadingRetry: h,
        emptyState: u,
        loadingStrategy: p,
        hoverable: m
      }
    } = this;
    return {
      status: {
        loading: c ?? !1,
        loadingFailed: d ?? !1,
        onLoadingRetry: h,
        emptyState: u
      },
      presentation: {
        headerWithBackground: !!t,
        stickyHeader: !!e,
        stickyFooter: !!n,
        hoverable: !!m
      },
      sorting: {
        sortable: !!o,
        sortableColumns: o?.sortableColumns,
        sortStatus: o?.sortStatus ?? null,
        onSortChange: o?.onSortChange ?? L
      },
      pagination: {
        paginated: !!r,
        selectedPage: r?.selectedPage ?? 1,
        pageCount: r?.pageCount ?? 1,
        onPageChange: r?.onPageChange ?? L,
        pageRangeDisplayed: r?.pageRangeDisplayed
      },
      rows: {
        expandableRows: l?.expandableRows ?? !1,
        expandedRows: this.state.expandedRows,
        onExpansionToggle: this.handleExpansionToggle,
        selectableRows: !!a,
        selectedRowIds: a?.selectedRowIds ?? [],
        onRowSelect: a?.onRowSelect ?? L,
        onAllRowsSelect: a?.onAllRowsSelect ?? L,
        allRowsSelected: a?.allRowsSelected ?? !1,
        allRowsSelectedIndeterminate: a?.allRowsSelectedIndeterminate ?? !1
      },
      loading: {
        loadingStrategy: p ?? "spinner"
      }
    };
  }
  render() {
    const {
      framed: t,
      className: e,
      children: n,
      wrapperProps: o,
      wrapperRef: r,
      innerWrapperClassName: a,
      nativeProps: l,
      tableRef: c
    } = this.props, d = $d(n), h = f(pe.wrapper, o?.className, {
      [pe.wrapperIsFramed]: t,
      [pe.wrapperIsLoading]: this.props.loading,
      [pe.wrapperIsDisabled]: this.props.loading && this.props.loadingStrategy && ["fade", "disabled"].includes(this.props.loadingStrategy)
    }), u = f(
      {
        [pe.innerWrapper]: !0
      },
      a
    ), p = f(pe.table, e), m = this.getContextValue();
    return /* @__PURE__ */ s.jsx(zs, { fallback: Hn.fallback, children: /* @__PURE__ */ s.jsx(Qn.Provider, { value: m, children: /* @__PURE__ */ s.jsxs("div", { ...o, className: h, children: [
      /* @__PURE__ */ s.jsx("div", { className: u, ref: r, children: /* @__PURE__ */ s.jsx("table", { ...l, ref: c, className: p, children: d.children }) }),
      m.pagination.paginated && /* @__PURE__ */ s.jsx(Kd, {}),
      !m.pagination.paginated && d.footers
    ] }) }) });
  }
}
const gt = Object.assign(
  $(
    function(t, e) {
      return /* @__PURE__ */ s.jsx(Hn, { ...t, tableRef: e });
    }
  ),
  {
    name: Hn.name,
    Thead: Ed,
    Tbody: nh,
    Tfoot: Fd,
    Tr: vh,
    Th: Fs,
    Td: ie,
    Footer: Us
  }
), Nh = "h-helpIcon--helpIcon__infoIcon", Fh = {
  infoIcon: Nh
};
class qs extends D {
  render() {
    const {
      side: t,
      text: e,
      title: n,
      disabled: o,
      requireClick: r,
      className: a,
      alwaysShow: l,
      tooltipClassName: c,
      ...d
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      st,
      {
        head: n,
        content: e,
        disabled: o,
        side: t,
        requireClick: r,
        alwaysShow: l,
        className: c,
        wrap: "none",
        ...d,
        children: /* @__PURE__ */ s.jsx("span", { className: f(Fh.infoIcon, a), children: /* @__PURE__ */ s.jsx(N, { name: "info" }) })
      }
    );
  }
}
const Dr = ({
  columns: i
}) => /* @__PURE__ */ s.jsx(s.Fragment, { children: i.map(({ label: t, style: e, helpIcon: n, columnId: o }, r) => /* @__PURE__ */ s.jsxs(gt.Th, { columnId: o || t, style: e, children: [
  t,
  n?.title && n?.text && /* @__PURE__ */ s.jsx(qs, { side: "bottom", ...n })
] }, t || r)) }), Ph = ({
  columns: i,
  data: t
}) => /* @__PURE__ */ s.jsxs(gt, { headerWithBackground: !1, framed: !1, children: [
  /* @__PURE__ */ s.jsx(gt.Thead, { children: /* @__PURE__ */ s.jsx(gt.Tr, { children: /* @__PURE__ */ s.jsx(Dr, { columns: i }) }) }),
  /* @__PURE__ */ s.jsx(gt.Tbody, { children: t.map((e, n) => /* @__PURE__ */ s.jsx(gt.Tr, { children: i.map(({ selector: o }, r) => /* @__PURE__ */ s.jsx(gt.Td, { children: o(e) }, r)) }, n)) })
] }), Rh = ({
  data: i,
  rowId: t,
  columns: e,
  subTableColumns: n,
  subTableDataSelector: o
}) => /* @__PURE__ */ s.jsx(
  gt.Tr,
  {
    expandableContent: !!(n && o) && /* @__PURE__ */ s.jsx(
      Ph,
      {
        data: o(i),
        columns: n
      }
    ),
    rowId: t,
    children: e.map(({ selector: r }, a) => /* @__PURE__ */ s.jsx(gt.Td, { children: r(i) }, a))
  }
), kk = ({
  columns: i,
  subTableColumns: t,
  data: e,
  subTableDataSelector: n,
  tableWrapperProps: o,
  tableInnerWrapperClassName: r,
  paginationProps: a,
  sortingProps: l,
  selectableRowsProps: c,
  tableStyleProps: d,
  tableStatusProps: h,
  tableRowIdSelector: u,
  tableLoadingStrategy: p,
  tableWrapperRef: m
}) => {
  const g = i.filter((b) => b.sortable).reduce(
    (b, x) => x.columnId ? [...b, x.columnId] : b,
    []
  );
  return g.length && l && (l.sortableColumns = g), /* @__PURE__ */ s.jsxs(
    gt,
    {
      stickyHeader: !0,
      wrapperProps: o,
      innerWrapperClassName: r,
      expandableRowsProps: {
        expandableRows: !!(t && n)
      },
      sortingProps: l,
      selectableRowsProps: c,
      loadingStrategy: p,
      wrapperRef: m,
      ...d,
      ...h,
      children: [
        /* @__PURE__ */ s.jsx(gt.Thead, { children: /* @__PURE__ */ s.jsx(gt.Tr, { children: /* @__PURE__ */ s.jsx(Dr, { columns: i }) }) }),
        /* @__PURE__ */ s.jsx(gt.Tbody, { children: e.map((b, x) => /* @__PURE__ */ s.jsx(
          Rh,
          {
            rowId: u ? u(b) : x,
            data: b,
            columns: i,
            subTableDataSelector: n,
            subTableColumns: t
          },
          x
        )) }),
        a && /* @__PURE__ */ s.jsx(gt.Footer, { children: /* @__PURE__ */ s.jsx(Td, { ...a }) })
      ]
    }
  );
}, Eh = "h-datePickerOld--datePickerDay__root", Lh = "h-datePickerOld--datePickerDay__rootActive", Ah = "h-datePickerOld--datePickerDay__rootDisabled", $h = "h-datePickerOld--datePickerDay__rootDim", Oh = "h-datePickerOld--datePickerDay__label", Oe = {
  root: Eh,
  rootActive: Lh,
  rootDisabled: Ah,
  rootDim: $h,
  label: Oh
};
class Bh extends D {
  render() {
    const {
      className: t,
      dim: e,
      active: n,
      disabled: o,
      children: r,
      onClick: a,
      ...l
    } = this.props, c = f(
      {
        [Oe.root]: !0,
        [Oe.rootDim]: e,
        [Oe.rootActive]: n,
        [Oe.rootDisabled]: !n && o
      },
      t
    );
    return /* @__PURE__ */ s.jsx(
      "button",
      {
        ...l,
        onClick: a,
        className: c,
        disabled: o,
        children: /* @__PURE__ */ s.jsx("span", { className: Oe.label, children: r })
      }
    );
  }
}
const Hh = "h-datePickerOld--datePickerOld__grid", Wh = "h-datePickerOld--datePickerOld__gridItem", Mh = "h-datePickerOld--datePickerOld__day", zh = "h-datePickerOld--datePickerOld__month", Vh = "h-datePickerOld--datePickerOld__timeButtonContainerLeft", Kh = "h-datePickerOld--datePickerOld__timeButtonContainerRight", Uh = "h-datePickerOld--datePickerOld__arrowTime", qh = "h-datePickerOld--datePickerOld__arrow", Gh = "h-datePickerOld--datePickerOld__dayNames", Yh = "h-datePickerOld--datePickerOld__dayName", Xh = "h-datePickerOld--datePickerOld__time", Qh = "h-datePickerOld--datePickerOld__timeDisplay", Y = {
  grid: Hh,
  gridItem: Wh,
  day: Mh,
  month: zh,
  timeButtonContainerLeft: Vh,
  timeButtonContainerRight: Kh,
  arrowTime: Uh,
  arrow: qh,
  dayNames: Gh,
  dayName: Yh,
  time: Xh,
  timeDisplay: Qh
}, Tk = (i) => [0, 6].indexOf(i.getDay()) !== -1;
class Ze extends D {
  static defaultProps;
  static getDateValue(t) {
    const e = t.value instanceof Date ? t.value : /* @__PURE__ */ new Date();
    return new Date(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes()
    );
  }
  constructor(t) {
    super(t);
    const e = Ze.getDateValue(t.input);
    this.state = {
      selectedDate: e,
      showDate: e
    };
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(t) {
    const { input: e } = this.props;
    t.input !== e && this.setState({
      selectedDate: Ze.getDateValue(t.input)
    });
  }
  generateGrid() {
    const { selectedDate: t, showDate: e } = this.state, { input: n, disabled: o, minDate: r, maxDate: a } = this.props, l = [], c = new Date(
      e.getFullYear(),
      e.getMonth(),
      1,
      t.getHours(),
      t.getMinutes()
    ), d = c.getDay() || 7, h = new Date(
      c.getFullYear(),
      c.getMonth() + 1,
      1
    );
    d < 3 && c.setDate(c.getDate() - 7), c.setDate(c.getDate() - (d - 1));
    const u = Ze.getDateValue(n).getTime();
    let p = 0;
    for (; c < h || c.getDay() !== 1 || p < 6; ) {
      const m = c.getTime(), g = new Date(m);
      l.push({
        date: g,
        label: c.getDate().toString(),
        isThisMonth: c.getMonth() === e.getMonth(),
        selected: m === u,
        disabled: o(c) || !!(a && g > a) || !!(r && g < r)
      }), c.getDay() === 1 && (p += 1), c.setDate(c.getDate() + 1);
    }
    return l;
  }
  goToMonth(t) {
    const { showDate: e } = this.state, n = new Date(e.getTime());
    n.setMonth(e.getMonth() + t), this.setState({
      showDate: n
    });
  }
  nextMonth = (t) => {
    t.preventDefault(), this.goToMonth(1);
  };
  prevMonth = (t) => {
    t.preventDefault(), this.goToMonth(-1);
  };
  handleDateClick(t, e) {
    t.preventDefault();
    const {
      input: { onChange: n }
    } = this.props, { showDate: o } = this.state, r = {
      ...this.state,
      selectedDate: e
    };
    o.getMonth() !== e.getMonth() && (r.showDate = e), this.setState(r), n(e);
  }
  goToTime(t, e, n = "hours") {
    const o = n === "minutes" ? "setMinutes" : "setHours", r = n === "minutes" ? "getMinutes" : "getHours", {
      input: { onChange: a }
    } = this.props, { selectedDate: l } = this.state, c = new Date(l.getTime());
    c[o](c[r]() + e), this.setState({
      selectedDate: c
    }), a(c);
  }
  nextMinutes = (t) => {
    t.preventDefault(), this.goToTime(t, 15, "minutes");
  };
  prevMinutes = (t) => {
    t.preventDefault(), this.goToTime(t, -15, "minutes");
  };
  nextHour = (t) => {
    t.preventDefault(), this.goToTime(t, 1);
  };
  prevHour = (t) => {
    t.preventDefault(), this.goToTime(t, -1);
  };
  canGoPrevMonth() {
    const { minDate: t } = this.props, { showDate: e } = this.state;
    if (t === null) return !0;
    const n = new Date(
      e.getFullYear(),
      e.getMonth(),
      1
    );
    return t < n;
  }
  canGoNextMonth() {
    const { maxDate: t } = this.props, { showDate: e } = this.state;
    if (t === null) return !0;
    const n = new Date(
      e.getFullYear(),
      e.getMonth() + 1,
      1,
      0,
      0,
      0,
      -1
    );
    return t > n;
  }
  canGoDirection(t = "hours", e) {
    const n = t === "minutes" ? "setMinutes" : "setHours", o = t === "minutes" ? "getMinutes" : "getHours", { maxDate: r } = this.props, { selectedDate: a } = this.state, l = new Date(a.getTime());
    return l[n](l[o]() + e), !(l.getDate() !== a.getDate()) && (r === null || r >= l);
  }
  render() {
    const {
      className: t,
      input: e,
      hasTime: n,
      disabled: o,
      minDate: r,
      maxDate: a,
      ...l
    } = this.props, { selectedDate: c, showDate: d } = this.state, h = f({}, t), u = this.generateGrid(), p = {
      month: "long",
      year: "numeric"
    };
    let m = null;
    try {
      m = d.toLocaleDateString("en-US", p);
    } catch (g) {
      m = `${d.getMonth() + 1} / ${d.getFullYear()}`, console.warn("toLocaleDateString exception", g);
    }
    return /* @__PURE__ */ s.jsxs("div", { ...l, className: h, children: [
      /* @__PURE__ */ s.jsxs("div", { className: Y.month, children: [
        /* @__PURE__ */ s.jsx(
          "button",
          {
            className: Y.arrow,
            disabled: !this.canGoPrevMonth(),
            onClick: this.prevMonth,
            "aria-label": "Previous month",
            children: /* @__PURE__ */ s.jsx(N, { name: "angle-left", className: "icon-vertical-fix" })
          }
        ),
        m,
        /* @__PURE__ */ s.jsx(
          "button",
          {
            className: Y.arrow,
            disabled: !this.canGoNextMonth(),
            onClick: this.nextMonth,
            "aria-label": "Next month",
            children: /* @__PURE__ */ s.jsx(N, { name: "angle-right", className: "icon-vertical-fix" })
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: Y.dayNames, children: [
        /* @__PURE__ */ s.jsx("p", { className: Y.dayName, children: "Mon" }),
        /* @__PURE__ */ s.jsx("p", { className: Y.dayName, children: "Tue" }),
        /* @__PURE__ */ s.jsx("p", { className: Y.dayName, children: "Wed" }),
        /* @__PURE__ */ s.jsx("p", { className: Y.dayName, children: "Thu" }),
        /* @__PURE__ */ s.jsx("p", { className: Y.dayName, children: "Fri" }),
        /* @__PURE__ */ s.jsx("p", { className: Y.dayName, children: "Sat" }),
        /* @__PURE__ */ s.jsx("p", { className: Y.dayName, children: "Sun" })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: Y.grid, children: u.map((g) => /* @__PURE__ */ s.jsx("div", { className: Y.gridItem, children: /* @__PURE__ */ s.jsx(
        Bh,
        {
          onClick: (b) => this.handleDateClick(b, g.date),
          dim: !g.isThisMonth,
          active: g.selected,
          disabled: g.disabled,
          className: Y.day,
          children: g.label
        }
      ) }, g.date.getTime())) }),
      n && /* @__PURE__ */ s.jsxs("div", { className: Y.time, children: [
        /* @__PURE__ */ s.jsxs("div", { className: Y.timeButtonContainerLeft, children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: Y.arrowTime,
              disabled: !this.canGoDirection("hours", -1),
              onClick: this.prevHour,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-double-left", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: Y.arrowTime,
              disabled: !this.canGoDirection("minutes", -15),
              onClick: this.prevMinutes,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-left", className: "icon-vertical-fix" })
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: Y.timeDisplay, children: `${lo(
          c.getHours().toString(),
          2,
          "0"
        )}:${lo(c.getMinutes().toString(), 2, "0")}` }),
        /* @__PURE__ */ s.jsxs("div", { className: Y.timeButtonContainerRight, children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: Y.arrowTime,
              disabled: !this.canGoDirection("minutes", 15),
              onClick: this.nextMinutes,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-right", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: Y.arrowTime,
              disabled: !this.canGoDirection("hours", 1),
              onClick: this.nextHour,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-double-right", className: "icon-vertical-fix" })
            }
          )
        ] })
      ] })
    ] });
  }
}
Ze.defaultProps = {
  /* eslint-disable react/default-props-match-prop-types */
  disabled: () => !1,
  minDate: null,
  maxDate: null,
  hasTime: !1
};
function Zh(i) {
  return Math.abs(i.diff(j())) < 25e3 ? "just now" : i.fromNow();
}
function Ps(i) {
  return j(i, j.ISO_8601).isValid();
}
function De(i) {
  return !!j.tz.zone(i ?? "");
}
const Nt = "HH:mm", kr = gr(24), Tr = gr(0, 60, 15), jr = (i) => j("1995-12-25").format(i);
function Nr(i) {
  if (i < 0 || i > 23)
    throw new Error("Hour must be between 0 and 23.");
}
function Fr(i) {
  if (i < 0 || i > 59)
    throw new Error("Minute must be between 0 and 59.");
}
function Pr({
  hour: i,
  minute: t,
  timeFormat: e
}) {
  const n = j({ hour: i, minute: t });
  return {
    id: n.format(Nt),
    name: n.format(e)
  };
}
function Jh(i, t) {
  return t?.map(({ hour: e, minute: n }) => (Nr(e), Fr(n), Pr({ hour: e, minute: n, timeFormat: i }))) || [];
}
function Rr({
  hours: i,
  minutes: t,
  overrides: e,
  timeFormat: n
}) {
  return wi(
    i.reduce(
      (o, r, a) => [
        ...o,
        ...t.map((l, c) => (c === 0 && Nr(r), a === 0 && Fr(l), Pr({ hour: r, minute: l, timeFormat: n })))
      ],
      []
    ).concat(Jh(n, e)),
    ["id"]
  );
}
const tu = "h-datePicker--datePicker__root", eu = "h-datePicker--datePicker__navigationButton", nu = "h-datePicker--datePicker__nextMonthButton", su = "h-datePicker--datePicker__prevMonthButton", Ie = {
  root: tu,
  navigationButton: eu,
  nextMonthButton: nu,
  prevMonthButton: su
}, Wn = {
  previousMonth({ ariaLabel: i, ...t }) {
    const e = f(
      Ie.navigationButton,
      Ie.prevMonthButton
    );
    return /* @__PURE__ */ s.jsx("div", { className: e, children: /* @__PURE__ */ s.jsx(N, { ...t, "aria-label": i, size: 24, name: "angle-left" }) });
  },
  nextMonth({ ariaLabel: i, ...t }) {
    const e = f(
      Ie.navigationButton,
      Ie.nextMonthButton
    );
    return /* @__PURE__ */ s.jsx("div", { className: e, children: /* @__PURE__ */ s.jsx(N, { ...t, "aria-label": i, size: 24, name: "angle-right" }) });
  }
}, Er = (i) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
  /* @__PURE__ */ s.jsx("span", { className: "date-number-container", children: i.date() }),
  /* @__PURE__ */ s.jsx("span", { className: "day-complimentary-highlight" })
] }), Lr = ({ month: i }) => /* @__PURE__ */ s.jsx("span", { children: i.format("MMMM YYYY") }), Ar = (i) => {
  const { value: t, presets: e, onSelect: n } = i, o = F(
    (r) => {
      n(r.key === t ? null : r);
    },
    [n, t]
  );
  return /* @__PURE__ */ s.jsxs(Qt, { children: [
    /* @__PURE__ */ s.jsx(qn, { orientation: "vertical" }),
    /* @__PURE__ */ s.jsx(po, { children: e.map((r) => /* @__PURE__ */ s.jsx(
      po.Item,
      {
        isSelected: r.key === t,
        onClick: () => o(r),
        children: r.label
      },
      r.key
    )) })
  ] });
}, ou = "h-fieldLabel--fieldLabel__root", ru = "h-fieldLabel--fieldLabel__label", iu = "h-fieldLabel--fieldLabel__labelChildren", au = "h-fieldLabel--fieldLabel__rootRequired", lu = "h-fieldLabel--fieldLabel__helpIcon", Be = {
  root: ou,
  label: ru,
  labelChildren: iu,
  rootRequired: au,
  helpIcon: lu
}, cu = "fieldLabel";
class Gs extends D {
  render() {
    const { required: t, helpIcon: e, className: n, children: o, ...r } = this.props, a = f(Be.root, n, {
      [Be.rootRequired]: t
    });
    return /* @__PURE__ */ s.jsxs("div", { className: a, "data-testid": cu, children: [
      /* @__PURE__ */ s.jsx("label", { className: Be.label, ...r, children: /* @__PURE__ */ s.jsx("div", { className: Be.labelChildren, children: o }) }),
      !!e?.text && /* @__PURE__ */ s.jsx(
        qs,
        {
          ...e,
          className: f(Be.helpIcon, e.className)
        }
      )
    ] });
  }
}
const du = "h-dropdownSelect--dropdownInfinite__item", hu = "h-dropdownSelect--dropdownInfinite__list", uu = "h-dropdownSelect--dropdownInfinite__listEmpty", ps = {
  item: du,
  list: hu,
  listEmpty: uu
};
class Fo extends D {
  render() {
    const {
      item: t,
      itemComponent: e,
      tooltip: n,
      onSelect: o,
      onChange: r,
      onKeyDown: a,
      clearSearch: l,
      checked: c,
      disabled: d,
      isLoading: h,
      active: u,
      id: p
    } = this.props, m = /* @__PURE__ */ s.jsx(
      e,
      {
        item: t,
        onSelect: o,
        onChange: r,
        onKeyDown: a,
        clearSearch: l,
        checked: c,
        disabled: d,
        isLoading: h,
        active: u,
        tabIndex: u ? 0 : -1,
        id: p,
        role: "option",
        "aria-disabled": d,
        "aria-selected": c
      }
    );
    return n ? /* @__PURE__ */ s.jsx(st, { ...n, children: m }, t.id) : m;
  }
}
const pu = 6, mu = 48;
class Ys extends D {
  listRef;
  infiniteListRef;
  static defaultProps = {
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  constructor(t) {
    super(t), this.isItemLoaded = this.isItemLoaded.bind(this), this.listRef = O(), this.infiniteListRef = O();
  }
  componentDidUpdate(t) {
    const { activeItem: e, items: n, pagination: o } = this.props, r = typeof t.activeItem == "object" && t.activeItem ? t.activeItem.id : t.activeItem, a = typeof e == "object" && e ? e.id : e;
    if (r !== a && a !== null) {
      const l = n.findIndex(
        (c) => c.id === a
      );
      if (l >= 0) {
        if (typeof o == "object" && o.infinite && this.infiniteListRef.current)
          this.infiniteListRef.current.scrollToItem(l, "smart");
        else if (this.listRef.current) {
          const c = this.listRef.current.children[l];
          c && c.scrollIntoView({ block: "nearest" });
        }
      }
    }
  }
  isItemLoaded(t) {
    const { items: e } = this.props;
    return t < e.length;
  }
  isItemActive(t) {
    if (!t) return !1;
    const { activeItem: e } = this.props;
    return e ? typeof e == "object" && "id" in e ? t.id === e.id : t.id === e : !1;
  }
  isItemChecked(t) {
    if (!t) return !1;
    const { selectedItems: e } = this.props;
    return (e?.findIndex((o) => typeof o == "object" ? o.id === t.id : o === t.id) ?? -1) > -1;
  }
  isItemDisabled(t) {
    return t ? (this.props.disabledItems?.indexOf(t.id) ?? -1) >= 0 : !0;
  }
  getTooltip(t) {
    const { tooltipItems: e } = this.props;
    return !t || Ws(e?.[t.id]) ? null : e?.[t.id] ?? null;
  }
  goToTop() {
    this.infiniteListRef.current && this.infiniteListRef.current.scrollToItem(0), this.listRef.current && (this.listRef.current.scrollTop = 0);
  }
  focusActiveItem() {
    const { items: t, activeItem: e } = this.props;
    if (!e || !this.listRef.current) return;
    const n = typeof e == "object" && "id" in e ? e.id : e, o = t.findIndex((r) => r.id === n);
    if (o >= 0 && this.listRef.current.children[o]) {
      const r = this.listRef.current.children[o];
      (r.querySelector('[tabindex="0"]') || r)?.focus();
    }
  }
  getItemId(t) {
    const { id: e } = this.props;
    return e ? `${e}-option-${t}` : void 0;
  }
  /**
   * This attribute is supposed to be a React component. The FixedSizeList
   * component expects a component is a child.
   *
   * @see https://react-window.vercel.app/#/examples/list/fixed-size
   */
  ListItem = ({
    index: t,
    style: e
  }) => {
    const { items: n, itemComponent: o, onSelect: r, onChange: a, clearSearch: l } = this.props, c = this.isItemLoaded(t), d = t === n.length - 1, h = c ? n[t] : { id: nn(), name: "Loading..." }, u = this.props.pagination ? this.props.pagination.nextEnable : !1;
    return /* @__PURE__ */ s.jsxs("div", { style: e, className: ps.item, children: [
      /* @__PURE__ */ s.jsx(
        Fo,
        {
          id: this.getItemId(t),
          checked: this.isItemChecked(h),
          clearSearch: l,
          disabled: this.isItemDisabled(h),
          isLoading: !c,
          item: h,
          itemComponent: o,
          onChange: a,
          onSelect: r,
          tooltip: this.getTooltip(h),
          active: this.isItemActive(h)
        }
      ),
      d && u && c && /* @__PURE__ */ s.jsx(vi, { onEnter: this.loadMoreItems })
    ] });
  };
  loadMoreItems = async () => {
    this.props.pagination && await this.props.pagination.onNext?.();
  };
  render() {
    const {
      items: t,
      pagination: e,
      itemComponent: n,
      onSelect: o,
      onChange: r,
      onKeyDown: a,
      clearSearch: l,
      itemsDisplayCount: c = pu,
      itemHeight: d = mu,
      id: h,
      ariaLabelledby: u
    } = this.props;
    if (!e || !e.infinite || !e.onNext)
      return /* @__PURE__ */ s.jsx(
        "div",
        {
          style: { maxHeight: `${c * d}px` },
          className: f({
            [ps.list]: !0,
            [ps.listEmpty]: t.length === 0
          }),
          ref: this.listRef,
          role: "listbox",
          id: h,
          "aria-labelledby": u,
          children: t.map((y, _) => {
            const C = Si(y) ? y : y.id.toString() || y.name.toString() || y.toString();
            return /* @__PURE__ */ s.jsx(
              Fo,
              {
                id: this.getItemId(_),
                checked: this.isItemChecked(y),
                clearSearch: l,
                disabled: this.isItemDisabled(y),
                item: y,
                itemComponent: n,
                onChange: r,
                onSelect: o,
                onKeyDown: a,
                tooltip: this.getTooltip(y),
                active: this.isItemActive(y)
              },
              C
            );
          })
        }
      );
    const { nextEnable: p, itemCount: m } = e, g = m || (p ? t.length + c : t.length), b = {
      items: t,
      selectedItems: this.props.selectedItems,
      disabledItems: this.props.disabledItems,
      tooltipItems: this.props.tooltipItems,
      activeItem: this.props.activeItem,
      pagination: this.props.pagination
    }, x = Math.min(
      g * d,
      c * d
    );
    return /* @__PURE__ */ s.jsx(Ii, { disableHeight: !0, doNotBailOutOnEmptyChildren: !0, children: ({ width: y }) => /* @__PURE__ */ s.jsx(
      Di,
      {
        ...b,
        ref: this.infiniteListRef,
        width: y,
        height: x,
        itemCount: g,
        itemSize: d,
        "aria-labelledby": u,
        children: this.ListItem
      }
    ) });
  }
}
const gu = "h-selectItems-checkableBaseItem--checkableBaseItem__root", fu = "h-selectItems-checkableBaseItem--checkableBaseItem__rootActive", bu = "h-selectItems-checkableBaseItem--checkableBaseItem__rootDisabled", xu = "h-selectItems-checkableBaseItem--checkableBaseItem__checkbox", yu = "h-selectItems-checkableBaseItem--checkableBaseItem__content", He = {
  root: gu,
  rootActive: fu,
  rootDisabled: bu,
  checkbox: xu,
  content: yu
};
class Xs extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  handleChange() {
    const { onChange: t, item: e, checked: n } = this.props;
    typeof t == "function" && t(e, !n);
  }
  handleKeyDown(t) {
    const { disabled: e, onKeyDown: n } = this.props;
    (t.key === "Enter" || t.key === " ") && !e && (t.preventDefault(), this.handleChange()), n && n(t);
  }
  noop(t) {
    t.preventDefault();
  }
  render() {
    const {
      item: t,
      onChange: e,
      clearSearch: n,
      checked: o,
      disabled: r,
      isLoading: a,
      children: l,
      active: c,
      tabIndex: d,
      onKeyDown: h,
      ...u
    } = this.props, p = f(He.root, {
      [He.rootDisabled]: r,
      [He.rootActive]: c
    }), m = r ? L : this.handleChange;
    return /* @__PURE__ */ s.jsxs(
      "label",
      {
        ...u,
        className: p,
        tabIndex: d,
        onKeyDown: this.handleKeyDown,
        children: [
          /* @__PURE__ */ s.jsx(
            cn,
            {
              id: t?.id,
              name: "",
              className: He.checkbox,
              checked: o,
              onChange: m,
              tabIndex: -1
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: He.content, children: l })
        ]
      }
    );
  }
}
const _u = "h-selectItems-emptySelectItem--emptySelectItem__root", Cu = "h-selectItems-emptySelectItem--emptySelectItem__name", Po = {
  root: _u,
  name: Cu
};
class hn extends D {
  render() {
    const { label: t, ...e } = this.props;
    return /* @__PURE__ */ s.jsx("div", { ...e, className: Po.root, children: /* @__PURE__ */ s.jsx("div", { className: Po.name, children: t }) });
  }
}
const wu = "h-selectItems-selectItem--selectItem__root", vu = "h-selectItems-selectItem--selectItem__rootActive", Su = "h-selectItems-selectItem--selectItem__name", Iu = "h-selectItems-selectItem--selectItem__nameBold", Du = "h-selectItems-selectItem--selectItem__nameWithDescription", ku = "h-selectItems-selectItem--selectItem__description", Tu = "h-selectItems-selectItem--selectItem__icon", ee = {
  root: wu,
  rootActive: vu,
  name: Su,
  nameBold: Iu,
  nameWithDescription: Du,
  description: ku,
  icon: Tu
};
class $r extends _t {
  static defaultProps = {
    checked: !1
  };
  render() {
    const {
      item: t,
      onSelect: e,
      clearSearch: n,
      checked: o,
      disabled: r,
      active: a,
      isLoading: l,
      ...c
    } = this.props, { description: d, name: h, icon: u, iconSize: p } = t, m = f(ee.root, {
      [ee.rootActive]: a
    }), g = f(ee.name, {
      [ee.nameBold]: o,
      [ee.nameWithDescription]: !!d
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": a,
        className: m,
        disabled: r,
        onClick: () => {
          e(t);
        },
        children: [
          u ? /* @__PURE__ */ s.jsx(N, { className: ee.icon, name: u, size: p ?? 16 }) : null,
          /* @__PURE__ */ s.jsxs(B, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
            /* @__PURE__ */ s.jsx("span", { className: g, "data-testid": "name", children: h }),
            d && /* @__PURE__ */ s.jsx("span", { className: ee.description, "data-testid": "description", children: d })
          ] }),
          o && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
const ju = "h-selectItems-checkableSelectItem--checkableSelectItem__name", Nu = {
  name: ju
};
class jk extends D {
  render() {
    const { item: t, isLoading: e } = this.props, { name: n } = e ? { name: "Loading..." } : t;
    return /* @__PURE__ */ s.jsx(Xs, { ...this.props, children: /* @__PURE__ */ s.jsx("span", { className: Nu.name, children: n }) });
  }
}
const Fu = "h-selectItems-tagSelectItem--tagSelectItem__root", Pu = "h-selectItems-tagSelectItem--tagSelectItem__rootActive", Ru = "h-selectItems-tagSelectItem--tagSelectItem__name", Eu = "h-selectItems-tagSelectItem--tagSelectItem__nameBold", Lu = "h-selectItems-tagSelectItem--tagSelectItem__dotContainer", Au = "h-selectItems-tagSelectItem--tagSelectItem__dot", me = {
  root: Fu,
  rootActive: Pu,
  name: Ru,
  nameBold: Eu,
  dotContainer: Lu,
  dot: Au
};
class Nk extends D {
  static defaultProps = {
    checked: !1
  };
  render() {
    const {
      item: t,
      onSelect: e,
      clearSearch: n,
      checked: o,
      disabled: r,
      isLoading: a,
      active: l,
      ...c
    } = this.props, { name: d, color: h = "#000" } = t, u = f(me.root, {
      [me.rootActive]: l
    }), p = f(me.name, {
      [me.nameBold]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": l,
        className: u,
        onClick: () => {
          e(t), n();
        },
        tabIndex: 0,
        title: typeof d == "string" ? d : d.toString(),
        disabled: r,
        children: [
          /* @__PURE__ */ s.jsx("div", { className: me.dotContainer, children: /* @__PURE__ */ s.jsx(
            "div",
            {
              className: me.dot,
              style: { backgroundColor: h ?? void 0 }
            }
          ) }),
          /* @__PURE__ */ s.jsx("div", { className: p, children: d }),
          o && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" }),
          r && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" })
        ]
      }
    );
  }
}
const $u = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__name", Ou = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dotContainer", Bu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dot", Hu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__nameContainer", fn = {
  name: $u,
  dotContainer: Ou,
  dot: Bu,
  nameContainer: Hu
};
class Fk extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this);
  }
  handleChange() {
    const { onChange: t, item: e, checked: n } = this.props;
    typeof t == "function" && t(e, !n);
  }
  render() {
    const { item: t, isLoading: e, disabled: n } = this.props, { name: o, color: r } = e ? { name: "Loading...", color: "#000" } : t;
    return /* @__PURE__ */ s.jsx(
      Xs,
      {
        ...this.props,
        disabled: this.props.checked ? !1 : n,
        children: /* @__PURE__ */ s.jsxs("div", { className: fn.nameContainer, children: [
          r && /* @__PURE__ */ s.jsx("div", { className: fn.dotContainer, children: /* @__PURE__ */ s.jsx("div", { className: fn.dot, style: { backgroundColor: r } }) }),
          /* @__PURE__ */ s.jsx("span", { className: fn.name, children: o }),
          n && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" })
        ] })
      }
    );
  }
}
const Wu = "h-selectItems-avatarSelectItem--avatarSelectItem__root", Mu = "h-selectItems-avatarSelectItem--avatarSelectItem__rootActive", zu = "h-selectItems-avatarSelectItem--avatarSelectItem__secondaryName", Vu = "h-selectItems-avatarSelectItem--avatarSelectItem__primaryName", Ku = "h-selectItems-avatarSelectItem--avatarSelectItem__names", Uu = "h-selectItems-avatarSelectItem--avatarSelectItem__namesBold", qu = "h-selectItems-avatarSelectItem--avatarSelectItem__container", Gu = "h-selectItems-avatarSelectItem--avatarSelectItem__containerCheckable", Mt = {
  root: Wu,
  rootActive: Mu,
  secondaryName: zu,
  primaryName: Vu,
  names: Ku,
  namesBold: Uu,
  container: qu,
  containerCheckable: Gu
};
class Yu extends D {
  static defaultProps = {
    checked: !1
  };
  getNames(t) {
    const e = /* @__PURE__ */ new Set();
    typeof t.name == "string" && e.add(t.name), typeof t.name != "string" && typeof t.display_name == "string" && e.add(t.display_name), typeof t.phone_number == "string" && e.add(t.phone_number), typeof t.email == "string" && e.add(t.email);
    const n = Array.from(e);
    return {
      primaryName: n.length > 0 ? n[0] : "No name",
      secondaryName: n.length > 1 ? n[1] : null
    };
  }
  getAvatar(t) {
    return typeof t.icon == "string" ? /* @__PURE__ */ s.jsx(N, { name: t.icon, size: 16 }) : /* @__PURE__ */ s.jsx(wr, { user: t });
  }
  renderContent() {
    const t = this.props.isLoading ? {
      id: "",
      name: "Loading..."
    } : this.props.item, e = this.getAvatar(t), n = this.getNames(t), o = f(Mt.container, {
      [Mt.containerCheckable]: this.props.checkable
    }), r = f(Mt.names, {
      [Mt.namesBold]: this.props.checked
    });
    return /* @__PURE__ */ s.jsxs("div", { className: o, children: [
      e,
      /* @__PURE__ */ s.jsxs("div", { className: r, children: [
        /* @__PURE__ */ s.jsx("div", { className: Mt.primaryName, children: n.primaryName }),
        n.secondaryName !== null && /* @__PURE__ */ s.jsx("div", { className: Mt.secondaryName, children: n.secondaryName })
      ] })
    ] });
  }
  render() {
    const t = this.renderContent(), { checkable: e, ...n } = this.props;
    if (e) {
      const m = n;
      return /* @__PURE__ */ s.jsx(Xs, { ...m, children: t });
    }
    const o = n, { item: r, disabled: a, onSelect: l, active: c, checked: d, isLoading: h, ...u } = o, p = f(Mt.root, {
      [Mt.rootActive]: c
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...u,
        type: "button",
        className: p,
        disabled: a,
        onClick: () => {
          l(r);
        },
        "aria-current": c,
        children: [
          t,
          d && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
class Pk extends D {
  render() {
    return /* @__PURE__ */ s.jsx(Yu, { checkable: !0, ...this.props });
  }
}
const Xu = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__root", Qu = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__rootActive", Zu = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__suggestion", Ju = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__icon", bn = {
  root: Xu,
  rootActive: Qu,
  suggestion: Zu,
  icon: Ju
};
class Rk extends _t {
  static defaultProps = {
    searchSuggestion: (t, e) => t.find((n) => n.name.toLowerCase() === e.toLowerCase()),
    renderSuggestion: (t) => `Add "${t}" tag`
  };
  constructor(t) {
    super(t), this.state = {}, this.onSuggest = this.onSuggest.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  componentDidUpdate(t) {
    const { searched: e, active: n } = this.props;
    e !== t.searched && this.searchItem(), n !== t.active && (n ? window.addEventListener("keydown", this.handleKeyDown) : window.removeEventListener("keydown", this.handleKeyDown));
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }
  searchItem() {
    const { items: t, searched: e, searchSuggestion: n } = this.props;
    this.setState({ searching: !0 }, async () => {
      try {
        const o = await n?.(t, e);
        this.setState({ item: o });
      } catch (o) {
        console.error(o);
      } finally {
        this.setState({ searching: !1 });
      }
    });
  }
  onSuggest() {
    const { searched: t, onSuggest: e, clearSearch: n, triggerClose: o } = this.props;
    o?.(), e?.(t), n();
  }
  handleKeyDown(t) {
    this.props.active && t.key === "Enter" && this.onSuggest();
  }
  render() {
    const {
      className: t,
      triggerClose: e,
      onSuggest: n,
      searched: o,
      items: r,
      active: a,
      renderSuggestion: l,
      searchSuggestion: c,
      clearSearch: d,
      ...h
    } = this.props, { item: u, searching: p } = this.state;
    if (!o || p || u)
      return null;
    const m = f(t, bn.root, {
      [bn.rootActive]: a
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...h,
        type: "button",
        "aria-current": a,
        className: m,
        onClick: this.onSuggest,
        tabIndex: 0,
        children: [
          /* @__PURE__ */ s.jsx("div", { className: bn.suggestion, children: l?.(o) }),
          /* @__PURE__ */ s.jsx("div", { className: bn.icon, children: /* @__PURE__ */ s.jsx(N, { name: "plus" }) })
        ]
      }
    );
  }
}
const tp = "h-selectItems-deselectItem--deselectItem__root", ep = "h-selectItems-deselectItem--deselectItem__rootDisabled", np = "h-selectItems-deselectItem--deselectItem__name", sp = "h-selectItems-deselectItem--deselectItem__icon", xn = {
  root: tp,
  rootDisabled: ep,
  name: np,
  icon: sp
};
class op extends D {
  render() {
    const { item: t, onSelect: e, clearSearch: n, disabled: o, ...r } = this.props, { name: a } = t, l = f(xn.root, {
      [xn.rootDisabled]: o
    });
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: l, children: [
      /* @__PURE__ */ s.jsx("div", { className: xn.name, children: a }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: xn.icon,
          onClick: () => {
            e(t);
          },
          disabled: o,
          children: /* @__PURE__ */ s.jsx(N, { name: "close" })
        }
      )
    ] });
  }
}
const rp = "h-selectItems-tagDeselectItem--tagDeselectItem__root", ip = "h-selectItems-tagDeselectItem--tagDeselectItem__name", ap = "h-selectItems-tagDeselectItem--tagDeselectItem__icon", lp = "h-selectItems-tagDeselectItem--tagDeselectItem__dotContainer", cp = "h-selectItems-tagDeselectItem--tagDeselectItem__dot", We = {
  root: rp,
  name: ip,
  icon: ap,
  dotContainer: lp,
  dot: cp
};
class Ek extends D {
  render() {
    const { item: t, onSelect: e, clearSearch: n, disabled: o, isLoading: r, ...a } = this.props, { name: l, color: c } = t, d = f(We.root);
    return /* @__PURE__ */ s.jsxs("div", { ...a, className: d, children: [
      /* @__PURE__ */ s.jsx("div", { className: We.dotContainer, children: /* @__PURE__ */ s.jsx(
        "div",
        {
          className: We.dot,
          style: { backgroundColor: c ?? void 0 }
        }
      ) }),
      /* @__PURE__ */ s.jsx("div", { className: We.name, children: l }),
      o && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: We.icon,
          onClick: () => {
            e(t);
          },
          children: /* @__PURE__ */ s.jsx(N, { name: "close" })
        }
      )
    ] });
  }
}
const dp = "h-chip--chip__root", hp = "h-chip--chip__rootLight", up = "h-chip--chip__rootNoBorder", pp = "h-chip--chip__rootDisabled", mp = "h-chip--chip__rootInteractable", Me = {
  root: dp,
  rootLight: hp,
  rootNoBorder: up,
  rootDisabled: pp,
  rootInteractable: mp
}, gp = ({
  className: i,
  children: t,
  onClick: e,
  light: n,
  noBorder: o,
  disabled: r,
  ...a
}) => {
  const l = f(
    {
      [Me.root]: !0,
      [Me.rootLight]: n,
      [Me.rootNoBorder]: o,
      [Me.rootDisabled]: r,
      [Me.rootInteractable]: typeof e == "function" && !r
    },
    i
  ), c = typeof e == "function" ? "button" : "div";
  return /* @__PURE__ */ s.jsx(at, { ...a, as: c, className: l, onClick: e, children: t });
}, fp = "h-tag--tag__tagName", bp = "h-tag--tag__tagNameTruncated", xp = "h-tag--tag__icon", yp = "h-tag--tag__deleteButton", _p = "h-tag--tag__deleteButtonDisabled", Cp = "h-tag--tag__deleteIcon", ge = {
  tagName: fp,
  tagNameTruncated: bp,
  icon: xp,
  deleteButton: yp,
  deleteButtonDisabled: _p,
  deleteIcon: Cp
}, ke = ({
  className: i,
  tagNameClassName: t,
  children: e,
  onDelete: n,
  color: o,
  light: r,
  noBorder: a,
  noTruncation: l = !1,
  disabled: c,
  ...d
}) => {
  const h = f(
    {
      [ge.tagName]: !0,
      [ge.tagNameTruncated]: !l
    },
    t
  ), u = f(ge.deleteButton, {
    [ge.deleteButtonDisabled]: c
  });
  return /* @__PURE__ */ s.jsxs(
    gp,
    {
      ...d,
      className: i,
      light: r,
      noBorder: a,
      disabled: c,
      children: [
        o && /* @__PURE__ */ s.jsx(
          "span",
          {
            className: ge.icon,
            style: { backgroundColor: tn(o) ?? void 0 }
          }
        ),
        /* @__PURE__ */ s.jsx("span", { className: h, children: e }),
        !!n && !c && /* @__PURE__ */ s.jsx("button", { className: u, type: "button", onClick: n, children: /* @__PURE__ */ s.jsx(N, { name: "close", className: ge.deleteIcon }) })
      ]
    }
  );
}, wp = "h-select--select__root", vp = "h-select--select__rootDisabled", Sp = "h-select--select__inputWrapper", Ip = "h-select--select__control", Dp = "h-select--select__rootHasIcon", kp = "h-select--select__selection", Tp = "h-select--select__selectionItem", jp = "h-select--select__tag", Np = "h-select--select__tagName", Fp = "h-select--select__tagLimiter", Pp = "h-select--select__text", Rp = "h-select--select__rootSearchable", Ep = "h-select--select__rootDropdownOpen", Lp = "h-select--select__rootIsSearching", Ap = "h-select--select__search", $p = "h-select--select__rootSingle", Op = "h-select--select__indicators", Bp = "h-select--select__spinner", Hp = "h-select--select__clearIndicator", Wp = "h-select--select__dropdownIndicator", Mp = "h-select--select__dropdown", zp = "h-select--select__dropdownFixed", Vp = "h-select--select__pagination", q = {
  root: wp,
  rootDisabled: vp,
  inputWrapper: Sp,
  control: Ip,
  rootHasIcon: Dp,
  selection: kp,
  selectionItem: Tp,
  tag: jp,
  tagName: Np,
  tagLimiter: Fp,
  text: Pp,
  rootSearchable: Rp,
  rootDropdownOpen: Ep,
  rootIsSearching: Lp,
  search: Ap,
  rootSingle: $p,
  indicators: Op,
  spinner: Bp,
  clearIndicator: Hp,
  dropdownIndicator: Wp,
  dropdown: Mp,
  dropdownFixed: zp,
  pagination: Vp
};
class Te extends D {
  controlRef;
  searchRef;
  listRef;
  static defaultProps = {
    id: fr("select"),
    selectedItems: [],
    disabledItems: [],
    itemComponent: $r,
    emptyComponent: hn,
    emptyMessage: "No options",
    placeholder: "",
    disabled: !1,
    loading: !1,
    multiple: !1,
    searchable: !1,
    clearable: !1,
    keepOpen: !1,
    hideSelectedItems: !1,
    hasDropDownIndicator: !0
  };
  constructor(t) {
    super(t), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSearch = this.handleSearch.bind(this), this.handleDropdown = this.handleDropdown.bind(this), this.handleClickOutside = this.handleClickOutside.bind(this), this.handleSelect = this.handleSelect.bind(this), this.handleChange = this.handleChange.bind(this), this.handleRemove = this.handleRemove.bind(this), this.handleClear = this.handleClear.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this), this.resolveItem = this.resolveItem.bind(this), this.resetSearch = this.resetSearch.bind(this), this.controlRef = O(), this.searchRef = O(), this.listRef = O();
    const e = this.initSelectedItems(), n = this.initHighlightedIndex(e);
    this.state = {
      dropdownOpen: !1,
      search: "",
      selectedItems: e,
      highlightedIndex: n
    }, !Te.isSuggestionComponentWarningShown && this.props.suggestionComponent && !this.props.searchable && (console.warn(
      "SuggestionComponent can only be shown on searchable select components. You should either remove suggestionComponent prop or add searchable prop"
    ), Te.isSuggestionComponentWarningShown = !0);
  }
  componentDidUpdate(t, e) {
    const { dropdownOpen: n } = this.state;
    if (n !== e.dropdownOpen)
      if (window[n ? "addEventListener" : "removeEventListener"](
        "click",
        this.handleClickOutside
      ), n) {
        this.searchRef.current?.focus();
        const o = this.initHighlightedIndex();
        this.highlightIndex(o, "auto");
      } else
        this.searchRef.current?.blur();
    br(t.selectedItems, this.props.selectedItems) || this.setState({ selectedItems: this.initSelectedItems() });
  }
  componentWillUnmount() {
    const { dropdownOpen: t } = this.state;
    t && window.removeEventListener("click", this.handleClickOutside);
  }
  static isSuggestionComponentWarningShown = !1;
  get a11y() {
    const { id: t } = this.props, { highlightedIndex: e } = this.state, n = `${t}-label`, o = `${t}-dropdown`, r = e !== null ? `${o}-option-${e}` : "";
    return { label: n, dropdown: o, option: r };
  }
  isItemIdType(t) {
    return typeof t == "string" || typeof t == "number";
  }
  initSelectedItems() {
    const { selectedItems: t = [] } = this.props;
    return t.map(this.resolveItem).filter(Boolean);
  }
  initHighlightedIndex(t = this.state.selectedItems) {
    const { multiple: e, items: n, hideSelectedItems: o } = this.props;
    if (!e && !o && t.length) {
      const r = this.resolveItem(t[0]);
      return n.indexOf(r);
    }
    return null;
  }
  resolveItem(t) {
    return this.isItemIdType(t) ? this.props.items.find((n) => n.id === t) : t;
  }
  resetSearch() {
    this.state.search && (this.setState({ search: "" }), this.searchRef.current?.focus());
  }
  handleSearch(t) {
    const { onSearch: e } = this.props, { value: n } = t.target;
    this.setState({ search: n }, () => {
      e?.(n), n && (this.highlightIndex(this.hasSuggestionComponent() ? -1 : 0), this.listRef.current?.goToTop());
    });
  }
  handleDropdown(t = "toggle") {
    const { dropdownOpen: e } = this.state, { keepOpen: n, onToggle: o } = this.props;
    if (n)
      return this.setState({ dropdownOpen: !0 });
    if (t === "toggle")
      return o?.(!e), this.controlRef.current?.focus(), this.setState({ dropdownOpen: !e });
    if (t === "open")
      return o?.(!0), this.setState({ dropdownOpen: !0 });
    if (t === "close" && e)
      return o?.(!1), this.controlRef.current?.blur(), this.setState({
        dropdownOpen: !1,
        search: ""
      });
  }
  handleClickOutside(t) {
    if (!this.controlRef || !(t.target instanceof Node)) return;
    const e = this.controlRef.current, { target: n } = t;
    n && n !== e && !e?.contains(n) && this.handleDropdown("close");
  }
  highlightIndex(t, e = "smooth") {
    this.setState({ highlightedIndex: t }, () => {
      if (t === null || t === -1) return;
      (this.listRef.current?.listRef.current?.children ?? [])[t]?.scrollIntoView({
        behavior: e,
        block: "nearest",
        inline: "start"
      });
    });
  }
  handleKeyDown(t) {
    const { search: e, dropdownOpen: n, highlightedIndex: o, selectedItems: r } = this.state, { multiple: a, hideSelectedItems: l } = this.props, c = this.getAvailableItems(), d = t.key === "Escape", h = t.key === "Enter", u = t.key === "ArrowUp", p = t.key === "ArrowDown", m = t.key === "Backspace";
    if ((h || u || p) && t.preventDefault(), p && !n)
      return t.preventDefault(), this.handleDropdown("open");
    if (d && (n && t.stopPropagation(), this.handleDropdown("close")), m && a && !e) {
      const g = r[r.length - 1];
      g && this.handleRemove(g);
    }
    if (this.hasSuggestionComponent()) {
      if (p && (o === null || o === c.length - 1 || o === 0 && c.length === 0))
        return this.highlightIndex(-1);
      if (u && o === 0)
        return this.highlightIndex(-1);
      if (h && o === -1) {
        this.props.onSuggest?.(e), this.resetSearch();
        return;
      }
    }
    if (p && o === null)
      return this.highlightIndex(0);
    if (o !== null) {
      if (p && o === c.length - 1)
        return this.highlightIndex(0);
      if (p)
        return this.highlightIndex(o + 1);
      if (u && o > 0)
        return this.highlightIndex(o - 1);
      if (u && o <= 0)
        return this.highlightIndex(c.length - 1);
      if (h) {
        const g = c[o], b = g && this.isItemDisabled(g);
        if (g && !b) {
          this.handleSelect(g);
          const x = Math.min(
            l ? o : o + 1,
            c.length - 2
          );
          this.highlightIndex(x);
        }
      }
    }
  }
  handleSelect(t) {
    const { multiple: e, keepOpen: n, onSelect: o } = this.props;
    if (e) {
      const r = this.isItemSelected(t);
      this.handleChange(t, !r);
    } else
      this.setState({
        selectedItems: [t],
        dropdownOpen: n ?? !1
      }), this.resetSearch(), o?.(t);
  }
  handleChange(t, e) {
    const { onChange: n } = this.props, { selectedItems: o } = this.state;
    this.setState({
      selectedItems: e ? [...o, t] : o.filter((r) => r.id !== t.id)
    }), this.resetSearch(), n?.(t, e);
  }
  handleRemove(t, e) {
    e && (e.preventDefault(), e.stopPropagation()), this.handleChange(t, !1);
  }
  handleClear(t) {
    t.stopPropagation();
    const { onClear: e } = this.props;
    e?.(), this.setState({ selectedItems: [] });
  }
  handleDropdownClick(t) {
    t.stopPropagation();
  }
  getPlaceholder() {
    return this.state.selectedItems.length ? "" : this.props.placeholder;
  }
  getInputSize() {
    return this.state.search ? this.state.search.length : this.state.selectedItems?.length ? 5 : this.props.placeholder?.length || 5;
  }
  getItemName(t) {
    return t.name.toString().trim();
  }
  getAvailableItems() {
    const { search: t } = this.state, { items: e, hideSelectedItems: n, onSearch: o, searchBy: r } = this.props, a = new RegExp(Ms(t), "i");
    return e.filter((c) => {
      const d = [];
      return t && !o && (r && typeof r == "function" ? d.push(r(c, t)) : r && r instanceof Array ? d.push(
        r.some((h) => {
          const u = c[h];
          return (typeof u == "string" || typeof u == "number") && a.test(u.toString().trim());
        })
      ) : d.push(a.test(this.getItemName(c)))), n && d.push(!this.isItemSelected(c)), d.every((h) => h);
    });
  }
  isItemSelected(t) {
    return this.state.selectedItems.some(
      (e) => e.id === t.id
    );
  }
  isItemDisabled(t) {
    return this.props.disabledItems?.includes(t.id);
  }
  isEmpty() {
    return this.state.selectedItems.length === 0;
  }
  hasSuggestionComponent(t) {
    return !!this.state.search && typeof this.props.suggestionComponent == "function";
  }
  renderHiddenItems() {
    const { limit: t } = this.props, { selectedItems: e } = this.state;
    if (t && t > 0)
      return /* @__PURE__ */ s.jsx(B, { flexDirection: "column", children: e?.slice(t).map((n) => /* @__PURE__ */ s.jsxs(
        B,
        {
          alignItems: "center",
          justifyContent: "space-between",
          "data-testid": "select-hidden-item",
          children: [
            /* @__PURE__ */ s.jsx(at, { margin: "0 400 0 0", children: this.getItemName(n) }),
            /* @__PURE__ */ s.jsx(
              K,
              {
                icon: "close",
                variant: "tertiary",
                onClick: (o) => this.handleRemove(n, o)
              }
            )
          ]
        },
        n.id
      )) });
  }
  renderSelection(t) {
    return this.props.renderSelection?.(t) ?? this.getItemName(t);
  }
  renderMultipleSelection() {
    const { selectedItems: t } = this.state, e = this.props.limit || t.length, n = e < t.length, o = t?.slice(0, e).map((r) => {
      const a = this.renderSelection(r);
      return /* @__PURE__ */ s.jsx(
        "div",
        {
          onClick: (l) => l.stopPropagation(),
          "data-testid": "select-selection",
          className: q.selectionItem,
          children: /* @__PURE__ */ s.jsx(
            ke,
            {
              className: q.tag,
              tagNameClassName: q.tagName,
              onDelete: (l) => this.handleRemove(r, l),
              color: r.color,
              noTruncation: !0,
              "data-testid": "select-tag",
              children: a
            }
          )
        },
        r.id
      );
    });
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      o,
      n && /* @__PURE__ */ s.jsx("div", { onClick: (r) => r.stopPropagation(), children: /* @__PURE__ */ s.jsx(
        st,
        {
          content: this.renderHiddenItems(),
          requireClick: !0,
          "data-testid": "select-limiter",
          light: !0,
          children: /* @__PURE__ */ s.jsxs(
            ke,
            {
              className: f(q.tag, q.tagLimiter),
              noTruncation: !0,
              children: [
                "+",
                t.length - e
              ]
            }
          )
        }
      ) })
    ] });
  }
  renderSingleSelection() {
    const { search: t, selectedItems: e } = this.state, n = e[0], o = /* @__PURE__ */ s.jsx("span", { style: { width: 0 }, "data-testid": "select-selection-empty", children: " " });
    return n ? /* @__PURE__ */ s.jsx(
      "span",
      {
        className: q.text,
        "aria-hidden": !!t,
        "data-testid": "select-selection",
        children: this.renderSelection(n)
      }
    ) : o;
  }
  renderSearch() {
    const { searchable: t } = this.props;
    return !t && !this.isEmpty() ? null : /* @__PURE__ */ s.jsx(
      "input",
      {
        className: q.search,
        ref: this.searchRef,
        tabIndex: -1,
        onFocus: (e) => e.stopPropagation(),
        value: this.state.search,
        size: this.getInputSize(),
        onChange: this.handleSearch,
        placeholder: this.getPlaceholder(),
        autoComplete: "off",
        readOnly: !t,
        "aria-autocomplete": "list",
        "aria-controls": this.a11y.dropdown,
        "aria-labelledby": this.a11y.label,
        "data-testid": "select-input"
      }
    );
  }
  renderDropdown() {
    const { dropdownOpen: t, highlightedIndex: e, search: n } = this.state, {
      disabledItems: o,
      tooltipItems: r,
      emptyComponent: a,
      suggestionComponent: l,
      emptyMessage: c,
      pagination: d,
      dropdownProps: h,
      searchSuggestion: u,
      renderSuggestion: p,
      onSuggest: m,
      multiple: g
    } = this.props, b = f(
      {
        [q.dropdown]: !0,
        [q.dropdownFixed]: h?.fixed ?? !1
      },
      h?.className
    ), x = this.getAvailableItems(), y = x[e ?? -1] ?? null, _ = !x.length;
    return /* @__PURE__ */ s.jsxs(
      Jt,
      {
        onClick: this.handleDropdownClick,
        ...h,
        className: b,
        isOpen: t,
        "data-testid": "select-dropdown",
        children: [
          _ && typeof a == "function" && /* @__PURE__ */ s.jsx(
            a,
            {
              label: c ?? "No options",
              "data-testid": "select-dropdown-empty"
            }
          ),
          this.hasSuggestionComponent(l) && /* @__PURE__ */ s.jsx(
            l,
            {
              searched: n,
              onSuggest: m,
              triggerClose: g ? void 0 : () => this.handleDropdown("close"),
              items: x,
              active: e === -1,
              clearSearch: this.resetSearch,
              searchSuggestion: u,
              renderSuggestion: p
            }
          ),
          !_ && /* @__PURE__ */ s.jsx(
            Ys,
            {
              id: this.a11y.dropdown,
              ariaLabelledby: this.a11y.label,
              ref: this.listRef,
              pagination: d,
              items: x,
              clearSearch: this.resetSearch,
              onSelect: this.handleSelect,
              onChange: this.handleChange,
              onKeyDown: this.handleKeyDown,
              selectedItems: this.state.selectedItems,
              disabledItems: o,
              tooltipItems: r,
              activeItem: y,
              itemComponent: this.props.itemComponent
            }
          ),
          !!d && !d.infinite && /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: q.pagination,
              "data-testid": "select-dropdown-pagination",
              children: [
                /* @__PURE__ */ s.jsx(
                  X,
                  {
                    variant: "secondary",
                    disabled: !d.previousEnable,
                    onClick: d.onPrevious,
                    children: "Prev page"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  X,
                  {
                    variant: "secondary",
                    disabled: !d.nextEnable,
                    onClick: d.onNext,
                    children: "Next page"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
  render() {
    const {
      className: t,
      disabled: e,
      hasDropDownIndicator: n,
      loading: o,
      multiple: r,
      searchable: a,
      clearable: l,
      prefix: c,
      suffix: d,
      icon: h,
      status: u
    } = this.props, { search: p, dropdownOpen: m } = this.state, g = f(
      {
        [q.root]: !0,
        [q.rootSingle]: !r,
        [q.rootDisabled]: e,
        [q.rootSearchable]: a,
        [q.rootDropdownOpen]: m,
        [q.rootIsSearching]: !!p,
        [q.rootHasIcon]: !!h
      },
      t
    ), b = p ? void 0 : () => this.handleDropdown("toggle");
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: g,
        role: "combobox",
        "aria-expanded": m,
        "aria-owns": this.a11y.dropdown,
        "aria-haspopup": "listbox",
        "data-testid": "select-root",
        children: [
          /* @__PURE__ */ s.jsx(
            Et,
            {
              prefix: c,
              suffix: d,
              icon: h,
              status: u,
              active: m,
              disabled: e,
              className: q.inputWrapper,
              children: /* @__PURE__ */ s.jsxs(
                "div",
                {
                  className: q.control,
                  ref: this.controlRef,
                  onKeyDown: this.handleKeyDown,
                  onClick: b,
                  tabIndex: e ? -1 : 0,
                  "aria-activedescendant": this.a11y.option,
                  "data-testid": "select-control",
                  children: [
                    /* @__PURE__ */ s.jsxs("div", { className: q.selection, children: [
                      r ? this.renderMultipleSelection() : this.renderSingleSelection(),
                      this.renderSearch()
                    ] }),
                    /* @__PURE__ */ s.jsxs("div", { className: q.indicators, children: [
                      o && /* @__PURE__ */ s.jsx(
                        Un,
                        {
                          className: q.spinner,
                          size: 16,
                          "aria-label": "Loading",
                          "data-testid": "select-loading"
                        }
                      ),
                      !this.isEmpty() && l && /* @__PURE__ */ s.jsx(
                        K,
                        {
                          tabIndex: -1,
                          className: q.clearIndicator,
                          icon: "close",
                          variant: "tertiary",
                          onClick: this.handleClear,
                          "aria-label": "Clear",
                          "data-testid": "select-clear"
                        }
                      ),
                      n && /* @__PURE__ */ s.jsx(
                        K,
                        {
                          tabIndex: -1,
                          className: q.dropdownIndicator,
                          icon: m ? "angle-up" : "angle-down",
                          variant: "tertiary",
                          onClick: (x) => {
                            x.stopPropagation(), this.handleDropdown("toggle");
                          },
                          "aria-label": m ? "Close" : "Open",
                          "data-testid": "select-toggle"
                        }
                      )
                    ] })
                  ]
                }
              )
            }
          ),
          !e && m && this.renderDropdown()
        ]
      }
    );
  }
}
function Kp(i) {
  return /* @__PURE__ */ s.jsx(
    zs,
    {
      fallback: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: "Something went wrong" }) }),
      children: /* @__PURE__ */ s.jsx(Te, { ...i })
    }
  );
}
const Up = "h-datePicker-timezoneSelector--timezoneSelector__root", qp = "h-datePicker-timezoneSelector--timezoneSelector__label", Ro = {
  root: Up,
  label: qp
}, Or = ({
  disabled: i,
  tooltipProps: t,
  selectedTimezone: e,
  onChange: n
}) => {
  const o = j.tz.guess(!0), r = F((h, u) => {
    const [p, m] = j.tz(h).format("Z").split(":"), [g, b] = j.tz(u).format("Z").split(":");
    return +parseInt(p) * 60 + parseInt(m) - (+parseInt(g) * 60 + parseInt(b));
  }, []), a = (h) => `(GMT${j.tz(h).format("Z")})`, l = (h) => `${a(h)} ${h}`, c = U(() => {
    const h = j.tz.names().filter((m) => m !== o), u = {
      id: o,
      name: `Default ${a(o)}`
    }, p = h.sort(r).map((m) => ({ id: m, name: l(m) }));
    return [u, ...p];
  }, [r]), d = ({ id: h }) => {
    n(h);
  };
  return /* @__PURE__ */ s.jsxs("div", { className: Ro.root, children: [
    /* @__PURE__ */ s.jsx(Gs, { className: Ro.label, children: "Time zone" }),
    /* @__PURE__ */ s.jsx(st, { ...t, side: "top", children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
      Kp,
      {
        disabled: i,
        items: c,
        onSelect: d,
        selectedItems: [
          De(e) ? e : o
        ],
        searchable: !0
      }
    ) }) })
  ] });
}, Gp = "h-fieldAlert--fieldAlert__root", Yp = "h-fieldAlert--fieldAlert__alert", Xp = "h-fieldAlert--fieldAlert__icon", ms = {
  root: Gp,
  alert: Yp,
  icon: Xp
}, Qp = "h-fieldAlert-fieldAlertButton--fieldAlertButton__root", Zp = {
  root: Qp
};
function Jp({
  className: i,
  variant: t = "tertiary",
  ...e
}) {
  return /* @__PURE__ */ s.jsx(
    X,
    {
      ...e,
      variant: t,
      className: f(i, Zp.root)
    }
  );
}
const tm = {
  error: "exclamation-circle-filled",
  warning: "exclamation-triangle-filled",
  success: "check-circle-filled",
  title: null
};
function Zn({
  children: i,
  className: t,
  ...e
}) {
  const n = e.variant || "title", o = f(ms.root, t), [r, a] = V(!1), l = tm[n], c = F(
    (d) => {
      if (!d) return;
      const { offsetWidth: h, scrollWidth: u } = d;
      a(h < u);
    },
    [i]
  );
  return /* @__PURE__ */ s.jsxs(A.Input, { ...e, variant: n, className: o, children: [
    !!l && /* @__PURE__ */ s.jsx(N, { className: ms.icon, name: l }),
    /* @__PURE__ */ s.jsx("div", { className: ms.alert, ref: c, children: r ? /* @__PURE__ */ s.jsx(st, { content: i, children: i }) : i })
  ] });
}
Zn.Button = Jp;
const yn = (i, t = 0) => {
  if (!i)
    return t;
  if (typeof i == "number")
    return i;
  const e = parseFloat(i);
  return isNaN(e) ? t : e;
}, em = "h-inputText-inputNumberArrows--inputNumberArrows__root", nm = "h-inputText-inputNumberArrows--inputNumberArrows__button", sm = "h-inputText-inputNumberArrows--inputNumberArrows__buttonUp", om = "h-inputText-inputNumberArrows--inputNumberArrows__buttonDown", rm = "h-inputText-inputNumberArrows--inputNumberArrows__spacer", fe = {
  root: em,
  button: nm,
  buttonUp: sm,
  buttonDown: om,
  spacer: rm
}, im = 50, Eo = 300, am = "inputNumberArrowsTestId";
class lm extends D {
  intervalId;
  timeoutId;
  constructor(t) {
    super(t), this.intervalId = null, this.timeoutId = null, this.increaseValue = this.increaseValue.bind(this), this.decreaseValue = this.decreaseValue.bind(this), this.startIncreaseValue = this.startIncreaseValue.bind(this), this.startDecreaseValue = this.startDecreaseValue.bind(this), this.stopChangeValue = this.stopChangeValue.bind(this);
  }
  componentDidMount() {
    window.addEventListener("mouseup", this.stopChangeValue);
  }
  componentWillUnmount() {
    window.removeEventListener("mouseup", this.stopChangeValue);
  }
  getNewValue(t) {
    const {
      step: e,
      min: n,
      max: o,
      inputRef: { current: r }
    } = this.props;
    if (!r)
      return 0;
    const a = yn(r.value), l = yn(e, 1), c = yn(n, Number.MIN_SAFE_INTEGER), d = yn(o, Number.MAX_SAFE_INTEGER);
    return t == "decrease" ? Math.max(a - l, c) : Math.min(a + l, d);
  }
  startIncreaseValue() {
    this.timeoutId = setTimeout(
      () => this.startChangeValue("increase"),
      Eo
    );
  }
  startDecreaseValue() {
    this.timeoutId = setTimeout(
      () => this.startChangeValue("decrease"),
      Eo
    );
  }
  startChangeValue(t) {
    this.intervalId || (this.intervalId = setInterval(
      () => this.triggerInputChange(t),
      im
    ));
  }
  stopChangeValue() {
    this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = null), this.intervalId && (clearInterval(this.intervalId), this.intervalId = null);
  }
  increaseValue(t) {
    t.preventDefault(), this.triggerInputChange("increase");
  }
  decreaseValue(t) {
    t.preventDefault(), this.triggerInputChange("decrease");
  }
  triggerInputChange(t) {
    const {
      inputRef: { current: e },
      readOnly: n
    } = this.props;
    if (!e || n)
      return;
    const o = this.getNewValue(t), r = new Event("input", { bubbles: !0 }), a = Object.getPrototypeOf(e);
    Object.getOwnPropertyDescriptor(
      a,
      "value"
    )?.set?.call(e, o), e.dispatchEvent(r), e.focus();
  }
  render() {
    return /* @__PURE__ */ s.jsxs("div", { className: fe.root, "data-testid": am, children: [
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: f(fe.button, fe.buttonUp),
          tabIndex: -1,
          onClick: this.increaseValue,
          onMouseDown: this.startIncreaseValue,
          children: /* @__PURE__ */ s.jsx(N, { name: "angle-up" })
        }
      ),
      /* @__PURE__ */ s.jsx("span", { className: fe.spacer }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: f(fe.button, fe.buttonDown),
          tabIndex: -1,
          onClick: this.decreaseValue,
          onMouseDown: this.startDecreaseValue,
          children: /* @__PURE__ */ s.jsx(N, { name: "angle-down" })
        }
      )
    ] });
  }
}
const cm = "h-inputText--inputText__rootReadOnly", dm = "h-inputText--inputText__container", hm = "h-inputText--inputText__rootHasIcon", um = "h-inputText--inputText__rootTypeNumber", pm = "h-inputText--inputText__input", ze = {
  rootReadOnly: cm,
  container: dm,
  rootHasIcon: hm,
  rootTypeNumber: um,
  input: pm
}, mm = "inputText", qt = $(function(t, e) {
  const n = G(null);
  je(e, () => n.current);
  const {
    className: o,
    disabled: r,
    readOnly: a,
    type: l = "text",
    name: c,
    prefix: d,
    suffix: h,
    icon: u,
    status: p,
    min: m,
    max: g,
    step: b,
    hideNumberArrows: x = !1,
    active: y = !1,
    ..._
  } = t, C = f(o, {
    [ze.rootTypeNumber]: l === "number",
    [ze.rootHasIcon]: !!u,
    [ze.rootReadOnly]: a
  });
  return /* @__PURE__ */ s.jsx(
    Et,
    {
      className: C,
      status: p,
      disabled: r,
      active: y,
      prefix: d,
      suffix: h,
      icon: u,
      children: /* @__PURE__ */ s.jsxs("div", { className: ze.container, children: [
        /* @__PURE__ */ s.jsx(
          "input",
          {
            "data-testid": mm,
            dir: "auto",
            id: c,
            name: c,
            ref: n,
            ..._,
            min: m,
            max: g,
            step: b,
            type: l,
            disabled: r,
            readOnly: a,
            className: ze.input
          }
        ),
        l === "number" && !x && /* @__PURE__ */ s.jsx(
          lm,
          {
            min: m,
            max: g,
            step: b,
            inputRef: n,
            readOnly: a
          }
        )
      ] })
    }
  );
}), gm = "hmm A", fm = (i, t) => {
  const e = `${i}`.padStart(2, "0"), n = `${t}`.padStart(2, "0");
  return `${e}:${n}`;
}, Lo = (i, t) => {
  const e = i.hours(), n = i.minutes();
  return {
    id: fm(e, n),
    name: i.format(t)
  };
}, sn = ({
  hasDropDownIndicator: i = !0,
  allowCustomTimeInput: t = !1,
  timeOptions: e,
  overrides: n,
  selectedItems: o,
  selectableHours: r = kr,
  selectableMinutes: a = Tr,
  timeFormat: l = j.localeData().longDateFormat("LT"),
  onSelect: c,
  onIsCustomTimeValid: d,
  ...h
}) => {
  const [u] = o || [], [p, m] = V(
    () => typeof u == "object" ? u?.id : u || null
  ), [g, b] = V(""), x = U(
    () => e || Rr({
      hours: r,
      minutes: a,
      overrides: n,
      timeFormat: l
    }),
    [
      e,
      r,
      a,
      n,
      l
    ]
  ), y = U(() => {
    const w = j(
      g || (typeof u == "object" ? u.id : u) || p,
      [l, gm]
    );
    if (!w.isValid())
      return null;
    const S = w.hours(), I = w.minutes();
    if (!d || d(S, I))
      return Lo(w, l);
    const T = S <= 12, R = S + 12, E = d(R, I);
    return T && E ? Lo(j({ hours: R, minutes: I }), l) : null;
  }, [u, g]), _ = U(() => {
    if (!t)
      return x;
    const w = p ? x.filter(({ name: S }) => S !== y?.name) : x.filter(
      ({ name: S }) => S.startsWith(g) && S !== y?.name
    );
    if (!y)
      return w;
    const v = p !== y.id ? 0 : w.findIndex(
      (S) => j(S.id, [l]) > j(y.id, [l])
    );
    return w.splice(
      // If it's -1 then there was no later time, so add it to the end.
      v === -1 ? w.length : v,
      0,
      y
    ), w;
  }, [y, g, p, x]), C = F(
    (w) => {
      w?.id !== y?.id && b(""), c(w?.id || null), m(w?.id || null);
    },
    [y]
  );
  return Z(() => {
    u ? (b(""), m(
      typeof u == "object" ? u.id : u
    )) : m(null);
  }, [u]), /* @__PURE__ */ s.jsx(
    Te,
    {
      searchable: !0,
      placeholder: jr(l),
      ...h,
      selectedItems: o,
      hasDropDownIndicator: i,
      items: t ? _ : x,
      onChange: L,
      onClear: C,
      onSelect: C,
      ...t && { onSearch: b }
    }
  );
}, bm = "h-timePicker-range--timeRangePicker__root", xm = "h-timePicker-range--timeRangePicker__timePickerFrom", ym = "h-timePicker-range--timeRangePicker__timePickerTo", _m = "h-timePicker-range--timeRangePicker__arrowContainer", Cm = "h-timePicker-range--timeRangePicker__arrowContainerHasError", wm = "h-timePicker-range--timeRangePicker__arrowContainerHasWarning", vm = "h-timePicker-range--timeRangePicker__arrowContainerHasSuccess", ne = {
  root: bm,
  timePickerFrom: xm,
  timePickerTo: ym,
  arrowContainer: _m,
  arrowContainerHasError: Cm,
  arrowContainerHasWarning: wm,
  arrowContainerHasSuccess: vm
}, Sm = ({
  className: i,
  disabled: t,
  endTime: e,
  onSelect: n,
  overrides: o,
  placeholder: r,
  selectableHours: a = kr,
  selectableMinutes: l = Tr,
  status: c,
  startTime: d,
  allowCustomTimeInput: h = !1,
  timeFormat: u = j.localeData().longDateFormat("LT"),
  ...p
}) => {
  const [{ startTime: m, endTime: g }, b] = V({
    startTime: d || null,
    endTime: e || null
  }), x = U(
    () => Rr({
      hours: a,
      minutes: l,
      overrides: o,
      timeFormat: u
    }),
    [a, l, o, u]
  ), y = U(() => {
    const v = x.map(
      ({ id: T }) => j(T, [u])
    ), S = j(m, [u]), I = m && v.findIndex(
      (T) => T > S
    ) || 0;
    return x.slice(I);
  }, [x, m, u]);
  Z(() => {
    const v = typeof d == "string", S = typeof d == "string";
    (v && d !== m || S && e !== g) && b((I) => ({
      ...I,
      ...v && { startTime: d },
      ...S && { endTime: e }
    }));
  });
  const _ = F(
    (v) => (S) => void b((I) => {
      const T = j(S, [u]), R = j(I.startTime, [u]), E = j(I.endTime, [u]), k = x.map(
        ({ id: et }) => j(et, [u])
      ), P = k.findIndex(
        (et) => et >= T
      ) || -1, H = v === "startTime" ? P : k.findIndex(
        (et) => et >= R
      ), nt = v === "endTime" ? -1 : k.findIndex(
        (et) => et >= E
      ), ot = {
        ...I,
        [v]: S,
        ...I.endTime !== null && v !== "endTime" && H >= nt && {
          endTime: x[P + 1]?.id || null
        }
      };
      return n(ot), ot;
    }),
    [n]
  ), C = F(
    (v, S) => {
      const I = j(m, [u]);
      if (!I.isValid())
        return !0;
      const R = I.hours(), E = I.minutes();
      return R < v || R === v && E < S;
    },
    [m, u]
  ), w = (v) => r?.[v] || r || jr(u);
  return /* @__PURE__ */ s.jsxs(at, { className: f(ne.root, i), children: [
    /* @__PURE__ */ s.jsx(
      sn,
      {
        className: ne.timePickerFrom,
        searchable: !0,
        ...p,
        disabled: t,
        hasDropDownIndicator: !1,
        timeOptions: x,
        onSelect: _("startTime"),
        placeholder: w("startTime"),
        allowCustomTimeInput: h,
        selectedItems: m ? [m] : [],
        status: c
      }
    ),
    /* @__PURE__ */ s.jsx(
      at,
      {
        className: f(ne.arrowContainer, {
          [ne.arrowContainerHasError]: c === "error",
          [ne.arrowContainerHasWarning]: c === "warning",
          [ne.arrowContainerHasSuccess]: c === "success"
        }),
        children: /* @__PURE__ */ s.jsx(N, { name: "arrow-right" })
      }
    ),
    /* @__PURE__ */ s.jsx(
      sn,
      {
        className: ne.timePickerTo,
        searchable: !0,
        disabled: t || !m,
        ...p,
        hasDropDownIndicator: !1,
        timeOptions: y,
        onSelect: _("endTime"),
        placeholder: w("endTime"),
        ...h && {
          allowCustomTimeInput: h,
          onIsCustomTimeValid: C
        },
        selectedItems: g ? [g] : [],
        status: c
      }
    )
  ] });
};
class Ut {
  constructor(t, e, n) {
    this.dateFormat = t, this.dateParser = e, this.dateRangeConstraint = n, this.dateFormat = t, this.dateParser = e, this.dateRangeConstraint = n;
  }
  static validationOK = { isValid: !0, error: null };
  isValidDate(t) {
    try {
      return this.dateParser(t).isValid();
    } catch {
      return !1;
    }
  }
  isSingleDateValid(t) {
    if (!this.isValidDate(t))
      return {
        isValid: !1,
        error: "Date is not valid"
      };
    const { minDate: e, maxDate: n } = this.dateRangeConstraint, o = this.dateParser(t);
    return o.isBefore(e, "day") ? {
      isValid: !1,
      error: `Date must be after ${e.format(this.dateFormat)}`
    } : o.isAfter(n, "day") ? {
      isValid: !1,
      error: `Date must be before ${n.format(this.dateFormat)}`
    } : Ut.validationOK;
  }
  /**
   * Mind that this is dependant on end date as well because it's a range
   */
  isStartDateValid({
    startDateInputValue: t,
    endDateInputValue: e
  }) {
    const { minDate: n, maxDate: o } = this.dateRangeConstraint;
    if (!this.isValidDate(t))
      return {
        isValid: !1,
        error: "From date is not valid"
      };
    const r = this.dateParser(t), a = this.dateParser(e);
    return r.isBefore(n, "day") ? {
      isValid: !1,
      error: `From date must be after ${n.format(this.dateFormat)}`
    } : e && this.isValidDate(e) && r.isAfter(a, "day") ? {
      isValid: !1,
      error: `From date must be before ${a.format(
        this.dateFormat
      )}`
    } : r.isAfter(o, "day") ? {
      isValid: !1,
      error: `From date must be before ${o.format(this.dateFormat)}`
    } : Ut.validationOK;
  }
  /**
   * Mind that this is dependant on start date as well because it's a range
   */
  isEndDateValid({
    startDateInputValue: t,
    endDateInputValue: e
  }) {
    const { minDate: n, maxDate: o } = this.dateRangeConstraint;
    if (!this.isValidDate(e))
      return {
        isValid: !1,
        error: "To date is not valid"
      };
    const r = this.dateParser(t), a = this.dateParser(e);
    return a.isAfter(o, "day") ? {
      isValid: !1,
      error: `To date must be before ${o.format(this.dateFormat)}`
    } : t && this.isValidDate(t) && a.isBefore(r, "day") ? {
      isValid: !1,
      error: `To date must be after ${r.format(
        this.dateFormat
      )}`
    } : a.isBefore(n, "day") ? {
      isValid: !1,
      error: `To date must be after ${n.format(this.dateFormat)}`
    } : Ut.validationOK;
  }
  isTimeOrderValid({
    startDate: t,
    endDate: e
  }) {
    return !t || !e ? Ut.validationOK : t.isAfter(e) ? {
      isValid: !1,
      error: "From time should be before to time"
    } : Ut.validationOK;
  }
}
const Im = "h-datePicker-range-inputFields--dateRangePickerInputFields__root", Dm = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTop", km = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTopWithTimezoneSelector", Tm = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementBottom", jm = "h-datePicker-range-inputFields--dateRangePickerInputFields__fields", Nm = "h-datePicker-range-inputFields--dateRangePickerInputFields__input", Fm = "h-datePicker-range-inputFields--dateRangePickerInputFields__alert", zt = {
  root: Im,
  rootPlacementTop: Dm,
  rootPlacementTopWithTimezoneSelector: km,
  rootPlacementBottom: Tm,
  fields: jm,
  input: Nm,
  alert: Fm
};
Array(24).fill(0).map((i, t) => t);
class Qs extends D {
  dateRangeValidators;
  timeOptions;
  instanceId;
  constructor(t) {
    super(t);
    const { dateFormat: e } = t;
    this.state = {
      startDateInputValue: this.props.startDate?.format(e) ?? "",
      startDateError: null,
      endDateInputValue: this.props.endDate?.format(e) ?? "",
      endDateError: null,
      timeOrderError: null
    }, this.timeOptions = [], this.instanceId = Qs.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateStartDateChangeEvent = this.propagateStartDateChangeEvent.bind(this), this.propagateEndDateChangeEvent = this.propagateEndDateChangeEvent.bind(this), this.dateRangeValidators = new Ut(
      t.dateFormat,
      this.parseDateString,
      { maxDate: t.maxDate, minDate: t.minDate }
    );
  }
  componentDidUpdate(t) {
    this.syncStartDateWithProps(t), this.syncEndDateWithProps(t), this.validateTimesOrder();
  }
  static instanceCount = 0;
  validateTimesOrder() {
    const { startDate: t, endDate: e } = this.props, { isValid: n, error: o } = this.dateRangeValidators.isTimeOrderValid({
      startDate: t,
      endDate: e
    });
    n ? this.setState({ timeOrderError: null }) : this.setState({
      timeOrderError: o
    });
  }
  syncEndDateWithProps(t) {
    const { endDate: e, timeRoundingStrategy: n } = this.props;
    if (!(e === t.endDate || e?.isSame(t.endDate, n)))
      return this.props.endDate ? this.setState({
        endDateError: null,
        endDateInputValue: this.props.endDate.format(this.props.dateFormat)
      }) : this.setState({
        endDateError: null,
        endDateInputValue: ""
      });
  }
  syncStartDateWithProps(t) {
    const { startDate: e, timeRoundingStrategy: n } = this.props;
    if (!(e === t.startDate || e?.isSame(t.startDate, n)))
      return this.props.startDate ? this.setState({
        startDateError: null,
        startDateInputValue: this.props.startDate.format(this.props.dateFormat)
      }) : this.setState({
        startDateError: null,
        startDateInputValue: ""
      });
  }
  handleInputValueChange(t, e) {
    const n = t.target.value;
    switch (e) {
      case "startDate":
        this.setState(
          { startDateInputValue: this.ensureValidChars(n) },
          this.propagateStartDateChangeEvent
        );
        break;
      case "endDate":
        this.setState(
          { endDateInputValue: this.ensureValidChars(n) },
          this.propagateEndDateChangeEvent
        );
        break;
    }
  }
  propagateStartDateChangeEvent() {
    const { startDateInputValue: t, endDateInputValue: e } = this.state;
    if (t === "") {
      this.props.onStartDateChange(null);
      return;
    }
    const { isValid: n, error: o } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    });
    if (!n) {
      this.setState({ startDateError: o });
      return;
    }
    const { isValid: r, error: a } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    }), l = e !== "" && !r ? a : null;
    this.setState(
      {
        startDateError: null,
        endDateError: l
      },
      () => this.props.onStartDateChange(this.parseDateString(t))
    );
  }
  propagateEndDateChangeEvent() {
    const { startDateInputValue: t, endDateInputValue: e } = this.state;
    if (e === "") {
      this.props.onEndDateChange(null);
      return;
    }
    const { isValid: n, error: o } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    });
    if (!n) {
      this.setState({ endDateError: o });
      return;
    }
    const { isValid: r, error: a } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    }), l = t !== "" && !r ? a : null;
    this.setState(
      {
        endDateError: null,
        startDateError: l
      },
      () => this.props.onEndDateChange(this.parseDateString(e))
    );
  }
  parseDateString(t) {
    return j(t, this.props.dateFormat, !0);
  }
  ensureValidChars(t) {
    return t.replace(/[^0-9/]/g, "");
  }
  getOverrides(t) {
    if (t !== "startTime")
      return [
        {
          hour: 23,
          minute: 59
        }
      ];
  }
  renderFields(t, e, n, o, r, a, l) {
    const {
      dateFormat: c,
      disabled: d,
      focusedInput: h,
      onFocusChange: u,
      onTimeChange: p,
      timeFormat: m,
      withTimePicker: g,
      withDateInput: b
    } = this.props, { timeOrderError: x } = this.state;
    return /* @__PURE__ */ s.jsxs("div", { children: [
      /* @__PURE__ */ s.jsx(Gs, { children: t === "startDate" ? "From" : "To" }),
      b && /* @__PURE__ */ s.jsx(
        qt,
        {
          className: zt.input,
          placeholder: c.toLowerCase(),
          name: `input__${t}__${this.instanceId}`,
          value: r,
          onChange: (y) => this.handleInputValueChange(y, t),
          onFocus: () => u(t),
          autoComplete: "off",
          status: a ? "error" : void 0,
          disabled: d,
          active: h === t
        }
      ),
      g && /* @__PURE__ */ s.jsx("div", { className: zt.input, children: /* @__PURE__ */ s.jsx(
        st,
        {
          content: "Please select a date first.",
          disabled: !!n || d,
          side: "right",
          children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
            sn,
            {
              disabled: !n,
              overrides: this.getOverrides(e),
              selectedItems: o ? [o] : void 0,
              status: x ? "error" : void 0,
              ...l,
              timeFormat: m,
              onSelect: (y) => p(e, y)
            }
          ) })
        }
      ) })
    ] });
  }
  getError() {
    const { startDateError: t, endDateError: e, timeOrderError: n } = this.state;
    return t || e || n || null;
  }
  renderErrors() {
    const t = this.getError();
    return /* @__PURE__ */ s.jsx(
      Zn,
      {
        className: zt.alert,
        variant: t ? "error" : void 0,
        children: t
      }
    );
  }
  render() {
    const {
      startDate: t,
      startTime: e,
      endDate: n,
      endTime: o,
      timePickerProps: r = { start: {}, end: {} },
      hasTimezoneSelector: a
    } = this.props, {
      startDateInputValue: l,
      startDateError: c,
      endDateInputValue: d,
      endDateError: h
    } = this.state, { placement: u } = this.props, p = f(zt.root, {
      [zt.rootPlacementTop]: u === "top",
      [zt.rootPlacementTopWithTimezoneSelector]: u === "top" && a,
      [zt.rootPlacementBottom]: u === "bottom"
    });
    return /* @__PURE__ */ s.jsxs("div", { className: p, children: [
      /* @__PURE__ */ s.jsxs("div", { className: zt.fields, children: [
        this.renderFields(
          "startDate",
          "startTime",
          t,
          e,
          l,
          c,
          r.start
        ),
        this.renderFields(
          "endDate",
          "endTime",
          n,
          o,
          d,
          h,
          r.end
        )
      ] }),
      this.renderErrors()
    ] });
  }
}
const Pm = "dateRangePickerTestId";
class Rm extends D {
  static defaultProps = {
    withDateInput: !0,
    withTimePicker: !1,
    timePickerProps: { start: {}, end: {} },
    inputsPlacement: "bottom",
    timeRoundingStrategy: "day"
  };
  constructor(t) {
    super(t);
    const {
      startDate: e,
      endDate: n,
      timezone: o,
      presetKey: r,
      presets: a,
      focusedInput: l = "startDate"
    } = t;
    this.state = {
      startTime: e ? j(e).format(Nt) : null,
      endTime: n ? j(n).format(Nt) : null,
      timezone: De(o) ? o : j.tz.guess(!0),
      presetKey: a?.find(({ key: c }) => c === r)?.key ?? null,
      focusedInput: l,
      dateRangePickerKey: 0
    }, this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onDatesChange = this.onDatesChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.handleFocusChange = this.handleFocusChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onStartDateChange = this.onStartDateChange.bind(this), this.onEndDateChange = this.onEndDateChange.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(t) {
    this.updateTimeOnDateChange(t), this.recalculateDatePickerKey(t), this.updateTimezoneFromProps(t), this.updatePresetKey(t);
  }
  visibleCalendarMonthRef = O();
  updatePresetKey(t) {
    const { presetKey: e } = this.props;
    t.presetKey !== e && this.setState({
      presetKey: this.props.presets?.find(({ key: n }) => n === e)?.key ?? null
    });
  }
  updateTimezoneFromProps(t) {
    const { timezone: e } = this.props;
    t.timezone !== e && De(e) && this.setState({ timezone: e });
  }
  getDateConstraints() {
    const { maxDate: t, minDate: e } = this.props, n = this.dateFormat;
    return {
      minDate: e ? j(e, n) : j("0001-01-01"),
      maxDate: t ? j(t, n) : j("9999-12-31")
    };
  }
  onTimezoneChange(t) {
    const { startDate: e, endDate: n } = this.props, { presetKey: o } = this.state;
    this.setState(
      { timezone: t },
      () => this.onDatesChange({ startDate: e, endDate: n }, o)
    );
  }
  onStartDateChange(t) {
    this.onDatesChange({ startDate: t, endDate: this.props.endDate });
  }
  onEndDateChange(t) {
    this.onDatesChange({ endDate: t, startDate: this.props.startDate });
  }
  onDatesChange(t, e = null) {
    const { startTime: n, endTime: o, timezone: r } = this.state, { timeRoundingStrategy: a } = this.props, l = this.addTimezoneToDate(
      t.startDate,
      r
    ), c = this.addTimezoneToDate(
      t.endDate,
      r
    );
    let d = l?.clone().startOf(a) || null, h = c?.clone().endOf(a) || null, u = t.startDate?.clone().startOf(a) || null, p = t.endDate?.clone().endOf(a) || null;
    if (this.setState({ presetKey: e }), e) {
      this.setState(
        {
          startTime: t.startDate?.clone().startOf(a).format(Nt) ?? null,
          endTime: t.endDate?.clone().startOf(a).format(Nt) ?? null
        },
        () => {
          this.props.onChange({
            startDate: d,
            localStartDate: u,
            endDate: h,
            localEndDate: p,
            timezone: r,
            localTimezone: j.tz.guess(!0),
            presetKey: e
          });
        }
      );
      return;
    }
    n && (d = this.addTimeToDate(
      l,
      n,
      "startDate"
    ), u = this.addTimeToDate(
      t.startDate,
      n,
      "startDate"
    )), o && (h = this.addTimeToDate(c, o, "endDate"), p = this.addTimeToDate(t.endDate, o, "endDate")), this.props.onChange({
      startDate: d,
      localStartDate: u,
      endDate: h,
      localEndDate: p,
      timezone: r,
      localTimezone: j.tz.guess(!0)
    });
  }
  onPresetSelect(t) {
    if (!t)
      this.onDatesChange({ startDate: null, endDate: null });
    else {
      const { startDate: e, endDate: n, key: o } = t;
      this.onDatesChange({ startDate: e, endDate: n }, o);
    }
    this.handleFocusChange("startDate");
  }
  handleTimeChange(t, e) {
    const { startDate: n, endDate: o } = this.props;
    this.setState(
      (r) => ({
        ...r,
        [t]: e
      }),
      () => this.onDatesChange({ startDate: n, endDate: o })
    );
  }
  addTimezoneToDate(t, e) {
    if (!t) return null;
    const { timeRoundingStrategy: n } = this.props;
    return De(e) ? t.clone().tz(e, !0) : t.clone().startOf(n);
  }
  handleFocusChange(t) {
    this.setState({ focusedInput: t ?? "startDate" });
  }
  addTimeToDate(t, e, n) {
    if (!t)
      return null;
    const { timeRoundingStrategy: o } = this.props, [r, a] = e.split(":");
    return !r || !a ? n === "startDate" ? t.clone().startOf(o) : t.clone().endOf(o) : t.clone().set({
      hours: parseInt(r, 10),
      minutes: parseInt(a, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(t) {
    if (this.props.disabled)
      return !0;
    const { timeRoundingStrategy: e } = this.props, { minDate: n, maxDate: o } = this.getDateConstraints();
    return !t.isBetween(n, o, e);
  }
  updateTimeOnDateChange({
    startDate: t,
    endDate: e
  }) {
    const { startDate: n, endDate: o } = this.props;
    n?.isSame(t) || this.setState({
      startTime: n ? j(n).format(Nt) : null
    }), o?.isSame(e) || this.setState({
      endTime: o ? j(o).format(Nt) : null
    });
  }
  recalculateDatePickerKey({
    startDate: t,
    endDate: e
  }) {
    const { startDate: n, endDate: o } = this.props;
    if (e && t && !n && !o)
      return this.setState({ dateRangePickerKey: this.generateRandomKey() });
    if (!(!o && !e) && !(!o && e)) {
      if (o && !e) {
        const r = this.visibleCalendarMonthRef.current?.state.currentMonth;
        if (this.visibleCalendarMonthRef.current && o.isSame(r, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
      if (o && e) {
        if (o.isSame(e, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
    }
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  get dateFormat() {
    const { dateFormat: t } = this.props;
    return t || j.localeData().longDateFormat("L");
  }
  renderTimezoneSelector() {
    const {
      startDate: t,
      endDate: e,
      disabled: n,
      withTimezoneSelector: o,
      timezoneSelectorProps: r
    } = this.props, { timezone: a } = this.state;
    if (!o)
      return null;
    const l = !!t || !!e, c = !l && !n, d = !l || n || r?.disabled;
    return /* @__PURE__ */ s.jsx(
      Or,
      {
        disabled: d,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !c,
          ...r?.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: a
      }
    );
  }
  renderInputFields(t) {
    const {
      withDateInput: e,
      withTimePicker: n,
      withTimezoneSelector: o,
      timePickerProps: r,
      disabled: a,
      startDate: l,
      endDate: c,
      selectableMinutes: d,
      selectableHours: h,
      inputsPlacement: u,
      timeFormat: p,
      timeRoundingStrategy: m
    } = this.props;
    if (u !== t || !e && !n)
      return null;
    const { startTime: g, endTime: b, focusedInput: x } = this.state, { minDate: y, maxDate: _ } = this.getDateConstraints();
    return /* @__PURE__ */ s.jsx(
      Qs,
      {
        dateFormat: this.dateFormat,
        timeFormat: p,
        onStartDateChange: this.onStartDateChange,
        onEndDateChange: this.onEndDateChange,
        onTimeChange: this.handleTimeChange,
        onFocusChange: this.handleFocusChange,
        startDate: l,
        endDate: c,
        startTime: g,
        endTime: b,
        minDate: y,
        maxDate: _,
        disabled: a,
        withDateInput: e,
        withTimePicker: n,
        hasTimezoneSelector: o,
        timePickerProps: r,
        selectableMinutes: d,
        selectableHours: h,
        placement: t,
        timeRoundingStrategy: m,
        focusedInput: x
      }
    );
  }
  renderPresets() {
    const { presets: t } = this.props, { presetKey: e } = this.state;
    return t?.length ? /* @__PURE__ */ s.jsx(
      Ar,
      {
        value: e,
        presets: t,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: t, calendarProps: e, disabled: n, startDate: o, endDate: r } = this.props, a = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Wn.previousMonth, l = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Wn.nextMonth;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Pm,
        className: f(Ie.root, t),
        children: [
          /* @__PURE__ */ s.jsxs(B, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ s.jsx(
              xr.DayPickerRangeController,
              {
                ref: this.visibleCalendarMonthRef,
                startDate: o,
                endDate: r,
                onDatesChange: this.onDatesChange,
                onFocusChange: this.handleFocusChange,
                focusedInput: this.state.focusedInput,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: Er,
                daySize: 32,
                minimumNights: 0,
                disabled: n,
                renderNavPrevButton: a,
                renderNavNextButton: l,
                renderMonthElement: Lr,
                initialVisibleMonth: () => o || r || j(),
                transitionDuration: 0,
                ...e
              },
              this.state.dateRangePickerKey
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
const Em = "h-datePicker-single-inputFields--datePickerInputFields__root", Lm = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTop", Am = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTopWithTimezoneSelector", $m = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementBottom", Om = "h-datePicker-single-inputFields--datePickerInputFields__input", Bm = "h-datePicker-single-inputFields--datePickerInputFields__alert", se = {
  root: Em,
  rootPlacementTop: Lm,
  rootPlacementTopWithTimezoneSelector: Am,
  rootPlacementBottom: $m,
  input: Om,
  alert: Bm
};
class Zs extends D {
  dateValidators;
  instanceId;
  constructor(t) {
    super(t);
    const { dateFormat: e } = t;
    this.state = {
      dateInputValue: this.props.date?.format(e) ?? "",
      dateError: null
    }, this.instanceId = Zs.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateDateChangeEvent = this.propagateDateChangeEvent.bind(this), this.dateValidators = new Ut(
      t.dateFormat,
      this.parseDateString,
      { maxDate: t.maxDate, minDate: t.minDate }
    );
  }
  componentDidUpdate(t) {
    this.syncDateWithProps(t);
  }
  static instanceCount = 0;
  syncDateWithProps(t) {
    const { date: e, timeRoundingStrategy: n } = this.props, o = j(e);
    if (!(e === t.date || o?.isSame(j(t.date), n)))
      return this.props.date ? this.setState({
        dateError: null,
        dateInputValue: o.format(this.props.dateFormat)
      }) : this.setState({
        dateError: null,
        dateInputValue: ""
      });
  }
  handleInputValueChange(t) {
    const e = this.ensureValidChars(t.target.value);
    this.setState({ dateInputValue: e }, this.propagateDateChangeEvent);
  }
  propagateDateChangeEvent() {
    const { dateInputValue: t } = this.state;
    if (t === "") {
      this.props.onDateChange(null);
      return;
    }
    const { isValid: e, error: n } = this.dateValidators.isSingleDateValid(t);
    if (!e) {
      this.setState({ dateError: n });
      return;
    }
    this.setState(
      {
        dateError: null
      },
      () => this.props.onDateChange(this.parseDateString(t))
    );
  }
  parseDateString(t) {
    return j(t, this.props.dateFormat, !0);
  }
  ensureValidChars(t) {
    return t.replace(/[^0-9/]/g, "");
  }
  renderDateInput() {
    const { disabled: t, dateFormat: e, withDateInput: n } = this.props, { dateInputValue: o, dateError: r } = this.state;
    return n ? /* @__PURE__ */ s.jsx(
      qt,
      {
        className: se.input,
        required: !0,
        name: `date__input__${this.instanceId}`,
        value: o,
        onChange: this.handleInputValueChange,
        autoComplete: "off",
        placeholder: e.toLowerCase(),
        disabled: t,
        status: r ? "error" : void 0
      }
    ) : null;
  }
  renderTimeInput() {
    const {
      date: t,
      time: e,
      withTimePicker: n,
      timePickerProps: o = {},
      disabled: r,
      onTimeChange: a,
      timeFormat: l
    } = this.props;
    if (!n)
      return null;
    const c = !t && !r, d = !t || r;
    return /* @__PURE__ */ s.jsx(
      st,
      {
        content: "Please select a date first.",
        disabled: !c,
        side: "right",
        children: /* @__PURE__ */ s.jsx("div", { className: se.input, children: /* @__PURE__ */ s.jsx(
          sn,
          {
            disabled: d,
            onSelect: a,
            selectedItems: e ? [e] : void 0,
            ...o,
            timeFormat: l
          }
        ) })
      }
    );
  }
  renderErrors() {
    const { dateError: t } = this.state;
    return /* @__PURE__ */ s.jsx(
      Zn,
      {
        className: se.alert,
        variant: t ? "error" : void 0,
        children: this.state.dateError
      }
    );
  }
  render() {
    const { hasTimezoneSelector: t, placement: e } = this.props, n = f(se.root, {
      [se.rootPlacementTop]: e === "top",
      [se.rootPlacementTopWithTimezoneSelector]: e === "top" && t,
      [se.rootPlacementBottom]: e === "bottom"
    });
    return /* @__PURE__ */ s.jsxs("div", { className: n, children: [
      this.renderDateInput(),
      this.renderTimeInput(),
      this.renderErrors()
    ] });
  }
}
const Hm = "datePickerTestId";
class Wm extends D {
  static defaultProps = {
    dateFormat: j.localeData().longDateFormat("L"),
    withDateInput: !1,
    withTimePicker: !1,
    timePickerProps: {},
    inputsPlacement: "bottom",
    timeRoundingStrategy: "day"
  };
  constructor(t) {
    super(t);
    const { date: e, timezone: n, presets: o, presetKey: r } = t;
    this.state = {
      time: e ? j(e).format(Nt) : null,
      timezone: De(n) ? n : j.tz.guess(!0),
      presetKey: o?.find(({ key: a }) => a === r)?.key ?? null,
      datePickerKey: 0
    }, this.onDateChange = this.onDateChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(t) {
    this.updateTimeOnDateChange(t), this.recalculateDatePickerKey();
  }
  visibleCalendarMonthRef = O();
  getDateConstraints() {
    const { maxDate: t, minDate: e } = this.props;
    return {
      minDate: e || j("0001-01-01"),
      maxDate: t || j("9999-12-31")
    };
  }
  onTimezoneChange(t) {
    const { date: e } = this.props, { presetKey: n } = this.state;
    this.setState({ timezone: t }, () => this.onDateChange(e, n));
  }
  onDateChange(t, e = null) {
    const { time: n, timezone: o } = this.state, { timeRoundingStrategy: r } = this.props, a = this.addTimezoneToDate(t, o);
    let l = a?.clone().startOf(r) || null, c = t?.clone().startOf(r) || null;
    if (this.setState({ presetKey: e }), e) {
      this.setState(
        {
          time: t?.clone().startOf(r).format(Nt) ?? null
        },
        () => {
          this.props.onChange({
            date: l,
            localDate: c,
            timezone: o,
            localTimezone: j.tz.guess(!0),
            presetKey: e
          });
        }
      );
      return;
    }
    n && (l = this.addTimeToDate(a, n), c = this.addTimeToDate(t, n)), this.props.onChange({
      date: l,
      localDate: c,
      timezone: o,
      localTimezone: j.tz.guess(!0)
    });
  }
  onPresetSelect(t) {
    t ? this.onDateChange(t.date, t.key) : this.onDateChange(null);
  }
  handleTimeChange(t) {
    const { date: e } = this.props;
    this.setState(
      (n) => ({
        ...n,
        time: t
      }),
      () => this.onDateChange(e)
    );
  }
  addTimezoneToDate(t, e) {
    if (!t) return null;
    const { timeRoundingStrategy: n } = this.props;
    return De(e) ? j(t).clone().tz(e, !0) : t.clone().startOf(n);
  }
  addTimeToDate(t, e) {
    if (!t) return null;
    const { timeRoundingStrategy: n } = this.props, [o, r] = e.split(":");
    return !o || !r ? t.clone().startOf(n) : t.clone().set({
      hours: parseInt(o, 10),
      minutes: parseInt(r, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(t) {
    const { disabled: e, timeRoundingStrategy: n } = this.props;
    if (e)
      return !0;
    const { minDate: o, maxDate: r } = this.getDateConstraints();
    return !t.isBetween(o, r, n);
  }
  updateTimeOnDateChange(t) {
    const { date: e } = this.props;
    t.date?.isSame(e) || this.setState({
      time: e ? j(e).format(Nt) : null
    });
  }
  recalculateDatePickerKey() {
    const { date: t } = this.props, e = this.visibleCalendarMonthRef.current?.state.currentMonth;
    if (e && t && !t.isSame(e, "month"))
      return this.setState({ datePickerKey: this.generateRandomKey() });
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  renderTimezoneSelector() {
    const { date: t, disabled: e, withTimezoneSelector: n, timezoneSelectorProps: o } = this.props, { timezone: r } = this.state;
    if (!n)
      return null;
    const a = !!t, l = !a && !e, c = !a || e || o?.disabled;
    return /* @__PURE__ */ s.jsx(
      Or,
      {
        disabled: c,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !l,
          ...o?.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: r,
        ...o
      }
    );
  }
  renderInputFields(t) {
    const {
      dateFormat: e,
      timeFormat: n,
      withDateInput: o,
      withTimePicker: r,
      withTimezoneSelector: a,
      timePickerProps: l,
      selectableMinutes: c,
      selectableHours: d,
      disabled: h,
      date: u,
      inputsPlacement: p,
      timeRoundingStrategy: m
    } = this.props;
    if (p !== t || !o && !r)
      return null;
    const { time: g } = this.state, { minDate: b, maxDate: x } = this.getDateConstraints();
    return /* @__PURE__ */ s.jsx(
      Zs,
      {
        dateFormat: e,
        timeFormat: n,
        onDateChange: this.onDateChange,
        onTimeChange: this.handleTimeChange,
        time: g,
        date: u,
        minDate: b,
        maxDate: x,
        disabled: h,
        withDateInput: o,
        withTimePicker: r,
        hasTimezoneSelector: a,
        timePickerProps: l,
        selectableMinutes: c,
        selectableHours: d,
        placement: t,
        timeRoundingStrategy: m
      }
    );
  }
  renderPresets() {
    const { presets: t } = this.props, { presetKey: e } = this.state;
    return t?.length ? /* @__PURE__ */ s.jsx(
      Ar,
      {
        value: e,
        presets: t,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: t, calendarProps: e, disabled: n, date: o } = this.props, { datePickerKey: r } = this.state, a = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Wn.previousMonth, l = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Wn.nextMonth;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Hm,
        className: f(Ie.root, t),
        children: [
          /* @__PURE__ */ s.jsxs(B, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ s.jsx(
              xr.DayPickerSingleDateController,
              {
                ref: this.visibleCalendarMonthRef,
                date: o,
                onDateChange: this.onDateChange,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: Er,
                daySize: 32,
                renderNavPrevButton: a,
                renderNavNextButton: l,
                renderMonthElement: Lr,
                initialVisibleMonth: () => o || j(),
                onFocusChange: L,
                focused: !0,
                transitionDuration: 0,
                ...e
              },
              r
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
const Mm = "h-dialer--dialer__dialer", zm = "h-dialer--dialer__number", Vm = "h-dialer--dialer__letters", Km = "h-dialer--dialer__asterisk", An = {
  dialer: Mm,
  number: zm,
  letters: Vm,
  asterisk: Km
}, Um = [
  { value: "1", letters: " " },
  { value: "2", letters: "abc" },
  { value: "3", letters: "def" },
  { value: "4", letters: "ghi" },
  { value: "5", letters: "jkl" },
  { value: "6", letters: "mno" },
  { value: "7", letters: "pqrs" },
  { value: "8", letters: "tuv" },
  { value: "9", letters: "wxyz" },
  { value: "*", letters: null, classNames: An.asterisk },
  { value: "0", letters: null },
  { value: "#", letters: null }
];
class Lk extends D {
  render() {
    const { className: t, onInput: e, ...n } = this.props, o = f(An.dialer, t);
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: Um.map((r) => /* @__PURE__ */ Li(
      "div",
      {
        className: f(An.number),
        ...Gn(() => e(r.value)),
        key: r.value
      },
      /* @__PURE__ */ s.jsx(A.Heading, { variant: "heading-1", color: "neutral.700", children: /* @__PURE__ */ s.jsx("span", { className: r.classNames ?? "", children: r.value }) }),
      /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "1", color: "neutral.700", children: !!r.letters && /* @__PURE__ */ s.jsx("span", { className: An.letters, children: r.letters }) })
    )) });
  }
}
const qm = "h-fieldWrapper--fieldWrapper__root", Gm = "h-fieldWrapper--fieldWrapper__rootDisabled", Ym = "h-fieldWrapper--fieldWrapper__label", Xm = "h-fieldWrapper--fieldWrapper__alert", _n = {
  root: qm,
  rootDisabled: Gm,
  label: Ym,
  alert: Xm
}, Qm = "fieldWrapper";
class z extends D {
  static hasStatus(t, e) {
    return t?.[e] ? t?.touched === void 0 || t.touched === !0 : !1;
  }
  static getStatusMessage(t, e) {
    if (this.hasStatus(t, e))
      return t?.[e];
  }
  static getStatus(t) {
    return z.hasStatus(t, "error") ? "error" : z.hasStatus(t, "warning") ? "warning" : z.hasStatus(t, "success") ? "success" : void 0;
  }
  renderAlerts() {
    const { meta: t, description: e } = this.props;
    let n = e, o;
    return z.hasStatus(t, "error") ? (n = z.getStatusMessage(t, "error"), o = "error") : z.hasStatus(t, "warning") ? (n = z.getStatusMessage(t, "warning"), o = "warning") : z.hasStatus(t, "success") && (n = z.getStatusMessage(t, "success"), o = "success"), /* @__PURE__ */ s.jsx(Zn, { variant: o, className: _n.alert, children: n });
  }
  render() {
    const {
      className: t,
      labelFor: e,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      noAlert: c,
      noLabel: d,
      children: h,
      ...u
    } = this.props, p = f(
      _n.root,
      {
        [_n.rootDisabled]: a
      },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Qm,
        ...u,
        className: p,
        children: [
          !d && /* @__PURE__ */ s.jsx(
            Gs,
            {
              required: r,
              htmlFor: e,
              helpIcon: l,
              className: _n.label,
              children: n
            }
          ),
          h,
          !c && this.renderAlerts()
        ]
      }
    );
  }
}
class Rs extends D {
  render() {
    const {
      className: t,
      input: e,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noLabel: d,
      noAlert: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        labelFor: e.name,
        meta: o,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noLabel: d,
        noAlert: h,
        children: /* @__PURE__ */ s.jsx(
          qt,
          {
            status: z.getStatus(o),
            disabled: a,
            required: r,
            ...e,
            ...u
          }
        )
      }
    );
  }
}
const Zm = "h-dropdownSelect--dropdownSelectContainer__search", Jm = "h-dropdownSelect--dropdownSelectContainer__pagination", tg = "h-dropdownSelect--dropdownSelectContainer__selectionActions", eg = "h-dropdownSelect--dropdownSelectContainer__extra", Cn = {
  search: Zm,
  pagination: Jm,
  selectionActions: tg,
  extra: eg
}, ng = "DROP_SEARCH_INPUT";
class Br extends _t {
  listRef;
  searchRef;
  static getDerivedStateFromProps(t, e) {
    const { dropdownOpen: n } = t, o = { ...e };
    return n || (o.searchValue = "", o.activeItemIndex = 0), o;
  }
  constructor(t) {
    super(t), this.state = {
      searchValue: "",
      activeItemIndex: 0
    }, this.search = this.search.bind(this), this.searchKeyDown = this.searchKeyDown.bind(this), this.handleItemKeyDown = this.handleItemKeyDown.bind(this), this.onSelect = this.onSelect.bind(this), this.onChange = this.onChange.bind(this), this.listRef = O(), this.searchRef = O();
  }
  componentDidMount() {
    this.onOpen();
  }
  componentDidUpdate(t) {
    const { dropdownOpen: e } = this.props;
    !t.dropdownOpen && e && this.onOpen();
  }
  getInput() {
    const { searchValue: t } = this.state;
    return {
      name: ng,
      value: t,
      onChange: this.search,
      onKeyDown: this.searchKeyDown,
      autoComplete: "off",
      "aria-label": "Search"
    };
  }
  searchKeyDown(t) {
    const { key: e } = t, { searchValue: n, activeItemIndex: o } = this.state, { triggerClose: r, items: a, disabledItems: l = [] } = this.props, c = a.map((h, u) => ({ item: h, index: u })).filter(({ item: h }) => !l.includes(h.id)).map(({ index: h }) => h), d = c.indexOf(o);
    if (e === "Escape")
      n === "" ? r() : this.clearSearch();
    else if (e === "ArrowDown") {
      if (t.preventDefault(), c.length > 0) {
        const h = d < c.length - 1 ? d + 1 : 0;
        this.setState(
          { activeItemIndex: c[h] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (e === "ArrowUp") {
      if (t.preventDefault(), c.length > 0) {
        const h = d > 0 ? d - 1 : c.length - 1;
        this.setState(
          { activeItemIndex: c[h] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (e === "Home")
      t.preventDefault(), c.length > 0 && this.setState(
        { activeItemIndex: c[0] },
        () => this.listRef.current?.focusActiveItem()
      );
    else if (e === "End")
      t.preventDefault(), c.length > 0 && this.setState(
        {
          activeItemIndex: c[c.length - 1]
        },
        () => this.listRef.current?.focusActiveItem()
      );
    else if (e === "Enter") {
      t.preventDefault();
      const h = a[o];
      if (h && !l.includes(h.id)) {
        const { onChange: u, selectedItems: p = [] } = this.props;
        if (u) {
          const m = p.some((g) => (typeof g == "object" ? g.id : g) === h.id);
          this.onChange(h, !m);
        } else
          this.onSelect(h);
      }
    }
  }
  handleItemKeyDown(t) {
    const { key: e } = t, { activeItemIndex: n } = this.state, { triggerClose: o, items: r, disabledItems: a = [] } = this.props, l = r.map((d, h) => ({ item: d, index: h })).filter(({ item: d }) => !a.includes(d.id)).map(({ index: d }) => d), c = l.indexOf(n);
    if (e === "Escape")
      o();
    else if (e === "ArrowDown") {
      if (t.preventDefault(), l.length > 0) {
        const d = c < l.length - 1 ? c + 1 : 0;
        this.setState(
          { activeItemIndex: l[d] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (e === "ArrowUp") {
      if (t.preventDefault(), l.length > 0) {
        const d = c > 0 ? c - 1 : l.length - 1;
        this.setState(
          { activeItemIndex: l[d] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else e === "Home" ? (t.preventDefault(), l.length > 0 && this.setState(
      { activeItemIndex: l[0] },
      () => this.listRef.current?.focusActiveItem()
    )) : e === "End" && (t.preventDefault(), l.length > 0 && this.setState(
      {
        activeItemIndex: l[l.length - 1]
      },
      () => this.listRef.current?.focusActiveItem()
    ));
  }
  search(t) {
    const { onSearch: e } = this.props, { value: n } = t.target;
    typeof e == "function" && e(n), n && this.listRef.current && this.listRef.current.goToTop(), this.setState({
      searchValue: n,
      activeItemIndex: 0
    });
  }
  onSelect(t) {
    const { onSelect: e, keepOpen: n, triggerClose: o } = this.props;
    typeof e == "function" && e(t), n && this.focusSearch(), !n && typeof o == "function" && o();
  }
  onChange(t, e) {
    const { onChange: n, keepOpen: o, triggerClose: r } = this.props;
    typeof n == "function" && n(t, e), o && this.focusSearch(), !o && typeof r == "function" && r();
  }
  onOpen() {
    const { hasSearch: t } = this.props;
    t ? this.focusSearch() : setTimeout(() => {
      this.listRef.current?.focusActiveItem();
    }, 0);
  }
  focusSearch() {
    const { hasSearch: t } = this.props;
    if (t && this.searchRef.current) {
      const e = this.searchRef.current.querySelector("input");
      e && e.focus();
    }
  }
  clearSearch = () => {
    const { onSearch: t } = this.props, { searchValue: e } = this.state;
    e && (typeof t == "function" && t(""), this.setState({ searchValue: "" }));
  };
  render() {
    const {
      className: t,
      itemComponent: e,
      emptyComponent: n,
      suggestionComponent: o,
      optionComponent: r,
      items: a,
      hasSearch: l,
      searchPlaceholder: c,
      pagination: d,
      keepOpen: h,
      onSelect: u,
      onSearch: p,
      onSuggest: m,
      onChange: g,
      onClear: b,
      onClearText: x,
      triggerClose: y,
      dropdownOpen: _,
      emptyMessage: C,
      selectedItems: w,
      disabledItems: v,
      tooltipItems: S,
      activeItem: I,
      itemsDisplayCount: T,
      itemHeight: R,
      renderSuggestion: E,
      searchSuggestion: k,
      ...P
    } = this.props;
    if (!_)
      return null;
    const { searchValue: H, activeItemIndex: nt } = this.state, ot = a.length === 0, et = a[nt] ?? I ?? a[0] ?? null, W = f(t);
    return /* @__PURE__ */ s.jsxs("div", { ...P, className: W, children: [
      l && /* @__PURE__ */ s.jsx("div", { className: Cn.search, ref: this.searchRef, children: /* @__PURE__ */ s.jsx(
        Rs,
        {
          input: this.getInput(),
          meta: { error: null, touched: !0 },
          icon: "search",
          noAlert: !0,
          noLabel: !0,
          placeholder: c
        }
      ) }),
      !!(l && o || r) && /* @__PURE__ */ s.jsxs("div", { className: Cn.extra, children: [
        r,
        l && typeof o == "function" && /* @__PURE__ */ s.jsx(
          o,
          {
            searched: H,
            onSuggest: m,
            triggerClose: h ? void 0 : y,
            clearSearch: this.clearSearch,
            items: a,
            searchSuggestion: k,
            renderSuggestion: E
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { children: [
        !ot && /* @__PURE__ */ s.jsx(
          Ys,
          {
            ref: this.listRef,
            pagination: d,
            items: a,
            onSelect: this.onSelect,
            onChange: this.onChange,
            onKeyDown: this.handleItemKeyDown,
            clearSearch: this.clearSearch,
            selectedItems: w,
            disabledItems: v,
            itemComponent: e,
            tooltipItems: S,
            itemsDisplayCount: T,
            itemHeight: R,
            activeItem: et
          }
        ),
        ot && typeof n == "function" && /* @__PURE__ */ s.jsx(n, { label: C || "" })
      ] }),
      typeof b == "function" && /* @__PURE__ */ s.jsx("div", { className: Cn.selectionActions, children: /* @__PURE__ */ s.jsx(
        X,
        {
          variant: "secondary",
          disabled: w?.length === 0,
          onClick: b,
          children: x || "Clear"
        }
      ) }),
      !!d && !d.infinite && /* @__PURE__ */ s.jsxs("div", { className: Cn.pagination, children: [
        /* @__PURE__ */ s.jsx(
          X,
          {
            variant: "secondary",
            disabled: !d.previousEnable,
            onClick: d.onPrevious,
            children: "Prev page"
          }
        ),
        /* @__PURE__ */ s.jsx(
          X,
          {
            variant: "secondary",
            disabled: !d.nextEnable,
            onClick: d.onNext,
            children: "Next page"
          }
        )
      ] })
    ] });
  }
}
class Js extends D {
  static defaultProps = {
    className: "",
    buttonProps: {},
    dropdownProps: {},
    containerProps: {},
    noArrow: !0,
    hasSearch: !1,
    searchPlaceholder: "Search...",
    pagination: !1,
    keepOpen: !1,
    onSearch: () => {
    },
    onSuggest: () => {
    },
    onChange: () => {
    },
    onSelect: () => {
    },
    onToggle: () => {
    },
    onKeyDown: () => {
    },
    emptyComponent: hn,
    emptyMessage: "No items found",
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  render() {
    const {
      className: t,
      items: e,
      onSelect: n,
      onChange: o,
      onSearch: r,
      onClear: a,
      onClearText: l,
      onKeyDown: c,
      hasSearch: d,
      searchPlaceholder: h = "Search...",
      onSuggest: u,
      keepOpen: p,
      itemComponent: m,
      suggestionComponent: g,
      children: b,
      buttonProps: x,
      dropdownProps: y,
      containerProps: _,
      pagination: C,
      emptyComponent: w,
      emptyMessage: v,
      selectedItems: S,
      disabledItems: I,
      tooltipItems: T,
      activeItem: R,
      itemsDisplayCount: E,
      itemHeight: k,
      optionComponent: P,
      renderSuggestion: H,
      searchSuggestion: nt,
      ...ot
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      le,
      {
        ...ot,
        className: t,
        buttonProps: { variant: "secondary", ...x },
        dropdownProps: y,
        dropdown: /* @__PURE__ */ s.jsx(dn.Consumer, { children: ({ toggleDropdown: et, dropdownOpen: W }) => /* @__PURE__ */ s.jsx(
          Br,
          {
            ..._,
            items: e,
            itemComponent: m,
            hasSearch: d,
            searchPlaceholder: h,
            suggestionComponent: g,
            onSuggest: u,
            keepOpen: p,
            onSearch: r,
            onSelect: n,
            onChange: o,
            onClear: a,
            onClearText: l,
            onKeyDown: c,
            triggerClose: et,
            dropdownOpen: W,
            pagination: C,
            emptyComponent: w,
            emptyMessage: v,
            selectedItems: S,
            disabledItems: I,
            tooltipItems: T,
            activeItem: R,
            itemsDisplayCount: E,
            itemHeight: k,
            optionComponent: P,
            renderSuggestion: H,
            searchSuggestion: nt
          }
        ) }),
        children: b
      }
    );
  }
}
const sg = "h-dropdownSelectMultiple--dropdownSelectMultiple__items", og = "h-dropdownSelectMultiple--dropdownSelectMultiple__moreItemsDropdown", rg = "h-dropdownSelectMultiple--dropdownSelectMultiple__tagName", gs = {
  items: sg,
  moreItemsDropdown: og,
  tagName: rg
};
class ig extends _t {
  static defaultProps = {
    noArrow: !0,
    hasSearch: !1,
    searchPlaceholder: "Search...",
    keepOpen: !1,
    onSearch: () => {
    },
    onSuggest: () => {
    },
    onChange: () => {
    },
    onSelect: () => {
    },
    emptyComponent: hn,
    emptyMessage: "No items found",
    buttonText: "+Select item",
    selectedItems: []
  };
  getItems() {
    const { items: t } = this.props;
    return t;
  }
  render() {
    const {
      items: t,
      itemComponent: e,
      onSelect: n,
      onChange: o,
      onSearch: r,
      onClear: a,
      hasSearch: l,
      searchPlaceholder: c,
      onSuggest: d,
      suggestionComponent: h,
      emptyComponent: u,
      emptyMessage: p,
      keepOpen: m,
      containerProps: g,
      buttonText: b,
      selectedItems: x,
      optionComponent: y,
      ..._
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      Js,
      {
        ..._,
        containerProps: g,
        items: this.getItems(),
        itemComponent: e,
        hasSearch: l,
        searchPlaceholder: c,
        suggestionComponent: h,
        onSuggest: d,
        keepOpen: m,
        onSearch: r,
        onSelect: n,
        onChange: o,
        onClear: a,
        emptyComponent: u,
        emptyMessage: p,
        selectedItems: x,
        optionComponent: y,
        children: b
      }
    );
  }
}
class Ak extends _t {
  static defaultProps = {
    MoreItemsItemComponent: op,
    hideSelectedItems: !1,
    disabledItems: [],
    tooltipItems: {}
  };
  constructor(t) {
    super(t), this.getListItem = this.getListItem.bind(this), this.getListMoreItem = this.getListMoreItem.bind(this);
  }
  resolveItem(t) {
    if (typeof t == "object")
      return t;
    const e = this.props.items.find((n) => n.id === t);
    return e || { id: fr(), name: "Unknown" };
  }
  getItemName(t) {
    return t.name.toString().trim();
  }
  isItemDisabled(t) {
    return this.props.disabledItems ? this.props.disabledItems.indexOf(t.id) >= 0 : !1;
  }
  getTooltip(t) {
    const { tooltipItems: e } = this.props;
    return !e || Ws(e[t.id]) ? null : e[t.id];
  }
  getListItem(t, e) {
    const { onRemove: n } = this.props, o = this.resolveItem(t), r = this.getItemName(o), a = this.getTooltip(o), l = /* @__PURE__ */ s.jsx(
      ke,
      {
        className: gs.tagName,
        onDelete: () => n(o),
        color: o.color,
        disabled: this.isItemDisabled(o),
        children: r
      },
      o.id
    );
    return a ? /* @__PURE__ */ s.jsx(st, { ...a, children: l }, e) : l;
  }
  getListMoreItem(t) {
    const { MoreItemsItemComponent: e, onRemove: n } = this.props, o = this.resolveItem(t), r = this.getTooltip(o), a = /* @__PURE__ */ s.jsx(
      e,
      {
        item: o,
        onSelect: n,
        disabled: this.isItemDisabled(o),
        clearSearch: L,
        isLoading: !1,
        checked: !1
      },
      o.id
    );
    return r ? /* @__PURE__ */ s.jsx(st, { ...r, children: a }, o.id) : a;
  }
  getPreviewItems() {
    const {
      selectedItems: t,
      previewItemsNumber: e,
      moreItemsDropdownProps: n = {}
    } = this.props;
    let o = [], r = [], a = "";
    if (e && t) {
      if (t.length > 0 && t.length < e)
        o = t.map(this.getListItem);
      else if (t.length >= e) {
        const h = t.slice(0, e), u = t.slice(
          e,
          t.length
        );
        o = h.map(this.getListItem), r = u.map(this.getListMoreItem), a = u.length.toString();
      }
    } else
      o = t.map(this.getListItem);
    const { className: l, ...c } = n, d = /* @__PURE__ */ s.jsx(
      "div",
      {
        ...c,
        className: f(gs.moreItemsDropdown, l),
        children: r
      }
    );
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      o,
      e && t.length > e ? /* @__PURE__ */ s.jsxs(
        le,
        {
          noArrow: !0,
          buttonProps: { variant: "tertiary" },
          dropdown: d,
          children: [
            "+ ",
            a,
            /* @__PURE__ */ s.jsx("span", { children: " selected" })
          ]
        }
      ) : null
    ] });
  }
  render() {
    const {
      items: t,
      selectedItems: e,
      previewItemsNumber: n,
      className: o,
      onSelect: r,
      onChange: a,
      onSearch: l,
      hasSearch: c,
      searchPlaceholder: d,
      onSuggest: h,
      onRemove: u,
      keepOpen: p,
      itemComponent: m,
      suggestionComponent: g,
      pagination: b,
      emptyComponent: x,
      emptyMessage: y,
      containerProps: _,
      moreItemsDropdownProps: C,
      MoreItemsItemComponent: w,
      hideSelectedItems: v,
      disabledItems: S,
      tooltipItems: I,
      optionComponent: T,
      ...R
    } = this.props, E = f(
      {
        [gs.items]: !0
      },
      o
    );
    return /* @__PURE__ */ s.jsxs("div", { className: E, children: [
      /* @__PURE__ */ s.jsx(
        ig,
        {
          items: t,
          itemComponent: m,
          hasSearch: c,
          searchPlaceholder: d,
          suggestionComponent: g,
          onSuggest: h,
          keepOpen: p,
          onSearch: l,
          onSelect: r,
          onChange: a,
          pagination: b,
          emptyComponent: x,
          emptyMessage: y,
          containerProps: _,
          selectedItems: e,
          disabledItems: S,
          tooltipItems: I,
          optionComponent: T,
          ...R
        }
      ),
      !v && this.getPreviewItems()
    ] });
  }
}
const ag = "h-fieldButton--fieldButton__button", lg = {
  button: ag
}, $k = $(
  function({
    className: t,
    buttonClassName: e,
    label: n,
    meta: o,
    disabled: r,
    helpIcon: a,
    description: l,
    noAlert: c,
    noLabel: d,
    children: h,
    ...u
  }, p) {
    const m = f(e, lg.button);
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        meta: o,
        disabled: r,
        helpIcon: a,
        description: l,
        noAlert: c,
        noLabel: d,
        children: /* @__PURE__ */ s.jsx(
          X,
          {
            ref: p,
            disabled: r,
            ...u,
            className: m,
            children: h
          }
        )
      }
    );
  }
), cg = "h-inputDatePicker--inputDatePicker__root", dg = "h-inputDatePicker--inputDatePicker__inputContainer", hg = "h-inputDatePicker--inputDatePicker__input", ug = "h-inputDatePicker--inputDatePicker__rootReadOnly", pg = "h-inputDatePicker--inputDatePicker__iconsContainer", mg = "h-inputDatePicker--inputDatePicker__rootHasClearIcon", gg = "h-inputDatePicker--inputDatePicker__rootHasWrapperIcon", fg = "h-inputDatePicker--inputDatePicker__calendarIcon", bg = "h-inputDatePicker--inputDatePicker__clearIcon", At = {
  root: cg,
  inputContainer: dg,
  input: hg,
  rootReadOnly: ug,
  iconsContainer: pg,
  rootHasClearIcon: mg,
  rootHasWrapperIcon: gg,
  calendarIcon: fg,
  clearIcon: bg
}, xg = "inputDatePickerTestId";
class yg extends D {
  inputRef;
  rootRef;
  datePickerContainerRef;
  static defaultProps = {
    dateFormat: j.localeData().longDateFormat("L"),
    name: Math.floor(Math.random() * 1e8).toString()
  };
  constructor(t) {
    super(t), this.inputRef = O(), this.rootRef = O(), this.datePickerContainerRef = O(), this.state = {
      isDropdownOpen: !1,
      shouldRerenderDatePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDateChange = this.handleDateChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  componentDidUpdate(t, e) {
    const { isDropdownOpen: n } = this.state;
    n !== e.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown)), n && this.focusDatePickerInput());
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDatePickerInput() {
    this.datePickerContainerRef.current?.querySelector('input[type="text"]')?.focus();
  }
  handleWindowClick(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleWindowKeyDown(t) {
    Fe(t.key) && this.state.isDropdownOpen && (t.stopPropagation(), this.hideDropdown());
  }
  handleDateChange(t) {
    const { onChange: e, value: n } = this.props;
    typeof e == "function" && e(t), (n ?? t !== null) && this.inputRef.current?.focus();
  }
  handleClearIconClick() {
    this.handleDateChange({
      date: null,
      localDate: null,
      timezone: null,
      localTimezone: null
    });
  }
  showDropdown() {
    this.setState({
      isDropdownOpen: !0,
      shouldRerenderDatePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus() {
    const { readOnly: t } = this.props;
    t || this.showDropdown();
  }
  handleInputBlur(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleInputClick(t) {
    const { readOnly: e } = this.props;
    e || (t.stopPropagation(), this.showDropdown());
  }
  handleInputKeydown({ key: t }) {
    Yn(t) && this.showDropdown();
  }
  handleCalendarIconClick(t) {
    const { readOnly: e } = this.props;
    e || (t.stopPropagation(), this.showDropdown());
  }
  renderInputAndIcons() {
    const {
      className: t,
      name: e,
      value: n,
      onChange: o,
      dateFormat: r,
      dropdownProps: a,
      prefix: l,
      suffix: c,
      icon: d,
      status: h,
      placeholder: u,
      disabled: p,
      datePickerProps: m,
      clearable: g,
      minDate: b,
      maxDate: x,
      readOnly: y,
      ..._
    } = this.props, { isDropdownOpen: C } = this.state;
    return /* @__PURE__ */ s.jsx(
      Et,
      {
        prefix: l,
        suffix: c,
        disabled: p,
        icon: d,
        active: C,
        status: h,
        children: /* @__PURE__ */ s.jsxs("div", { className: At.inputContainer, children: [
          /* @__PURE__ */ s.jsx(
            "input",
            {
              ..._,
              id: e,
              name: e,
              className: At.input,
              ref: this.inputRef,
              onClick: this.handleInputClick,
              onFocus: this.handleInputFocus,
              onBlur: this.handleInputBlur,
              onKeyDown: this.handleInputKeydown,
              disabled: p,
              placeholder: u || r?.toLowerCase(),
              autoComplete: "off",
              value: On(n) ? void 0 : n?.format(r) ?? "",
              onChange: On(n) ? void 0 : L,
              readOnly: !0
            }
          ),
          /* @__PURE__ */ s.jsxs("div", { className: At.iconsContainer, children: [
            this.renderClearIcon(),
            this.renderCalendarIcon()
          ] })
        ] })
      }
    );
  }
  renderCalendarIcon() {
    const { disabled: t } = this.props;
    return /* @__PURE__ */ s.jsx(
      K,
      {
        className: At.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: this.handleCalendarIconClick,
        tabIndex: -1,
        disabled: t
      }
    );
  }
  renderClearIcon() {
    const { clearable: t, value: e, disabled: n } = this.props;
    return !t || !e ? null : /* @__PURE__ */ s.jsx(
      K,
      {
        className: At.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: n,
        onClick: this.handleClearIconClick
      }
    );
  }
  renderDropdown() {
    const {
      value: t,
      minDate: e,
      maxDate: n,
      timezone: o,
      datePickerProps: r,
      disabled: a,
      dropdownProps: l,
      dateFormat: c
    } = this.props, { isDropdownOpen: d, shouldRerenderDatePicker: h } = this.state;
    return /* @__PURE__ */ s.jsx(Jt, { ...l, isOpen: d, children: /* @__PURE__ */ s.jsx("div", { ref: this.datePickerContainerRef, children: /* @__PURE__ */ s.jsx(
      Wm,
      {
        disabled: a,
        ...r,
        dateFormat: c,
        date: t ?? null,
        timezone: o,
        onChange: this.handleDateChange,
        minDate: e,
        maxDate: n
      },
      h.toString()
    ) }) });
  }
  render() {
    const { className: t, value: e, clearable: n, readOnly: o, icon: r } = this.props, a = f(At.root, t, {
      [At.rootHasClearIcon]: n && e,
      [At.rootHasWrapperIcon]: !!r,
      [At.rootReadOnly]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": xg,
        ref: this.rootRef,
        className: a,
        children: [
          this.renderInputAndIcons(),
          this.renderDropdown()
        ]
      }
    );
  }
}
class Ok extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(t) {
    const {
      input: { onChange: e }
    } = this.props;
    e?.({
      date: t?.date ? t.date.toISOString() : "",
      localDate: t?.localDate ? t.localDate.toISOString() : "",
      timezone: t?.timezone || "",
      localTimezone: t?.localTimezone || ""
    });
  }
  render() {
    const {
      className: t,
      input: { value: e, name: n, onChange: o, ...r },
      label: a,
      meta: l,
      required: c,
      disabled: d,
      helpIcon: h,
      description: u,
      noLabel: p,
      noAlert: m,
      ...g
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: a,
        labelFor: n,
        meta: l,
        required: c,
        disabled: d,
        helpIcon: h,
        description: u,
        noLabel: p,
        noAlert: m,
        children: /* @__PURE__ */ s.jsx(
          yg,
          {
            name: n,
            value: Ps(e?.localDate) ? j(e.localDate, j.ISO_8601) : null,
            timezone: e?.timezone,
            onChange: this.handleChange,
            ...r,
            status: z.getStatus(l),
            disabled: d,
            required: c,
            ...g
          }
        )
      }
    );
  }
}
const _g = "h-inputDateRangePicker--inputDateRangePicker__root", Cg = "h-inputDateRangePicker--inputDateRangePicker__inputsContainer", wg = "h-inputDateRangePicker--inputDateRangePicker__arrowContainer", vg = "h-inputDateRangePicker--inputDateRangePicker__inputContainer", Sg = "h-inputDateRangePicker--inputDateRangePicker__input", Ig = "h-inputDateRangePicker--inputDateRangePicker__rootReadOnly", Dg = "h-inputDateRangePicker--inputDateRangePicker__iconsContainer", kg = "h-inputDateRangePicker--inputDateRangePicker__rootStartDateHasClearIcon", Tg = "h-inputDateRangePicker--inputDateRangePicker__startDateIconsContainer", jg = "h-inputDateRangePicker--inputDateRangePicker__rootEndDateHasClearIcon", Ng = "h-inputDateRangePicker--inputDateRangePicker__endDateIconsContainer", Fg = "h-inputDateRangePicker--inputDateRangePicker__rootHasWrapperIcon", Pg = "h-inputDateRangePicker--inputDateRangePicker__calendarIcon", Rg = "h-inputDateRangePicker--inputDateRangePicker__clearIcon", ut = {
  root: _g,
  inputsContainer: Cg,
  arrowContainer: wg,
  inputContainer: vg,
  input: Sg,
  rootReadOnly: Ig,
  iconsContainer: Dg,
  rootStartDateHasClearIcon: kg,
  startDateIconsContainer: Tg,
  rootEndDateHasClearIcon: jg,
  endDateIconsContainer: Ng,
  rootHasWrapperIcon: Fg,
  calendarIcon: Pg,
  clearIcon: Rg
}, Eg = "inputDateRangePickerTestId";
class on extends D {
  inputsRef;
  rootRef;
  dateRangePickerContainerRef;
  static getInputName(t, e) {
    return t[e] || `${t}__${e}`;
  }
  static defaultProps = {
    name: {
      startDate: Math.floor(Math.random() * 1e8).toString(),
      endDate: Math.floor(Math.random() * 1e8).toString()
    }
  };
  constructor(t) {
    super(t), this.inputsRef = {
      startDate: O(),
      endDate: O()
    }, this.rootRef = O(), this.dateRangePickerContainerRef = O(), this.state = {
      isDropdownOpen: !1,
      focusedInput: "startDate",
      shouldRerenderDateRangePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDatesChange = this.handleDatesChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  componentDidUpdate(t, e) {
    const { isDropdownOpen: n, focusedInput: o } = this.state;
    n !== e.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown))), (n !== e.isDropdownOpen || o !== e.focusedInput) && this.focusDateRangePickerInput();
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDateRangePickerInput() {
    const { focusedInput: t } = this.state, e = this.dateRangePickerContainerRef.current?.querySelectorAll(
      'input[type="text"]'
    );
    t === "startDate" ? e?.[0]?.focus() : e?.[1]?.focus();
  }
  handleWindowClick(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleWindowKeyDown(t) {
    Fe(t.key) && this.state.isDropdownOpen && (t.stopPropagation(), this.hideDropdown());
  }
  handleDatesChange(t) {
    const { onChange: e, value: n } = this.props, { focusedInput: o } = this.state;
    typeof e == "function" && e(t), (n?.[o] ?? t[o] !== null) && this.inputsRef[o].current?.focus();
  }
  handleClearIconClick(t, e) {
    const { value: n, timezone: o, localTimezone: r } = this.props, a = {
      startDate: e === "startDate" ? null : n?.startDate ?? null,
      localStartDate: e === "startDate" ? null : n?.localStartDate ?? null,
      endDate: e === "endDate" ? null : n?.endDate ?? null,
      localEndDate: e === "endDate" ? null : n?.localEndDate ?? null,
      timezone: o || null,
      localTimezone: r || null
    };
    this.handleDatesChange(a);
  }
  showDropdown(t) {
    this.setState({
      isDropdownOpen: !0,
      focusedInput: t,
      shouldRerenderDateRangePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus(t, e) {
    const { readOnly: n } = this.props;
    n || this.showDropdown(e);
  }
  handleInputBlur(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleInputKeydown({ key: t }, e) {
    Yn(t) && this.showDropdown(e);
  }
  handleInputClick(t, e) {
    const { readOnly: n } = this.props;
    n || (t.stopPropagation(), this.showDropdown(e));
  }
  handleCalendarIconClick(t, e) {
    const { readOnly: n } = this.props;
    n || (t.stopPropagation(), this.showDropdown(e));
  }
  get dateFormat() {
    const { dateFormat: t } = this.props;
    return t || j.localeData().longDateFormat("L");
  }
  renderInputLayout() {
    const { prefix: t, suffix: e, icon: n, status: o, disabled: r } = this.props, { isDropdownOpen: a } = this.state;
    return /* @__PURE__ */ s.jsx(
      Et,
      {
        prefix: t,
        suffix: e,
        disabled: r,
        icon: n,
        active: a,
        status: o,
        children: /* @__PURE__ */ s.jsxs("div", { className: ut.inputsContainer, children: [
          this.renderInputAndIcons("startDate"),
          /* @__PURE__ */ s.jsx("div", { className: ut.arrowContainer, children: /* @__PURE__ */ s.jsx(N, { name: "arrow-right" }) }),
          this.renderInputAndIcons("endDate", -1)
        ] })
      }
    );
  }
  renderInputAndIcons(t, e) {
    const {
      className: n,
      clearable: o,
      dateFormat: r,
      dateRangePickerProps: a,
      disabled: l,
      dropdownProps: c,
      icon: d,
      localTimezone: h,
      maxDate: u,
      minDate: p,
      name: m,
      onChange: g,
      placeholder: b,
      prefix: x,
      readOnly: y,
      status: _,
      suffix: C,
      tabIndex: w,
      timezone: v,
      value: S,
      ...I
    } = this.props;
    return /* @__PURE__ */ s.jsxs("div", { className: ut.inputContainer, children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ...I,
          id: on.getInputName(m, t),
          name: on.getInputName(m, t),
          className: ut.input,
          ref: this.inputsRef[t],
          onClick: (T) => this.handleInputClick(T, t),
          onFocus: (T) => this.handleInputFocus(T, t),
          onBlur: (T) => this.handleInputBlur(T),
          onKeyDown: (T) => this.handleInputKeydown(T, t),
          disabled: l,
          placeholder: b?.[t] || b || this.dateFormat?.toLowerCase(),
          autoComplete: "off",
          value: S && j(S[t]).isValid() ? j(S[t]).format(this.dateFormat) : "",
          onChange: On(S) ? void 0 : L,
          tabIndex: e ?? w,
          readOnly: !0
        }
      ),
      /* @__PURE__ */ s.jsxs(
        "div",
        {
          className: f(ut.iconsContainer, {
            [ut.startDateIconsContainer]: t === "startDate",
            [ut.endDateIconsContainer]: t === "endDate"
          }),
          children: [
            this.renderClearIcon(t),
            this.renderCalendarIcon(t)
          ]
        }
      )
    ] });
  }
  renderCalendarIcon(t) {
    const { disabled: e } = this.props;
    return /* @__PURE__ */ s.jsx(
      K,
      {
        className: ut.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: (n) => this.handleCalendarIconClick(n, t),
        tabIndex: -1,
        disabled: e
      }
    );
  }
  renderClearIcon(t) {
    const { clearable: e, value: n, disabled: o } = this.props;
    return !e || !n?.[t] ? null : /* @__PURE__ */ s.jsx(
      K,
      {
        className: ut.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: o,
        onClick: (r) => this.handleClearIconClick(r, t)
      }
    );
  }
  renderDropdown() {
    const {
      value: t,
      minDate: e,
      maxDate: n,
      timezone: o,
      dateRangePickerProps: r,
      disabled: a,
      dropdownProps: l
    } = this.props, { isDropdownOpen: c, focusedInput: d, shouldRerenderDateRangePicker: h } = this.state;
    return /* @__PURE__ */ s.jsx(Jt, { ...l, isOpen: c, children: /* @__PURE__ */ s.jsx("div", { ref: this.dateRangePickerContainerRef, children: /* @__PURE__ */ s.jsx(
      Rm,
      {
        disabled: a,
        ...r,
        dateFormat: this.dateFormat,
        onChange: this.handleDatesChange,
        startDate: t?.startDate ?? null,
        endDate: t?.endDate ?? null,
        timezone: o ?? null,
        minDate: e,
        maxDate: n,
        focusedInput: d
      },
      h.toString()
    ) }) });
  }
  render() {
    const { className: t, value: e, clearable: n, readOnly: o, icon: r } = this.props, a = f(ut.root, t, {
      [ut.rootStartDateHasClearIcon]: n && e?.startDate,
      [ut.rootEndDateHasClearIcon]: n && e?.endDate,
      [ut.rootHasWrapperIcon]: !!r,
      [ut.rootReadOnly]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Eg,
        ref: this.rootRef,
        className: a,
        children: [
          this.renderInputLayout(),
          this.renderDropdown()
        ]
      }
    );
  }
}
class Bk extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(t) {
    const {
      input: { onChange: e }
    } = this.props;
    e?.({
      startDate: t?.startDate ? t.startDate.toISOString() : "",
      localStartDate: t?.localStartDate ? t.localStartDate.toISOString() : "",
      endDate: t?.endDate ? t.endDate.toISOString() : "",
      localEndDate: t?.localEndDate ? t.localEndDate.toISOString() : "",
      timezone: t?.timezone ?? "",
      localTimezone: t?.localTimezone ?? ""
    });
  }
  getDateRange({
    localStartDate: t,
    localEndDate: e
  }) {
    const n = Ps(t) ? j(t, j.ISO_8601) : null, o = Ps(e) ? j(e, j.ISO_8601) : null;
    return {
      startDate: n,
      endDate: o
    };
  }
  render() {
    const {
      className: t,
      input: { name: e, value: n, onChange: o, ...r },
      label: a,
      meta: l,
      required: c,
      disabled: d,
      description: h,
      helpIcon: u,
      noLabel: p,
      noAlert: m,
      ...g
    } = this.props, { timezone: b, localTimezone: x } = n;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: a,
        labelFor: on.getInputName(e, "startDate"),
        meta: l,
        required: c,
        disabled: d,
        helpIcon: u,
        description: h,
        noLabel: p,
        noAlert: m,
        children: /* @__PURE__ */ s.jsx(
          on,
          {
            name: e,
            value: this.getDateRange(n),
            timezone: b,
            localTimezone: x,
            onChange: this.handleChange,
            ...r,
            status: z.getStatus(l),
            disabled: d,
            required: c,
            ...g
          }
        )
      }
    );
  }
}
const Lg = [
  "link",
  "bold",
  "italic",
  "unorderedList",
  "orderedList",
  "format",
  "inlineCode"
], Mn = (i) => ki(i), to = (i, t = window) => t.getComputedStyle(i).display === "block", Yt = /(Mac|iPhone|iPod|iPad)/i.test(
  navigator.userAgent
);
function fs(i, t) {
  const e = {
    ctrlKey: [
      "Control",
      ...Yt ? ["$controlOrAlt"] : ["$metaOrCtrl"]
    ],
    shiftKey: ["Shift"],
    altKey: ["Alt", ...Yt ? [] : ["$controlOrAlt"]],
    metaKey: ["Meta", "OS", ...Yt ? ["$metaOrCtrl"] : []]
  };
  return i.some((n) => {
    if (t.code !== n[1])
      return !1;
    const o = n[0] ?? [];
    return Object.entries(e).every(
      ([r, a]) => {
        const l = Ti(
          a,
          o
        ).length;
        return t[r] ? l > 0 : l === 0;
      }
    );
  });
}
const Ag = (i, t, e) => {
  if (!i || t < 0 || e < 0) return !1;
  const n = i?.textContent?.length ?? 0;
  return !(t > n || e > n);
}, $g = (i, t) => i.document.queryCommandState(t), Og = (i) => i.document.queryCommandValue("formatBlock"), Bg = (i) => i.type.indexOf("image/") === 0, Ao = (i, t) => {
  const e = nn();
  return {
    src: (i.URL || i.webkitURL).createObjectURL(t),
    uid: e
  };
}, Hg = (i) => {
  i && i.querySelectorAll("td").forEach((t) => {
    t.style.border = "1px solid currentColor";
  });
}, Es = (i) => {
  i.setAttribute("dir", "auto");
  const t = window.getComputedStyle(i).direction;
  i.setAttribute("dir", t);
}, $o = (i) => {
  i && i.childNodes.forEach((t) => {
    t.nodeType !== Node.ELEMENT_NODE && t.nodeType !== Node.TEXT_NODE || Mn(t) && to(t) && Es(t);
  });
}, eo = (i, t = !0) => {
  const e = document.createElement("div");
  return e.style.display = "none", e.innerHTML = i, document.body.appendChild(e), e.childNodes.forEach((n) => {
    if (!(n.nodeType !== Node.ELEMENT_NODE && n.nodeType !== Node.TEXT_NODE)) {
      if (Mn(n) && to(n))
        n.innerHTML = eo(n.innerHTML, !1), Es(n);
      else if (t) {
        const o = document.createElement("div");
        o.appendChild(n.cloneNode(!0)), n.replaceWith(o), Es(o);
      }
    }
  }), document.body.removeChild(e), e.innerHTML;
}, Oo = (i, t = { side: "both" }) => {
  const { side: e } = t, n = i.split(""), o = " ", r = "&nbsp;";
  let a = 0, l = n.length - 1;
  if (e === "both" || e === "start")
    for (; n[a] === o; )
      n[a++] = r;
  if (e === "both" || e === "end")
    for (; n[l] === o; )
      n[l--] = r;
  return n.join("");
}, zn = (i, t) => i.split(/\r\n|\r|\n/g).map((e, n) => e ? t.inline && n === 0 ? Oo(e, { side: "end" }) : `<div>${Oo(e)}</div>` : "<br />").join("");
function Wg(i) {
  const t = "&nbsp;", e = " ", n = " ", o = Mg(i.anchorNode), r = zg(i.anchorNode);
  if (i.anchorNode?.nodeType === Node.TEXT_NODE && o.endsWith(t)) {
    const { focusOffset: a, anchorOffset: l } = i, c = Array.prototype.indexOf.call(
      i.anchorNode.parentElement?.childNodes,
      i.anchorNode
    ), d = r.replaceAll(t, n).replace(/.$/, e), h = document.createTextNode(d);
    if (i.anchorNode.parentElement?.childNodes[c].replaceWith(h), i?.rangeCount && i?.rangeCount > 0 && Ag(h, a, l)) {
      const u = i.getRangeAt(0);
      u.setStart(h, a), u.setEnd(h, l);
    }
  }
}
function Mg(i) {
  if (!i)
    return "";
  if (i instanceof Element)
    return i.innerHTML;
  const t = document.createElement("span");
  return t.appendChild(i.cloneNode()), t.innerHTML;
}
function zg(i) {
  return !i || !i.textContent ? "" : i.textContent;
}
const Vg = "h-inputRichText-addonTrigger--addonTrigger__root", Kg = {
  root: Vg
};
function Ug(i) {
  if (!i)
    return null;
  const { focusOffset: t, anchorOffset: e, anchorNode: n } = i;
  return t !== e || !n || n.nodeName !== "#text" ? null : n?.textContent?.slice(0, t) || null;
}
const wn = (i, t) => {
  const e = Hr(i, t);
  return e && i.triggers.isAddonTrigger(e.matchedTrigger) ? e.matchedTrigger : null;
}, vn = (i, t) => {
  const e = Hr(i, t);
  return e ? e.match : null;
}, Hr = (i, t) => t ? i.triggers.test(t) : null, Bo = "input-rich-text-addon-trigger", qg = (i, t) => {
  const e = i.selection.recreate();
  if (!e || !t) return null;
  const n = e.getRangeAt(0).getBoundingClientRect();
  return i.ref.current && n && e?.rangeCount && e?.rangeCount > 0 ? e.getRangeAt(0).getBoundingClientRect() : null;
}, Gg = (i, t) => {
  if (i.ref.current && t) {
    const e = i.ref.current.getBoundingClientRect();
    return {
      left: `${t.x - e.x}px`,
      top: `${t.y - e.y}px`,
      height: "0",
      width: t.width,
      position: "absolute"
    };
  }
  return {};
}, Vt = (i) => Ug(i.selection.recreate()) || "", bs = (i, t) => !!t && i.triggers.isAddonTrigger(t), xs = (i) => i?.nodeType === Node.ELEMENT_NODE, Ls = (i, t) => i.dataset.testid === t ? i : i.parentElement ? Ls(i.parentElement, t) : null, be = {};
class Yg extends EventTarget {
  /**
   * A map of event listeners for each event type.
   *
   * Since it can be tricky to register/unregister event listeners as data
   * changes in the consumer, we store the event listeners in a map to be able
   * to clear them easily, in order to avoid memory leaks.
   */
  callbacks = {
    focus: [],
    insert: [],
    up: [],
    down: []
  };
  addEventListener(t, e, n) {
    super.addEventListener(t, e, n), e && this.callbacks[t].push(e);
  }
  /** Clear all event listeners for a given event type. */
  clearEventListeners(t) {
    this.callbacks[t].forEach((e) => {
      this.removeEventListener(t, e);
    }), this.callbacks[t] = [];
  }
}
const ve = new Yg(), Xg = Bt({
  matchText: "",
  insertContent: () => {
  },
  eventEmitter: ve
});
var Qg = /* @__PURE__ */ ((i) => (i.FOCUS = "focus", i.INSERT = "insert", i.UP = "up", i.DOWN = "down", i))(Qg || {});
const Zg = (i) => {
  const { editor: t } = i, [e, n] = V(null), [o, r] = V(null), [a, l] = V(null), [c, d] = V(!1), h = Gg(t, a), [u] = V(nn()), { dismissText: p } = be[u] ?? { dismissText: "" }, m = e?.[0] ?? "", g = p && /**
  * Replaces trailing spaces with regular spaces. If a text was dismissed
  * with trailing space, editor uses non-breaking space (U+00A0) instead of
  * regular ` ` space, which results in isDismissed being `false` where it
  * should be `true`.
  */
  m?.replace(/\s+$/, " ").startsWith(p.replace(/\s+$/, " ")) || !1, b = F(() => {
    const S = wn(t, Vt(t)), I = vn(t, Vt(t)), T = qg(t, S);
    bs(t, S) && S?.shouldHandleSelectionChange?.() !== !1 ? (r(S), n(I), l(T)) : (r(null), n(null), l(null)), d(!0);
  }, [t]), x = F(() => {
    const S = wn(t, Vt(t)), I = vn(t, Vt(t))?.[0];
    return bs(t, S) && !!I;
  }, [t]), y = F(() => {
    const S = wn(t, Vt(t)), I = vn(t, Vt(t))?.[0], T = be[u]?.dismissText || "", R = T ? I?.startsWith(T) : !1;
    return bs(t, S) && !!I && !R;
  }, [t, u]), _ = F(() => {
    t.hotkeys.add([
      {
        keybindings: [[[], "Tab"]],
        condition: y,
        callback: () => {
          ve.dispatchEvent(new Event(
            "focus"
            /* FOCUS */
          ));
        }
      },
      {
        keybindings: [[[], "Enter"]],
        condition: y,
        callback: () => {
          ve.dispatchEvent(new Event(
            "insert"
            /* INSERT */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowUp"]],
        condition: y,
        callback: () => {
          ve.dispatchEvent(new Event(
            "up"
            /* UP */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: y,
        callback: () => {
          ve.dispatchEvent(new Event(
            "down"
            /* DOWN */
          ));
        }
      },
      {
        keybindings: [[[], "Escape"]],
        condition: y,
        callback: (S, I) => {
          const T = vn(t, Vt(t))?.[0];
          if (!T) {
            be[u] = {
              dismissText: ""
            };
            return;
          }
          wn(t, Vt(t))?.persistOnEsc === !1 && (I.stopPropagation(), r(null), n(null), l(null)), be[u] = {
            dismissText: (T.trim().length === 1 ? "" : T) ?? ""
          };
        }
      }
    ]);
  }, [t, y, u]);
  Z(() => {
    x() && p !== m && // If persistOnEsc is non-false - preserve existing behavior and reset trigger if the match text changes.
    (g && o?.persistOnEsc !== !1 || // If trigger has been dismissed with Esc and persistOnEsc is false
    // reset dismissText when text is being removed, but preserve dismissText when characters are only added.
    !g && o?.persistOnEsc === !1) && (be[u] = {
      dismissText: ""
    });
  }, [p, g, x, m, u, o]);
  const C = F((S) => {
    const I = S.nativeEvent.relatedTarget, T = xs(I) && Ls(I, Gr), R = xs(I) && Ls(I, Bo);
    (!xs(I) || !T && !R) && d(!1);
  }, []), w = F(
    (S, { inline: I } = {}) => {
      const T = t.selection.recreate();
      if (!T || !o)
        return;
      const E = !!T.anchorNode?.textContent?.match(
        `^${o?.trigger.source}`
      ) && !I ? (
        // Adjust each lines direction if it's been added to a new line
        eo(
          zn(S, { inline: !1 })
        )
      ) : (
        // Or concatenate to the end of the current line without changing direction
        zn(S, { inline: !0 })
      );
      T?.rangeCount && T?.rangeCount > 0 && t.content.insert(
        // template is sanitized
        // eslint-disable-next-line no-unsanitized/method
        T.getRangeAt(0).createContextualFragment(E),
        {
          getSelection: () => {
            const k = t.selection.recreate();
            if (!k)
              return null;
            const { focusOffset: P } = k, ot = o.trigger.exec(m)?.[1]?.length ?? 0, et = m.length - ot;
            return k?.anchorNode && k.extend(
              k.anchorNode,
              P - et
            ), k;
          }
        }
      );
    },
    [t, m, o]
  );
  if (Ne(() => {
    _(), t.selection.onUpdate(b), t.events.onBlur(C);
  }), Zt(() => {
    delete be[u];
  }), !o || !c || !m || g)
    return null;
  const v = o.customContainer?.current || window.document.body;
  return /* @__PURE__ */ s.jsx("div", { style: h, children: /* @__PURE__ */ s.jsxs(ji, { open: !0, children: [
    /* @__PURE__ */ s.jsx(Ni, {}),
    /* @__PURE__ */ s.jsx(Fi, { container: v, children: /* @__PURE__ */ s.jsx(
      Pi,
      {
        onOpenAutoFocus: (S) => S.preventDefault(),
        "data-testid": Bo,
        className: Kg.root,
        side: o.popoverContent?.side ?? "top",
        align: o.popoverContent?.align ?? void 0,
        children: /* @__PURE__ */ s.jsx(
          Xg.Provider,
          {
            value: { matchText: m, insertContent: w, eventEmitter: ve },
            children: o.component
          }
        )
      }
    ) })
  ] }) });
}, Jg = "h-inputRichText-toolbarButton--toolbarButton__root", tf = "h-inputRichText-toolbarButton--toolbarButton__rootDisabled", ef = "h-inputRichText-toolbarButton--toolbarButton__rootActive", nf = "h-inputRichText-toolbarButton--toolbarButton__rootWithBadge", sf = "h-inputRichText-toolbarButton--toolbarButton__rootWithText", xe = {
  root: Jg,
  rootDisabled: tf,
  rootActive: ef,
  rootWithBadge: nf,
  rootWithText: sf
};
function Ft({
  className: i,
  isActive: t,
  icon: e,
  disabled: n,
  showBadge: o,
  text: r,
  tooltip: a,
  tabIndex: l = -1,
  ...c
}) {
  const d = f(
    {
      [xe.root]: xe.root,
      [xe.rootActive]: t,
      [xe.rootDisabled]: n,
      [xe.rootWithBadge]: o,
      [xe.rootWithText]: r
    },
    i
  ), h = /* @__PURE__ */ s.jsx(
    "button",
    {
      tabIndex: l,
      type: "button",
      ...c,
      className: d,
      disabled: n,
      children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx("span", { children: /* @__PURE__ */ s.jsx(N, { name: e }) }),
        r && /* @__PURE__ */ s.jsx("span", { children: /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "3", wrap: "nowrap", color: "inherit", children: r }) })
      ] })
    }
  );
  return a ? /* @__PURE__ */ s.jsx(st, { content: a, side: "top", wrap: "none", children: h }) : h;
}
const of = "h-inputRichText-attachmentButton--attachmentButton__dropzone", rf = "h-inputRichText-attachmentButton--attachmentButton__fileInput", af = "h-inputRichText-attachmentButton--attachmentButton__dropdown", lf = "h-inputRichText-attachmentButton--attachmentButton__dropzoneIcon", Sn = {
  dropzone: of,
  fileInput: rf,
  dropdown: af,
  dropzoneIcon: lf
};
let cf = class extends D {
  static displayName = "AttachmentButtonDropzone";
  constructor(t) {
    super(t), this.state = {
      fileHover: !1
    };
  }
  handleDragEnter = (t) => {
    t.preventDefault();
    const { allowAttachments: e } = this.props;
    !e || !t.dataTransfer?.types?.includes("Files") || this.setState({
      fileHover: !0
    });
  };
  handleDragLeave = (t) => {
    t.preventDefault(), this.setState({
      fileHover: !1
    });
  };
  handleAttachmentDrop = (t) => {
    t.preventDefault();
    const { onAddAttachment: e } = this.props;
    t.dataTransfer && e(t.dataTransfer.files), this.setState({
      fileHover: !1
    });
  };
  render() {
    const {
      className: t,
      children: e,
      isAttachmentsUploading: n,
      allowAttachments: o,
      allowInline: r,
      onAddAttachment: a,
      ...l
    } = this.props, { fileHover: c } = this.state, d = f(t), h = c || n;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...l,
        className: d,
        onDragEnter: this.handleDragEnter,
        onDragOver: this.handleDragEnter,
        onDragLeave: this.handleDragLeave,
        onDrop: this.handleAttachmentDrop,
        children: [
          e,
          h && /* @__PURE__ */ s.jsx(Qt, { children: n ? "Uploading..." : "Drop to add an attachment" }),
          !h && "Drop the file or click to upload"
        ]
      }
    );
  }
};
const df = [
  {
    name: "addAttachment",
    label: "Add attachment",
    keybindings: [[["$metaOrCtrl"], "KeyU"]]
  }
];
class hf extends D {
  unsubscribeAddAttachment;
  fileInputRef;
  constructor(t) {
    super(t), this.fileInputRef = O(), this.unsubscribeAddAttachment = Vi;
  }
  componentDidMount() {
    this.unsubscribeAddAttachment = this.props.editor.events.subscribe(
      "addAttachment",
      () => {
        this.props.disabled || this.fileInputRef.current?.click();
      }
    );
  }
  componentWillUnmount() {
    this.unsubscribeAddAttachment?.();
  }
  openFileBrowser = (t) => {
    t.preventDefault();
    const { current: e } = this.fileInputRef;
    e && e.click();
  };
  handleFileChanged = (t) => {
    const { onAttachFiles: e, editorWindow: n } = this.props, o = t.target;
    o !== null && o instanceof n.HTMLInputElement && (e(o.files), o.value = "");
  };
  renderDropdown() {
    const { isAttachmentsUploading: t, attachments: e, onAttachFiles: n, children: o } = this.props;
    return /* @__PURE__ */ s.jsxs("div", { className: Sn.dropdown, children: [
      /* @__PURE__ */ s.jsx(
        cf,
        {
          className: Sn.dropzone,
          onAddAttachment: n,
          attachments: e,
          isAttachmentsUploading: t,
          allowInline: !1,
          onClick: this.openFileBrowser,
          allowAttachments: !0,
          children: /* @__PURE__ */ s.jsx(N, { name: "paperclip", className: Sn.dropzoneIcon })
        }
      ),
      o
    ] });
  }
  preventDefault = (t) => {
    t.preventDefault();
  };
  render() {
    const {
      className: t,
      attachments: e,
      onAttachFiles: n,
      onDetachFile: o,
      isAttachmentsUploading: r,
      dropdownRef: a,
      editorWindow: l,
      disabled: c,
      disabledTooltip: d,
      ...h
    } = this.props, u = /* @__PURE__ */ s.jsx(
      Ft,
      {
        onMouseDown: this.preventDefault,
        icon: "paperclip",
        showBadge: e.length > 0,
        disabled: c,
        tooltip: "Insert attachment"
      }
    );
    return c ? /* @__PURE__ */ s.jsx(st, { content: d, disabled: !d, children: u }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ref: this.fileInputRef,
          type: "file",
          className: Sn.fileInput,
          onChange: this.handleFileChanged,
          multiple: !0
        }
      ),
      /* @__PURE__ */ s.jsx(
        le,
        {
          ...h,
          className: t,
          noStyle: !0,
          ref: a,
          dropdown: this.renderDropdown(),
          children: u
        }
      )
    ] });
  }
}
const uf = "h-inputRichText-dropzone--dropzone__root", pf = "h-inputRichText-dropzone--dropzone__inlineDropzone", mf = "h-inputRichText-dropzone--dropzone__attachmentDropzone", gf = "h-inputRichText-dropzone--dropzone__rootDual", ff = "h-inputRichText-dropzone--dropzone__icon", ye = {
  root: uf,
  inlineDropzone: pf,
  attachmentDropzone: mf,
  rootDual: gf,
  icon: ff
};
class bf extends D {
  static displayName = "InputRichTextDropzone";
  constructor(t) {
    super(t), this.state = {
      fileHover: !1,
      overDropzone: !1
    };
  }
  handleDragEnter = (t) => {
    t.preventDefault();
    const { allowInlineAttachments: e, allowAttachments: n } = this.props;
    !e && !n || !t.dataTransfer?.types?.includes("Files") || this.setState({
      fileHover: !0
    });
  };
  handleDragLeave = (t) => {
    t.preventDefault(), this.setState({
      fileHover: !1
    });
  };
  handleEnterDropzone = (t) => {
    t.preventDefault(), this.setState({
      overDropzone: !0
    });
  };
  handleLeaveDropzone = (t) => {
    t.preventDefault(), this.setState({
      overDropzone: !1
    });
  };
  handleInlineDrop = (t) => {
    t.preventDefault();
    const { onAddInline: e } = this.props;
    t.dataTransfer && typeof e == "function" && e(t.dataTransfer.files), this.setState({
      overDropzone: !1,
      fileHover: !1
    });
  };
  handleAttachmentDrop = (t) => {
    t.preventDefault();
    const { onAddAttachment: e } = this.props;
    t.dataTransfer && typeof e == "function" && e(t.dataTransfer.files), this.setState({
      overDropzone: !1,
      fileHover: !1
    });
  };
  render() {
    const {
      className: t,
      children: e,
      allowInlineAttachments: n,
      allowAttachments: o,
      onAddInline: r,
      onMouseDown: a,
      attachments: l,
      onAddAttachment: c,
      ...d
    } = this.props, { fileHover: h, overDropzone: u } = this.state, p = f(
      {
        [ye.root]: !0,
        [ye.rootDual]: n && o
      },
      t
    ), m = n || o, g = {};
    return a && (g.onClick = a), m && (g.onDragEnter = this.handleDragEnter, g.onDragOver = this.handleDragEnter, g.onDragLeave = this.handleDragLeave), /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...d,
        tabIndex: -1,
        className: p,
        ...g,
        children: [
          e,
          (h || u) && /* @__PURE__ */ s.jsxs(Qt, { children: [
            n && /* @__PURE__ */ s.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleInlineDrop,
                className: ye.inlineDropzone,
                children: [
                  /* @__PURE__ */ s.jsx(N, { name: "upload", size: 24, className: ye.icon }),
                  "Drop to add inline"
                ]
              }
            ),
            o && /* @__PURE__ */ s.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleAttachmentDrop,
                className: ye.attachmentDropzone,
                children: [
                  /* @__PURE__ */ s.jsx(N, { name: "paperclip", size: 24, className: ye.icon }),
                  "Drop to add an attachment"
                ]
              }
            )
          ] })
        ]
      }
    );
  }
}
const Wr = (i, t) => i.split(new RegExp(`(${Ms(t)})`, "gi")).map(
  (e, n) => e.toLowerCase() === t.toLowerCase() ? /* @__PURE__ */ s.jsx("span", { children: e }, n) : e
), xf = "h-inputRichText-emoji--emoji__root", yf = "h-inputRichText-emoji--emoji__decorator", _f = "h-inputRichText-emoji--emoji__suggestion", Cf = "h-inputRichText-emoji--emoji__suggestionActive", wf = "h-inputRichText-emoji--emoji__suggestionName", Je = {
  root: xf,
  decorator: yf,
  suggestion: _f,
  suggestionActive: Cf,
  suggestionName: wf
}, vf = Ai(
  () => import("./emoji-DZcJJbOG.js").then((i) => i.g).then((i) => ({
    default: i.EmojiPicker
  }))
), Vn = {};
Hi.emojis.forEach((i) => {
  i.forEach(
    (t) => {
      t.shortNames && t.shortNames.forEach((e) => {
        Vn[e.replace(/:/g, "")] = t.emoji;
      });
    }
  );
});
const Sf = (i) => {
  const { active: t, item: e, match: n, onSelect: o } = i, r = n ? Wr(e, n) : e;
  return /* @__PURE__ */ s.jsxs(
    "button",
    {
      onClick: () => o(e),
      type: "button",
      "aria-current": t,
      className: f(Je.suggestion, {
        [Je.suggestionActive]: t
      }),
      children: [
        Vn[e],
        /* @__PURE__ */ s.jsx("span", { className: Je.suggestionName, children: r })
      ]
    }
  );
};
class If extends D {
  constructor(t) {
    super(t), this.insertEmoji = this.insertEmoji.bind(this), this.insertContent = this.insertContent.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.triggers.add({
      trigger: /(^|\s):/,
      minChars: 2,
      allowSpaces: !1,
      getSuggestions: this.getSuggestions,
      suggestionComponent: Sf,
      insertContent: this.insertContent
    });
  }
  insertContent(t, e = "", n) {
    this.insertEmoji(Vn[t], e, n);
  }
  insertEmoji(t, e, n) {
    const { editor: o } = this.props, r = document.createElement("span");
    r.classList.add(Je.decorator), r.innerHTML = t, o.content.insert(r, {
      getSelection: () => {
        const a = o.selection.recreate();
        return e && a?.anchorNode && a.extend(a.anchorNode, n), a;
      }
    });
  }
  getSuggestions = (t) => Object.keys(Vn).filter((n) => n.indexOf(t) !== -1);
  // eslint-disable-next-line no-undef
  preventDefault = (t) => {
    t.preventDefault();
  };
  renderDropdown = () => /* @__PURE__ */ s.jsx($i, { fallback: /* @__PURE__ */ s.jsx("div", { children: "Loading..." }), children: /* @__PURE__ */ s.jsx(dn.Consumer, { children: ({ toggleDropdown: t }) => /* @__PURE__ */ s.jsx(
    vf,
    {
      onSelect: (e) => {
        this.insertEmoji(e), t();
      }
    }
  ) }) });
  render() {
    const { className: t } = this.props, e = f(
      {
        [Je.root]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsx("div", { className: e, children: /* @__PURE__ */ s.jsx(le, { icon: "smile", dropdown: this.renderDropdown(), noStyle: !0, children: /* @__PURE__ */ s.jsx(
      Ft,
      {
        icon: "smile",
        tooltip: "Emojis",
        onMouseDown: this.preventDefault
      }
    ) }) });
  }
}
const Df = "h-inputRichText--inputRichText__inputWrapper", kf = "h-inputRichText--inputRichText__root", Tf = "h-inputRichText--inputRichText__toolbar", jf = "h-inputRichText--inputRichText__toolbarHint", Nf = "h-inputRichText--inputRichText__toolbarHintVisible", Ff = "h-inputRichText--inputRichText__toolbarHintHidden", Pf = "h-inputRichText--inputRichText__editorWrap", Rf = "h-inputRichText--inputRichText__placeholder", Ef = "h-inputRichText--inputRichText__editor", Lf = "h-inputRichText--inputRichText__editorDisabled", Af = "h-inputRichText--inputRichText__fileInput", $f = "h-inputRichText--inputRichText__uiBlocker", ft = {
  inputWrapper: Df,
  root: kf,
  toolbar: Tf,
  toolbarHint: jf,
  toolbarHintVisible: Nf,
  toolbarHintHidden: Ff,
  editorWrap: Pf,
  placeholder: Rf,
  editor: Ef,
  editorDisabled: Lf,
  fileInput: Af,
  uiBlocker: $f
};
function no(i) {
  if (!i || i.length === 0)
    return "";
  const [t = [], e = ""] = i[0];
  if (!e)
    return "";
  const n = t.map((r) => Of(r)).filter(Boolean), o = Bf(e);
  return Yt ? [...n, o].join("") : [...n, o].join("+");
}
function Of(i) {
  if (Yt)
    switch (i) {
      case "$metaOrCtrl":
      case "Meta":
        return "⌘";
      case "Control":
      case "$controlOrAlt":
        return "⌃";
      case "Shift":
        return "⇧";
      case "Alt":
        return "⌥";
      default:
        return i;
    }
  switch (i) {
    case "$metaOrCtrl":
    case "Control":
      return "Ctrl";
    case "$controlOrAlt":
    case "Alt":
      return "Alt";
    case "Shift":
      return "Shift";
    case "Meta":
      return "Win";
    default:
      return i;
  }
}
function Bf(i) {
  if (i.startsWith("Key"))
    return i.slice(3);
  if (i.startsWith("Digit"))
    return i.slice(5);
  switch (i) {
    case "Backslash":
      return "\\";
    case "Slash":
      return "/";
    case "Enter":
      return Yt ? "↵" : "Enter";
    case "Escape":
      return "Esc";
    case "Space":
      return "Space";
    case "Backspace":
      return Yt ? "⌫" : "Backspace";
    case "Delete":
      return Yt ? "⌦" : "Del";
    case "ArrowUp":
      return "↑";
    case "ArrowDown":
      return "↓";
    case "ArrowLeft":
      return "←";
    case "ArrowRight":
      return "→";
    default:
      return i;
  }
}
const Hf = "h-inputRichText-linkButton--linkButton__linkOpener", Wf = "h-inputRichText-linkButton--linkButton__dropdownContainer", Ho = {
  linkOpener: Hf,
  dropdownContainer: Wf
}, Mf = "h-inputRichText-linkButton--linkMenu__root", zf = "h-inputRichText-linkButton--linkMenu__field", ys = {
  root: Mf,
  field: zf
};
class Vf extends D {
  constructor(t) {
    super(t);
    const { initialText: e, initialUrl: n } = t;
    this.state = {
      textValue: e,
      urlValue: n
    };
  }
  componentDidUpdate(t) {
    const { initialText: e, initialUrl: n } = this.props;
    (e !== t.initialText || n !== t.initialUrl) && this.setState({
      textValue: e,
      urlValue: n
    });
  }
  handleTextChange = (t) => {
    t && this.setState({
      textValue: t.target.value
    });
  };
  handleUrlChange = (t) => {
    t && this.setState({
      urlValue: t.target.value
    });
  };
  handleAddLink = (t) => {
    t?.preventDefault();
    const { onAddLink: e, toggleDropdown: n } = this.props, { textValue: o, urlValue: r } = this.state;
    r && (e(o || void 0, r), n());
  };
  handleUnlink = (t) => {
    t.preventDefault();
    const { onUnlink: e, toggleDropdown: n } = this.props;
    e(), n();
  };
  handleKeyDown = (t) => {
    t.key === "Enter" && (t.preventDefault(), this.handleAddLink());
  };
  render() {
    const {
      className: t,
      initialText: e,
      initialUrl: n,
      onAddLink: o,
      toggleDropdown: r,
      onUnlink: a,
      ...l
    } = this.props, { textValue: c, urlValue: d } = this.state, h = f({ [ys.root]: !0 }, t);
    return /* @__PURE__ */ s.jsxs("div", { ...l, className: h, children: [
      /* @__PURE__ */ s.jsx(
        Rs,
        {
          label: "Link title",
          noAlert: !0,
          className: ys.field,
          input: {
            value: c,
            name: "pleasedontautofillthis",
            onChange: this.handleTextChange
          },
          onKeyDown: this.handleKeyDown
        }
      ),
      /* @__PURE__ */ s.jsx(
        Rs,
        {
          label: "Link URL",
          noAlert: !0,
          className: ys.field,
          input: {
            value: d,
            name: "link_url",
            onChange: this.handleUrlChange
          },
          onKeyDown: this.handleKeyDown,
          autoFocus: !0
        }
      ),
      /* @__PURE__ */ s.jsxs(B, { gap: "200", children: [
        /* @__PURE__ */ s.jsx(X, { variant: "primary", onClick: this.handleAddLink, children: "Add" }),
        !!d && /* @__PURE__ */ s.jsx(X, { variant: "secondary", onClick: this.handleUnlink, children: "Remove link" })
      ] })
    ] });
  }
}
const Mr = [
  {
    name: "hyperlink",
    label: "Link: insert",
    keybindings: [[["$metaOrCtrl", "Shift"], "KeyK"]]
  },
  {
    name: "removeHyperlink",
    label: "Link: remove",
    keybindings: [],
    callback: (i) => i.command.run("unlink")
  }
], Kf = ({ editor: i }) => {
  const [t, e] = Oi((_) => _ + 1, 0), [n, o] = Wi(!1), r = G(null), a = G(), [
    { hoverLinkBounds: l, hoverLinkHref: c, selectedLink: d, selectedText: h },
    u
  ] = Mi({
    selectedLink: "",
    selectedText: "",
    hoverLinkHref: null,
    hoverLinkBounds: null
  });
  Ne(() => {
    i.events.onMouseOver((_) => {
      m(_);
    }), a.current = i.events.subscribe("hyperlink", () => {
      o(!0);
    }), i.selection.onUpdate(() => {
      p();
    });
  }), Zt(() => {
    a.current?.();
  });
  const p = () => {
    const _ = i.selection.recreate();
    if (!_)
      return;
    const { anchorNode: C, focusNode: w } = _;
    if (C && w === C && C.parentElement?.nodeName === "A") {
      const { href: v, innerText: S } = C.parentElement;
      u({
        selectedLink: v,
        selectedText: S
      });
    } else
      u({
        selectedLink: "",
        selectedText: _.toString()
      });
  }, m = F(
    (_) => {
      const { target: C } = _, { current: w } = i.ref;
      if (w && C && C instanceof HTMLAnchorElement) {
        const v = w.getBoundingClientRect(), S = C.getBoundingClientRect();
        u({
          hoverLinkHref: C.getAttribute("href"),
          hoverLinkBounds: {
            top: S.top - v.top,
            left: S.left - v.left,
            width: S.width
          }
        });
      } else
        u({
          hoverLinkHref: null,
          hoverLinkBounds: null
        });
    },
    [i.ref, u]
  ), g = F(() => {
    const _ = i.selection.recreate();
    if (!_)
      return;
    const { anchorNode: C, focusNode: w } = _;
    if (C && C === w && C.parentElement?.nodeName === "A") {
      const v = document.createRange();
      v.selectNodeContents(C.parentElement), _.removeAllRanges(), _.addRange(v);
    }
  }, [i.selection]), b = F(
    (_, C) => {
      C && (g(), i.command.run("insertHTML", `<a href="${C}">${_ || C}</a>`), e());
    },
    [i.command, g]
  ), x = F(() => {
    g(), i.command.run("unlink");
  }, [i.command, g]), y = F((_) => {
    _.preventDefault();
  }, []);
  return Cr(r, () => {
    o(!1);
  }), _r("Escape", () => {
    o(!1), g();
  }), /* @__PURE__ */ s.jsxs(Qt, { children: [
    /* @__PURE__ */ s.jsxs("div", { ref: r, className: Ho.dropdownContainer, children: [
      /* @__PURE__ */ s.jsx(
        Ft,
        {
          isActive: !!d,
          icon: "link",
          onMouseDown: y,
          onClick: () => o(),
          tooltip: `Insert link (${no(Mr[0].keybindings)})`
        }
      ),
      n && /* @__PURE__ */ s.jsx(Jt, { isOpen: n, children: /* @__PURE__ */ s.jsx(
        Vf,
        {
          onAddLink: b,
          toggleDropdown: o,
          initialUrl: d,
          initialText: h,
          onUnlink: x
        }
      ) })
    ] }),
    !!l && !!c && /* @__PURE__ */ s.jsx(
      "a",
      {
        className: Ho.linkOpener,
        href: c,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          top: `${l.top}px`,
          left: `${l.left + l.width}px`
        },
        children: /* @__PURE__ */ s.jsx(N, { className: "icon-vertical-fix", name: "external-link" })
      }
    )
  ] });
}, Uf = "h-tabs--tabs__root", qf = "h-tabs--tabs__tabs", Gf = "h-tabs--tabs__tab", Yf = "h-tabs--tabs__tabTop", Xf = "h-tabs--tabs__tabTopActive", Qf = "h-tabs--tabs__tabTopSelected", Zf = "h-tabs--tabs__tabLeft", Jf = "h-tabs--tabs__tabLeftActive", tb = "h-tabs--tabs__tabLeftSelected", eb = "h-tabs--tabs__tabBottom", nb = "h-tabs--tabs__tabBottomActive", sb = "h-tabs--tabs__tabBottomSelected", ob = "h-tabs--tabs__tabRight", rb = "h-tabs--tabs__tabRightActive", ib = "h-tabs--tabs__tabRightSelected", ab = "h-tabs--tabs__tabDisabled", it = {
  root: Uf,
  tabs: qf,
  tab: Gf,
  tabTop: Yf,
  tabTopActive: Xf,
  tabTopSelected: Qf,
  tabLeft: Zf,
  tabLeftActive: Jf,
  tabLeftSelected: tb,
  tabBottom: eb,
  tabBottomActive: nb,
  tabBottomSelected: sb,
  tabRight: ob,
  tabRightActive: rb,
  tabRightSelected: ib,
  tabDisabled: ab
}, lb = 13;
class cb extends D {
  constructor(t) {
    super(t), this.handleOnClick = this.handleOnClick.bind(this), this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
  }
  handleOnClick() {
    const { id: t, onChange: e, disabled: n } = this.props;
    n || e(t);
  }
  handleOnKeyDown(t) {
    t.keyCode === lb && this.handleOnClick();
  }
  getClassName() {
    const {
      selected: t,
      placement: e,
      className: n,
      disabled: o,
      active: r,
      selectedClassName: a
    } = this.props;
    let l = f(it.tab, n, {
      [it.tabDisabled]: o,
      [it.tabTop]: e === "top",
      [it.tabRight]: e === "right",
      [it.tabLeft]: e === "left",
      [it.tabBottom]: e === "bottom",
      [it.tabTopSelected]: e === "top" && t,
      [it.tabRightSelected]: e === "right" && t,
      [it.tabLeftSelected]: e === "left" && t,
      [it.tabBottomSelected]: e === "bottom" && t,
      [it.tabTopActive]: e === "top" && r,
      [it.tabRightActive]: e === "right" && r,
      [it.tabLeftActive]: e === "left" && r,
      [it.tabBottomActive]: e === "bottom" && r
    });
    return a && (l = f(l, { [a]: t })), l;
  }
  render() {
    const { id: t, label: e, icon: n, disabled: o, slotEnd: r, slotStart: a } = this.props;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        role: "tab",
        className: this.getClassName(),
        onClick: this.handleOnClick,
        onKeyDown: this.handleOnKeyDown,
        tabIndex: o ? -1 : 0,
        children: [
          a || !!n && /* @__PURE__ */ s.jsx(N, { name: n, className: "icon-vertical-fix" }),
          e,
          r
        ]
      },
      t
    );
  }
}
class so extends D {
  containerRef;
  static defaultProps = {
    tabsPlacement: "top"
  };
  constructor(t) {
    super(t), this.containerRef = O(), this.renderTab = this.renderTab.bind(this), this.renderTabs = this.renderTabs.bind(this);
  }
  renderTab({
    id: t,
    label: e,
    icon: n,
    disabled: o,
    slotEnd: r,
    slotStart: a
  }) {
    const {
      selectedId: l,
      activeId: c,
      onChange: d,
      tabsPlacement: h,
      tabClassName: u,
      tabSelectedClassName: p
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      cb,
      {
        selected: t === l,
        className: u,
        selectedClassName: p,
        id: t,
        label: e,
        icon: n,
        onChange: d,
        placement: h,
        disabled: o,
        active: t === c,
        slotEnd: r,
        slotStart: a
      },
      t
    );
  }
  renderTabs() {
    const { tabs: t } = this.props;
    return t.map(this.renderTab);
  }
  render() {
    const {
      className: t,
      tabClassName: e,
      tabSelectedClassName: n,
      tabs: o,
      selectedId: r,
      onChange: a,
      tabsPlacement: l,
      activeId: c,
      ...d
    } = this.props, h = f(it.root, t);
    return /* @__PURE__ */ s.jsx("div", { ref: this.containerRef, ...d, className: h, children: /* @__PURE__ */ s.jsx("div", { className: it.tabs, children: this.renderTabs() }) });
  }
}
const db = an(so, {
  fallback: null
}), hb = "h-inputRichText-quickResponseSelector--quickResponseItem__root", ub = "h-inputRichText-quickResponseSelector--quickResponseItem__rootActive", pb = "h-inputRichText-quickResponseSelector--quickResponseItem__name", Ve = {
  root: hb,
  rootActive: ub,
  name: pb
};
class _s extends D {
  constructor(t) {
    super(t), this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect() {
    const { isLoading: t, onSelect: e, item: n } = this.props;
    t || e(n);
  }
  render() {
    const {
      className: t,
      item: e,
      isLoading: n,
      onSelect: o,
      active: r,
      searchValue: a,
      clearSearch: l,
      ...c
    } = this.props, { name: d, content: h, matched: u } = !n && e ? e : {
      name: "Loading...",
      content: "",
      matched: ""
    }, p = f(
      {
        [Ve.root]: Ve.root,
        [Ve.rootActive]: r
      },
      t
    ), m = u ? Wr(d, u) : d;
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        type: "button",
        "aria-current": r,
        ...c,
        className: p,
        onClick: this.handleSelect,
        title: d,
        children: [
          /* @__PURE__ */ s.jsx(A.Heading, { variant: "heading-3", className: Ve.name, children: m }),
          /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "4", className: Ve.name, subdued: !0, children: h })
        ]
      }
    );
  }
}
const mb = "h-inputRichText-quickResponseSelector--quickResponseSelector__container", gb = "h-inputRichText-quickResponseSelector--quickResponseSelector__dropdownButtonContainer", fb = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdown", bb = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabs", xb = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabsContent", yb = "h-inputRichText-quickResponseSelector--quickResponseSelector__regularDropdown", _e = {
  container: mb,
  dropdownButtonContainer: gb,
  tabbedDropdown: fb,
  tabbedDropdownTabs: bb,
  tabbedDropdownTabsContent: xb,
  regularDropdown: yb
}, Wo = /(^|\s)=/, Cs = "Quick responses";
class _b extends _t {
  constructor(t) {
    super(t), this.state = {
      searchTerm: "",
      selectedTab: t.languages[0]?.code
    }, this.handleToggle = this.handleToggle.bind(this), this.handleNextPage = this.handleNextPage.bind(this), this.getPagination = this.getPagination.bind(this), this.normalizeSuggestion = this.normalizeSuggestion.bind(this), this.handleSearchChange = this.handleSearchChange.bind(this), this.handleTabChange = this.handleTabChange.bind(this), this.handleTabbedSearchChange = this.handleTabbedSearchChange.bind(this), this.getTabDefinitions = this.getTabDefinitions.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.triggers.add({
      trigger: Wo,
      minChars: 0,
      allowSpaces: !0,
      getSuggestions: this.handleSearchChange,
      suggestionComponent: _s,
      getPagination: this.getPagination,
      getTabs: this.getTabDefinitions,
      insertContent: this.insertContent
    });
  }
  normalizeSuggestion(t) {
    const { quickResponsesApi: e } = this.props;
    return {
      id: t.name,
      matched: e.params.search ?? "",
      ...t
    };
  }
  getTabDefinitions() {
    const { languages: t } = this.props;
    return t.map((e) => ({
      id: e.code,
      label: e.label
    }));
  }
  handleNextPage() {
    const { quickResponsesApi: t } = this.props;
    return new Promise((e) => t.getItemsAsyncStatus === "loading" ? e(t.items.map(this.normalizeSuggestion)) : e(
      t.nextPage().then((n) => n.map(this.normalizeSuggestion)).catch((n) => {
        console.error(n);
      })
    ));
  }
  preventDefault = (t) => {
    t.preventDefault();
  };
  handleSelect = (t, e) => {
    this.insertContent(t)?.then(() => {
      e && e();
    });
  };
  insertContent = (t, e, n) => {
    const { renderQuickResponse: o, sanitize: r, editor: a } = this.props;
    return o(t).then((l) => {
      const c = a.selection.recreate();
      if (!c)
        return;
      const d = !!e, h = d && !!c.anchorNode?.textContent?.match(
        `^${Wo.source}`
      ) || !d && !c.anchorNode?.textContent;
      let u;
      h ? u = eo(
        zn(r(l), { inline: !1 })
      ) : u = zn(r(l), { inline: !0 }), c?.rangeCount && c?.rangeCount > 0 && a.content.insert(
        // template is sanitized
        // eslint-disable-next-line no-unsanitized/method
        c.getRangeAt(0).createContextualFragment(u),
        {
          getSelection: () => {
            const p = a.selection.recreate();
            return d && p?.anchorNode && p.extend(p.anchorNode, n), p;
          }
        }
      );
    });
  };
  handleToggle(t) {
    const { quickResponsesApi: e, languages: n } = this.props;
    t && (e.params.search !== "" || e.params.locale !== n[0]?.code) && this.setState({ searchTerm: "", selectedTab: n[0]?.code }, () => {
      const { searchTerm: o, selectedTab: r } = this.state;
      this.handleSearchChange(o, r, 0);
    });
  }
  getPagination() {
    const { quickResponsesApi: t } = this.props;
    return {
      nextEnable: t.hasNextPage,
      previousEnable: !1,
      infinite: !0,
      onNext: this.handleNextPage
    };
  }
  handleSearchChange(t, e, n) {
    const { quickResponsesApi: o } = this.props;
    return o.paramsChange({ search: t, locale: e }, n).then((r) => r.map(this.normalizeSuggestion));
  }
  handleTabbedSearchChange(t) {
    this.setState({ searchTerm: t }, () => {
      const { searchTerm: e, selectedTab: n } = this.state;
      this.handleSearchChange(e, n);
    });
  }
  handleTabChange(t) {
    this.setState({ selectedTab: t }, () => {
      const { searchTerm: e, selectedTab: n } = this.state;
      this.handleSearchChange(e, n, 0);
    });
  }
  renderIcon() {
    return /* @__PURE__ */ s.jsx(
      Ft,
      {
        icon: this.props.iconName ?? "bolt",
        onMouseDown: this.preventDefault
      }
    );
  }
  renderItemsWithoutTabs() {
    const { className: t, quickResponsesApi: e } = this.props;
    return /* @__PURE__ */ s.jsx(st, { content: `${Cs} (=)`, children: /* @__PURE__ */ s.jsx(
      Js,
      {
        className: t,
        dropdownProps: {
          className: _e.regularDropdown
        },
        containerProps: { className: _e.container },
        items: e.items.map(this.normalizeSuggestion),
        pagination: this.getPagination(),
        itemComponent: _s,
        hasSearch: !0,
        noStyle: !0,
        onSearch: this.handleSearchChange,
        onSelect: this.handleSelect,
        onToggle: this.handleToggle,
        emptyMessage: e.getItemsAsyncStatus === "loading" ? "Loading..." : void 0,
        children: this.renderIcon()
      }
    ) });
  }
  renderItemsWithTabs() {
    const { className: t } = this.props, { selectedTab: e } = this.state;
    return /* @__PURE__ */ s.jsx("div", { className: _e.dropdownButtonContainer, children: /* @__PURE__ */ s.jsx(st, { content: `${Cs} (=)`, children: /* @__PURE__ */ s.jsx(
      le,
      {
        className: t,
        noStyle: !0,
        onToggle: this.handleToggle,
        buttonProps: { title: Cs },
        dropdown: /* @__PURE__ */ s.jsxs("div", { className: _e.tabbedDropdown, children: [
          /* @__PURE__ */ s.jsx(
            so,
            {
              className: _e.tabbedDropdownTabs,
              tabs: this.getTabDefinitions(),
              tabsPlacement: "left",
              selectedId: e,
              onChange: this.handleTabChange
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: _e.tabbedDropdownTabsContent, children: this.renderTabItems() })
        ] }),
        children: this.renderIcon()
      }
    ) }) });
  }
  renderTabItems() {
    const { quickResponsesApi: t } = this.props;
    return /* @__PURE__ */ s.jsx(dn.Consumer, { children: ({ dropdownOpen: e, closeDropdown: n }) => /* @__PURE__ */ s.jsx(
      Br,
      {
        dropdownOpen: e,
        triggerClose: n,
        hasSearch: !0,
        pagination: this.getPagination(),
        items: t.items.map(this.normalizeSuggestion),
        itemComponent: _s,
        onSearch: this.handleTabbedSearchChange,
        onSelect: (o) => this.handleSelect(o, n),
        emptyComponent: hn,
        emptyMessage: t.getItemsAsyncStatus === "loading" ? "Loading..." : "No items found."
      }
    ) });
  }
  render() {
    const { languages: t } = this.props;
    return t?.length ? this.renderItemsWithTabs() : this.renderItemsWithoutTabs();
  }
}
const Cb = "h-inputRichText-formatSelector--formatSelector__root", wb = "h-inputRichText-formatSelector--formatSelector__list", vb = "h-inputRichText-formatSelector--formatSelector__selector", Sb = "h-inputRichText-formatSelector--formatSelector__option", Ib = "h-inputRichText-formatSelector--formatSelector__optionActive", Db = "h-inputRichText-formatSelector--formatSelector__button", Ce = {
  root: Cb,
  list: wb,
  selector: vb,
  option: Sb,
  optionActive: Ib,
  button: Db
}, As = [
  {
    name: "noHeading",
    label: "Normal",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "div"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h1",
    label: "Headline 1",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H1>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h2",
    label: "Headline 2",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H2>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h3",
    label: "Headline 3",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H3>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h4",
    label: "Headline 4",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H4>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h5",
    label: "Headline 5",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H5>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "quote",
    label: "Blockquote",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<BLOCKQUOTE>"),
    condition: (i) => i.allowFormatting.includes("format")
  }
], Mo = {
  h1: { tag: "<H1>" },
  h2: { tag: "<H2>" },
  h3: { tag: "<H3>" },
  h4: { tag: "<H4>" },
  h5: { tag: "<H5>" },
  noHeading: { default: !0, tag: "div" },
  quote: { tag: "<BLOCKQUOTE>" }
};
class kb extends D {
  preventDefault = (t) => {
    t.preventDefault();
  };
  renderDropdown() {
    const { editor: t } = this.props;
    return /* @__PURE__ */ s.jsx(dn.Consumer, { children: ({ closeDropdown: e }) => /* @__PURE__ */ s.jsx("ul", { className: Ce.list, children: As.map((n) => {
      const o = "condition" in n;
      if (!(!o || o && n.condition(t)))
        return;
      const a = Mo[n.name];
      return /* @__PURE__ */ s.jsx(
        "li",
        {
          className: f(Ce.option, {
            [Ce.optionActive]: this.isActiveFormat(a)
          }),
          children: /* @__PURE__ */ s.jsx(
            "button",
            {
              type: "button",
              className: Ce.button,
              onClick: () => {
                n.callback?.(t), e();
              },
              children: n.label
            }
          )
        },
        n.name
      );
    }).filter(Boolean) }) });
  }
  isActiveFormat(t) {
    const { formatBlock: e } = this.props;
    return !!(!e && t.default || t.tag === e || t.tag === `<${e.toUpperCase()}>`);
  }
  getCurrentFormatName() {
    return As.find(
      (t) => this.isActiveFormat(Mo[t.name])
    )?.label ?? "Normal";
  }
  render() {
    const { className: t, editor: e, formatBlock: n, ...o } = this.props, r = f(Ce.root, t);
    return /* @__PURE__ */ s.jsx(
      le,
      {
        className: r,
        ...o,
        dropdown: this.renderDropdown(),
        noStyle: !0,
        children: /* @__PURE__ */ s.jsxs("div", { className: Ce.selector, children: [
          this.getCurrentFormatName(),
          /* @__PURE__ */ s.jsx(N, { className: "icon-vertical-fix", name: "angle-down" })
        ] })
      }
    );
  }
}
const Tb = "h-inputRichText-stylingMenu--stylingMenu__menu", jb = "h-inputRichText-stylingMenu--stylingMenu__buttonsContainer", zo = {
  menu: Tb,
  buttonsContainer: jb
}, zr = [
  {
    name: "bold",
    label: "Bold",
    icon: "bold",
    keybindings: [[["$metaOrCtrl"], "KeyB"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyB"]],
    callback: (i) => i.command.run("bold"),
    condition: (i) => i.allowFormatting.includes("bold")
  },
  {
    name: "italic",
    label: "Italic",
    icon: "italic",
    keybindings: [[["$metaOrCtrl"], "KeyI"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyI"]],
    callback: (i) => i.command.run("italic"),
    condition: (i) => i.allowFormatting.includes("italic")
  },
  {
    name: "orderedList",
    label: "List: ordered",
    icon: "list-ol",
    keybindings: [[["Control", "$controlOrAlt"], "Digit7"]],
    callback: (i) => i.command.run("insertOrderedList"),
    condition: (i) => i.allowFormatting.includes("orderedList")
  },
  {
    name: "unorderedList",
    label: "List: unordered",
    icon: "list-ul",
    keybindings: [[["Control", "$controlOrAlt"], "Digit8"]],
    callback: (i) => i.command.run("insertUnorderedList"),
    condition: (i) => i.allowFormatting.includes("unorderedList")
  },
  {
    name: "inlineCode",
    label: "Inline code",
    icon: "code",
    keybindings: [[["$metaOrCtrl"], "KeyE"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyE"]],
    callback: (i) => i.command.run("inlineCode"),
    condition: (i) => i.allowFormatting.includes("inlineCode")
  },
  {
    name: "noFormat",
    label: "Clear formatting",
    icon: "pen-slash",
    keybindings: [[["$metaOrCtrl"], "Backslash"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "Backslash"]],
    callback: (i) => i.command.run("removeFormat")
  }
], Vr = [...As, ...zr];
class Nb extends D {
  domRef;
  constructor(t) {
    super(t), this.state = {
      isOpen: !1,
      currentFormat: ""
    }, this.domRef = O(), this.handleToolbarButtonClick = this.handleToolbarButtonClick.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.selection.onUpdate(() => {
      this.updateCurrentFormat();
    });
  }
  componentDidUpdate(t, e) {
    const { isOpen: n } = this.state, { editorWindow: o } = this.props;
    n !== e.isOpen && o[n ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutside,
      !0
    );
  }
  componentWillUnmount() {
    const { isOpen: t } = this.state, { editorWindow: e } = this.props;
    t && e.removeEventListener("click", this.handleClickOutside, !0);
  }
  updateCurrentFormat() {
    const { editorWindow: t } = this.props;
    this.setState({
      currentFormat: Og(t)
    });
  }
  handleClickOutside = (t) => {
    const { current: e } = this.domRef;
    e && t.target instanceof Element && t.target !== e && !e.contains(t.target) && this.setState({
      isOpen: !1
    });
  };
  handleClick = (t) => {
    t.preventDefault();
    const { isOpen: e } = this.state;
    this.setState({
      isOpen: !e
    });
  };
  handleToolbarButtonClick(t) {
    return (e) => {
      const { editor: n } = this.props;
      e.preventDefault(), t && (Vr.find(
        (r) => r.name === t
      )?.callback(n), this.forceUpdate());
    };
  }
  styleActive(t) {
    const { editor: e } = this.props;
    return e.command.active(t);
  }
  render() {
    const { className: t, isActive: e, editor: n, editorWindow: o, ...r } = this.props, { isOpen: a, currentFormat: l } = this.state, c = f(t);
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: c, ref: this.domRef, children: [
      a && /* @__PURE__ */ s.jsxs("div", { className: zo.menu, children: [
        n.allowFormatting.includes("format") && /* @__PURE__ */ s.jsx(
          kb,
          {
            formatBlock: l,
            editor: this.props.editor
          }
        ),
        /* @__PURE__ */ s.jsx("div", { className: zo.buttonsContainer, children: zr.map((d) => {
          const h = "condition" in d;
          if (!(!h || h && d.condition(n)))
            return;
          const p = no(d.keybindings), m = p ? `${d.label} (${p})` : d.label;
          return /* @__PURE__ */ s.jsx(
            Ft,
            {
              isActive: this.styleActive(d.name),
              onMouseDown: this.handleToolbarButtonClick(d.name),
              icon: d.icon,
              tooltip: m
            },
            d.name
          );
        }).filter(Boolean) })
      ] }),
      /* @__PURE__ */ s.jsx(
        Ft,
        {
          isActive: e,
          icon: "format",
          onClick: this.handleClick,
          tooltip: "Formatting"
        }
      )
    ] });
  }
}
const Fb = "h-inputRichText-suggestions--suggestions__dropdown", Pb = "h-inputRichText-suggestions--suggestions__dropdownWithTabs", Rb = "h-inputRichText-suggestions--suggestions__dropdownWithoutTabs", Eb = "h-inputRichText-suggestions--suggestions__dropdownTabs", Lb = "h-inputRichText-suggestions--suggestions__dropdownTabsContent", Ke = {
  dropdown: Fb,
  dropdownWithTabs: Pb,
  dropdownWithoutTabs: Rb,
  dropdownTabs: Eb,
  dropdownTabsContent: Lb
};
function Ab(i) {
  if (!i)
    return null;
  const { focusOffset: t, anchorOffset: e, anchorNode: n } = i;
  return t !== e || !n || n.nodeName !== "#text" ? null : n?.textContent?.slice(0, t);
}
class $b extends D {
  dropdownRef;
  tabsRef;
  constructor(t) {
    super(t), this.state = {
      listenForSelectionChange: !0,
      suggestions: null,
      suggestionPosition: null,
      suggestionIndex: 0,
      suggestionExtendBy: 0,
      suggestionTrigger: null,
      suggestionMatchedString: "",
      selectedTab: null,
      selectionMode: "suggestion",
      tabIndex: 0
    }, this.dropdownRef = O(), this.tabsRef = O(), this.handleSuggestionClick = this.handleSuggestionClick.bind(this), this.handleSelectionChange = this.handleSelectionChange.bind(this), this.getPagination = this.getPagination.bind(this), this.handleBlur = this.handleBlur.bind(this), this.handleTabChange = this.handleTabChange.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.selection.onUpdate(this.handleSelectionChange), t.events.onBlur(this.handleBlur), t.hotkeys.add([
      {
        keybindings: [[[], "ArrowUp"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(-1)
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(1)
      },
      {
        keybindings: [[[], "Escape"]],
        condition: () => this.hasSuggestions() || this.hasTabs(),
        callback: (e, n) => this.handleEscapeKey(n)
      },
      {
        keybindings: [[[], "Enter"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleEnterKey()
      }
    ]);
  }
  componentDidUpdate(t, e) {
    const { suggestionIndex: n, tabIndex: o } = this.state;
    n !== e.suggestionIndex && this.updateSuggestionScroll(), o !== e.tabIndex && this.updateTabScroll();
  }
  shouldHandleKey() {
    const { selectionMode: t } = this.state;
    return t === "suggestion" && this.hasSuggestions() || t === "tab" && this.hasTabs();
  }
  handleArrowKey(t) {
    const { selectionMode: e } = this.state;
    e === "suggestion" && this.hasSuggestions() ? this.suggestionsNavigate(t) : e === "tab" && this.hasTabs() && this.tabsNavigate(t);
  }
  handleEscapeKey(t) {
    const { selectionMode: e } = this.state;
    this.shouldRenderDropdown() && t.stopPropagation(), e === "suggestion" && this.hasTabs() ? this.setState({
      selectionMode: "tab",
      tabIndex: this.getSelectedTabIndex()
    }) : this.clearSuggestions();
  }
  handleEnterKey() {
    const { selectionMode: t, tabIndex: e, suggestionTrigger: n } = this.state;
    if (t === "suggestion" && this.hasSuggestions())
      this.expandSuggestion();
    else if (t === "tab" && this.hasTabs()) {
      const o = n?.getTabs?.()[e];
      o && this.handleTabChange(o.id);
    }
  }
  handleBlur(t) {
    const {
      nativeEvent: { relatedTarget: e }
    } = t;
    e === null && this.clearSuggestions();
  }
  hasSuggestions() {
    const { suggestions: t } = this.state;
    return !!t?.length;
  }
  hasTabs() {
    return !!this.state.suggestionTrigger?.getTabs?.().length;
  }
  getSelectedTabIndex() {
    const { suggestionTrigger: t, selectedTab: e } = this.state;
    return this.hasTabs() ? t?.getTabs?.().findIndex((n) => n.id === e) : -1;
  }
  clearSuggestions() {
    this.setState({
      suggestions: null,
      suggestionPosition: null,
      selectedTab: null,
      selectionMode: "suggestion"
    });
  }
  suggestionsNavigate(t) {
    this.setState(({ suggestionIndex: e, suggestions: n }) => {
      if (n && n.length) {
        let o;
        return t < 0 ? o = e > 0 ? e - 1 : n.length - 1 : o = (e + 1) % n.length, {
          suggestionIndex: o
        };
      }
      return null;
    });
  }
  tabsNavigate(t) {
    this.setState(({ tabIndex: e, suggestionTrigger: n }) => {
      const o = n?.getTabs?.();
      if (o?.length) {
        let r;
        return t < 0 ? r = e > 0 ? e - 1 : o.length - 1 : r = (e + 1) % o.length, {
          tabIndex: r
        };
      }
      return null;
    });
  }
  lookForTriggers(t, e) {
    const { editor: n } = this.props, { selectedTab: o, selectionMode: r } = this.state, a = Ab(n.selection.recreate());
    if (a) {
      const l = n.triggers.test(a);
      if (l && n.triggers.isSuggestionTrigger(l.matchedTrigger)) {
        const { match: c, matchedTrigger: d } = l, h = d?.getTabs?.();
        if (h?.length) {
          let p = null;
          if (t ? p = {
            selectionMode: "suggestion",
            selectedTab: t,
            tabIndex: -1
          } : o ? t = o : p = {
            selectionMode: "tab",
            selectedTab: h[0].id,
            tabIndex: 0
          }, p && this.setState(p, () => {
            t || this.lookForTriggers();
          }), !t)
            return;
        } else r !== "suggestion" && this.setState({ selectionMode: "suggestion" });
        Promise.resolve(
          d.getSuggestions(c[1], t, e)
        ).then((p) => {
          this.updateSuggestions(c, d, p);
        });
        return;
      }
    }
    this.clearSuggestions();
  }
  findTriggerPosition(t, e) {
    this.setState(
      {
        listenForSelectionChange: !1
      },
      () => {
        const { onError: n, editor: o } = this.props, r = o.selection.recreate();
        if (r) {
          const { focusOffset: a, anchorNode: l } = r;
          if (l) {
            if (a - t >= 0)
              try {
                r.extend(l, a - t);
              } catch (c) {
                n?.(c);
              }
            if (r?.rangeCount && r?.rangeCount > 0) {
              const c = r.getRangeAt(0).getBoundingClientRect();
              r.collapseToEnd(), setTimeout(() => {
                e(c), this.setState({
                  listenForSelectionChange: !0
                });
              });
            }
          }
        }
      }
    );
  }
  updateSuggestions(t, e, n) {
    const { editor: o } = this.props;
    this.findTriggerPosition(t[0].length, (r) => {
      const a = o.selection.recreate();
      if (!a)
        return;
      const { focusOffset: l } = a, h = new RegExp(e.trigger).exec(t[0])?.[1]?.length ?? 0, u = t[0].length - h;
      this.setState({
        suggestions: n,
        suggestionTrigger: e,
        suggestionPosition: r,
        suggestionIndex: 0,
        suggestionMatchedString: t[1],
        suggestionExtendBy: l - u,
        listenForSelectionChange: !0
      });
    });
  }
  updateSuggestionScroll() {
    const { suggestionIndex: t } = this.state, { current: e } = this.dropdownRef;
    if (e) {
      if (e.infiniteListRef.current)
        e.infiniteListRef.current.scrollToItem(t);
      else if (e.listRef.current) {
        const n = e.listRef.current, r = e.listRef.current.children[t].getBoundingClientRect(), a = n.getBoundingClientRect();
        a.bottom < r.bottom ? n.scrollTop += r.bottom - a.bottom : a.top > r.top && (n.scrollTop -= a.top - r.top);
      }
    }
  }
  updateTabScroll() {
    const { tabIndex: t } = this.state, { current: e } = this.tabsRef;
    if (!(t < 0 || !e) && e.containerRef.current) {
      const n = e.containerRef.current, r = e.containerRef.current.children[0].children[t].getBoundingClientRect(), a = n.getBoundingClientRect();
      a.bottom < r.bottom ? n.scrollTop += r.bottom - a.bottom : a.top > r.top && (n.scrollTop -= a.top - r.top);
    }
  }
  expandSuggestion() {
    const {
      suggestions: t,
      suggestionIndex: e,
      suggestionExtendBy: n,
      suggestionTrigger: o
    } = this.state;
    if (!(!t || !t[e] || !o))
      return o.insertContent(
        t[e],
        o.trigger,
        n
      );
  }
  handleSelectionChange() {
    const { listenForSelectionChange: t } = this.state;
    t && this.lookForTriggers();
  }
  handleSuggestionClick(t) {
    this.setState(
      (e) => ({
        suggestionIndex: e.suggestions ? e.suggestions.indexOf(t) : 0
      }),
      () => {
        this.expandSuggestion();
      }
    );
  }
  calculateSuggestionBoxPosition() {
    const { suggestionPosition: t } = this.state, { editor: e } = this.props;
    if (e.ref.current && t) {
      const n = e.ref.current.getBoundingClientRect();
      return {
        bottom: n.bottom - t.bottom + t.height,
        left: t.x - n.x + t.width
      };
    }
    return {};
  }
  suggestionBoxStyle() {
    const { suggestionPosition: t } = this.state, { editor: e } = this.props;
    if (e.ref.current && t) {
      const n = e.ref.current.getBoundingClientRect();
      return {
        left: `${t.x - n.x}px`,
        top: `${t.y - n.y + t.height / 2}px`,
        //`${suggestionPosition.x}px`,
        height: 1,
        width: t.width,
        position: "absolute"
      };
    }
    return {};
  }
  getPagination() {
    const { suggestionTrigger: t } = this.state;
    if (!t || !t.getPagination)
      return !1;
    const e = t.getPagination();
    return !e || !e.onNext ? !1 : {
      ...e,
      onNext: () => e.onNext?.().then((n) => {
        this.setState({ suggestions: n });
      }) ?? Promise.resolve(void 0)
    };
  }
  handleTabChange(t) {
    this.lookForTriggers(t, 0);
  }
  renderEmptyState() {
    return /* @__PURE__ */ s.jsx(hn, { label: "No suggestions found" });
  }
  renderTabs() {
    const { suggestions: t, suggestionTrigger: e, selectedTab: n, tabIndex: o } = this.state, r = e?.getTabs?.() ?? [], a = !!t?.length;
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        so,
        {
          ref: this.tabsRef,
          className: Ke.dropdownTabs,
          tabs: r,
          tabsPlacement: "left",
          selectedId: n,
          activeId: r?.[o]?.id,
          onChange: this.handleTabChange
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: Ke.dropdownTabsContent, children: a ? this.renderItems() : this.renderEmptyState() })
    ] });
  }
  renderItems() {
    const { suggestions: t, suggestionIndex: e, suggestionTrigger: n, selectionMode: o } = this.state, r = n ? n.suggestionComponent : null;
    return /* @__PURE__ */ s.jsx(
      Ys,
      {
        ref: this.dropdownRef,
        pagination: this.getPagination(),
        items: t || void 0,
        onSelect: this.handleSuggestionClick,
        itemComponent: r,
        activeItem: o === "suggestion" ? t?.[e] : void 0
      }
    );
  }
  shouldRenderDropdown() {
    const { suggestionPosition: t, selectedTab: e, suggestions: n } = this.state;
    return !(!t || !this.hasTabs() && !n?.length || this.hasTabs() && !e);
  }
  render() {
    const { editor: t, onError: e, ...n } = this.props;
    if (!this.shouldRenderDropdown())
      return null;
    const o = f(Ke.dropdown, {
      [Ke.dropdownWithTabs]: this.hasTabs(),
      [Ke.dropdownWithoutTabs]: !this.hasTabs()
    });
    return /* @__PURE__ */ s.jsx("div", { ...n, children: /* @__PURE__ */ s.jsx("div", { style: this.suggestionBoxStyle(), children: /* @__PURE__ */ s.jsx(Jt, { className: o, isOpen: !0, children: this.hasTabs() ? this.renderTabs() : this.renderItems() }) }) });
  }
}
function Ob({ children: i, className: t }) {
  const e = G(null), [n, o] = V(0), r = () => e.current ? Array.from(
    e.current.querySelectorAll("button:not([disabled])")
  ).filter((l) => l.closest('[role="toolbar"]') === e.current) : [];
  Z(() => {
    const l = r();
    l.length !== 0 && l.forEach((c, d) => {
      d === 0 ? c.setAttribute("tabindex", "0") : c.setAttribute("tabindex", n === d ? "0" : "-1");
    });
  }, [n]);
  const a = (l) => {
    const c = r();
    if (c.length === 0) return;
    const d = document.activeElement;
    if (!e.current?.contains(d)) return;
    let h = n;
    switch (l.key) {
      case "ArrowLeft":
      case "ArrowUp":
        l.preventDefault(), l.stopPropagation(), h = h <= 0 ? c.length - 1 : h - 1, o(h), c[h]?.focus();
        break;
      case "ArrowRight":
      case "ArrowDown":
        l.preventDefault(), l.stopPropagation(), h = h >= c.length - 1 ? 0 : h + 1, o(h), c[h]?.focus();
        break;
      case "Home":
        l.preventDefault(), l.stopPropagation(), o(0), c[0]?.focus();
        break;
      case "End":
        l.preventDefault(), l.stopPropagation();
        const u = c.length - 1;
        o(u), c[u]?.focus();
        break;
    }
  };
  return Z(() => {
    const l = e.current;
    if (!l) return;
    const c = (h) => {
      const u = r(), p = h.target, m = u.indexOf(p);
      m !== -1 && o(m);
    }, d = (h) => {
      l.contains(h.relatedTarget) || o(0);
    };
    return l.addEventListener("focusin", c), l.addEventListener("focusout", d), () => {
      l.removeEventListener("focusin", c), l.removeEventListener("focusout", d);
    };
  }, []), /* @__PURE__ */ s.jsx(
    "div",
    {
      ref: e,
      className: t,
      role: "toolbar",
      "aria-label": "Text formatting",
      onKeyDown: a,
      children: i
    }
  );
}
function Vo(i) {
  return i instanceof RegExp ? i.source : i;
}
function Bb(i) {
  return i.replace(/\(/g, "(?:");
}
class Kr {
  storedTriggers;
  constructor() {
    this.storedTriggers = [];
  }
  get excludeTriggersRegex() {
    return this.storedTriggers.map(
      (t) => `(?!${Vo(t.trigger)})`
    ).join("");
  }
  add(t) {
    this.storedTriggers.push(t);
  }
  update(t) {
    const e = this.storedTriggers.findIndex(
      (n) => this.isAddonTrigger(n) && n.id === t.id
    );
    e !== -1 && (this.storedTriggers[e] = t);
  }
  test(t) {
    let e;
    for (let n = 0; n < this.storedTriggers.length; n += 1) {
      const o = this.storedTriggers[n], { trigger: r, allowSpaces: a, minChars: l } = o, c = Bb(
        Vo(r)
      ), d = this.excludeTriggersRegex, h = a ? "." : "\\S";
      if (e = new RegExp(`${c}((?:${d}${h})*)$`, "g").exec(t), e && (!l || e[1].length >= l))
        return {
          match: e,
          matchedTrigger: o
        };
    }
    return null;
  }
  isSuggestionTrigger(t) {
    return "getSuggestions" in t;
  }
  isAddonTrigger(t) {
    return !this.isSuggestionTrigger(t);
  }
}
function Ur(i, t) {
  const e = i.getSelection();
  if (!e || e.rangeCount === 0) return !1;
  let n = e.anchorNode;
  const o = "CODE";
  for (; n; ) {
    if (n.nodeType === Node.ELEMENT_NODE && n.tagName === o)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
function Hb(i, t) {
  t?.();
  const e = i.getSelection();
  if (!e || e.rangeCount === 0) return;
  const n = e.getRangeAt(0);
  if (Ur(i)) {
    Wb(i, "CODE");
    return;
  }
  const o = n.collapsed, r = i.document.createElement("code");
  if (o) {
    const a = i.document.createTextNode("​");
    r.appendChild(a), n.insertNode(r), n.setStart(r.firstChild, 1), n.setEnd(r.firstChild, 1);
  } else {
    const a = n.extractContents();
    r.appendChild(a), n.insertNode(r), n.setStartAfter(r), n.setEndAfter(r);
  }
  e.removeAllRanges(), e.addRange(n);
}
function Wb(i, t) {
  const e = i.getSelection();
  if (!e || e.rangeCount === 0) return;
  let n = e.anchorNode;
  for (; n; ) {
    if (n.nodeType === Node.ELEMENT_NODE) {
      const o = n;
      if (o.tagName === t) {
        const r = o.parentNode;
        if (r) {
          const a = i.document.createDocumentFragment();
          for (; o.firstChild; )
            a.appendChild(o.firstChild);
          r.replaceChild(a, o);
          const l = i.document.createRange();
          l.selectNodeContents(r), l.collapse(!1), e.removeAllRanges(), e.addRange(l);
        }
        return;
      }
    }
    n = n.parentNode;
  }
}
const In = 25;
let It = null, ae = null;
function Mb(i, t) {
  const e = t.document.createElement("div");
  return e.className = `image-resize-handle image-resize-handle-${i}`, e.dataset.handle = i, e;
}
function zb(i, t) {
  const e = t.document.createElement("div");
  return e.className = "image-resize-wrapper", e.contentEditable = "false", i.parentNode?.insertBefore(e, i), e.appendChild(i), ["nw", "ne", "se", "sw"].forEach((o) => {
    const r = Mb(o, t);
    e.appendChild(r);
  }), e;
}
function qr(i) {
  const t = i.querySelector("img");
  t && i.parentNode && (i.parentNode.insertBefore(t, i), i.remove());
}
function Vb(i, t, e) {
  const { startX: n, startWidth: o, handle: r, aspectRatio: a } = i, l = t - n;
  let c = o;
  switch (r) {
    case "se":
    case "ne":
      c = o + l;
      break;
    case "sw":
    case "nw":
      c = o - l;
      break;
  }
  let d = c / a;
  c < In && (c = In, d = In / a);
  const h = In / a;
  return d < h && (d = h, c = h * a), { width: c, height: d };
}
function oo(i) {
  if (!It) return;
  i.preventDefault(), i.stopPropagation();
  const { width: t } = Vb(
    It,
    i.clientX,
    i.clientY
  );
  It.img.style.width = `${t}px`, It.img.style.height = "auto";
}
function ro(i) {
  if (!It) return;
  i.preventDefault(), i.stopPropagation();
  const { img: t } = It, e = t.ownerDocument.defaultView;
  e.document.removeEventListener("mousemove", oo), e.document.removeEventListener("mouseup", ro), It = null;
  const n = new Event("input", { bubbles: !0 });
  t.closest('[contenteditable="true"]')?.dispatchEvent(n);
}
function Kb(i, t, e) {
  i.preventDefault(), i.stopPropagation();
  const n = t.ownerDocument.defaultView, o = t.closest(".image-resize-wrapper");
  if (!o) return;
  const r = t.naturalWidth, a = t.naturalHeight, l = r / a, c = t.getBoundingClientRect(), d = c.width, h = c.height;
  It = {
    img: t,
    originalWidth: r,
    originalHeight: a,
    aspectRatio: l,
    startX: i.clientX,
    startY: i.clientY,
    startWidth: d,
    startHeight: h,
    handle: e,
    wrapper: o
  }, n.document.addEventListener("mousemove", oo), n.document.addEventListener("mouseup", ro);
}
function Ub(i, t) {
  ae && (qr(ae), ae = null);
  const e = zb(i, t);
  ae = e, e.querySelectorAll(".image-resize-handle").forEach((o) => {
    const r = o.dataset.handle;
    o.addEventListener(
      "mousedown",
      (a) => Kb(a, i, r)
    );
  });
}
function ws() {
  if (ae && (qr(ae), ae = null), It) {
    const i = It.img.ownerDocument.defaultView;
    i.document.removeEventListener("mousemove", oo), i.document.removeEventListener("mouseup", ro), It = null;
  }
}
function qb(i) {
  return i ? i.classList.contains("image-resize-wrapper") || i.classList.contains("image-resize-handle") || i.closest(".image-resize-wrapper") !== null : !1;
}
function Ko(i) {
  if (!i) return i;
  const n = new DOMParser().parseFromString(`<div>${i}</div>`, "text/html").body.firstChild;
  return n ? (n.querySelectorAll(".image-resize-wrapper").forEach((r) => {
    const a = r.querySelector("img");
    a && r.parentNode && (r.parentNode.insertBefore(a, r), r.remove());
  }), n.innerHTML) : i;
}
const Gr = "input-rich-text-editor", Yr = [
  {
    name: "insertInlineAttachment",
    label: "Insert inline image",
    keybindings: [[["$metaOrCtrl"], "KeyM"]]
  }
], Uo = [
  ...Yr,
  ...Vr,
  ...Mr,
  ...df
], Gb = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/\S*)?$/i, Yb = Bt({
  command: {
    run: L,
    active: () => !1
  },
  content: {
    insert: L,
    setUiBlocker: L
  },
  hotkeys: {
    add: L,
    updateKeybindings: L
  },
  selection: {
    recreate: () => null,
    getRange: () => null,
    isWithinEditor: () => !1,
    onUpdate: L
  },
  events: {
    subscribe: () => L,
    publish: L,
    onMouseOver: L,
    onBlur: L
  },
  allowFormatting: [],
  triggers: new Kr(),
  ref: O(),
  window,
  history: {
    canUndo: () => !1,
    undo: L,
    takeSnapshot: L,
    reset: L
  }
});
class io extends D {
  editor;
  editorRef;
  currentSuggestionRef;
  fileInputRef;
  attachmentDropdownButtonRef;
  unsubscribeInlineAttachment;
  isInserting;
  contentInsertionQueue;
  /**
   * Button that can be used in `toolbarAddons` to have same styles as the
   * buitlin buttons.
   */
  static ToolbarButton = Ft;
  /** Context containing props and methods to interact with the editor. */
  static Context = Yb;
  static defaultProps = {
    allowAttachments: !1,
    allowInlineAttachments: !1,
    allowEmoji: !0,
    languages: [],
    onTriggerSend() {
      console.warn("InputRichText: onTriggerSend callback missing in props");
    },
    onToggleSendOnEnter: L,
    sendOnEnter: !1,
    editorWindow: window,
    onMount: L,
    onUnmount: L,
    disabled: !1,
    hasAutocompleteSuggestionsFeature: !1
  };
  constructor(t) {
    super(t), this.editorRef = O(), this.currentSuggestionRef = O(), this.fileInputRef = O(), this.attachmentDropdownButtonRef = O(), this.unsubscribeInlineAttachment = L, this.isInserting = !1, this.contentInsertionQueue = [], this.state = {
      keyDownHandled: !1,
      keyCommands: Uo,
      selectionUpdateListeners: [],
      mouseOverListeners: [],
      blurListeners: [],
      htmlOld: "",
      lastSelection: null,
      hasFocus: !1,
      selectedText: "",
      selectedLink: "",
      showHint: !1,
      pubsub: {},
      uiBlocker: t.uiBlocker,
      undoStack: []
    }, this.editor = {
      command: {
        run: this.commandRun.bind(this),
        active: this.commandActive.bind(this)
      },
      content: {
        insert: this.insertContent.bind(this),
        setUiBlocker: this.setUiBlocker.bind(this)
      },
      hotkeys: {
        add: this.addKeyCommands.bind(this),
        updateKeybindings: this.updateKeyCommandsKeybindings.bind(this)
      },
      selection: {
        onUpdate: this.addSelectionUpdateListener.bind(this),
        recreate: this.recreateSelection.bind(this),
        getRange: this.getSelectionRange.bind(this),
        isWithinEditor: this.isSelectionWithinEditor.bind(this)
      },
      events: {
        onMouseOver: this.addMouseOverListener.bind(this),
        onBlur: this.addBlurListener.bind(this),
        subscribe: this.subscribe.bind(this),
        publish: this.publish.bind(this)
      },
      allowFormatting: this.getAllowedFormattingOptions(),
      triggers: new Kr(),
      ref: this.editorRef,
      window: this.props.editorWindow ?? window,
      history: {
        undo: this.undo,
        canUndo: this.canUndo,
        reset: this.resetUndoStack,
        takeSnapshot: this.addCurrentContentToUndoStack
      }
    };
  }
  componentDidMount() {
    const { editorWindow: t = window, onMount: e } = this.props;
    t.document.execCommand(
      "defaultParagraphSeparator",
      !1,
      "div"
    );
    const { value: n } = this.props;
    n && !n.startsWith("<") ? this.setHtml(`<div>${n}</div>`) : n ? this.setHtml(n) : this.setHtml(""), this.unsubscribeInlineAttachment = this.editor.events.subscribe(
      "insertInlineAttachment",
      () => {
        this.props.allowInlineAttachments && this.openFileBrowser();
      }
    ), e(), this.updateKeyCommandsKeybindings(this.props.keybindings);
  }
  componentDidUpdate(t) {
    const { fileUploadStatuses: e, autocomplete: n, keybindings: o, uiBlocker: r } = this.props, { current: a } = this.editorRef;
    e && e !== t.fileUploadStatuses && a && (Object.keys(e).forEach((l) => {
      this.updateFileLoader(l, e[l]);
    }), this.handleSelectionChange()), n && n.showAutocompleteSuggestions !== t.autocomplete?.showAutocompleteSuggestions && this.setState({ showHint: !0 }, () => {
      setTimeout(() => {
        this.setState({ showHint: !1 });
      }, 1e3);
    }), br(t.keybindings, o) || this.updateKeyCommandsKeybindings(o), t.uiBlocker !== r && this.setUiBlocker(r);
  }
  componentWillUnmount() {
    const { onUnmount: t } = this.props;
    this.unsubscribeInlineAttachment?.(), ws(), t(this.getSanitizedHtml());
  }
  getCommandsWithInputKeybindings() {
    const { keybindings: t } = this.props;
    return Uo.map((e) => ({
      ...e,
      keybindings: t && e.name ? t[e.name] ?? [] : e.keybindings
    }));
  }
  subscribe(t, e) {
    return this.setState((n) => ({
      pubsub: {
        ...n.pubsub,
        [t]: [...n.pubsub[t] ?? [], e]
      }
    })), () => {
      this.setState((n) => yr(n, t));
    };
  }
  publish(t) {
    this.state.pubsub[t]?.forEach((e) => e(this.editor));
  }
  /**
   * The core update function, that triggers every time the selection is
   * changed, which will also trigger when the contents change.
   *
   * This method handles calling onChange prop.
   *
   * @returns {void | undefined} Description
   * @todo Test if onInput would be a better way of triggering onChange
   */
  handleSelectionChange = () => {
    const { onChange: t, onSelectionChange: e } = this.props, { htmlOld: n, selectionUpdateListeners: o } = this.state, { current: r } = this.editorRef;
    if (r) {
      this.forceUpdate();
      const a = this.extractEditorContent();
      a !== n && (this.setState({
        htmlOld: a
      }), t(a));
    }
    o.forEach((a) => {
      a();
    }), e && e();
  };
  /** Handle any mouse over events on the editor */
  handleMouseOver = (t) => {
    const { mouseOverListeners: e } = this.state;
    e.forEach((n) => {
      n(t);
    });
  };
  /** Handle click events on the editor to select images */
  handleEditorClick = (t) => {
    const e = t.target, { editorWindow: n = window } = this.props;
    if (Mn(e) && e.tagName === "IMG") {
      t.preventDefault();
      const o = n.getSelection();
      if (o) {
        const r = n.document.createRange();
        r.selectNode(e), o.removeAllRanges(), o.addRange(r), this.handleSelectionChange();
      }
      Ub(e, n);
    } else qb(e) || ws();
  };
  /** Handle blur events on the editor */
  handleBlurListeners = (t) => {
    const { blurListeners: e } = this.state;
    e.forEach(
      (n) => {
        n(t);
      }
    );
  };
  handleKeyDown = (t) => {
    if (t.getModifierState(t.key))
      return;
    const { keyCommands: e } = this.state, { sendOnEnter: n, onKeyDown: o } = this.props;
    if (o?.(t), e.some(
      ({ preventDefaultKeybinding: a }) => a && fs(a, t)
    ) && t.preventDefault(), e.some(
      ({ name: a, keybindings: l, condition: c, callback: d }) => {
        if (fs(l, t) && (c === void 0 || c(this.editor)))
          return d?.(this.editor, t), a && this.editor.events.publish(a), !0;
      }
    )) {
      this.setKeyDownHandled(t), t.stopPropagation();
      return;
    }
    if (fs([[["$metaOrCtrl"], "Enter"]], t)) {
      const { onTriggerSend: a } = this.props;
      this.setKeyDownHandled(t), a();
    } else if (t.key === "Enter" && n && !t.shiftKey) {
      const { onTriggerSend: a } = this.props;
      this.setKeyDownHandled(t), a();
    }
    return null;
  };
  getBlockLevelParent = (t) => {
    const { editorWindow: e = window } = this.props;
    let n = Mn(t) ? t : t.parentElement;
    for (; !to(n, e); )
      n = n.parentElement;
    return n;
  };
  // Insert actual text direction into the html
  onInput = (t) => {
    const { current: e } = this.editorRef, n = t?.nativeEvent;
    if (!n)
      return;
    this.resetUndoStack();
    const { inputType: o } = n;
    if (o === "insertFromPaste" || !o) {
      $o(e), Hg(e);
      return;
    }
    const a = document.getSelection()?.anchorNode;
    if (o === "insertText" && a && a.textContent?.length === 1) {
      const l = this.getBlockLevelParent(a);
      if (
        // if the parent element is `ol` or `ul`, and if it has direction, do not change it
        (l.tagName === "UL" || l.tagName === "OL") && l.hasAttribute("dir")
      )
        return;
      l.setAttribute("dir", "auto");
      const c = window.getComputedStyle(l).direction;
      l.setAttribute("dir", c), l.style.textAlign = "";
    }
  };
  handleKeyUp = () => {
    const { keyDownHandled: t } = this.state;
    t || this.handleSelectionChange(), this.setState({
      keyDownHandled: !1
    });
  };
  setKeyDownHandled = (t) => {
    t.preventDefault(), this.setState({
      keyDownHandled: !0
    });
  };
  addKeyCommands = (t) => {
    this.setState(({ keyCommands: e }) => ({
      keyCommands: [...e, ...t]
    }));
  };
  updateKeyCommandsKeybindings = (t) => {
    if (!t)
      return;
    const { keyCommands: e } = this.state;
    Object.entries(t).forEach(([n, o]) => {
      const r = e.findIndex(
        ({ name: a }) => a === n
      );
      r > -1 && o && (e[r].keybindings = o);
    });
  };
  addSelectionUpdateListener(t) {
    this.setState(({ selectionUpdateListeners: e }) => ({
      selectionUpdateListeners: [...e, t]
    }));
  }
  addMouseOverListener(t) {
    this.setState(({ mouseOverListeners: e }) => ({
      mouseOverListeners: [...e, t]
    }));
  }
  addBlurListener(t) {
    this.setState(({ blurListeners: e }) => ({
      blurListeners: [...e, t]
    }));
  }
  handlePaste = (t) => {
    const {
      onFileDropped: e,
      allowInlineAttachments: n,
      editorWindow: o = window,
      sanitize: r
    } = this.props, { clipboardData: a } = t;
    if (!a)
      return;
    let l = a.getData("text/html");
    const c = a.getData("text/plain"), d = a.files.item(0);
    if (l) {
      t.preventDefault(), this.commandRun("insertHTML", r?.(l));
      return;
    }
    if (c && Gb.test(c)) {
      t.preventDefault(), l = `<a href="${c}">${c}</a>`, this.commandRun("insertHTML", l);
      return;
    }
    if (d) {
      if (n && e) {
        const { src: h, uid: u } = Ao(o, d);
        this.insertImageLoader(h, u), e(d, u);
      }
      t.preventDefault();
    }
  };
  commandRun(t, e = null) {
    setTimeout(() => {
      const { hasFocus: n } = this.state, { current: o } = this.editorRef, { editorWindow: r = window } = this.props;
      if (o) {
        if (n || this.recreateSelection(), t === "inlineCode") {
          Hb(r, this.addCurrentContentToUndoStack), this.handleSelectionChange();
          return;
        }
        r.document.execCommand(
          t,
          !1,
          // execCommand 3rd expects string | null, TS thinks it needs string | undefined
          e
        );
      }
    });
  }
  commandActive(t) {
    const { hasFocus: e } = this.state, { editorWindow: n = window } = this.props;
    return t === "inlineCode" ? !!(e && Ur(n)) : !!(e && $g(n, t));
  }
  getText = () => {
    const { current: t } = this.editorRef;
    return t && this.hasContent(this.extractEditorContent()) ? this.extractEditorContent() : "";
  };
  getSanitizedHtml = () => this.props.sanitize?.(this.getText());
  getPlainText = () => {
    const { current: t } = this.editorRef, e = (
      // innerHTML of <div></div> should count as empty
      t && this.hasContent(this.extractEditorContent()) ? t.innerText : ""
    );
    return e ? e.replace(/\n\n/g, `
`).trim() : "";
  };
  setHtml(t) {
    const { current: e } = this.editorRef, n = this.props.sanitize?.(t);
    e && (e.innerHTML = n || "", $o(e)), this.setState({
      htmlOld: n
    }), this.handleSelectionChange();
  }
  handleInlineUpload = (t) => {
    if (t === null) return;
    const { onFileDropped: e, editorWindow: n = window } = this.props;
    t && e && Array.from(t).forEach((r) => {
      if (Bg(r)) {
        const { src: a, uid: l } = Ao(n, r);
        this.insertImageLoader(a, l), e(r, l);
      } else {
        const a = nn();
        this.insertFileLoader(r.name, a), e(r, a);
      }
    });
  };
  handleAttachmentUpload = (t) => {
    const { onAttachmentsFile: e } = this.props, { current: n } = this.attachmentDropdownButtonRef;
    n && n.open(), t && typeof e == "function" && Array.from(t).forEach((r) => {
      const a = nn();
      e(r, a);
    });
  };
  handleDetachAttachmentFile = (t) => {
    const { onDetachAttacmentFile: e } = this.props;
    typeof e == "function" && e(t);
  };
  handleFileSelect = (t) => {
    const e = t.target;
    e?.ownerDocument?.defaultView && e instanceof e.ownerDocument.defaultView.HTMLInputElement && (this.handleInlineUpload(e.files), e.value = "");
  };
  openFileBrowser = (t) => {
    t?.preventDefault();
    const { current: e } = this.fileInputRef;
    e && e.click();
  };
  insertImageLoader(t, e) {
    const { editorWindow: n = window } = this.props, o = n.document.createElement("img");
    o.setAttribute("class", "async-loading"), o.setAttribute("data-uid", e), o.setAttribute("src", t), this.insertContent(o);
  }
  insertFileLoader(t, e) {
    const { editorWindow: n = window } = this.props, o = n.document.createElement("a");
    o.setAttribute("class", "async-loading"), o.setAttribute("data-uid", e), o.setAttribute("href", "#"), o.innerText = t, this.insertContent(o);
  }
  updateFileLoader(t, { link: e, status: n, filename: o }) {
    const { current: r } = this.editorRef;
    if (r) {
      const a = r.querySelector(`[data-uid="${t}"]`);
      a && (n === "failed" && a.parentElement ? a.parentElement.removeChild(a) : (a.classList.remove(
        "async-loading",
        "async-succeeded",
        "async-failed"
      ), a.classList.add(`async-${n}`), e && a.tagName === "IMG" && (a.src = e, o && (a.title = o)), e && a.tagName === "A" && (a.href = e)));
    }
  }
  handleToggleSendOnEnter = (t) => {
    t.preventDefault();
    const { onToggleSendOnEnter: e } = this.props;
    e();
  };
  handleToggleAutocompleteSuggestions = (t) => {
    t.preventDefault();
    const { autocomplete: e } = this.props;
    e && e.onToggleShowAutocompleteSuggestions();
  };
  isSelectionWithinEditor(t) {
    const { anchorNode: e } = t;
    let { parentElement: n = null } = e || {};
    const o = `.${ft.editor}`;
    let r = e !== null && e.nodeType === Node.ELEMENT_NODE ? e.matches(o) : !1;
    for (; !r && n !== null; ) {
      if (n.matches(o)) {
        r = !0;
        break;
      }
      n = n.parentElement;
    }
    return r;
  }
  insertContent = (t, e) => {
    this.contentInsertionQueue.push(t), e?.getSelection ? this.processContentInsertionQueue(e.getSelection()) : this.isInserting || (this.isInserting = !0, this.editor.window.requestAnimationFrame(() => {
      this.processContentInsertionQueue(this.recreateSelection()), this.isInserting = !1;
    }));
  };
  processContentInsertionQueue = (t) => {
    if (!(!t || !this.isSelectionWithinEditor(t))) {
      if (Wg(t), t?.rangeCount && t?.rangeCount > 0) {
        const e = t.getRangeAt(0);
        if (t.isCollapsed || e.deleteContents(), this.contentInsertionQueue.length === 1)
          e.insertNode(this.contentInsertionQueue[0]);
        else if (this.contentInsertionQueue.length > 1) {
          const n = document.createElement("span");
          this.contentInsertionQueue.forEach((o) => {
            n.appendChild(o);
          }), e.insertNode(n);
        }
      }
      this.contentInsertionQueue = [], this.editor.window.requestAnimationFrame(() => {
        t.collapseToEnd();
      }), this.handleSelectionChange();
    }
  };
  setUiBlocker(t) {
    this.setState({ uiBlocker: t });
  }
  getSelectionRange() {
    const { editorWindow: t = window } = this.props;
    if (t.document.activeElement === this.editorRef.current) {
      const e = t.document.getSelection();
      return e?.rangeCount && e?.rangeCount > 0 ? e.getRangeAt(0) : null;
    }
    return this.state.lastSelection;
  }
  recreateSelection() {
    const { current: t } = this.editorRef, { hasFocus: e, lastSelection: n } = this.state, { editorWindow: o = window } = this.props, r = o.getSelection();
    return t && !e && (t.focus(), n && r && (r.removeAllRanges(), r.addRange(n))), r;
  }
  handleFocus = () => {
    const { editorWindow: t = window } = this.props;
    this.setState({
      hasFocus: !0
    }), t.document.addEventListener(
      "selectionchange",
      this.handleSelectionChange
    );
  };
  handleBlur = (t) => {
    const { editorWindow: e = window } = this.props, n = e.getSelection(), o = () => n?.rangeCount && n?.rangeCount > 0 ? n.getRangeAt(0) : null;
    ws(), this.setState({
      lastSelection: o(),
      hasFocus: !1
    }), e.document.removeEventListener(
      "selectionchange",
      this.handleSelectionChange
    ), this.handleBlurListeners(t);
  };
  focus = () => {
    const { current: t } = this.editorRef, { hasFocus: e } = this.state;
    t && (e || t.focus());
  };
  moveCursorToEnd = () => {
    const { current: t } = this.editorRef, { editorWindow: e = window } = this.props;
    if (!t) return;
    const n = e.getSelection();
    if (n) {
      const o = e.document.createRange();
      o.selectNodeContents(t), o.collapse(!1), n.removeAllRanges(), n.addRange(o);
    }
  };
  hasContent(t) {
    return t?.length ? !t.match(
      /^\s*<br>\s*$|^<[A-z\s="0-9]*>\s*(<br>\s*)?<\/[A-z\s="0-9]*>$/
    ) : !1;
  }
  isStylingActive() {
    return this.commandActive("bold") || this.commandActive("italic") || this.commandActive("insertUnorderedList") || this.commandActive("insertOrderedList") || this.commandActive("inlineCode");
  }
  getAllowedFormattingOptions() {
    const { allowFormatting: t } = this.props;
    return Array.isArray(t) ? t : t ? Lg : [];
  }
  lastExtractedContent = O();
  extractEditorContent() {
    const { editorContentExtractor: t, sanitize: e } = this.props, { current: n } = this.editorRef, o = n?.innerHTML ?? "";
    if (!t)
      return Ko(o);
    if (o === this.lastExtractedContent.current)
      return this.lastExtractedContent.current;
    const r = t(n);
    return this.lastExtractedContent.current = Ko(
      e?.(r) ?? r
    ), this.lastExtractedContent.current;
  }
  canUndo = () => this.state.undoStack.length > 0;
  undo = () => {
    const { undoStack: t } = this.state;
    if (t.length > 0) {
      const e = t[t.length - 1];
      this.setHtml(e), this.setState({
        undoStack: t.slice(0, -1)
      });
    }
  };
  resetUndoStack = () => {
    this.setState({
      undoStack: []
    });
  };
  addCurrentContentToUndoStack = () => {
    this.setState({
      // To prevent undo stack from growing indefinitely, we only keep a finite amount
      undoStack: [...this.state.undoStack.slice(-50), this.getText()]
    });
  };
  render() {
    const {
      className: t,
      wrapperClassName: e,
      renderQuickResponse: n,
      quickResponsesApi: o,
      sendOnEnter: r,
      placeholder: a,
      allowInlineAttachments: l,
      allowAttachments: c,
      attachmentsDisabled: d,
      attachmentsDisabledTooltip: h,
      textInputDisabled: u,
      allowEmoji: p,
      attachmentsFields: m,
      attachments: g,
      isAttachmentsUploading: b,
      hideSendOnEnterToggle: x,
      editorWindow: y = window,
      languages: _,
      disabled: C,
      status: w,
      onError: v,
      icon: S,
      prefix: I,
      suffix: T,
      id: R,
      autocomplete: E,
      toolbarAddons: k
    } = this.props, { htmlOld: P, uiBlocker: H } = this.state, nt = f(ft.root, t);
    return /* @__PURE__ */ s.jsx(io.Context.Provider, { value: this.editor, children: /* @__PURE__ */ s.jsx(
      Et,
      {
        status: w,
        icon: S,
        prefix: I,
        suffix: T,
        disabled: C,
        className: f(ft.inputWrapper, e),
        children: /* @__PURE__ */ s.jsxs("div", { className: nt, children: [
          /* @__PURE__ */ s.jsxs(
            bf,
            {
              className: ft.editorWrap,
              onAddInline: this.handleInlineUpload,
              onAddAttachment: this.handleAttachmentUpload,
              attachments: Array.isArray(g) ? g : [],
              allowInlineAttachments: l,
              allowAttachments: c,
              children: [
                /* @__PURE__ */ s.jsx(
                  "div",
                  {
                    id: R,
                    ref: this.editorRef,
                    onPaste: this.handlePaste,
                    onKeyDown: this.handleKeyDown,
                    onInput: this.onInput,
                    onKeyUp: this.handleKeyUp,
                    onBlur: this.handleBlur,
                    onFocus: this.handleFocus,
                    onMouseOver: this.handleMouseOver,
                    onClick: this.handleEditorClick,
                    className: f(ft.editor, {
                      [ft.editorDisabled]: u
                    }),
                    "data-testid": Gr,
                    contentEditable: !u
                  }
                ),
                !this.hasContent(P) && !!a && /* @__PURE__ */ s.jsx("span", { role: "presentation", className: ft.placeholder, children: a })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs(Ob, { className: ft.toolbar, children: [
            this.editor.allowFormatting.length > 0 && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              /* @__PURE__ */ s.jsx(
                Nb,
                {
                  isActive: this.isStylingActive(),
                  editor: this.editor,
                  editorWindow: y
                }
              ),
              this.editor.allowFormatting.includes("link") && /* @__PURE__ */ s.jsx(Kf, { editor: this.editor })
            ] }),
            l && /* @__PURE__ */ s.jsx(
              Ft,
              {
                icon: "upload",
                onMouseDown: this.openFileBrowser,
                tooltip: `Insert inline image (${no(Yr[0].keybindings)})`
              }
            ),
            c && /* @__PURE__ */ s.jsx(
              hf,
              {
                dropdownRef: this.attachmentDropdownButtonRef,
                onAttachFiles: this.handleAttachmentUpload,
                attachments: Array.isArray(g) ? g : [],
                isAttachmentsUploading: b,
                onDetachFile: this.handleDetachAttachmentFile,
                editorWindow: y,
                editor: this.editor,
                disabled: d,
                disabledTooltip: h,
                children: m
              }
            ),
            p && /* @__PURE__ */ s.jsx(If, { "data-tip": "Emojis", editor: this.editor }),
            !!o && !!n && /* @__PURE__ */ s.jsx(
              _b,
              {
                languages: _,
                renderQuickResponse: n,
                quickResponsesApi: o,
                editor: this.editor,
                sanitize: this.props.sanitize,
                iconName: this.props.quickResponseIcon
              }
            ),
            E && E.hasAutocompleteSuggestionsFeature && /* @__PURE__ */ s.jsx(
              Ft,
              {
                isActive: E.showAutocompleteSuggestions,
                onMouseDown: this.handleToggleAutocompleteSuggestions,
                icon: "autocomplete",
                tooltip: "Autocomplete suggestions"
              }
            ),
            k,
            !x && /* @__PURE__ */ s.jsx(
              Ft,
              {
                isActive: r,
                onMouseDown: this.handleToggleSendOnEnter,
                icon: "enter",
                tooltip: "Send on Enter"
              }
            ),
            E ? /* @__PURE__ */ s.jsxs(
              "span",
              {
                className: f(ft.toolbarHint, {
                  [ft.toolbarHintVisible]: this.state.showHint,
                  [ft.toolbarHintHidden]: !this.state.showHint
                }),
                children: [
                  "Autocomplete",
                  " ",
                  E.showAutocompleteSuggestions ? "ON" : "OFF"
                ]
              }
            ) : null
          ] }),
          /* @__PURE__ */ s.jsx(
            "input",
            {
              tabIndex: -1,
              ref: this.fileInputRef,
              type: "file",
              className: ft.fileInput,
              onChange: this.handleFileSelect,
              multiple: !0
            }
          ),
          /* @__PURE__ */ s.jsx($b, { editor: this.editor, onError: v }),
          /* @__PURE__ */ s.jsx(Zg, { editor: this.editor }),
          H && /* @__PURE__ */ s.jsx("div", { className: ft.uiBlocker, children: H })
        ] })
      }
    ) });
  }
}
const Xb = "h-textarea--textarea__inputWrapper", Qb = "h-textarea--textarea__input", qo = {
  inputWrapper: Xb,
  input: Qb
}, Zb = "textarea", Xr = $(function(t, e) {
  const n = G(null), {
    className: o,
    disabled: r,
    readOnly: a,
    name: l,
    prefix: c,
    suffix: d,
    icon: h,
    status: u,
    height: p = 0,
    style: m,
    autoGrow: g,
    ...b
  } = t, [x, y] = V(p), _ = {
    ...m,
    height: x ? `${x}px` : void 0
  }, C = F(() => {
    if (!n.current)
      return;
    const w = n.current.clientHeight, v = window.getComputedStyle(n.current), S = parseInt(v.lineHeight || "16");
    n.current.style.height = "auto";
    const I = n.current.scrollHeight + S, T = Math.max(
      p,
      Math.min(w, I)
    ), R = I > T ? I : T;
    n.current.style.height = `${R}px`, y(R);
  }, [p]);
  return Z(() => {
    if (g)
      return C(), window.addEventListener("resize", C), () => {
        window.removeEventListener("resize", C);
      };
  }, [g, C]), /* @__PURE__ */ s.jsx(
    Et,
    {
      className: qo.inputWrapper,
      status: u,
      disabled: r,
      prefix: c,
      suffix: d,
      icon: h,
      children: /* @__PURE__ */ s.jsx(
        "textarea",
        {
          "data-testid": Zb,
          className: qo.input,
          dir: "auto",
          id: l,
          ...b,
          onChange: (w) => {
            b?.onChange?.(w), g && C();
          },
          ref: n,
          style: _,
          name: l,
          disabled: r,
          readOnly: a
        }
      )
    }
  );
}), Jb = "h-fieldRichText--fieldRichText__editorContainer", tx = "h-fieldRichText--fieldRichText__fallbackTextArea", Go = {
  editorContainer: Jb,
  fallbackTextArea: tx
};
class Wk extends D {
  static defaultProps = {
    allowFormatting: !0
  };
  render() {
    const {
      className: t,
      input: e,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        labelFor: e.name,
        meta: o,
        required: r,
        helpIcon: l,
        disabled: a,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          zs,
          {
            fallback: /* @__PURE__ */ s.jsx(
              Xr,
              {
                ...e,
                className: Go.fallbackTextArea,
                disabled: a,
                value: e.value,
                onChange: (p) => e.onChange(p.target.value)
              }
            ),
            children: /* @__PURE__ */ s.jsx("div", { className: Go.editorContainer, children: /* @__PURE__ */ s.jsx(
              io,
              {
                disabled: a,
                status: z.getStatus(o),
                ...e,
                ...u,
                hideSendOnEnterToggle: !0,
                onTriggerSend: L
              }
            ) })
          }
        )
      }
    );
  }
}
class Mk extends D {
  constructor(t) {
    super(t), this.handleSelect = this.handleSelect.bind(this), this.handleClear = this.handleClear.bind(this);
  }
  getSelectedItems() {
    const {
      input: { value: t },
      items: e
    } = this.props;
    return typeof t == "string" && e?.some((n) => n.id === t) ? [t] : Array.isArray(t) && t.length && e?.some((n) => t.some((o) => o === n.id)) ? t : [];
  }
  handleSelect(t) {
    const {
      input: { onChange: e }
    } = this.props;
    typeof e == "function" && e(t === null ? "" : t.id.toString());
  }
  handleClear() {
    const {
      input: { value: t },
      onClear: e
    } = this.props;
    typeof t == "string" && this.handleSelect(null), typeof e == "function" && e();
  }
  render() {
    const {
      className: t,
      input: e,
      meta: n,
      label: o,
      required: r,
      disabled: a,
      description: l,
      helpIcon: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: o,
        labelFor: e.name,
        meta: n,
        required: r,
        disabled: a,
        helpIcon: c,
        description: l,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Te,
          {
            ...u,
            id: e.name,
            disabled: a,
            selectedItems: this.getSelectedItems(),
            onSelect: this.handleSelect,
            onClear: this.handleClear,
            status: z.getStatus(n)
          }
        )
      }
    );
  }
}
function Qr(i, t = "") {
  return Rt.toArray(i).reduce((e, n) => Pt(n) ? n.type === Qt ? [
    ...e,
    ...Qr(n.props.children, n.key)
  ] : [...e, { ...n, key: `${t}${n.key}` }] : e, []);
}
const Jn = (i) => U(() => Qr(i), [i]), ex = "h-selectionList--selectionList__root", nx = "h-selectionList--selectionList__disabled", Yo = {
  root: ex,
  disabled: nx
}, Re = Ri(
  () => Bt({
    list: {
      isMultiple: !1,
      isActive: !1,
      isFocused: !1,
      isDisabled: !1
    },
    item: {
      isActive: !1,
      setActive: L,
      register: L,
      isSelected: () => !1,
      onSelect: L,
      isOnlyVisibleItem: !1
    }
  })
), ao = ({ defaultActiveItemIndex: i = 0 } = {
  defaultActiveItemIndex: 0
}) => {
  const [t, e] = V(!1), [n, o] = V(-1), [r, a] = V([]), [l, c] = V({}), d = F(
    ({
      isActivatable: g,
      isLastChild: b,
      isOnlyVisibleItem: x,
      keysTakenOverHandlingFromParent: y
    }, _) => {
      g !== void 0 && a((C) => {
        const w = g ? [...C, _].sort((v, S) => v - S) : C.filter((v) => v !== _);
        return b && o((v) => (w.includes(_) && !C.includes(_) || _ !== v) && w.includes(v) && _ !== w[i] ? v : w[i] ?? w[0] ?? v), w;
      }), x !== void 0 && e(x), y !== void 0 && c((C) => ({
        ...C,
        [_]: y
      }));
    },
    [i]
  ), h = F(
    (g) => "index" in g ? g.index : g.step === "first" ? r[0] : g.step === "last" ? r[r.length - 1] : r[(r.findIndex(
      (b) => b === n
    ) + g.step + r.length) % r.length],
    [r, n]
  ), u = F(
    (g) => {
      o(h(g));
    },
    [h]
  );
  Z(() => {
    (n < 0 || n === void 0) && o(r[i]);
  }, [n, r, i]);
  const p = U(
    () => l[n] ?? [],
    [n, l]
  );
  return U(
    () => ({
      activeItemIndex: n,
      getActiveItemIndex: h,
      activatableItemIndices: r,
      setActiveItem: u,
      handleItemRegister: d,
      isOnlyActiveItemVisible: t,
      keysDelegatedHandlingToItem: p
    }),
    [
      r,
      n,
      h,
      d,
      t,
      p,
      u
    ]
  );
}, Xo = ({
  className: i,
  selectedValues: t = [],
  isActive: e,
  isDisabled: n,
  isMultiple: o = !1,
  onChange: r = L,
  equalityFn: a = Object.is,
  tabIndex: l = 0,
  defaultActiveItemIndex: c,
  children: d,
  ...h
}, u) => {
  const [p, m] = V(!1), [g, b] = V({ isActive: !!e, source: "parent" }), x = Re(), {
    activeItemIndex: y,
    setActiveItem: _,
    handleItemRegister: C,
    isOnlyActiveItemVisible: w,
    keysDelegatedHandlingToItem: v
  } = ao({ defaultActiveItemIndex: c }), S = Jn(d), I = F(
    (k) => k !== void 0 && (t || []).some(
      (P) => a(P, k)
    ),
    [a, t]
  ), T = F(
    ({ value: k, meta: P }, H) => {
      _({ index: H }), k !== void 0 && r(o ? {
        selectedValues: I(k) ? t.filter(
          (nt) => !a(nt, k)
        ) : [...t, k],
        selectedItem: {
          isNode: P?.isNode,
          isSelected: !I(k),
          value: k
        },
        event: P?.event
      } : {
        selectedValues: [k],
        selectedItem: {
          isNode: P?.isNode,
          isSelected: !0,
          value: k
        },
        event: P?.event
      });
    },
    [
      a,
      I,
      o,
      r,
      t,
      _
    ]
  ), R = U(
    () => !n && (g.isActive || p),
    [n, g.isActive, p]
  ), E = (k) => {
    !R || v.includes(k.key) || (k.key === "Enter" ? k.preventDefault() : k.key === "Home" ? (_({ step: "first" }), k.preventDefault()) : k.key === "End" ? (_({ step: "last" }), k.preventDefault()) : k.key === "ArrowDown" ? (_({ step: 1 }), k.preventDefault()) : k.key === "ArrowUp" && (_({ step: -1 }), k.preventDefault()));
  };
  return Z(() => {
    b({ isActive: !!e, source: "parent" });
  }, [e]), ln("keydown", E), /* @__PURE__ */ s.jsx(
    "ul",
    {
      ref: u,
      role: "listbox",
      tabIndex: n || e ? -1 : l,
      ...h,
      className: f(i, Yo.root, {
        [Yo.disabled]: n
      }),
      onFocus: () => m(!0),
      onBlur: () => m(!1),
      onMouseLeave: () => {
        g.source === "child" && b({ isActive: !1, source: "self" });
      },
      children: S.map(
        (k, P) => Pt(k) && (!w || P === y) && /* @__PURE__ */ s.jsx(
          x.Provider,
          {
            value: {
              list: {
                isFocused: p,
                isMultiple: o,
                isActive: g.isActive,
                isDisabled: n
              },
              item: {
                isActive: R && P === y,
                setActive: () => {
                  b({ isActive: !0, source: "child" }), _({ index: P });
                },
                register: (H) => C(H, P),
                isSelected: I,
                onSelect: (H) => T(H, P),
                isOnlyVisibleItem: w,
                isLastChild: P === S.length - 1
              }
            },
            children: k
          },
          P
        )
      )
    }
  );
}, Qo = ({ className: i, label: t, ...e }, n) => {
  const {
    item: { register: o, isLastChild: r }
  } = Gt(Re());
  return Ne(() => {
    o({ isActivatable: !1, isLastChild: r });
  }), Zt(() => {
    o({ isActivatable: !1, isLastChild: r });
  }), /* @__PURE__ */ s.jsx(
    qn,
    {
      ref: n,
      as: "li",
      color: "tertiary",
      padding: "200 250",
      ...e,
      children: /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "4", color: "secondary", children: t })
    }
  );
}, Zr = Object.assign($(Qo), {
  name: Qo.name
}), sx = "h-selectionList-subComponents-item--selectionListItem__root", ox = "h-selectionList-subComponents-item--selectionListItem__rootDisabled", rx = "h-selectionList-subComponents-item--selectionListItem__rootActive", ix = "h-selectionList-subComponents-item--selectionListItem__selectionState", ax = "h-selectionList-subComponents-item--selectionListItem__fixedSize", lx = "h-selectionList-subComponents-item--selectionListItem__content", cx = "h-selectionList-subComponents-item--selectionListItem__contentDisabled", oe = {
  root: sx,
  rootDisabled: ox,
  rootActive: rx,
  selectionState: ix,
  fixedSize: ax,
  content: lx,
  contentDisabled: cx
}, Zo = ({
  value: i,
  isDisabled: t = !1,
  isIndeterminate: e = !1,
  className: n,
  contentClassName: o,
  noFixedSelectionStateSpace: r,
  onActiveStateChange: a,
  onSelectedStateChange: l,
  onSelect: c,
  children: d,
  ...h
}, u) => {
  const {
    list: {
      isMultiple: p,
      isDisabled: m,
      isActive: g,
      isFocused: b
    },
    item: {
      register: x,
      isSelected: y,
      onSelect: _,
      isActive: C,
      isNode: w = !1,
      isLastChild: v = !1,
      setActive: S
    }
  } = Gt(Re()), I = y(i), T = U(
    () => !m && (g || b),
    [g, m, b]
  ), R = U(
    () => !t && C && T,
    [C, t, T]
  ), E = G(null);
  je(
    u,
    () => E.current
  );
  const k = F(
    (W) => {
      !t && !m && (c?.({ value: i, meta: { target: W?.target } }), _({
        value: i,
        meta: {
          target: W?.target,
          event: W || void 0
        }
      }));
    },
    [t, m, c, _, i]
  ), P = F(
    (W) => {
      R && W.key === "Enter" && k(W);
    },
    [R, k]
  );
  Z(() => {
    C && T && E.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start"
    });
  }, [C]);
  const H = F(
    () => ({
      isActive: C,
      isSelected: I,
      isLastChild: v,
      isNode: w,
      value: i
    }),
    [C, v, w, I, i]
  ), nt = en(C), ot = en(I);
  Xt(() => {
    C !== nt && a?.(H()), I !== ot && l?.(H());
  }, [
    H,
    C,
    I,
    a,
    l,
    nt,
    ot
  ]), ln("keydown", P), Z(() => (x({ isActivatable: !t, isLastChild: v }), () => x({ isActivatable: !1, isLastChild: v })), [t]);
  const et = !p && I || p && i !== void 0 || !r;
  return /* @__PURE__ */ s.jsxs(
    "li",
    {
      ref: E,
      role: "option",
      "aria-selected": I,
      "aria-disabled": t,
      onClick: k,
      onMouseMove: S,
      className: f(oe.root, n, {
        [oe.rootActive]: R,
        [oe.rootDisabled]: t
      }),
      ...h,
      children: [
        et && /* @__PURE__ */ s.jsxs(
          B,
          {
            className: f(oe.selectionState, {
              [oe.fixedSize]: !r
            }),
            children: [
              !p && I && /* @__PURE__ */ s.jsx(N, { name: "done" }),
              p && i !== void 0 && /* @__PURE__ */ s.jsx(
                cn,
                {
                  checked: I,
                  indeterminate: !I && e,
                  disabled: t,
                  onChange: L,
                  tabIndex: -1
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ s.jsx(
          at,
          {
            className: f(oe.content, o, {
              [oe.contentDisabled]: t
            }),
            children: d
          }
        ),
        w && /* @__PURE__ */ s.jsx(N, { name: "angle-right" })
      ]
    }
  );
}, dx = Object.assign($(Zo), {
  name: Zo.name
}), hx = "h-selectionList-subComponents-list-backItem--selectionListBackItem__root", ux = "h-selectionList-subComponents-list-backItem--selectionListBackItem__rootActive", Jo = {
  root: hx,
  rootActive: ux
}, tr = ({
  className: i,
  content: t,
  onActiveStateChange: e,
  onSelected: n,
  ...o
}, r) => {
  const {
    list: {
      isDisabled: a,
      isActive: l,
      isFocused: c
    },
    item: { register: d, isActive: h, onSelect: u, setActive: p }
  } = Gt(Re()), m = U(
    () => !a && (l || c),
    [l, a, c]
  ), g = U(
    () => h && m,
    [h, m]
  ), b = G(null);
  je(
    r,
    () => b.current
  );
  const x = F(() => {
    u({}), n?.();
  }, [u, n]), y = F(
    (C) => {
      !g || a || C.key === "Enter" && x();
    },
    [x, g, a]
  );
  Z(() => {
    h && m && b.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start"
    });
  }, [h]);
  const _ = en(h);
  return Xt(() => {
    h !== _ && e?.({ isActive: h });
  }, [h, e, _]), ln("keydown", y), Ne(() => {
    d({ isActivatable: !0 });
  }), Zt(() => {
    d({ isActivatable: !1 });
  }), /* @__PURE__ */ s.jsx(
    "li",
    {
      ref: b,
      role: "navigation",
      className: f(Jo.root, i, {
        [Jo.rootActive]: g
      }),
      onClick: x,
      onMouseMove: p,
      ...o,
      children: t || /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(N, { name: "angle-left" }),
        /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "1", children: "Back" })
      ] })
    }
  );
}, Jr = Object.assign(
  $(tr),
  {
    name: tr.name
  }
), px = "h-selectionList-subComponents-list--selectionListList__list", mx = {
  list: px
}, er = ({
  parentItem: i,
  children: t,
  backItemProps: e = {},
  listProps: { className: n, ...o } = {},
  onActiveStateChange: r,
  ...a
}, l) => {
  const c = Re(), d = Gt(c), {
    list: {
      isFocused: h,
      isActive: u,
      isDisabled: p
    },
    item: {
      isActive: m,
      onSelect: g,
      isOnlyVisibleItem: b,
      register: x,
      setActive: y,
      isLastChild: _ = !1
    }
  } = d, C = U(
    () => !p && (u || h),
    [u, p, h]
  ), w = Jn(t), {
    activeItemIndex: v,
    setActiveItem: S,
    handleItemRegister: I,
    isOnlyActiveItemVisible: T,
    keysDelegatedHandlingToItem: R
  } = ao({ defaultActiveItemIndex: 1 }), E = F(
    (W, rt) => {
      S({ index: rt }), g(W);
    },
    [g, S]
  ), k = (W) => {
    !C || !b || R.includes(W.key) || (W.key === "Home" ? (S({ step: "first" }), W.preventDefault()) : W.key === "End" ? (S({ step: "last" }), W.preventDefault()) : W.key === "ArrowDown" ? (S({ step: 1 }), W.preventDefault()) : W.key === "ArrowUp" && (S({ step: -1 }), W.preventDefault()));
  }, P = en(
    b
  );
  Xt(() => {
    b !== P && r?.({
      isActive: b,
      isLastChild: _
    });
  }, [
    b,
    r,
    P
  ]), Z(() => {
    x(b ? {
      keysTakenOverHandlingFromParent: [
        "Home",
        "End",
        "ArrowDown",
        "ArrowUp"
      ]
    } : { keysTakenOverHandlingFromParent: [] });
  }, [b]), ln("keydown", k);
  const H = F(
    ({ value: W, meta: rt }) => {
      rt?.target instanceof HTMLInputElement && rt.target.type === "checkbox" ? g({ value: W, meta: { isNode: !0 } }) : x({ isOnlyVisibleItem: !0 });
    },
    // excluding `register` to avoid infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  ), nt = F(() => {
    x({ isOnlyVisibleItem: !1 });
  }, []);
  Z(() => {
    b || S({ index: -1 });
  }, [b, S]);
  const ot = U(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: H,
        isNode: !0
      }
    }),
    [H, d]
  ), et = U(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: nt,
        isActive: v === 0,
        setActive: () => {
          y(), S({ index: 0 });
        },
        register: (W) => I(W, 0)
      }
    }),
    [
      v,
      nt,
      I,
      d,
      y,
      S
    ]
  );
  return b ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    !T && /* @__PURE__ */ s.jsx(c.Provider, { value: et, children: /* @__PURE__ */ s.jsx(Jr, { ...e }) }),
    /* @__PURE__ */ s.jsx("li", { ref: l, ...a, children: /* @__PURE__ */ s.jsx(
      "ul",
      {
        role: "listbox",
        className: f(mx.list, n),
        ...o,
        children: w.map((W, rt) => {
          const Dt = rt + 1;
          return Pt(W) && (!T || Dt === v) && /* @__PURE__ */ s.jsx(
            c.Provider,
            {
              value: {
                ...d,
                item: {
                  ...d.item,
                  isActive: m && Dt === v,
                  setActive: () => {
                    y(), S({ index: Dt });
                  },
                  register: (ce) => I(ce, Dt),
                  onSelect: (ce) => E(ce, Dt),
                  isOnlyVisibleItem: T,
                  isLastChild: rt === w.length - 1
                }
              },
              children: W
            },
            rt
          );
        })
      }
    ) })
  ] }) : /* @__PURE__ */ s.jsx(c.Provider, { value: ot, children: i });
}, gx = Object.assign($(er), {
  name: er.name
}), fx = "h-selectionList-subComponents-section--selectionListSection__section", bx = {
  section: fx
}, nr = ({
  title: i,
  children: t,
  listProps: { className: e, ...n } = {},
  onActiveStateChange: o,
  ...r
}, a) => {
  const l = Re(), c = Gt(l), {
    list: {
      isFocused: d,
      isActive: h,
      isDisabled: u
    },
    item: {
      isActive: p,
      setActive: m,
      onSelect: g,
      register: b,
      isLastChild: x = !1
    }
  } = c, y = U(
    () => !u && (h || d),
    [h, u, d]
  ), _ = Jn(t), {
    activatableItemIndices: C,
    activeItemIndex: w,
    setActiveItem: v,
    handleItemRegister: S,
    keysDelegatedHandlingToItem: I
  } = ao(), T = F(
    (k, P) => {
      v({ index: P }), g(k);
    },
    [g, v]
  ), R = (k) => {
    !y || I.includes(k.key) || (k.key === "Home" ? v({ step: "first" }) : k.key === "End" && v({ step: "last" }), p ? k.key === "ArrowDown" && w !== C[C.length - 1] ? (v({ step: 1 }), k.preventDefault()) : k.key === "ArrowUp" && w !== C[0] && (v({ step: -1 }), k.preventDefault()) : k.key === "ArrowDown" ? v({ step: "first" }) : k.key === "ArrowUp" && v({ step: "last" }));
  }, E = en(p);
  return Xt(() => {
    p !== E && o?.({
      isActive: p,
      isLastChild: x
    });
  }, [p, o, E]), Z(() => {
    const k = [];
    p && (w !== C[C.length - 1] && k.push("ArrowDown"), w !== C[0] && k.push("ArrowUp")), b({ keysTakenOverHandlingFromParent: k });
  }, [C, w, p]), Ne(() => b({ isActivatable: !0 })), Zt(() => b({ isActivatable: !1 })), ln("keydown", R), /* @__PURE__ */ s.jsx("li", { ref: a, ...r, children: /* @__PURE__ */ s.jsxs(
    "ul",
    {
      role: "group",
      className: f(bx.section, e),
      ...n,
      children: [
        /* @__PURE__ */ s.jsx(Zr, { label: i }),
        _.map(
          (k, P) => Pt(k) && /* @__PURE__ */ s.jsx(
            l.Provider,
            {
              value: {
                ...c,
                item: {
                  ...c.item,
                  isActive: p && P === w,
                  setActive: () => {
                    m(), v({ index: P });
                  },
                  register: (H) => S(H, P),
                  onSelect: (H) => T(H, P),
                  isLastChild: x && P === _.length - 1
                }
              },
              children: k
            },
            P
          )
        )
      ]
    }
  ) });
}, xx = Object.assign($(nr), {
  name: nr.name
}), yx = Object.assign($(Xo), {
  name: Xo.name,
  Item: dx,
  BackItem: Jr,
  Divider: Zr,
  Section: xx,
  List: gx
}), _x = "h-inputSelectionList-chip--inputSelectionListChip__root", Cx = "h-inputSelectionList-chip--inputSelectionListChip__name", sr = {
  root: _x,
  name: Cx
}, vs = ({
  onDelete: i,
  className: t,
  disabled: e,
  readOnly: n,
  ...o
}) => {
  const r = U(() => {
    if (!(!i || e || n))
      return (a) => {
        a.stopPropagation(), i();
      };
  }, [e, i, n]);
  return /* @__PURE__ */ s.jsx(
    ke,
    {
      ...o,
      onDelete: r,
      className: f(sr.root, t),
      tagNameClassName: sr.name
    }
  );
}, wx = "h-inputSelectionList--inputSelectionList__root", vx = "h-inputSelectionList--inputSelectionList__inputWrapper", Sx = "h-inputSelectionList--inputSelectionList__inputWrapperChild", Ix = "h-inputSelectionList--inputSelectionList__rootHasWrapperIcon", Dx = "h-inputSelectionList--inputSelectionList__rootReadOnly", kx = "h-inputSelectionList--inputSelectionList__titleContainer", Tx = "h-inputSelectionList--inputSelectionList__filterInput", jx = "h-inputSelectionList--inputSelectionList__placeholder", Nx = "h-inputSelectionList--inputSelectionList__titleBox", Fx = "h-inputSelectionList--inputSelectionList__iconContainer", Px = "h-inputSelectionList--inputSelectionList__iconButton", Rx = "h-inputSelectionList--inputSelectionList__dropdown", Ex = "h-inputSelectionList--inputSelectionList__hiddenItemsTooltip", Lx = "h-inputSelectionList--inputSelectionList__hiddenItemsChip", ct = {
  root: wx,
  inputWrapper: vx,
  inputWrapperChild: Sx,
  rootHasWrapperIcon: Ix,
  rootReadOnly: Dx,
  titleContainer: kx,
  filterInput: Tx,
  placeholder: jx,
  titleBox: Nx,
  iconContainer: Fx,
  iconButton: Px,
  dropdown: Rx,
  hiddenItemsTooltip: Ex,
  hiddenItemsChip: Lx
}, Ax = "inputSelectionListTestId", or = ({
  className: i,
  name: t,
  value: e,
  onChange: n,
  prefix: o,
  suffix: r,
  icon: a,
  status: l,
  placeholder: c,
  disabled: d,
  readOnly: h,
  children: u,
  filter: p,
  multiple: m,
  getItemTitleByValue: g,
  tabIndex: b,
  keepOpen: x,
  onToggleDropdown: y,
  onClick: _,
  onBlur: C,
  onKeyDown: w,
  limit: v = Number.POSITIVE_INFINITY,
  clearable: S = !1,
  equalityFn: I = Object.is,
  defaultActiveItemIndex: T,
  valueArrayToStringFn: R = JSON.stringify,
  rootClassName: E,
  dropdownProps: k,
  selectionListProps: P,
  slotBeforeList: H,
  slotAfterList: nt,
  ...ot
}, et) => {
  const W = G(null), rt = G(null), Dt = G(null), ce = G(null), [Q, ei] = V(!1);
  je(
    et,
    () => rt.current
  );
  const es = U(
    () => p?.value !== void 0 && p.onChange !== void 0 && Q,
    [p, Q]
  ), ni = U(() => {
    if (!e?.length)
      return c;
    if (!m) {
      const M = g(e[0]);
      return typeof M == "object" ? "" : M?.toString();
    }
    return "";
  }, [m, c, g, e]), si = U(() => es ? m && !!e?.length : !0, [m, es, e?.length]), ns = F(
    (M) => {
      !h && !d && n?.({
        selectedItem: {
          isSelected: !1,
          value: M
        },
        selectedValues: e?.filter((Ae) => !I(Ae, M)) ?? []
      });
    },
    [d, I, n, h, e]
  ), oi = U(() => {
    if (!e?.length)
      return /* @__PURE__ */ s.jsx(B, { alignItems: "center", className: ct.placeholder, children: c });
    if (m) {
      const M = v < e.length ? e.slice(0, v) : e, Ae = v < e.length ? e.slice(v) : [];
      return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        M?.map(($e, ss) => /* @__PURE__ */ s.jsx(
          vs,
          {
            onDelete: () => {
              ns($e);
            },
            disabled: d,
            readOnly: h,
            children: g($e)
          },
          ss
        )),
        !!Ae.length && /* @__PURE__ */ s.jsx(
          st,
          {
            disabled: d,
            requireClick: !0,
            content: /* @__PURE__ */ s.jsx(
              B,
              {
                className: ct.hiddenItemsTooltip,
                gap: "100",
                flexWrap: "wrap",
                children: Ae?.map(($e, ss) => /* @__PURE__ */ s.jsx(
                  vs,
                  {
                    onDelete: () => {
                      ns($e);
                    },
                    disabled: d,
                    readOnly: h,
                    children: g($e)
                  },
                  ss
                ))
              }
            ),
            light: !0,
            children: /* @__PURE__ */ s.jsxs(
              vs,
              {
                className: ct.hiddenItemsChip,
                disabled: d,
                children: [
                  "+ ",
                  Ae.length
                ]
              }
            )
          }
        )
      ] });
    }
    return /* @__PURE__ */ s.jsx(at, { className: ct.titleBox, children: g(e[0]) });
  }, [
    e,
    m,
    g,
    c,
    v,
    d,
    h,
    ns
  ]), ht = F(
    (M) => {
      (h || d) && M || (M !== Q && y?.(M), ei(M));
    },
    [d, Q, y, h]
  ), Ee = F(
    ({ target: M }) => {
      ce.current?.contains(M) || (W.current?.contains(M) && rt.current?.focus(), ht(!1));
    },
    [ht]
  ), Le = F(
    (M) => {
      Fe(M.key) && Q && (ht(!1), rt.current?.focus());
    },
    [Q, ht]
  ), ri = F(
    (M) => {
      M.relatedTarget && W.current?.contains(M.relatedTarget) || (ht(!1), C?.(M));
    },
    [C, ht]
  ), ii = F(
    (M) => {
      Q || M.stopPropagation(), ht(!0), _?.(M);
    },
    [Q, _, ht]
  ), ai = F(
    (M) => {
      Yn(M.key) && ht(!0), w?.(M);
    },
    [w, ht]
  ), li = F(
    (M) => {
      M.stopPropagation(), ht(!Q), rt.current?.focus();
    },
    [Q, ht]
  ), ci = F(
    (M) => {
      M.stopPropagation(), rt.current?.focus(), !d && !h && n?.({ selectedValues: [] });
    },
    [d, n, h]
  ), di = F(
    (M) => {
      n?.(M), rt.current?.focus(), !x && !m ? ht(!1) : Dt.current?.focus();
    },
    [m, x, n, ht]
  );
  return Z(() => (Q ? (window.addEventListener("click", Ee), window.addEventListener("keydown", Le)) : (window.removeEventListener("click", Ee), window.removeEventListener("keydown", Le)), () => {
    window.removeEventListener("click", Ee), window.removeEventListener("keydown", Le);
  }), [Ee, Le, Q]), Z(() => {
    Q && Dt.current?.focus();
  }, [Q]), Zt(() => {
    window.removeEventListener("click", Ee), window.removeEventListener("keydown", Le);
  }), /* @__PURE__ */ s.jsxs(
    "div",
    {
      "data-testid": Ax,
      ref: W,
      className: f(ct.root, E, {
        [ct.rootHasWrapperIcon]: !!a,
        [ct.rootReadOnly]: h
      }),
      "aria-expanded": Q,
      "aria-haspopup": "listbox",
      role: "combobox",
      children: [
        /* @__PURE__ */ s.jsx(
          Et,
          {
            ...ot,
            ref: rt,
            className: f(i, ct.inputWrapper),
            prefix: o,
            suffix: r,
            disabled: d,
            icon: a,
            active: Q,
            status: l,
            onClick: ii,
            onBlur: ri,
            onKeyDown: ai,
            tabIndex: d ? -1 : b ?? 0,
            children: /* @__PURE__ */ s.jsxs(B, { className: ct.inputWrapperChild, children: [
              /* @__PURE__ */ s.jsxs(B, { gap: "100", flexWrap: "wrap", className: ct.titleContainer, children: [
                si && oi,
                es && /* @__PURE__ */ s.jsx(
                  "input",
                  {
                    ...p,
                    ref: Dt,
                    className: f(ct.filterInput, p?.className),
                    autoComplete: "off",
                    "aria-autocomplete": "list",
                    placeholder: ni,
                    disabled: d || p?.disabled
                  }
                )
              ] }),
              /* @__PURE__ */ s.jsxs(B, { alignItems: "center", className: ct.iconContainer, children: [
                S && !d && !h && !!e?.length && /* @__PURE__ */ s.jsx(
                  K,
                  {
                    className: ct.iconButton,
                    variant: "tertiary",
                    icon: "close",
                    disabled: d,
                    onClick: ci,
                    "aria-label": "Clear"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  K,
                  {
                    className: ct.iconButton,
                    variant: "tertiary",
                    icon: Q ? "angle-up" : "angle-down",
                    disabled: d,
                    onClick: li,
                    "aria-label": Q ? "Close" : "Open"
                  }
                )
              ] })
            ] })
          }
        ),
        t && /* @__PURE__ */ s.jsx(
          "input",
          {
            type: "hidden",
            disabled: d,
            name: t,
            value: R(e)
          }
        ),
        /* @__PURE__ */ s.jsx(
          Jt,
          {
            isOpen: Q,
            ...k,
            className: f(k?.className, ct.dropdown),
            children: /* @__PURE__ */ s.jsx("div", { ref: ce, style: { width: "100%" }, children: Q && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              H,
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              /* @__PURE__ */ s.jsx(
                yx,
                {
                  ...P,
                  equalityFn: I,
                  defaultActiveItemIndex: T,
                  isActive: Q,
                  isMultiple: m,
                  selectedValues: e,
                  onChange: di,
                  children: u
                }
              ),
              nt
            ] }) })
          }
        )
      ]
    }
  );
}, $x = Object.assign($(or), {
  name: or.name
}), zk = ({
  className: i,
  input: { value: t, name: e, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => /* @__PURE__ */ s.jsx(
  z,
  {
    className: i,
    label: r,
    labelFor: e,
    meta: a,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ s.jsx(
      $x,
      {
        name: e,
        value: t || [],
        onChange: (g) => {
          n(g.selectedValues);
        },
        ...o,
        status: z.getStatus(a),
        disabled: c,
        required: l,
        ...m
      }
    )
  }
), Ox = "h-slider--slider__rootWrapper", Bx = "h-slider--slider__rootWrapperNoAnnotations", Hx = "h-slider--slider__root", Wx = "h-slider--slider__rootDark", Mx = "h-slider--slider__rootDisabled", zx = "h-slider--slider__handle", Vx = "h-slider--slider__trackWrapper", Kx = "h-slider--slider__track", Ux = "h-slider--slider__highlight", qx = "h-slider--slider__minValueIndicator", Gx = "h-slider--slider__maxValueIndicator", bt = {
  rootWrapper: Ox,
  rootWrapperNoAnnotations: Bx,
  root: Hx,
  rootDark: Wx,
  rootDisabled: Mx,
  handle: zx,
  trackWrapper: Vx,
  track: Kx,
  highlight: Ux,
  minValueIndicator: qx,
  maxValueIndicator: Gx
};
var jt = /* @__PURE__ */ ((i) => (i.LowBoundIndicator = "input-slider-low-indicator", i.HighBoundIndicator = "input-slider-high-indicator", i.Handle = "input-slider-handle", i.Value = "input-slider-value", i.TrackBackground = "input-slider-tack-background", i.Track = "input-slider-track", i.Highlight = "input-slider-highlight", i))(jt || {});
const Yx = (i) => {
  i.preventDefault();
}, Xx = (i, t, e) => typeof i != "number" && !Array.isArray(i) ? "" : typeof i == "number" ? /* @__PURE__ */ s.jsxs(A.Paragraph, { variant: "3", children: [
  t,
  i,
  e
] }) : /* @__PURE__ */ s.jsxs(A.Paragraph, { variant: "3", children: [
  t,
  i[0],
  e,
  " - ",
  t,
  i[1],
  e
] });
class Qx extends D {
  static defaultProps = {
    min: 0,
    max: 100,
    dark: !1,
    highlightRange: null,
    formatValue: Xx,
    hideAnnotations: !1
  };
  constructor(t) {
    super(t), this.state = {
      startX: 0,
      startVal: 0,
      sliderWidth: 0,
      currentIndex: null
    }, this.handleHandleGrab = this.handleHandleGrab.bind(this), this.handleHandleMove = this.handleHandleMove.bind(this), this.handleHandleDrop = this.handleHandleDrop.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSliderMouseDown = this.handleSliderMouseDown.bind(this), this.relativeValueToAbsoluteValue = this.relativeValueToAbsoluteValue.bind(this), this.absoluteValueToRelativeValue = this.absoluteValueToRelativeValue.bind(this);
  }
  sliderRef = O();
  isInterval(t) {
    return Array.isArray(t);
  }
  handleChange(t) {
    typeof t == "number" ? this.props.onChange?.(Math.round(t)) : this.props.onChange?.(
      t.map((e) => Math.round(e))
    );
  }
  /*
    This method handles grab on handle, and saves the index of the handle, so that
    when the event bubbles to the slider, the handler will know that we chose a specific handle
   */
  handleHandleGrab(t) {
    t.target instanceof Element && this.setState({
      currentIndex: parseInt(
        t.target.getAttribute("data-index") || "",
        10
      )
    });
  }
  handleHandleMove(t) {
    t.preventDefault();
    const { startVal: e, startX: n, sliderWidth: o, currentIndex: r } = this.state, a = e + (t.clientX - n) / o, l = this.getAbsoluteValue(a, r);
    this.handleChange(l);
  }
  handleHandleDrop() {
    window.removeEventListener("mousemove", this.handleHandleMove), window.removeEventListener("mouseup", this.handleHandleDrop), this.setState({ currentIndex: null });
  }
  handleKeyDown(t) {
    const { step: e = 1, value: n } = this.props;
    t.preventDefault();
    const o = this.isInterval(n) && t.target instanceof Element ? parseInt(t.target.getAttribute("data-index") || "", 10) : null;
    switch (t.key) {
      case "ArrowRight":
      case "ArrowUp":
        this.increment(e, o);
        break;
      case "ArrowLeft":
      case "ArrowDown":
        this.increment(-e, o);
        break;
    }
  }
  /*
    This method handles mouse down on the slider (both handles and track)
    this will move the handle to the click position and start a drag.
    If the slider is an interval slider it will move and grab the closest handle
   */
  handleSliderMouseDown(t) {
    if (!this.sliderRef.current) return;
    const { value: e } = this.props, { currentIndex: n } = this.state, o = this.sliderRef.current.getBoundingClientRect(), r = (t.clientX - o.left) / o.width;
    this.setState({
      startX: t.clientX,
      // save the current mouse x
      startVal: r,
      // save the current percentage
      sliderWidth: o.width
      // save the slider width
    });
    let a;
    if (this.isInterval(e)) {
      const l = n ?? this.findTheNearestHandle(r, e);
      this.setState({
        currentIndex: l
      }), a = this.getAbsoluteValue(r, l);
    } else
      a = this.getAbsoluteValue(r);
    this.handleChange(a), window.addEventListener("mousemove", this.handleHandleMove), window.addEventListener("mouseup", this.handleHandleDrop);
  }
  findTheNearestHandle(t, e) {
    const [n, o] = e.map(
      this.absoluteValueToRelativeValue
    );
    return t > o && t > n ? 1 : t < o && t < n ? 0 : Math.abs(n - t) > Math.abs(o - t) ? 1 : 0;
  }
  getAdjustedStep(t) {
    const { min: e, max: n } = this.props;
    return t / (n - e);
  }
  getAbsoluteValue(t, e) {
    const { value: n, step: o } = this.props;
    let r = Rn(t, 0, 1);
    if (o) {
      const h = this.getAdjustedStep(o);
      r = Math.round(r / h) * h;
    }
    if (!this.isInterval(n))
      return this.relativeValueToAbsoluteValue(r);
    const [a, l] = n;
    let c = this.relativeValueToAbsoluteValue(r);
    e === 0 && c > l ? c = l : e === 1 && c < a && (c = a);
    const d = [a, l];
    return typeof e == "number" && (d[e] = c), d;
  }
  /**
   * @param ratio Is a number between 0 and 1 and it represents the **relative**
   *   placement of the handle within the slider track.
   */
  relativeValueToAbsoluteValue(t) {
    const { min: e, max: n } = this.props, o = e + (n - e) * t;
    return Rn(o, e, n);
  }
  /**
   * @param value Is a number between 'min' and 'max' and it represents the
   *   **absolute** value that is derived from the relative placement of the
   *   handle.
   */
  absoluteValueToRelativeValue(t) {
    const { min: e, max: n } = this.props, o = (t - e) / (n - e);
    return Rn(o, 0, 1);
  }
  increment(t, e) {
    const { value: n } = this.props;
    let o;
    if (this.isInterval(n)) {
      const r = [...n];
      r[e ?? 0] = r[e ?? 0] + t, o = r;
    } else
      o = n + t;
    this.handleChange(o);
  }
  getTrackStyles() {
    const { value: t, min: e } = this.props, n = this.isInterval(t) ? this.absoluteValueToRelativeValue(t[1]) - this.absoluteValueToRelativeValue(t[0]) : this.absoluteValueToRelativeValue(t), o = this.isInterval(t) ? this.absoluteValueToRelativeValue(t[0]) : this.absoluteValueToRelativeValue(e);
    return {
      width: `${n * 100}%`,
      left: `${o * 100}%`
    };
  }
  getHandleStyles(t) {
    const { value: e } = this.props;
    return {
      left: `${(this.isInterval(e) ? this.absoluteValueToRelativeValue(e[t ?? 0]) : this.absoluteValueToRelativeValue(e)) * 100}%`
    };
  }
  getHighlightStyles() {
    const { highlightRange: t } = this.props;
    if (yt(t)) return {};
    const [e, n] = t.map(this.absoluteValueToRelativeValue);
    return {
      left: `${e * 100}%`,
      width: `${(n - e) * 100}%`
    };
  }
  render() {
    const {
      className: t,
      value: e,
      step: n,
      highlightRange: o,
      min: r,
      max: a,
      dark: l,
      disabled: c,
      onChange: d,
      formatValue: h,
      hideAnnotations: u,
      valuePrefix: p,
      valueSuffix: m,
      onBlur: g,
      onFocus: b,
      children: x,
      ...y
    } = this.props, _ = f(
      bt.root,
      { [bt.rootDark]: l },
      { [bt.rootDisabled]: c },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: f(bt.rootWrapper, {
          [bt.rootWrapperNoAnnotations]: u
        }),
        children: [
          /* @__PURE__ */ s.jsxs(
            "div",
            {
              ...y,
              className: _,
              ref: this.sliderRef,
              onMouseDown: this.handleSliderMouseDown,
              children: [
                /* @__PURE__ */ s.jsxs(
                  "div",
                  {
                    className: bt.trackWrapper,
                    "data-testid": jt.TrackBackground,
                    children: [
                      !yt(o) && /* @__PURE__ */ s.jsx(
                        "div",
                        {
                          className: bt.highlight,
                          style: this.getHighlightStyles(),
                          "data-testid": jt.Highlight
                        }
                      ),
                      /* @__PURE__ */ s.jsx(
                        "div",
                        {
                          className: bt.track,
                          style: this.getTrackStyles(),
                          "data-testid": jt.Track
                        }
                      )
                    ]
                  }
                ),
                !this.isInterval(e) && /* @__PURE__ */ s.jsx(
                  "button",
                  {
                    tabIndex: 0,
                    role: "slider",
                    type: "button",
                    "aria-valuemin": r,
                    "aria-valuemax": a,
                    "aria-valuenow": e,
                    className: bt.handle,
                    onClick: Yx,
                    onKeyDown: this.handleKeyDown,
                    style: this.getHandleStyles(),
                    "data-testid": jt.Handle
                  }
                ),
                this.isInterval(e) && /* @__PURE__ */ s.jsxs(Qt, { children: [
                  /* @__PURE__ */ s.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "0",
                      className: bt.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(0),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": jt.Handle
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "1",
                      className: bt.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(1),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": jt.Handle
                    }
                  )
                ] }),
                !u && /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    "data-testid": jt.LowBoundIndicator,
                    className: bt.minValueIndicator,
                    children: /* @__PURE__ */ s.jsxs(A.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      p,
                      r,
                      m
                    ] })
                  }
                ),
                !u && /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    className: bt.maxValueIndicator,
                    "data-testid": jt.HighBoundIndicator,
                    children: /* @__PURE__ */ s.jsxs(A.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      p,
                      a,
                      m
                    ] })
                  }
                )
              ]
            }
          ),
          !u && /* @__PURE__ */ s.jsx("div", { "data-testid": jt.Value, children: h(e, p, m) })
        ]
      }
    );
  }
}
const $s = an(Qx, {
  fallback: null
}), Zx = "h-fieldSlider--fieldSlider__root", Jx = {
  root: Zx
};
class Vk extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this), this.handleBlur = this.handleBlur.bind(this);
  }
  handleChange(t) {
    const e = new Event("change");
    Object.defineProperty(e, "target", {
      writable: !0,
      value: { value: t, name: this.props.input.name }
    }), this.props.input.onChange(e);
  }
  /**
   * Redux form performs a value check when `blur` happens, so we need to make
   * sure the value is attached to the blur event otherwise it will be set to
   * null
   *
   * @see https://github.com/redux-form/redux-form/issues/2768
   */
  handleBlur(t) {
    const { input: e } = this.props, n = new FocusEvent(
      "blur",
      t
    );
    Object.defineProperty(n, "target", {
      writable: !0,
      value: { value: e.value, name: e.name }
    }), e.onBlur?.(n);
  }
  render() {
    const {
      className: t,
      input: e,
      meta: n,
      label: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props, p = f(Jx.root, t);
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: p,
        label: o,
        meta: n,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          $s,
          {
            ...e,
            onChange: this.handleChange,
            disabled: a,
            ...u
          }
        )
      }
    );
  }
}
const ty = "h-switch--switch__root", ey = "h-switch--switch__input", ny = "h-switch--switch__inner", sy = "h-switch--switch__pending", oy = "h-switch--switch__active", Ue = {
  root: ty,
  input: ey,
  inner: ny,
  pending: sy,
  active: oy
}, rr = {
  input: "Switch-input",
  label: "Switch-label"
};
class ry extends D {
  render() {
    const { id: t, className: e, variant: n, ...o } = this.props, r = t || `switch_${Math.random()}`;
    return /* @__PURE__ */ s.jsxs("div", { className: f(e, Ue.root), "data-testid": t, children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ...o,
          id: r,
          type: "checkbox",
          className: Ue.input,
          "data-testid": rr.input
        }
      ),
      /* @__PURE__ */ s.jsx(
        "label",
        {
          htmlFor: r,
          className: f(Ue.inner, {
            [Ue.active]: n === "active",
            [Ue.pending]: n === "pending"
          }),
          "data-testid": rr.label
        }
      )
    ] });
  }
}
class Kk extends D {
  render() {
    const { input: t, ...e } = this.props, { ref: n, ...o } = t;
    return /* @__PURE__ */ s.jsx(ry, { ...o, ...e });
  }
}
class Uk extends D {
  render() {
    const {
      className: t,
      input: e,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        labelFor: e.name,
        meta: o,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Xr,
          {
            status: z.getStatus(o),
            disabled: a,
            required: r,
            ...e,
            ...u
          }
        )
      }
    );
  }
}
const qk = ({
  className: i,
  input: { name: t, value: e, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => {
  const g = F(
    (b) => void n(b ?? ""),
    []
  );
  return /* @__PURE__ */ s.jsx(
    z,
    {
      className: i,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: t,
      meta: a,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ s.jsx(
        sn,
        {
          selectedItems: e ? [e] : [],
          ...o,
          ...m,
          disabled: c,
          id: t,
          onSelect: g,
          status: z.getStatus(a)
        }
      )
    }
  );
}, Gk = ({
  className: i,
  input: { name: t, value: e, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => {
  const g = F(
    (b) => void n({
      startTime: b.startTime ?? "",
      endTime: b.endTime ?? ""
    }),
    []
  );
  return /* @__PURE__ */ s.jsx(
    z,
    {
      className: i,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: t,
      meta: a,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ s.jsx(
        Sm,
        {
          endTime: e.endTime,
          startTime: e.startTime,
          ...o,
          ...m,
          disabled: c,
          id: t,
          onSelect: g,
          status: z.getStatus(a)
        }
      )
    }
  );
}, iy = "h-inputColorPicker-indicator--inputColorPickerIndicator__root", ay = "h-inputColorPicker-indicator--inputColorPickerIndicator__rootAlpha", ly = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicator", cy = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicatorNoColor", Dn = {
  root: iy,
  rootAlpha: ay,
  indicator: ly,
  indicatorNoColor: cy
}, dy = ({
  color: i,
  alpha: t,
  className: e,
  ...n
}) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ...n,
    className: f(Dn.root, e, {
      [Dn.rootAlpha]: t
    }),
    children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: f(Dn.indicator, {
          [Dn.indicatorNoColor]: !i
        }),
        style: { backgroundColor: i }
      }
    )
  }
), hy = "h-inputColorPicker--inputColorPicker__root", uy = "h-inputColorPicker--inputColorPicker__inputContainer", py = "h-inputColorPicker--inputColorPicker__input", my = "h-inputColorPicker--inputColorPicker__rootReadOnly", gy = "h-inputColorPicker--inputColorPicker__iconContainer", fy = "h-inputColorPicker--inputColorPicker__rootHasWrapperIcon", by = "h-inputColorPicker--inputColorPicker__clearIcon", xy = "h-inputColorPicker--inputColorPicker__colorIndicator", Kt = {
  root: hy,
  inputContainer: uy,
  input: py,
  rootReadOnly: my,
  iconContainer: gy,
  rootHasWrapperIcon: fy,
  clearIcon: by,
  colorIndicator: xy
}, yy = "inputColorPickerTestId", _y = ({
  className: i,
  name: t = Math.floor(Math.random() * 1e8).toString(),
  value: e,
  onChange: n,
  dropdownProps: o,
  prefix: r,
  suffix: a,
  icon: l,
  status: c,
  placeholder: d,
  disabled: h,
  colorPickerProps: u,
  clearable: p,
  readOnly: m,
  children: g,
  ...b
}) => {
  const x = G(null), y = G(null), _ = G(null), [C, w] = V(!1);
  Z(() => {
    C ? (window.addEventListener("click", S), window.addEventListener("keydown", I)) : (window.removeEventListener("click", S), window.removeEventListener("keydown", I)), C && v();
  }, [C]), Zt(() => {
    window.removeEventListener("click", S), window.removeEventListener("keydown", I);
  });
  const v = () => {
    _.current?.querySelector("input")?.focus();
  }, S = ({ target: P }) => {
    y.current?.contains(P) || w(!1);
  }, I = (P) => {
    Fe(P.key) && C && (P.stopPropagation(), w(!1));
  }, T = () => {
    m || w(!0);
  }, R = ({ target: P }) => {
    y.current?.contains(P) || w(!1);
  }, E = () => {
    m || w(!0);
  }, k = ({ key: P }) => {
    Yn(P) && w(!0);
  };
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      "data-testid": yy,
      ref: y,
      className: f(Kt.root, i, {
        [Kt.rootHasWrapperIcon]: !!l,
        [Kt.rootReadOnly]: m
      }),
      children: [
        /* @__PURE__ */ s.jsx(
          Et,
          {
            prefix: r,
            suffix: a,
            disabled: h,
            icon: l,
            active: C,
            status: c,
            children: /* @__PURE__ */ s.jsxs("div", { className: Kt.inputContainer, children: [
              /* @__PURE__ */ s.jsx(
                "input",
                {
                  ...b,
                  id: t,
                  name: t,
                  className: Kt.input,
                  ref: x,
                  onClick: E,
                  onFocus: T,
                  onBlur: R,
                  onKeyDown: k,
                  disabled: h,
                  placeholder: d,
                  autoComplete: "off",
                  value: e,
                  onChange: On(e) ? void 0 : L,
                  readOnly: !0
                }
              ),
              /* @__PURE__ */ s.jsx("div", { className: Kt.iconContainer, children: p && e && /* @__PURE__ */ s.jsx(
                K,
                {
                  className: Kt.clearIcon,
                  variant: "tertiary",
                  icon: "close",
                  disabled: h,
                  onClick: () => n?.("")
                }
              ) }),
              /* @__PURE__ */ s.jsx(
                dy,
                {
                  className: Kt.colorIndicator,
                  onClick: E,
                  color: e,
                  alpha: u?.alpha
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ s.jsx(Jt, { ...o, isOpen: C, children: /* @__PURE__ */ s.jsx("div", { ref: _, children: /* @__PURE__ */ s.jsx(
          Xn,
          {
            margin: "300",
            ...u,
            color: e,
            onChange: n ?? L,
            children: g
          }
        ) }) })
      ]
    }
  );
}, Yk = ({
  className: i,
  input: { value: t, name: e, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => /* @__PURE__ */ s.jsx(
  z,
  {
    className: i,
    label: r,
    labelFor: e,
    meta: a,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ s.jsx(
      _y,
      {
        name: e,
        value: t,
        onChange: n,
        ...o,
        status: z.getStatus(a),
        disabled: c,
        required: l,
        ...m
      }
    )
  }
), Cy = "h-fieldAddonDropdown--fieldAddonDropdown__root", wy = "h-fieldAddonDropdown--fieldAddonDropdown__prefix", vy = "h-fieldAddonDropdown--fieldAddonDropdown__suffix", Sy = "h-fieldAddonDropdown--fieldAddonDropdown__angleDown", kn = {
  root: Cy,
  prefix: wy,
  suffix: vy,
  angleDown: Sy
}, Xk = ({
  className: i,
  noArrow: t,
  ...e
}) => Ws(e) ? null : /* @__PURE__ */ s.jsx(Ns.Consumer, { children: ({ position: n, disabled: o }) => /* @__PURE__ */ s.jsx(
  Js,
  {
    ...yr(e, "meta"),
    noStyle: !0,
    itemComponent: $r,
    children: /* @__PURE__ */ s.jsxs(
      "button",
      {
        className: f(
          kn.root,
          {
            [kn.prefix]: n === "prefix",
            [kn.suffix]: n === "suffix"
          },
          i
        ),
        disabled: o || e.meta.disabled,
        type: "button",
        children: [
          /* @__PURE__ */ s.jsx("span", { children: e.meta.selectedValue }),
          !t && /* @__PURE__ */ s.jsx(
            N,
            {
              name: "angle-down",
              className: f("icon-vertical-fix", kn.angleDown)
            }
          )
        ]
      }
    )
  }
) }), Iy = "h-countryFlag--countryFlag__flag", Dy = "h-countryFlag--countryFlag__ad", ky = "h-countryFlag--countryFlag__ae", Ty = "h-countryFlag--countryFlag__af", jy = "h-countryFlag--countryFlag__ag", Ny = "h-countryFlag--countryFlag__ai", Fy = "h-countryFlag--countryFlag__al", Py = "h-countryFlag--countryFlag__am", Ry = "h-countryFlag--countryFlag__ao", Ey = "h-countryFlag--countryFlag__aq", Ly = "h-countryFlag--countryFlag__ar", Ay = "h-countryFlag--countryFlag__as", $y = "h-countryFlag--countryFlag__at", Oy = "h-countryFlag--countryFlag__au", By = "h-countryFlag--countryFlag__aw", Hy = "h-countryFlag--countryFlag__ax", Wy = "h-countryFlag--countryFlag__az", My = "h-countryFlag--countryFlag__ba", zy = "h-countryFlag--countryFlag__bb", Vy = "h-countryFlag--countryFlag__bd", Ky = "h-countryFlag--countryFlag__be", Uy = "h-countryFlag--countryFlag__bf", qy = "h-countryFlag--countryFlag__bg", Gy = "h-countryFlag--countryFlag__bh", Yy = "h-countryFlag--countryFlag__bi", Xy = "h-countryFlag--countryFlag__bj", Qy = "h-countryFlag--countryFlag__bl", Zy = "h-countryFlag--countryFlag__bm", Jy = "h-countryFlag--countryFlag__bn", t_ = "h-countryFlag--countryFlag__bo", e_ = "h-countryFlag--countryFlag__bq", n_ = "h-countryFlag--countryFlag__br", s_ = "h-countryFlag--countryFlag__bs", o_ = "h-countryFlag--countryFlag__bt", r_ = "h-countryFlag--countryFlag__bv", i_ = "h-countryFlag--countryFlag__bw", a_ = "h-countryFlag--countryFlag__by", l_ = "h-countryFlag--countryFlag__bz", c_ = "h-countryFlag--countryFlag__ca", d_ = "h-countryFlag--countryFlag__cd", h_ = "h-countryFlag--countryFlag__cf", u_ = "h-countryFlag--countryFlag__cg", p_ = "h-countryFlag--countryFlag__ch", m_ = "h-countryFlag--countryFlag__ci", g_ = "h-countryFlag--countryFlag__ck", f_ = "h-countryFlag--countryFlag__cl", b_ = "h-countryFlag--countryFlag__cm", x_ = "h-countryFlag--countryFlag__cn", y_ = "h-countryFlag--countryFlag__co", __ = "h-countryFlag--countryFlag__cp", C_ = "h-countryFlag--countryFlag__cr", w_ = "h-countryFlag--countryFlag__cu", v_ = "h-countryFlag--countryFlag__cv", S_ = "h-countryFlag--countryFlag__cw", I_ = "h-countryFlag--countryFlag__cy", D_ = "h-countryFlag--countryFlag__cz", k_ = "h-countryFlag--countryFlag__de", T_ = "h-countryFlag--countryFlag__dj", j_ = "h-countryFlag--countryFlag__dk", N_ = "h-countryFlag--countryFlag__dm", F_ = "h-countryFlag--countryFlag__dz", P_ = "h-countryFlag--countryFlag__ec", R_ = "h-countryFlag--countryFlag__ee", E_ = "h-countryFlag--countryFlag__eg", L_ = "h-countryFlag--countryFlag__eh", A_ = "h-countryFlag--countryFlag__er", $_ = "h-countryFlag--countryFlag__es", O_ = "h-countryFlag--countryFlag__et", B_ = "h-countryFlag--countryFlag__eu", H_ = "h-countryFlag--countryFlag__fi", W_ = "h-countryFlag--countryFlag__fj", M_ = "h-countryFlag--countryFlag__fm", z_ = "h-countryFlag--countryFlag__fo", V_ = "h-countryFlag--countryFlag__fr", K_ = "h-countryFlag--countryFlag__ga", U_ = "h-countryFlag--countryFlag__gb", q_ = "h-countryFlag--countryFlag__gd", G_ = "h-countryFlag--countryFlag__ge", Y_ = "h-countryFlag--countryFlag__gg", X_ = "h-countryFlag--countryFlag__gh", Q_ = "h-countryFlag--countryFlag__gi", Z_ = "h-countryFlag--countryFlag__gl", J_ = "h-countryFlag--countryFlag__gm", tC = "h-countryFlag--countryFlag__gn", eC = "h-countryFlag--countryFlag__gp", nC = "h-countryFlag--countryFlag__gq", sC = "h-countryFlag--countryFlag__gr", oC = "h-countryFlag--countryFlag__gt", rC = "h-countryFlag--countryFlag__gu", iC = "h-countryFlag--countryFlag__gw", aC = "h-countryFlag--countryFlag__gy", lC = "h-countryFlag--countryFlag__hk", cC = "h-countryFlag--countryFlag__hn", dC = "h-countryFlag--countryFlag__hr", hC = "h-countryFlag--countryFlag__ht", uC = "h-countryFlag--countryFlag__hu", pC = "h-countryFlag--countryFlag__id", mC = "h-countryFlag--countryFlag__ie", gC = "h-countryFlag--countryFlag__il", fC = "h-countryFlag--countryFlag__im", bC = "h-countryFlag--countryFlag__iq", xC = "h-countryFlag--countryFlag__ir", yC = "h-countryFlag--countryFlag__is", _C = "h-countryFlag--countryFlag__it", CC = "h-countryFlag--countryFlag__je", wC = "h-countryFlag--countryFlag__jm", vC = "h-countryFlag--countryFlag__jo", SC = "h-countryFlag--countryFlag__jp", IC = "h-countryFlag--countryFlag__ke", DC = "h-countryFlag--countryFlag__kg", kC = "h-countryFlag--countryFlag__kh", TC = "h-countryFlag--countryFlag__ki", jC = "h-countryFlag--countryFlag__km", NC = "h-countryFlag--countryFlag__kn", FC = "h-countryFlag--countryFlag__kp", PC = "h-countryFlag--countryFlag__kr", RC = "h-countryFlag--countryFlag__kw", EC = "h-countryFlag--countryFlag__ky", LC = "h-countryFlag--countryFlag__kz", AC = "h-countryFlag--countryFlag__la", $C = "h-countryFlag--countryFlag__lb", OC = "h-countryFlag--countryFlag__lc", BC = "h-countryFlag--countryFlag__li", HC = "h-countryFlag--countryFlag__lk", WC = "h-countryFlag--countryFlag__lr", MC = "h-countryFlag--countryFlag__ls", zC = "h-countryFlag--countryFlag__lt", VC = "h-countryFlag--countryFlag__lu", KC = "h-countryFlag--countryFlag__lv", UC = "h-countryFlag--countryFlag__ly", qC = "h-countryFlag--countryFlag__ma", GC = "h-countryFlag--countryFlag__mc", YC = "h-countryFlag--countryFlag__md", XC = "h-countryFlag--countryFlag__me", QC = "h-countryFlag--countryFlag__mf", ZC = "h-countryFlag--countryFlag__mg", JC = "h-countryFlag--countryFlag__mh", tw = "h-countryFlag--countryFlag__mk", ew = "h-countryFlag--countryFlag__ml", nw = "h-countryFlag--countryFlag__mm", sw = "h-countryFlag--countryFlag__mn", ow = "h-countryFlag--countryFlag__mo", rw = "h-countryFlag--countryFlag__mq", iw = "h-countryFlag--countryFlag__mr", aw = "h-countryFlag--countryFlag__ms", lw = "h-countryFlag--countryFlag__mt", cw = "h-countryFlag--countryFlag__mu", dw = "h-countryFlag--countryFlag__mv", hw = "h-countryFlag--countryFlag__mw", uw = "h-countryFlag--countryFlag__mx", pw = "h-countryFlag--countryFlag__my", mw = "h-countryFlag--countryFlag__mz", gw = "h-countryFlag--countryFlag__na", fw = "h-countryFlag--countryFlag__nc", bw = "h-countryFlag--countryFlag__ne", xw = "h-countryFlag--countryFlag__ng", yw = "h-countryFlag--countryFlag__ni", _w = "h-countryFlag--countryFlag__nl", Cw = "h-countryFlag--countryFlag__no", ww = "h-countryFlag--countryFlag__np", vw = "h-countryFlag--countryFlag__nq", Sw = "h-countryFlag--countryFlag__nr", Iw = "h-countryFlag--countryFlag__nu", Dw = "h-countryFlag--countryFlag__nz", kw = "h-countryFlag--countryFlag__om", Tw = "h-countryFlag--countryFlag__pa", jw = "h-countryFlag--countryFlag__pe", Nw = "h-countryFlag--countryFlag__pf", Fw = "h-countryFlag--countryFlag__pg", Pw = "h-countryFlag--countryFlag__ph", Rw = "h-countryFlag--countryFlag__pk", Ew = "h-countryFlag--countryFlag__pl", Lw = "h-countryFlag--countryFlag__pr", Aw = "h-countryFlag--countryFlag__ps", $w = "h-countryFlag--countryFlag__pt", Ow = "h-countryFlag--countryFlag__pw", Bw = "h-countryFlag--countryFlag__py", Hw = "h-countryFlag--countryFlag__qa", Ww = "h-countryFlag--countryFlag__re", Mw = "h-countryFlag--countryFlag__ro", zw = "h-countryFlag--countryFlag__rs", Vw = "h-countryFlag--countryFlag__ru", Kw = "h-countryFlag--countryFlag__rw", Uw = "h-countryFlag--countryFlag__sa", qw = "h-countryFlag--countryFlag__sb", Gw = "h-countryFlag--countryFlag__sc", Yw = "h-countryFlag--countryFlag__sd", Xw = "h-countryFlag--countryFlag__se", Qw = "h-countryFlag--countryFlag__sg", Zw = "h-countryFlag--countryFlag__sh", Jw = "h-countryFlag--countryFlag__si", tv = "h-countryFlag--countryFlag__sj", ev = "h-countryFlag--countryFlag__sk", nv = "h-countryFlag--countryFlag__sl", sv = "h-countryFlag--countryFlag__sm", ov = "h-countryFlag--countryFlag__sn", rv = "h-countryFlag--countryFlag__so", iv = "h-countryFlag--countryFlag__sr", av = "h-countryFlag--countryFlag__ss", lv = "h-countryFlag--countryFlag__st", cv = "h-countryFlag--countryFlag__sv", dv = "h-countryFlag--countryFlag__sx", hv = "h-countryFlag--countryFlag__sy", uv = "h-countryFlag--countryFlag__sz", pv = "h-countryFlag--countryFlag__tc", mv = "h-countryFlag--countryFlag__td", gv = "h-countryFlag--countryFlag__tg", fv = "h-countryFlag--countryFlag__th", bv = "h-countryFlag--countryFlag__tj", xv = "h-countryFlag--countryFlag__tl", yv = "h-countryFlag--countryFlag__tm", _v = "h-countryFlag--countryFlag__tn", Cv = "h-countryFlag--countryFlag__to", wv = "h-countryFlag--countryFlag__tr", vv = "h-countryFlag--countryFlag__tt", Sv = "h-countryFlag--countryFlag__tv", Iv = "h-countryFlag--countryFlag__tw", Dv = "h-countryFlag--countryFlag__tz", kv = "h-countryFlag--countryFlag__ua", Tv = "h-countryFlag--countryFlag__ug", jv = "h-countryFlag--countryFlag__us", Nv = "h-countryFlag--countryFlag__uy", Fv = "h-countryFlag--countryFlag__uz", Pv = "h-countryFlag--countryFlag__va", Rv = "h-countryFlag--countryFlag__vc", Ev = "h-countryFlag--countryFlag__ve", Lv = "h-countryFlag--countryFlag__vg", Av = "h-countryFlag--countryFlag__vi", $v = "h-countryFlag--countryFlag__vn", Ov = "h-countryFlag--countryFlag__vu", Bv = "h-countryFlag--countryFlag__ws", Hv = "h-countryFlag--countryFlag__ye", Wv = "h-countryFlag--countryFlag__yt", Mv = "h-countryFlag--countryFlag__za", zv = "h-countryFlag--countryFlag__zm", Vv = "h-countryFlag--countryFlag__zw", ir = {
  flag: Iy,
  ad: Dy,
  ae: ky,
  af: Ty,
  ag: jy,
  ai: Ny,
  al: Fy,
  am: Py,
  ao: Ry,
  aq: Ey,
  ar: Ly,
  as: Ay,
  at: $y,
  au: Oy,
  aw: By,
  ax: Hy,
  az: Wy,
  ba: My,
  bb: zy,
  bd: Vy,
  be: Ky,
  bf: Uy,
  bg: qy,
  bh: Gy,
  bi: Yy,
  bj: Xy,
  bl: Qy,
  bm: Zy,
  bn: Jy,
  bo: t_,
  bq: e_,
  br: n_,
  bs: s_,
  bt: o_,
  bv: r_,
  bw: i_,
  by: a_,
  bz: l_,
  ca: c_,
  cd: d_,
  cf: h_,
  cg: u_,
  ch: p_,
  ci: m_,
  ck: g_,
  cl: f_,
  cm: b_,
  cn: x_,
  co: y_,
  cp: __,
  cr: C_,
  cu: w_,
  cv: v_,
  cw: S_,
  cy: I_,
  cz: D_,
  de: k_,
  dj: T_,
  dk: j_,
  dm: N_,
  do: "h-countryFlag--countryFlag__do",
  dz: F_,
  ec: P_,
  ee: R_,
  eg: E_,
  eh: L_,
  er: A_,
  es: $_,
  et: O_,
  eu: B_,
  fi: H_,
  fj: W_,
  fm: M_,
  fo: z_,
  fr: V_,
  ga: K_,
  gb: U_,
  gd: q_,
  ge: G_,
  gg: Y_,
  gh: X_,
  gi: Q_,
  gl: Z_,
  gm: J_,
  gn: tC,
  gp: eC,
  gq: nC,
  gr: sC,
  gt: oC,
  gu: rC,
  gw: iC,
  gy: aC,
  hk: lC,
  hn: cC,
  hr: dC,
  ht: hC,
  hu: uC,
  id: pC,
  ie: mC,
  il: gC,
  im: fC,
  in: "h-countryFlag--countryFlag__in",
  iq: bC,
  ir: xC,
  is: yC,
  it: _C,
  je: CC,
  jm: wC,
  jo: vC,
  jp: SC,
  ke: IC,
  kg: DC,
  kh: kC,
  ki: TC,
  km: jC,
  kn: NC,
  kp: FC,
  kr: PC,
  kw: RC,
  ky: EC,
  kz: LC,
  la: AC,
  lb: $C,
  lc: OC,
  li: BC,
  lk: HC,
  lr: WC,
  ls: MC,
  lt: zC,
  lu: VC,
  lv: KC,
  ly: UC,
  ma: qC,
  mc: GC,
  md: YC,
  me: XC,
  mf: QC,
  mg: ZC,
  mh: JC,
  mk: tw,
  ml: ew,
  mm: nw,
  mn: sw,
  mo: ow,
  mq: rw,
  mr: iw,
  ms: aw,
  mt: lw,
  mu: cw,
  mv: dw,
  mw: hw,
  mx: uw,
  my: pw,
  mz: mw,
  na: gw,
  nc: fw,
  ne: bw,
  ng: xw,
  ni: yw,
  nl: _w,
  no: Cw,
  np: ww,
  nq: vw,
  nr: Sw,
  nu: Iw,
  nz: Dw,
  om: kw,
  pa: Tw,
  pe: jw,
  pf: Nw,
  pg: Fw,
  ph: Pw,
  pk: Rw,
  pl: Ew,
  pr: Lw,
  ps: Aw,
  pt: $w,
  pw: Ow,
  py: Bw,
  qa: Hw,
  re: Ww,
  ro: Mw,
  rs: zw,
  ru: Vw,
  rw: Kw,
  sa: Uw,
  sb: qw,
  sc: Gw,
  sd: Yw,
  se: Xw,
  sg: Qw,
  sh: Zw,
  si: Jw,
  sj: tv,
  sk: ev,
  sl: nv,
  sm: sv,
  sn: ov,
  so: rv,
  sr: iv,
  ss: av,
  st: lv,
  sv: cv,
  sx: dv,
  sy: hv,
  sz: uv,
  tc: pv,
  td: mv,
  tg: gv,
  th: fv,
  tj: bv,
  tl: xv,
  tm: yv,
  tn: _v,
  to: Cv,
  tr: wv,
  tt: vv,
  tv: Sv,
  tw: Iv,
  tz: Dv,
  ua: kv,
  ug: Tv,
  us: jv,
  uy: Nv,
  uz: Fv,
  va: Pv,
  vc: Rv,
  ve: Ev,
  vg: Lv,
  vi: Av,
  vn: $v,
  vu: Ov,
  ws: Bv,
  ye: Hv,
  yt: Wv,
  za: Mv,
  zm: zv,
  zw: Vv
}, Kv = 127365, Uv = /^[a-z]{2}$/, qv = (i) => Uv.test(i) ? String.fromCodePoint(
  ...i.split("").map((t) => Kv + t.charCodeAt(0))
) : "", Qk = ({
  className: i,
  countryCode: t,
  size: e = 16
}) => navigator.userAgent.includes("Windows") ? /* @__PURE__ */ s.jsx(at, { style: { width: e, height: e }, children: /* @__PURE__ */ s.jsx(
  at,
  {
    className: f(ir.flag, ir[t], i),
    style: {
      width: 32,
      height: 32,
      transform: `scale(calc(${e} / 32))`
    }
  }
) }) : /* @__PURE__ */ s.jsx("span", { className: i, style: { fontSize: e }, children: qv(t) }), Zk = [
  "ad",
  "ae",
  "af",
  "ag",
  "ai",
  "al",
  "am",
  "ao",
  "ar",
  "as",
  "at",
  "au",
  "aw",
  "az",
  "ba",
  "bb",
  "bd",
  "be",
  "bf",
  "bg",
  "bh",
  "bi",
  "bj",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "bt",
  "bw",
  "by",
  "bz",
  "ca",
  "cd",
  "cf",
  "cg",
  "ch",
  "ci",
  "ck",
  "cl",
  "cm",
  "cn",
  "co",
  "cr",
  "cu",
  "cv",
  "cw",
  "cy",
  "cz",
  "de",
  "dj",
  "dk",
  "dm",
  "do",
  "dz",
  "ec",
  "ee",
  "eg",
  "er",
  "es",
  "et",
  "fi",
  "fj",
  "fk",
  "fm",
  "fo",
  "fr",
  "bl",
  "mf",
  "ga",
  "gb",
  "gd",
  "ge",
  "gf",
  "gh",
  "gi",
  "gl",
  "gm",
  "gn",
  "gp",
  "gq",
  "gr",
  "gt",
  "gu",
  "gw",
  "gy",
  "hk",
  "hn",
  "hr",
  "ht",
  "hu",
  "id",
  "ie",
  "il",
  "in",
  "io",
  "iq",
  "ir",
  "is",
  "it",
  "jm",
  "jo",
  "jp",
  "ke",
  "kg",
  "kh",
  "ki",
  "km",
  "kn",
  "kp",
  "kr",
  "kw",
  "ky",
  "kz",
  "la",
  "lb",
  "lc",
  "li",
  "lk",
  "lr",
  "ls",
  "lt",
  "lu",
  "lv",
  "ly",
  "ma",
  "mc",
  "md",
  "me",
  "mg",
  "mh",
  "mk",
  "ml",
  "mm",
  "mn",
  "mo",
  "mp",
  "mq",
  "mr",
  "ms",
  "mt",
  "mu",
  "mv",
  "mw",
  "mx",
  "my",
  "mz",
  "na",
  "nc",
  "ne",
  "nf",
  "ng",
  "ni",
  "nl",
  "bq",
  "no",
  "np",
  "nr",
  "nu",
  "nz",
  "om",
  "pa",
  "pe",
  "pf",
  "pg",
  "ph",
  "pk",
  "pl",
  "pm",
  "pr",
  "ps",
  "pt",
  "pw",
  "py",
  "qa",
  "re",
  "ro",
  "rs",
  "ru",
  "rw",
  "sa",
  "sb",
  "sc",
  "sd",
  "se",
  "sg",
  "sh",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sr",
  "ss",
  "st",
  "sv",
  "sx",
  "sy",
  "sz",
  "tc",
  "td",
  "tg",
  "th",
  "tj",
  "tk",
  "tl",
  "tm",
  "tn",
  "to",
  "tr",
  "tt",
  "tv",
  "tw",
  "tz",
  "ua",
  "ug",
  "us",
  "uy",
  "uz",
  "va",
  "vc",
  "ve",
  "vg",
  "vi",
  "vn",
  "vu",
  "wf",
  "ws",
  "ye",
  "za",
  "zm",
  "zw"
], Gv = "h-formGrid--formGrid__root", Yv = {
  root: Gv
}, Xv = "formGridTestId", Jk = $(function({ className: t, children: e, ...n }, o) {
  const r = f(Yv.root, t);
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-testid": Xv,
      className: r,
      ...n,
      ref: o,
      children: e
    }
  );
}), Qv = "h-formGrid-field--formField__root", Zv = "h-formGrid-field--formField__rootSpan5", Jv = "h-formGrid-field--formField__rootSpan4", tS = "h-formGrid-field--formField__rootSpan3", eS = "h-formGrid-field--formField__rootSpan2", nS = "h-formGrid-field--formField__rootSpan1", Se = {
  root: Qv,
  rootSpan5: Zv,
  rootSpan4: Jv,
  rootSpan3: tS,
  rootSpan2: eS,
  rootSpan1: nS
}, sS = "formFieldTestId", oS = {
  1: Se.rootSpan1,
  2: Se.rootSpan2,
  3: Se.rootSpan3,
  4: Se.rootSpan4,
  5: Se.rootSpan5,
  6: void 0
};
class tT extends D {
  static defaultProps = {
    span: 6
  };
  render() {
    const { span: t, className: e, children: n, ...o } = this.props, r = f(
      Se.root,
      e,
      oS[t]
    );
    return /* @__PURE__ */ s.jsx("div", { "data-testid": sS, className: r, ...o, children: n });
  }
}
const rS = "h-helperField--helperField__root", iS = "h-helperField--helperField__label", aS = "h-helperField--helperField__helpIcon", lS = "h-helperField--helperField__error", cS = "h-helperField--helperField__rootRequired", qe = {
  root: rS,
  label: iS,
  helpIcon: aS,
  error: lS,
  rootRequired: cS
};
class eT extends D {
  render() {
    const {
      className: t,
      label: e,
      required: n,
      disabled: o,
      errorMessage: r,
      fieldId: a,
      children: l,
      helpIcon: c,
      ...d
    } = this.props, h = f(
      {
        [qe.root]: !0,
        [qe.rootRequired]: n
      },
      t
    );
    return /* @__PURE__ */ s.jsxs("div", { ...d, className: h, children: [
      !!e && /* @__PURE__ */ s.jsx(
        "label",
        {
          className: qe.label,
          htmlFor: a,
          id: `${a}-label`,
          children: e
        }
      ),
      !!c?.text && /* @__PURE__ */ s.jsx(
        qs,
        {
          ...c,
          className: f(qe.helpIcon, c?.className ?? "")
        }
      ),
      !!r && /* @__PURE__ */ s.jsx("p", { className: qe.error, children: r }),
      l
    ] });
  }
}
const dS = "h-inputDuration--inputDuration__root", hS = {
  root: dS
}, Ss = (i, t = [
  "hours",
  "minutes",
  "seconds"
]) => {
  const e = Math.floor(i / 1e3), n = {};
  let o = e;
  return t.includes("days") && (n.days = Math.floor(e / (24 * 3600)), o = e % (24 * 3600)), t.includes("hours") && (n.hours = Math.floor(o / 3600), o %= 3600), t.includes("minutes") && (n.minutes = Math.floor(o / 60), o %= 60), t.includes("seconds") && (n.seconds = o), n;
}, Is = (i) => ((i.days ?? 0) * 86400 + (i.hours ?? 0) * 3600 + (i.minutes ?? 0) * 60 + (i.seconds ?? 0)) * 1e3, uS = [
  "hours",
  "minutes",
  "seconds"
], nT = $(
  function(t, e) {
    const n = G(null);
    je(e, () => n.current);
    const {
      className: o,
      name: r = "input-duration",
      value: a = 0,
      required: l = !1,
      disabled: c = !1,
      readOnly: d = !1,
      inputParts: h = uS,
      status: u,
      onChange: p,
      onBlur: m
    } = t, [g, b] = V(
      () => Ss(a, h)
    );
    Z(() => {
      const w = Is(g);
      if (a !== w) {
        const v = Ss(a, h);
        b(v);
      }
    }, [a, h]);
    const x = F(
      (w, v) => {
        const S = Math.max(0, parseInt(v) || 0);
        if ((w === "minutes" || w === "seconds") && S > 60)
          return;
        const I = { ...g, [w]: S };
        b(I);
        const T = Is(I);
        p?.(T);
      },
      [g, p]
    ), y = F(() => {
      const w = Is(g), v = Ss(
        w,
        h
      );
      b(v), m?.();
    }, [g, h, m]), _ = (w) => {
      const v = g[w] ?? 0, S = v === 0;
      return {
        type: "number",
        id: `${r}-${w}`,
        name: `${r}-${w}`,
        value: S ? "" : v,
        placeholder: S ? "0" : void 0,
        suffix: {
          type: "custom",
          value: w.charAt(0).toUpperCase() + w.slice(1)
        },
        min: 0,
        step: 1,
        required: l,
        disabled: c,
        readOnly: d,
        status: u,
        "aria-required": l,
        "aria-disabled": c,
        "aria-readonly": d,
        onBlur: y,
        onChange: (I) => x(w, I.target.value)
      };
    }, C = f(o, hS.root);
    return /* @__PURE__ */ s.jsxs("div", { ref: n, className: C, children: [
      h.includes("days") && /* @__PURE__ */ s.jsx(qt, { ..._("days") }),
      h.includes("hours") && /* @__PURE__ */ s.jsx(qt, { ..._("hours") }),
      h.includes("minutes") && /* @__PURE__ */ s.jsx(qt, { ..._("minutes"), max: 60 }),
      h.includes("seconds") && /* @__PURE__ */ s.jsx(qt, { ..._("seconds"), max: 60 })
    ] });
  }
), Ge = /* @__PURE__ */ new Map();
function pS({
  containerId: i,
  children: t
}) {
  const [e, n] = V(null), o = (a) => {
    const l = Ge.get(i);
    l !== void 0 && Ge.set(i, l + a);
  }, r = () => {
    const a = document.createElement("div");
    return a.id = i, a;
  };
  return Z(() => {
    let a = document.getElementById(i);
    return a || (a = r(), document.body.appendChild(a), Ge.set(i, 0)), n(a), o(1), () => {
      o(-1), Ge.get(i) === 0 && a && (Ge.delete(i), a.remove());
    };
  }, [i]), e ? Ki.createPortal(t, e) : null;
}
const mS = "h-modal--modal__root", gS = "h-modal--modal__rootSkipAnimation", fS = "h-modal--modal__modalContainer", bS = "h-modal--modal__modalContent", xS = "h-modal--modal__rootDisplayed", yS = "h-modal--modal__rootOpened", _S = "h-modal--modal__modal", re = {
  root: mS,
  rootSkipAnimation: gS,
  modalContainer: fS,
  modalContent: bS,
  rootDisplayed: xS,
  rootOpened: yS,
  modal: _S
};
class CS extends D {
  rootRef;
  haskeydownEventListner;
  closeTimer;
  static defaultProps = {
    allowEscClose: !0,
    restoreFocus: !0,
    bringInFocusOnTab: !0
  };
  constructor(t) {
    super(t), this.rootRef = O(), this.closeTimer = null, this.state = {
      opened: !1,
      displayed: !1
    }, this.haskeydownEventListner = !1, this.animateOpening = this.animateOpening.bind(this), this.animateClosing = this.animateClosing.bind(this), this.onTransitionEnd = this.onTransitionEnd.bind(this), this.handleKey = this.handleKey.bind(this);
  }
  componentDidMount() {
    const { isOpen: t } = this.props;
    t && this.animateOpening();
  }
  componentDidUpdate(t) {
    const { isOpen: e, allowEscClose: n } = this.props, { isOpen: o } = t;
    n && !this.haskeydownEventListner && (window.addEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !0), e !== o && (e ? this.animateOpening() : this.animateClosing());
  }
  componentWillUnmount() {
    this.cancelAnimation(), this.removeKeyDownEventListener();
  }
  handleKey(t) {
    const { isOpen: e, onClose: n } = this.props;
    e && Fe(t.key) && (this.rootRef.current?.querySelector(
      '[role="menu"][aria-expanded="true"]'
    ) || (t.preventDefault(), t.stopPropagation(), this.animateClosing(), n(t)));
  }
  removeKeyDownEventListener = () => {
    window.removeEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !1;
  };
  cancelAnimation() {
    const { current: t } = this.rootRef;
    t && t.removeEventListener("transitionend", this.onTransitionEnd), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null);
  }
  animateOpening() {
    const { skipAnimation: t } = this.props;
    t ? this.setState({ displayed: !0, opened: !0 }) : (this.setState({ displayed: !0 }), setTimeout(() => this.setState({ opened: !0 })));
  }
  animateClosing() {
    const { skipAnimation: t } = this.props;
    this.removeKeyDownEventListener(), t ? this.setState({ opened: !1, displayed: !1 }) : (this.rootRef.current && this.rootRef.current.addEventListener(
      "transitionend",
      this.onTransitionEnd
    ), this.setState({ opened: !1 }), this.closeIfNoTransitionOccurred());
  }
  closeIfNoTransitionOccurred() {
    this.closeTimer = setTimeout(() => {
      this.closeTimer && this.onTransitionEnd();
    }, 400);
  }
  onTransitionEnd() {
    this.setState({ displayed: !1 }), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null), this.rootRef.current && this.rootRef.current.removeEventListener(
      "transitionend",
      this.onTransitionEnd
    );
  }
  render() {
    const {
      className: t,
      isOpen: e,
      children: n,
      onClose: o,
      allowClickOutside: r,
      allowEscClose: a,
      // Stops allowEscClose from being passed in with otherProps
      skipAnimation: l,
      wrapProps: c,
      autoFocus: d,
      restoreFocus: h,
      bringInFocusOnTab: u,
      ...p
    } = this.props, { displayed: m, opened: g } = this.state, b = f(re.root, c?.className, {
      [re.rootDisplayed]: m,
      [re.rootOpened]: g,
      [re.rootSkipAnimation]: l
    }), x = f(re.modal, t);
    return /* @__PURE__ */ s.jsx(pS, { containerId: "modal-container", children: /* @__PURE__ */ s.jsx("div", { ...c, className: b, children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: re.modalContainer,
        ref: this.rootRef,
        ...r ? { onClick: o } : {},
        ...p,
        children: g && // fixes an issue with child-components that need to measure boundingClientRect
        /* @__PURE__ */ s.jsx(
          vr,
          {
            containerRef: this.rootRef,
            autoFocus: d,
            restoreFocus: h,
            bringInFocusOnTab: u,
            children: /* @__PURE__ */ s.jsx("div", { className: re.modalContent, children: /* @__PURE__ */ s.jsx(
              "div",
              {
                className: x,
                onClick: (y) => r && y.stopPropagation(),
                children: n
              }
            ) })
          }
        )
      }
    ) }) });
  }
}
const wS = "h-lightbox--lightbox__lightSource", vS = "h-lightbox--lightbox__closeButton", SS = "h-lightbox--lightbox__downloadButton", IS = "h-lightbox--lightbox__image", DS = "h-lightbox--lightbox__loadingContainer", kS = "h-lightbox--lightbox__navButton", TS = "h-lightbox--lightbox__navButtonPrevious", jS = "h-lightbox--lightbox__navButtonNext", NS = "h-lightbox--lightbox__counter", kt = {
  lightSource: wS,
  closeButton: vS,
  downloadButton: SS,
  image: IS,
  loadingContainer: DS,
  navButton: kS,
  navButtonPrevious: TS,
  navButtonNext: jS,
  counter: NS
};
class sT extends D {
  render() {
    const {
      className: t,
      src: e,
      alt: n,
      isOpen: o,
      onClose: r,
      showNavigation: a = !1,
      currentIndex: l = 0,
      totalImages: c = 1,
      onPrevious: d,
      onNext: h,
      isLoading: u = !1
    } = this.props, p = c > 1;
    return /* @__PURE__ */ s.jsx(
      CS,
      {
        className: t,
        isOpen: o,
        allowClickOutside: !0,
        onClose: r,
        children: /* @__PURE__ */ s.jsxs("div", { className: kt.lightSource, children: [
          u ? /* @__PURE__ */ s.jsx("div", { className: kt.loadingContainer, children: /* @__PURE__ */ s.jsx(Un, { size: 64 }) }) : e && /* @__PURE__ */ s.jsx(Vs, { className: kt.image, alt: n, src: e }),
          r && /* @__PURE__ */ s.jsx(
            K,
            {
              onClick: r,
              icon: "close",
              variant: "secondary",
              className: kt.closeButton
            }
          ),
          e && typeof e == "string" && /* @__PURE__ */ s.jsx(
            "a",
            {
              href: e,
              target: "_blank",
              download: !0,
              className: kt.downloadButton,
              rel: "noreferrer",
              children: /* @__PURE__ */ s.jsx(
                N,
                {
                  name: "cloud-download",
                  className: f("icon-vertical-fix")
                }
              )
            }
          ),
          a && p && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx(
              K,
              {
                icon: "arrow-left",
                variant: "primary",
                size: "large",
                onClick: d,
                className: `${kt.navButton} ${kt.navButtonPrevious}`
              }
            ),
            /* @__PURE__ */ s.jsx(
              K,
              {
                icon: "arrow-right",
                variant: "primary",
                size: "large",
                onClick: h,
                className: `${kt.navButton} ${kt.navButtonNext}`
              }
            ),
            /* @__PURE__ */ s.jsxs("div", { className: kt.counter, children: [
              l + 1,
              " / ",
              c
            ] })
          ] })
        ] })
      }
    );
  }
}
const FS = "h-list-items--item__root", PS = "h-list-items--item__rootWithHoverEffect", RS = "h-list-items--item__rootDense", ES = "h-list-items--item__rootLarge", LS = "h-list-items--item__contentLeft", AS = "h-list-items--item__contentRight", $S = "h-list-items--item__titles", OS = "h-list-items--item__title", BS = "h-list-items--item__titleSecondary", HS = "h-list-items--item__arrow", Tt = {
  root: FS,
  rootWithHoverEffect: PS,
  rootDense: RS,
  rootLarge: ES,
  contentLeft: LS,
  contentRight: AS,
  titles: $S,
  title: OS,
  titleSecondary: BS,
  arrow: HS
};
class ts extends D {
  static defaultProps = {
    variant: "dense",
    withHoverEffect: !0
  };
  renderTitle() {
    const { title: t, titleSecondary: e } = this.props;
    return t || e ? /* @__PURE__ */ s.jsxs("div", { className: Tt.titles, children: [
      !!t && /* @__PURE__ */ s.jsx(A.Paragraph, { as: "div", variant: "2", className: Tt.title, children: t }),
      !!e && /* @__PURE__ */ s.jsx(
        A.Paragraph,
        {
          as: "div",
          variant: "4",
          subdued: !0,
          className: Tt.titleSecondary,
          children: e
        }
      )
    ] }) : null;
  }
  renderContentLeft() {
    const { contentLeft: t } = this.props;
    return t ? /* @__PURE__ */ s.jsx("div", { className: Tt.contentLeft, children: t }) : null;
  }
  renderContentRight() {
    const { contentRight: t } = this.props;
    return t ? /* @__PURE__ */ s.jsx("div", { className: Tt.contentRight, children: t }) : null;
  }
  renderIcon() {
    const { isLink: t, contentRight: e } = this.props;
    return t && !e ? /* @__PURE__ */ s.jsx(
      N,
      {
        className: f(Tt.arrow, "icon-vertical-fix"),
        name: "angle-right",
        size: 24
      }
    ) : null;
  }
  renderContent() {
    return /* @__PURE__ */ s.jsxs(Qt, { children: [
      this.renderContentLeft(),
      this.renderTitle(),
      this.renderContentRight(),
      this.renderIcon()
    ] });
  }
  getChildrenWithFallback() {
    return this.props.children ?? this.renderContent();
  }
  render() {
    const {
      className: t,
      children: e,
      contentLeft: n,
      contentRight: o,
      title: r,
      titleSecondary: a,
      secondaryTitleBelow: l,
      isLink: c,
      variant: d,
      withHoverEffect: h,
      ...u
    } = this.props, p = f(Tt.root, t, {
      [Tt.rootDense]: d === "dense",
      [Tt.rootLarge]: d === "large",
      [Tt.rootWithHoverEffect]: h
    });
    return /* @__PURE__ */ s.jsx("li", { ...u, className: p, children: this.getChildrenWithFallback() });
  }
}
const WS = "h-list-items--keyValue__root", MS = {
  root: WS
};
class zS extends D {
  static defaultProps = {
    hideIfValueIsEmpty: !0
  };
  isValueEmpty() {
    return !this.props.pair.value;
  }
  render() {
    const { hideIfValueIsEmpty: t, className: e, pair: n, ...o } = this.props, r = f(MS.root, e);
    return t && this.isValueEmpty() ? null : /* @__PURE__ */ s.jsx(
      ts,
      {
        ...o,
        className: r,
        title: /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "4", subdued: !0, children: n.key }),
        titleSecondary: /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "2", children: n.value }),
        "data-testid": "List-KeyValue"
      }
    );
  }
}
const VS = "h-list-items--text__root", KS = {
  root: VS
};
class US extends D {
  render() {
    const { children: t, className: e, ...n } = this.props, o = f(KS.root, e);
    return /* @__PURE__ */ s.jsx(
      ts,
      {
        ...n,
        className: o,
        "data-testid": "List-Text",
        children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: t })
      }
    );
  }
}
const qS = "h-list-items--user__root", GS = "h-list-items--user__avatarWrapper", ar = {
  root: qS,
  avatarWrapper: GS
};
class YS extends D {
  getTitle() {
    const { user: t, title: e } = this.props;
    return e || t.display_name || t.name || t.phone_number || t.id;
  }
  getSubTitle() {
    const { user: t, titleSecondary: e } = this.props;
    return e || t.email;
  }
  render() {
    const { className: t, user: e, title: n, titleSecondary: o, ...r } = this.props, a = f(t, ar.root);
    return /* @__PURE__ */ s.jsx(
      ts,
      {
        className: a,
        contentLeft: /* @__PURE__ */ s.jsx("div", { className: ar.avatarWrapper, children: /* @__PURE__ */ s.jsx(wr, { user: e }) }),
        title: this.getTitle(),
        titleSecondary: this.getSubTitle(),
        "data-testid": "<List.User>",
        ...r
      }
    );
  }
}
const XS = "h-list--list__root", QS = {
  root: XS
};
class ZS extends D {
  static Item = ts;
  static Text = US;
  static User = YS;
  static KeyValue = zS;
  render() {
    const { className: t, ...e } = this.props;
    return /* @__PURE__ */ s.jsx("ul", { ...e, className: f(QS.root, t) });
  }
}
const oT = an(ZS, {
  fallback: null
}), JS = () => {
  document.exitFullscreen && document.exitFullscreen();
}, tI = (i) => {
  i.requestFullscreen ? i.requestFullscreen() : i.mozRequestFullScreen ? i.mozRequestFullScreen() : i.webkitRequestFullscreen ? i.webkitRequestFullscreen() : i.msRequestFullscreen && i.msRequestFullscreen();
}, eI = (i) => document.fullscreenElement === i;
class nI extends Error {
  status;
  url;
  response;
  constructor(t) {
    super(`NetworkError ${t.status} ${t.url}`), this.status = t.status, this.url = t.url, this.response = t;
  }
}
const sI = {
  fetch: (i, ...t) => fetch(i, ...t).then((e) => {
    if (!(e.status >= 200 && e.status < 300))
      throw new nI(e);
    return e;
  })
}, oI = "h-mediaPlayer--mediaPlayer__root", rI = "h-mediaPlayer--mediaPlayer__controls", iI = "h-mediaPlayer--mediaPlayer__unstyled", aI = "h-mediaPlayer--mediaPlayer__rootFullScreen", lI = "h-mediaPlayer--mediaPlayer__rootHideControls", cI = "h-mediaPlayer--mediaPlayer__control", dI = "h-mediaPlayer--mediaPlayer__progress", hI = "h-mediaPlayer--mediaPlayer__progressSlider", uI = "h-mediaPlayer--mediaPlayer__volumeSlider", pI = "h-mediaPlayer--mediaPlayer__timestamp", mI = "h-mediaPlayer--mediaPlayer__videoWrapper", gI = "h-mediaPlayer--mediaPlayer__rootWaiting", fI = "h-mediaPlayer--mediaPlayer__rootAudio", bI = "h-mediaPlayer--mediaPlayer__video", xI = "h-mediaPlayer--mediaPlayer__volume", yI = "h-mediaPlayer--mediaPlayer__volumeMuteControl", _I = "h-mediaPlayer--mediaPlayer__downloadLink", J = {
  root: oI,
  controls: rI,
  unstyled: iI,
  rootFullScreen: aI,
  rootHideControls: lI,
  control: cI,
  progress: dI,
  progressSlider: hI,
  volumeSlider: uI,
  timestamp: pI,
  videoWrapper: mI,
  rootWaiting: gI,
  rootAudio: fI,
  video: bI,
  volume: xI,
  volumeMuteControl: yI,
  downloadLink: _I
};
function CI(i) {
  const t = i >= 3600 ? 8 : 5;
  return Number.isNaN(i) || !Number.isFinite(i) ? "00:00" : new Date(i * 1e3).toISOString().substr(19 - t, t);
}
class rT extends D {
  intersectionObserver;
  static defaultProps = {
    headers: {}
  };
  constructor(t) {
    super(t), this.state = {
      src: void 0,
      playing: !1,
      actuallyPlaying: !1,
      duration: 0,
      time: 0,
      prevVolume: 1,
      volume: 100,
      isFullScreen: !1,
      hideControls: !1,
      isWaiting: !1,
      buffer: null,
      asyncStatus: null
    }, this.updateBuffer = this.updateBuffer.bind(this), this.updateProgress = this.updateProgress.bind(this), this.handleMute = this.handleMute.bind(this), this.handlePlaying = this.handlePlaying.bind(this), this.handleWaiting = this.handleWaiting.bind(this), this.handleEnded = this.handleEnded.bind(this), this.handleError = this.handleError.bind(this), this.seek = this.seek.bind(this), this.handleIntersection = this.handleIntersection.bind(this), this.handleTogglePlayClick = this.handleTogglePlayClick.bind(this), this.handleFullscreenToggle = this.handleFullscreenToggle.bind(this), this.handleFullscreenChange = this.handleFullscreenChange.bind(this), this.startHideControlCountdown = this.startHideControlCountdown.bind(this);
  }
  componentDidMount() {
    const { lazy: t } = this.props, { current: e } = this.playerRef;
    e && e.addEventListener("fullscreenchange", this.handleFullscreenChange), t ? this.createIntersectionObserver() : this.loadSrc();
  }
  componentDidUpdate(t, e) {
    const {
      mediaFile: { src: n }
    } = t, {
      lazy: o,
      mediaFile: { src: r }
    } = this.props;
    n !== r && (o ? this.setSrc() : this.loadSrc()), this.tryReloadPlayer(e);
  }
  componentWillUnmount() {
    const { current: t } = this.playerRef;
    t && t.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    ), window.removeEventListener("mousemove", this.startHideControlCountdown), this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.controller.abort();
  }
  videoRef = O();
  playerRef = O();
  hideControlsTimeout = void 0;
  controller = new AbortController();
  loadSrc() {
    const {
      mediaFile: { src: t },
      isPrivateFile: e
    } = this.props;
    this.tryStopPlayer(), e ? this.fetchFile() : this.setSrc(t);
  }
  setSrc(t) {
    this.setState({
      src: t
    });
  }
  handleIntersection([t]) {
    const { src: e, asyncStatus: n } = this.state;
    !e && !(n === "loading") && t.isIntersecting && (this.loadSrc(), this.intersectionObserver?.disconnect());
  }
  createIntersectionObserver() {
    const { current: t } = this.playerRef;
    t && (this.intersectionObserver = new IntersectionObserver(
      this.handleIntersection,
      { threshold: 1 }
    ), this.intersectionObserver.observe(t));
  }
  tryStopPlayer() {
    const { current: t } = this.videoRef;
    if (!t)
      return;
    t.currentTime = 0;
    const { playing: e, actuallyPlaying: n } = this.state;
    e && n && (t.pause(), this.setState({ playing: !1, actuallyPlaying: !1 }));
  }
  tryReloadPlayer(t) {
    const { current: e } = this.videoRef;
    if (!e)
      return;
    const { src: n } = this.state;
    n !== t.src && e.load();
  }
  fetchFile(t) {
    const {
      mediaFile: { src: e },
      headers: n,
      filename: o
    } = this.props;
    this.setState({ asyncStatus: "loading" });
    const r = new Headers(n);
    sI.fetch(e, {
      headers: r,
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      signal: this.controller.signal
    }).then((a) => a.blob()).then((a) => {
      const l = window.URL.createObjectURL(a);
      t ? Ei.saveAs(
        a,
        o || decodeURIComponent(e.split("/").pop())
      ) : this.setSrc(l), this.setState({ asyncStatus: "succeeded" });
    }).catch((a) => {
      a && a.name === "AbortError" || (console.error("[MediaPlayer] fetchFile", a), this.setState({ asyncStatus: "failed" }));
    });
  }
  updateProgress() {
    const { current: t } = this.videoRef;
    t && this.setState({
      time: t.currentTime,
      duration: t.duration
    });
  }
  updateBuffer() {
    const { current: t } = this.videoRef, { time: e, duration: n } = this.state;
    if (t) {
      let o = null;
      const r = t.buffered;
      for (let a = 0; a < r.length; a += 1) {
        const l = r.start(a), c = r.end(a);
        l <= e && e <= c && (o = [l / n, c / n]);
      }
      this.setState({
        buffer: o
      });
    }
  }
  handleWaiting() {
    this.setState({
      isWaiting: !0
    });
  }
  handlePlaying() {
    this.setState({
      isWaiting: !1
    });
  }
  handleTogglePlayClick() {
    const { playing: t, actuallyPlaying: e } = this.state, { current: n } = this.videoRef;
    n && (t && e ? (n.pause(), this.setState({
      isWaiting: !1,
      playing: !1,
      actuallyPlaying: !1
    })) : t || (this.setState({
      isWaiting: !0,
      playing: !0,
      actuallyPlaying: !1
    }), n.play().then(() => {
      this.setState({ actuallyPlaying: !0 });
    })));
  }
  startHideControlCountdown() {
    this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.setState({
      hideControls: !1
    }), this.hideControlsTimeout = setTimeout(() => {
      this.setState({
        hideControls: !0
      });
    }, 2e3);
  }
  handleFullscreenChange() {
    const { current: t } = this.playerRef, e = eI(t);
    this.setState({
      isFullScreen: e
    }), e ? (this.startHideControlCountdown(), window.addEventListener("mousemove", this.startHideControlCountdown)) : (this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), window.removeEventListener("mousemove", this.startHideControlCountdown));
  }
  handleFullscreenToggle() {
    const { current: t } = this.playerRef, { isFullScreen: e } = this.state;
    t && (e ? JS() : tI(t));
  }
  handleEnded() {
    this.setState({
      playing: !1
    });
  }
  handleError() {
    this.props.onError && this.props.onError();
  }
  seek(t) {
    const { current: e } = this.videoRef, { duration: n } = this.state;
    e && t && !Number.isNaN(t) && (e.currentTime = n * t);
  }
  handleVolume = (t) => {
    const { current: e } = this.videoRef;
    !e || typeof t > "u" || !Number.isFinite(t) || this.setState({ volume: t }, () => {
      this.setPlayerVolume(t);
    });
  };
  handleMute() {
    const { current: t } = this.videoRef;
    if (!t)
      return;
    const { volume: e, prevVolume: n } = this.state, o = e === 0, r = o ? n : 0;
    this.setState(
      {
        volume: r,
        prevVolume: o ? n : e
      },
      () => {
        this.setPlayerVolume(r);
      }
    );
  }
  setPlayerVolume(t) {
    const { current: e } = this.videoRef;
    e && (e.volume = t / 100);
  }
  render() {
    const {
      className: t,
      mediaFile: { type: e },
      headers: n,
      isPrivateFile: o,
      width: r,
      controls: a,
      noControlsStyle: l,
      ...c
    } = this.props, {
      src: d,
      playing: h,
      duration: u,
      time: p,
      volume: m,
      hideControls: g,
      isFullScreen: b,
      isWaiting: x,
      buffer: y,
      asyncStatus: _
    } = this.state, C = a?.play ?? !0, w = a?.download ?? !0, v = a?.progress ?? !0, S = a?.volume ?? !0, I = a?.maximize ?? !0, T = C || w || v || S || I, R = typeof e == "string" && e.startsWith("audio"), E = !d || _ === "loading", k = b ? "primary" : "secondary", P = f(
      J.root,
      {
        [J.rootFullScreen]: b,
        [J.rootHideControls]: g,
        [J.rootWaiting]: h && x,
        [J.rootAudio]: R
      },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...c,
        className: P,
        ref: this.playerRef,
        style: { width: r },
        children: [
          /* @__PURE__ */ s.jsx("div", { className: J.videoWrapper, children: !!d && /* @__PURE__ */ s.jsx(
            "video",
            {
              className: J.video,
              ref: this.videoRef,
              onDurationChange: this.updateProgress,
              onTimeUpdate: this.updateProgress,
              onWaiting: this.handleWaiting,
              onPlaying: this.handlePlaying,
              onProgress: this.updateBuffer,
              onEnded: this.handleEnded,
              onError: this.handleError,
              children: /* @__PURE__ */ s.jsx("source", { src: d })
            }
          ) }),
          T && /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: f(J.controls, {
                [J.unstyled]: l
              }),
              children: [
                C && /* @__PURE__ */ s.jsx(
                  K,
                  {
                    onClick: this.handleTogglePlayClick,
                    className: J.control,
                    disabled: E,
                    icon: h ? "pause" : "play",
                    variant: k
                  }
                ),
                w && (o ? /* @__PURE__ */ s.jsx(
                  X,
                  {
                    variant: k,
                    className: J.control,
                    disabled: E,
                    children: /* @__PURE__ */ s.jsx(
                      "a",
                      {
                        href: d,
                        download: !0,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: J.downloadLink,
                        children: /* @__PURE__ */ s.jsx(N, { name: "download" })
                      }
                    )
                  }
                ) : /* @__PURE__ */ s.jsx(
                  K,
                  {
                    icon: "download",
                    variant: k,
                    className: J.control,
                    disabled: E,
                    onClick: () => this.fetchFile(!0)
                  }
                )),
                v && /* @__PURE__ */ s.jsxs("div", { className: J.progress, children: [
                  /* @__PURE__ */ s.jsx(
                    $s,
                    {
                      hideAnnotations: !0,
                      className: J.progressSlider,
                      min: 0,
                      max: u,
                      value: p,
                      onChange: (H) => !Array.isArray(H) && this.seek(H / u),
                      dark: b,
                      highlightRange: y?.map((H) => H * u)
                    }
                  ),
                  /* @__PURE__ */ s.jsx("span", { className: J.timestamp, children: CI(u) })
                ] }),
                S && /* @__PURE__ */ s.jsxs("div", { className: J.volume, children: [
                  /* @__PURE__ */ s.jsx(
                    N,
                    {
                      className: J.volumeMuteControl,
                      name: m === 0 ? "volume-off" : "volume-up",
                      onClick: this.handleMute
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    $s,
                    {
                      hideAnnotations: !0,
                      className: J.volumeSlider,
                      value: m,
                      onChange: (H) => !Array.isArray(H) && this.handleVolume(H),
                      dark: b
                    }
                  )
                ] }),
                I && !R && /* @__PURE__ */ s.jsx(
                  K,
                  {
                    variant: k,
                    onClick: this.handleFullscreenToggle,
                    className: J.control,
                    icon: "expand"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
}
const wI = "h-modalBody--modalBody__root", vI = {
  root: wI
};
class iT extends D {
  render() {
    const { className: t, children: e, ...n } = this.props, o = f(
      {
        [vI.root]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: e });
  }
}
const SI = "h-modalFoot--modalFoot__root", II = "h-modalFoot--modalFoot__confirm", DI = "h-modalFoot--modalFoot__confirmSecondary", kI = "h-modalFoot--modalFoot__cancel", Tn = {
  root: SI,
  confirm: II,
  confirmSecondary: DI,
  cancel: kI
};
class TI extends D {
  static defaultProps;
  render() {
    const {
      className: t,
      confirmOnClick: e,
      confirmSecondaryOnClick: n,
      cancelOnClick: o,
      confirmName: r,
      confirmSecondaryName: a,
      cancelName: l,
      confirmProps: c,
      confirmSecondaryProps: d,
      cancelProps: h,
      children: u,
      ...p
    } = this.props, m = f(
      {
        [Tn.root]: !0
      },
      t
    ), g = f(
      {
        [Tn.cancel]: !0
      },
      h?.className
    ), b = f(
      {
        [Tn.confirm]: !0
      },
      c?.className
    ), x = f(
      {
        [Tn.confirmSecondary]: !0
      },
      d?.className
    );
    return /* @__PURE__ */ s.jsxs("div", { ...p, className: m, children: [
      u,
      n && /* @__PURE__ */ s.jsx(
        X,
        {
          variant: "secondary",
          ...d,
          className: x,
          onClick: n,
          children: a
        }
      ),
      o && /* @__PURE__ */ s.jsx(
        X,
        {
          variant: "tertiary",
          ...h,
          className: g,
          onClick: o,
          children: l
        }
      ),
      e && /* @__PURE__ */ s.jsx(
        X,
        {
          variant: "primary",
          ...c,
          className: b,
          onClick: e,
          children: r
        }
      )
    ] });
  }
}
TI.defaultProps = {
  confirmName: "Save",
  cancelName: "Cancel",
  // eslint-disable-next-line react/default-props-match-prop-types
  confirmProps: {},
  // eslint-disable-next-line react/default-props-match-prop-types
  cancelProps: {}
};
const jI = "h-modalHead--modalHead__root", NI = "h-modalHead--modalHead__top", FI = "h-modalHead--modalHead__title", PI = "h-modalHead--modalHead__buttons", RI = "h-modalHead--modalHead__caption", Ye = {
  root: jI,
  top: NI,
  title: FI,
  buttons: PI,
  caption: RI
}, aT = ({
  className: i,
  title: t,
  children: e,
  onClose: n,
  secondaryButton: o,
  buttonsClassName: r,
  ...a
}) => {
  const l = f(
    {
      [Ye.root]: !0
    },
    i
  );
  return /* @__PURE__ */ s.jsxs("div", { ...a, className: l, children: [
    /* @__PURE__ */ s.jsxs("div", { className: Ye.top, children: [
      /* @__PURE__ */ s.jsx(A.Heading, { className: Ye.title, children: t }),
      /* @__PURE__ */ s.jsxs("div", { className: f(Ye.buttons, r), children: [
        typeof o?.onClick == "function" && /* @__PURE__ */ s.jsx(st, { content: o?.tooltipContent, children: /* @__PURE__ */ s.jsx(
          K,
          {
            icon: o?.icon,
            variant: "tertiary",
            onClick: o?.onClick
          }
        ) }),
        typeof n == "function" && /* @__PURE__ */ s.jsx(
          K,
          {
            icon: "close",
            iconSize: 24,
            variant: "tertiary",
            onClick: n
          }
        )
      ] })
    ] }),
    !!e && /* @__PURE__ */ s.jsx(
      A.Paragraph,
      {
        variant: "2",
        color: "secondary",
        className: Ye.caption,
        children: e
      }
    )
  ] });
}, EI = "h-page-body--pageBody__root", LI = {
  root: EI
}, AI = $(function({ children: t, className: e, ...n }, o) {
  return /* @__PURE__ */ s.jsx(
    mt.Row,
    {
      ...n,
      ref: o,
      className: f(LI.root, e),
      scrollable: !0,
      noMinHeight: !0,
      noHorizontalPadding: !0,
      noVerticalPadding: !0,
      children: t
    }
  );
}), $I = "h-page-head--pageHead__root", OI = {
  root: $I
}, BI = $(function({ className: t, title: e, controls: n, ...o }, r) {
  return /* @__PURE__ */ s.jsxs(
    mt.Row,
    {
      ...o,
      ref: r,
      as: "header",
      className: f(OI.root, t),
      slottable: !0,
      borderBottom: !0,
      children: [
        /* @__PURE__ */ s.jsx(mt.Slot, { placement: "start", children: /* @__PURE__ */ s.jsx(A.Heading, { variant: "heading-2", as: "h1", children: e }) }),
        n && /* @__PURE__ */ s.jsx(mt.Slot, { placement: "end", children: /* @__PURE__ */ s.jsx(B, { alignItems: "center", gap: "200", children: n }) })
      ]
    }
  );
}), HI = "h-page-section--pageSection__root", WI = "h-page-section--pageSection__head", MI = "h-page-section--pageSection__callout", zI = "h-page-section--pageSection__content", jn = {
  root: HI,
  head: WI,
  callout: MI,
  content: zI
}, VI = $(function({
  children: t,
  className: e,
  title: n,
  titleMeta: o,
  controls: r,
  callout: a,
  ...l
}, c) {
  const d = !!(n || o || r);
  return /* @__PURE__ */ s.jsxs(
    mt.Row,
    {
      ...l,
      ref: c,
      as: "section",
      className: f(jn.root, e),
      noMinHeight: !0,
      children: [
        d && /* @__PURE__ */ s.jsxs(
          mt.Row,
          {
            className: jn.head,
            slottable: !0,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: [
              (n || o) && /* @__PURE__ */ s.jsx(mt.Slot, { placement: "start", noVerticalPadding: !0, children: /* @__PURE__ */ s.jsxs(B, { alignItems: "center", gap: "200", children: [
                n && /* @__PURE__ */ s.jsx(A.Heading, { variant: "heading-3", as: "h2", children: n }),
                o && /* @__PURE__ */ s.jsx(B, { alignItems: "center", gap: "200", children: o })
              ] }) }),
              r && /* @__PURE__ */ s.jsx(mt.Slot, { placement: "end", noVerticalPadding: !0, children: /* @__PURE__ */ s.jsx(B, { alignItems: "center", gap: "200", children: r }) })
            ]
          }
        ),
        a && /* @__PURE__ */ s.jsx(
          mt.Row,
          {
            className: jn.callout,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: a
          }
        ),
        /* @__PURE__ */ s.jsx(
          mt.Row,
          {
            className: jn.content,
            size: 1,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: t
          }
        )
      ]
    }
  );
}), KI = $(function({ children: t, className: e, ...n }, o) {
  return /* @__PURE__ */ s.jsx(
    mt.Row,
    {
      ...n,
      ref: o,
      className: e,
      borderBottom: !0,
      noVerticalPadding: !0,
      noMinHeight: !0,
      children: t
    }
  );
}), lr = ({ children: i, className: t, ...e }, n) => /* @__PURE__ */ s.jsx(ad, { ...e, ref: n, as: "article", className: t, children: /* @__PURE__ */ s.jsx(mt, { children: i }) }), lT = Object.assign($(lr), {
  name: lr.name,
  Head: BI,
  Body: AI,
  Section: VI,
  Tabs: KI
}), UI = "h-radio--radio__radio", qI = "h-radio--radio__radioDisabled", GI = "h-radio--radio__radioChecked", YI = "h-radio--radio__input", Nn = {
  radio: UI,
  radioDisabled: qI,
  radioChecked: GI,
  input: YI
}, cT = $(function(t, e) {
  const { id: n, checked: o, disabled: r, className: a, labelProps: l, ...c } = t, d = f(
    Nn.radio,
    { [Nn.radioChecked]: o },
    { [Nn.radioDisabled]: r },
    a
  ), h = n || `radio_${Math.random()}`;
  return /* @__PURE__ */ s.jsx(
    "label",
    {
      ...l,
      className: d,
      htmlFor: h,
      "data-testid": "radio",
      children: /* @__PURE__ */ s.jsx(
        "input",
        {
          ...c,
          ref: e,
          id: h,
          onChange: c.onChange || L,
          checked: o,
          disabled: r,
          type: "radio",
          className: Nn.input,
          "data-testid": "input"
        }
      )
    }
  );
}), XI = "h-reverseScroll--reverseScroll__root", QI = "h-reverseScroll--reverseScroll__column", ZI = "h-reverseScroll--reverseScroll__row", JI = "h-reverseScroll--reverseScroll__scrollHandle", Xe = {
  root: XI,
  column: QI,
  row: ZI,
  scrollHandle: JI
}, tD = "reverse-scroll", dT = $(function({
  children: t,
  className: e,
  direction: n = "column",
  ...o
}, r) {
  const a = G(null), l = G(null), c = G(null), d = Jn(t), h = U(
    () => d.reverse(),
    [d]
  ), u = (b) => c.current?.scrollIntoView(b), p = (b) => l.current?.scrollIntoView(b), m = (b) => a.current?.children[1]?.scrollIntoView(b), g = (b) => a.current?.children[a.current.children.length - 2]?.scrollIntoView(b);
  return je(r, () => ({
    rootElem: a.current,
    scrollToEnd: u,
    scrollToStart: p,
    scrollToFirstChild: g,
    scrollToLastChild: m
  })), /* @__PURE__ */ s.jsxs(
    "div",
    {
      ...o,
      "data-testid": tD,
      ref: a,
      className: f(e, Xe.root, {
        [Xe.row]: n === "row",
        [Xe.column]: n === "column"
      }),
      children: [
        /* @__PURE__ */ s.jsx("div", { ref: c, className: Xe.scrollHandle }),
        h,
        /* @__PURE__ */ s.jsx("div", { ref: l, className: Xe.scrollHandle })
      ]
    }
  );
}), eD = "h-removableCard--removableCard__root", nD = "h-removableCard--removableCard__close", sD = "h-removableCard--removableCard__title", oD = "h-removableCard--removableCard__titleIcon", Qe = {
  root: eD,
  close: nD,
  title: sD,
  titleIcon: oD
};
class hT extends D {
  render() {
    const { icon: t, title: e, children: n, onRemove: o, className: r, ...a } = this.props, l = f(
      {
        [Qe.root]: Qe.root
      },
      r
    );
    return /* @__PURE__ */ s.jsxs(
      at,
      {
        padding: "300",
        background: "neutral.100",
        borderRadius: !0,
        ...a,
        className: l,
        children: [
          /* @__PURE__ */ s.jsx(
            at,
            {
              as: "button",
              "aria-label": "Remove",
              className: Qe.close,
              onClick: o,
              children: /* @__PURE__ */ s.jsx(N, { name: "close" })
            }
          ),
          /* @__PURE__ */ s.jsxs(
            B,
            {
              alignItems: "flex-start",
              justifyContent: "flex-start",
              className: Qe.title,
              children: [
                t && /* @__PURE__ */ s.jsx(N, { name: t, className: Qe.titleIcon }),
                e
              ]
            }
          ),
          /* @__PURE__ */ s.jsx(at, { margin: "300 0 0 0" }),
          n
        ]
      }
    );
  }
}
const cr = ({
  colorMode: i = "light"
}) => `<script>
  (function() {
    let lastHeight = null;

    function measureHeight() {
      const currentHeight = document.body.offsetHeight;
      if (currentHeight === lastHeight) return;
      lastHeight = currentHeight;
      window.parent.postMessage(
        {
          event: 'heightChange',
          value: currentHeight,
        },
        '*',
      );
    };

    function setColorMode() {
      const rootElement = document.documentElement;
      if (rootElement) {
        rootElement.setAttribute('data-color-mode', '${i}');
      }

      const style = document.createElement('style');
      style.innerHTML = 'html {color-scheme: ${i};}';
      document.head.appendChild(style);
    }

    document.body.style.padding = '0px';
    document.body.style.margin = '0px';
    document.body.style.display = 'inline-block';
    document.body.style.width = '100%';
    document.addEventListener('click', measureHeight);

    document.querySelectorAll('a').forEach(link => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });

    document.addEventListener('load', measureHeight, true);
    document.addEventListener('transitionend', measureHeight, true);

    new ResizeObserver(measureHeight).observe(document.body);

    measureHeight();
    setColorMode();
  })();
<\/script>`, rD = "h-sandboxIframe--sandboxIframe__frame", iD = {
  frame: rD
};
class ti extends D {
  frameRef;
  static defaultProps;
  constructor(t) {
    super(t), this.state = {
      iframeHeight: 0
    }, this.frameRef = O(), this.handlePostMessage = this.handlePostMessage.bind(this);
  }
  componentDidMount() {
    this.buildSandbox(), window.addEventListener("message", this.handlePostMessage);
  }
  componentDidUpdate(t) {
    const { content: e, headContent: n, colorMode: o } = this.props;
    (t.content !== e || t.headContent !== n || t.colorMode !== o) && this.buildSandbox();
  }
  componentWillUnmount() {
    window.removeEventListener("message", this.handlePostMessage);
  }
  static defaultSandboxParams = "allow-scripts allow-popups allow-forms";
  buildSandbox() {
    const { content: t, headContent: e = "", colorMode: n = "light" } = this.props, { current: o } = this.frameRef;
    if (o) {
      let r = "";
      t.indexOf("</body>") !== -1 ? r = t.replace(
        "</body>",
        `${cr({ colorMode: n })}</body>`
      ) : r = `<html><head><meta charset="utf-8" /><base target="_parent" />${e}</head><body>${t}${cr(
        { colorMode: n }
      )}</body></html>`, o.src = `data:text/html;base64,${window.btoa(
        unescape(encodeURIComponent(r))
      )}`;
    }
  }
  handlePostMessage(t) {
    const { current: e } = this.frameRef;
    if (e && t.source === e.contentWindow) {
      const { data: n } = t;
      typeof n == "object" && n !== null && n.event === "heightChange" && typeof n.value == "number" && this.setState({
        iframeHeight: n.value
      });
    }
  }
  render() {
    const {
      className: t,
      content: e,
      headContent: n,
      sandbox: o,
      colorMode: r,
      ...a
    } = this.props, { iframeHeight: l } = this.state, c = f({}, t);
    return /* @__PURE__ */ s.jsx("div", { ...a, className: c, children: /* @__PURE__ */ s.jsx(
      "iframe",
      {
        title: "message",
        sandbox: o ?? ti.defaultSandboxParams,
        allowFullScreen: !0,
        scrolling: "no",
        frameBorder: "no",
        style: { height: `${l}px` },
        className: iD.frame,
        ref: this.frameRef
      }
    ) });
  }
}
const aD = "h-scrollbar--scrollbar__track", lD = "h-scrollbar--scrollbar__handle", dr = {
  track: aD,
  handle: lD
};
class uT extends D {
  constructor(t) {
    super(t), this.state = {
      size: 0,
      progress: 0,
      offset: 0
    }, this.handleTrackClick = this.handleTrackClick.bind(this), this.handleHandleClick = this.handleHandleClick.bind(this), this.handleDrag = this.handleDrag.bind(this), this.handleDrop = this.handleDrop.bind(this);
  }
  componentDidMount() {
    const { container: t } = this.props;
    t.current && t.current.addEventListener("scroll", this.updateSize), window.addEventListener("resize", this.updateSize), this.updateSize();
  }
  componentWillUnmount() {
    const { container: t } = this.props;
    t.current && t.current.removeEventListener("scroll", this.updateSize), window.removeEventListener("resize", this.updateSize);
  }
  updateSize = () => {
    const { container: t } = this.props;
    if (t.current) {
      const { current: e } = t;
      this.setState({
        size: e.offsetHeight / e.scrollHeight,
        progress: e.scrollTop / e.scrollHeight
      });
    }
  };
  handleTrackClick(t) {
    const { container: e } = this.props, { size: n } = this.state;
    if (this.setState({
      offset: n / 2
    }), e.current) {
      const o = e.current.getBoundingClientRect();
      let r = (t.clientY - o.top) / e.current.offsetHeight - n / 2;
      r < 0 && (r = 0), r + n > 1 && (r = 1 - n), e.current.scrollTop = r * e.current.scrollHeight, window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
    }
  }
  handleHandleClick(t) {
    const { size: e } = this.state;
    if (t.stopPropagation(), !(t.target instanceof Element)) return;
    const n = t.target.getBoundingClientRect();
    this.setState({
      offset: (t.clientY - n.top) / n.height * e
    }), window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
  }
  handleDrag(t) {
    t.preventDefault();
    const { container: e } = this.props, { size: n, offset: o } = this.state;
    if (e.current) {
      const r = e.current.getBoundingClientRect();
      let a = (t.clientY - r.top) / e.current.offsetHeight - o;
      a < 0 && (a = 0), a + n > 1 && (a = 1 - n), e.current.scrollTop = a * e.current.scrollHeight;
    }
  }
  handleDrop() {
    window.removeEventListener("mousemove", this.handleDrag), window.removeEventListener("mouseup", this.handleDrop);
  }
  render() {
    const { className: t, thumbClassName: e, trackClassName: n, ...o } = this.props, { size: r, progress: a } = this.state, l = f(t);
    return /* @__PURE__ */ s.jsx("div", { ...o, className: l, children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: f(dr.track, n),
        onMouseDown: this.handleTrackClick,
        children: /* @__PURE__ */ s.jsx(
          "div",
          {
            className: f(dr.handle, e),
            onMouseDown: this.handleHandleClick,
            style: {
              height: `${r * 100}%`,
              top: `${a * 100}%`
            }
          }
        )
      }
    ) });
  }
}
const cD = "h-scrollShadow--scrollShadow__wrapper", dD = "h-scrollShadow--scrollShadow__content", hr = {
  wrapper: cD,
  content: dD
}, pT = ({
  className: i,
  children: t,
  ...e
}) => {
  const n = f(hr.wrapper, i);
  return /* @__PURE__ */ s.jsx("div", { className: n, ...e, children: /* @__PURE__ */ s.jsx("div", { className: hr.content, children: t }) });
}, hD = "h-searchInput--searchInput__root", uD = "h-searchInput--searchInput__input", pD = "h-searchInput--searchInput__inputButton", Fn = {
  root: hD,
  input: uD,
  inputButton: pD
}, mD = 275, ur = 300, mT = ({
  className: i,
  initialSearch: t,
  maxWidth: e = mD,
  placeholder: n,
  onChange: o,
  onSubmit: r,
  onToggle: a,
  ...l
}) => {
  const c = G(null), [d, h] = V(!!t), [u, p] = V(!1), [m, g] = V(t ?? "");
  zi(
    () => {
      u && (h(!1), p(!1), g(""));
    },
    ur,
    [u]
  ), Xt(() => {
    a?.(d), d && requestAnimationFrame(() => c.current?.focus());
  }, [d]);
  const b = F(() => {
    h(!0);
  }, []), x = F(() => {
    p(!0);
  }, []), y = F(
    (v) => {
      v.preventDefault(), r(m);
    },
    [r, m]
  ), _ = F(
    (v) => {
      const {
        target: { value: S }
      } = v;
      g(S), o?.(S);
    },
    [o]
  ), C = F(
    ({ key: v }) => {
      v === "Enter" && b();
    },
    [b]
  ), w = F(
    ({ key: v }) => {
      (v === "Esc" || v === "Escape") && x();
    },
    [x]
  );
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: f(Fn.root, i),
      style: {
        "--max-width": `${d && !u ? e : 32}px`,
        "--transition-delay": `${ur}ms`
      },
      ...l,
      children: d ? /* @__PURE__ */ s.jsx("form", { onSubmit: y, children: /* @__PURE__ */ s.jsx(
        qt,
        {
          className: Fn.input,
          ref: c,
          onChange: _,
          placeholder: n ?? "Search...",
          type: "search",
          value: m,
          prefix: {
            type: "button",
            button: {
              icon: "search",
              onClick: y,
              className: Fn.inputButton
            }
          },
          suffix: {
            type: "button",
            button: {
              icon: "close",
              onClick: x,
              className: Fn.inputButton
            }
          },
          onKeyDown: w
        }
      ) }) : /* @__PURE__ */ s.jsx(
        K,
        {
          icon: "search",
          variant: "secondary",
          onClick: b,
          onKeyDown: C,
          "data-testid": "search-input-button"
        }
      )
    }
  );
}, gD = "h-selectOption--selectOption__root", fD = "h-selectOption--selectOption__checkbox", bD = "h-selectOption--selectOption__content", Ds = {
  root: gD,
  checkbox: fD,
  content: bD
}, gT = (i) => {
  const t = f(Ds.root);
  return /* @__PURE__ */ s.jsxs("label", { className: t, children: [
    /* @__PURE__ */ s.jsx(
      cn,
      {
        ...i,
        className: f(Ds.checkbox, i.className)
      }
    ),
    /* @__PURE__ */ s.jsx("div", { className: Ds.content, children: i.name })
  ] });
}, xD = "h-simpleProgressBar--simpleProgressBar__container", yD = "h-simpleProgressBar--simpleProgressBar__progressBar", _D = "h-simpleProgressBar--simpleProgressBar__progressBarFill", ks = {
  container: xD,
  progressBar: yD,
  progressBarFill: _D
}, CD = "simpleProgressBarId";
function fT({
  progress: i,
  base: t = 100,
  progressColor: e = "purple.500",
  backgroundColor: n = "neutral.200",
  tooltipContent: o,
  tooltipProps: r,
  ...a
}) {
  const [l, c] = V(0), d = 4;
  Z(() => c(i), [i]);
  const h = t >= l ? l / t : 1, u = () => d / h, p = {
    backgroundColor: tn(n)
  }, m = {
    transform: `scaleX(${h})`,
    borderTopRightRadius: `${u()}px ${d}px`,
    borderBottomRightRadius: `${u()}px ${d}px`,
    backgroundColor: tn(e)
  };
  return /* @__PURE__ */ s.jsx(
    B,
    {
      "test-id": CD,
      "align-items": "center",
      "justify-content": "center",
      className: ks.container,
      ...a,
      children: /* @__PURE__ */ s.jsx(
        st,
        {
          disabled: !o,
          content: o,
          wrap: "none",
          ...r,
          children: /* @__PURE__ */ s.jsx("div", { className: ks.progressBar, style: p, children: /* @__PURE__ */ s.jsx(
            "div",
            {
              className: ks.progressBarFill,
              style: m
            }
          ) })
        }
      )
    }
  );
}
const wD = "h-tabsWithContent--tabsWithContent__container", vD = "h-tabsWithContent--tabsWithContent__containerTop", SD = "h-tabsWithContent--tabsWithContent__containerLeft", ID = "h-tabsWithContent--tabsWithContent__containerRight", DD = "h-tabsWithContent--tabsWithContent__containerBottom", kD = "h-tabsWithContent--tabsWithContent__childrenContainer", we = {
  container: wD,
  containerTop: vD,
  containerLeft: SD,
  containerRight: ID,
  containerBottom: DD,
  childrenContainer: kD
};
class Os extends _t {
  static defaultProps = {
    tabsPlacement: "top"
  };
  constructor(t) {
    super(t), this.state = { activeTab: t.initiallySelectedTabId }, this.handleTabChange = this.handleTabChange.bind(this);
  }
  handleTabChange(t) {
    this.ensureTabIsValid(t) && (this.setState({ activeTab: t }), this.props.onChange?.(t));
  }
  ensureTabIsValid(t) {
    return this.props.tabs.some((e) => e.id === t);
  }
  getActiveChildIndex() {
    return this.props.tabs.findIndex(({ id: t }) => t === this.state.activeTab);
  }
  render() {
    const {
      className: t,
      tabsClassName: e,
      tabClassName: n,
      tabSelectedClassName: o,
      childrenWrapperClassName: r,
      tabs: a,
      children: l,
      tabsPlacement: c
    } = this.props, { activeTab: d } = this.state, h = Rt.toArray(l);
    if (h.length !== a.length) {
      const g = `${Os.name}: Number of tabs don't match the number of children.`;
      console.warn(g);
    }
    const u = this.getActiveChildIndex();
    if (u === -1) {
      const g = `${Os.name}: The selected tab does not exist in tabs array!`;
      console.warn(g);
    }
    const p = f(t, we.container, {
      [we.containerTop]: c === "top",
      [we.containerLeft]: c === "left",
      [we.containerBottom]: c === "bottom",
      [we.containerRight]: c === "right"
    }), m = f(
      r,
      we.childrenContainer
    );
    return /* @__PURE__ */ s.jsxs("section", { className: p, children: [
      /* @__PURE__ */ s.jsx(
        db,
        {
          className: e,
          tabClassName: n,
          tabSelectedClassName: o,
          tabs: a,
          onChange: this.handleTabChange,
          selectedId: d,
          tabsPlacement: c
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: m, children: h[u] })
    ] });
  }
}
const TD = "h-tagsInput--tagsInput__root", jD = "h-tagsInput--tagsInput__wrapper", ND = "h-tagsInput--tagsInput__input", FD = "h-tagsInput--tagsInput__inputIsHidden", PD = "h-tagsInput--tagsInput__placeholder", RD = "h-tagsInput--tagsInput__placeholderText", ED = "h-tagsInput--tagsInput__iconBox", LD = "h-tagsInput--tagsInput__iconText", AD = "h-tagsInput--tagsInput__tag", $D = "h-tagsInput--tagsInput__tagIsActive", OD = "h-tagsInput--tagsInput__tagButton", BD = "h-tagsInput--tagsInput__divider", pt = {
  root: TD,
  wrapper: jD,
  input: ND,
  inputIsHidden: FD,
  placeholder: PD,
  placeholderText: RD,
  iconBox: ED,
  iconText: LD,
  tag: AD,
  tagIsActive: $D,
  tagButton: OD,
  divider: BD
};
function pr(i = [], t) {
  switch (t) {
    case "asc":
      return i.sort();
    case "desc":
      return i.sort().reverse();
    default:
      return i;
  }
}
const HD = 255, bT = ({
  className: i,
  disabled: t,
  limit: e,
  placeholder: n,
  selectedTags: o,
  sortDirection: r,
  onChange: a
}) => {
  const l = G(null), c = G(null), [d, h] = V(""), [u, p] = V(
    pr(o, r)
  ), [m, g] = V(""), [b, x] = V(!1);
  Cr(l, () => x(!1)), Xt(() => a(u), [u, a]), Xt(() => {
    c.current && b && c.current.focus();
  }, [c.current, b]);
  const y = (I) => {
    h(I.target.value ?? "");
  }, _ = (I) => {
    const T = u.indexOf(m);
    switch (I.key) {
      // Creates a new tag from the given input text.
      case "Enter":
        !m && d && p((R) => {
          const E = Array.from(/* @__PURE__ */ new Set([...R, d]));
          return h(""), pr(E, r);
        });
        break;
      // If there is no input text left, it will select the last tag.
      // If there is already a tag selected, it will remove that from the list.
      case "Backspace":
        !m && d.length === 0 && g(u[u.length - 1]), m && (C(m), g(""));
        break;
      // If there is a tag selected, it will select the previous one.
      case "ArrowLeft":
        m && T > 0 && g(u[T - 1]);
        break;
      // If there is a tag selected, it will select the next one.
      case "ArrowRight":
        m && T < u.length - 1 && g(u[T + 1]);
        break;
      default:
        m && g("");
    }
  }, C = (I) => {
    p((T) => {
      const R = [...T];
      return R.splice(R.indexOf(I), 1), R;
    });
  }, w = b ? u.length : e || u.length, v = w < u.length, S = u.slice(0, w);
  return /* @__PURE__ */ s.jsx(
    Et,
    {
      ref: l,
      className: f(pt.root, i),
      onClick: () => x(!0),
      disabled: t,
      children: /* @__PURE__ */ s.jsxs("div", { className: pt.wrapper, "data-testid": "tags-wrapper", children: [
        S.map((I, T, R) => {
          const E = !b && R.length > 1 && T === R.length - 1;
          return /* @__PURE__ */ s.jsxs(Qt, { children: [
            E && /* @__PURE__ */ s.jsx(
              A.Paragraph,
              {
                variant: "3",
                color: "secondary",
                className: pt.divider,
                children: "or"
              }
            ),
            /* @__PURE__ */ s.jsx(
              ke,
              {
                className: f(pt.tag, {
                  [pt.tagIsActive]: I === m
                }),
                onDelete: () => C(I),
                "data-testid": "tag",
                children: I
              },
              I
            )
          ] }, I);
        }),
        !b && v && /* @__PURE__ */ s.jsxs(
          ke,
          {
            className: f(pt.tag, pt.tagButton),
            "data-testid": "tag",
            children: [
              "+",
              u.length - w
            ]
          }
        ),
        !b && !u.length && !d && /* @__PURE__ */ s.jsx(B, { className: pt.placeholder, alignItems: "center", gap: "200", children: n ? /* @__PURE__ */ s.jsx(A.Paragraph, { className: pt.placeholderText, variant: "2", children: n }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsx(A.Paragraph, { className: pt.placeholderText, variant: "2", children: "Type words or phrases and add with" }),
          /* @__PURE__ */ s.jsxs("div", { className: pt.iconBox, children: [
            /* @__PURE__ */ s.jsx(N, { name: "enter", color: "neutral.500" }),
            /* @__PURE__ */ s.jsx(A.Paragraph, { className: pt.iconText, children: "enter" })
          ] })
        ] }) }),
        /* @__PURE__ */ s.jsx(
          "input",
          {
            className: f(pt.input, {
              [pt.inputIsHidden]: !b
            }),
            onChange: y,
            onKeyDown: _,
            maxLength: HD,
            ref: c,
            type: "text",
            value: d,
            "data-testid": "tag-input"
          }
        )
      ] })
    }
  );
}, WD = "h-textWithHighlight--textWithHighlight__highlight", MD = {
  highlight: WD
}, zD = ({
  text: i,
  highlight: t,
  className: e,
  highlightClassName: n,
  ignoreCase: o = !0
}) => {
  if (!t?.trim())
    return /* @__PURE__ */ s.jsx(s.Fragment, { children: i });
  const r = new RegExp(
    Ms(t.trim()),
    o ? "ig" : "g"
  ), a = i.match(r), l = i.split(r);
  return /* @__PURE__ */ s.jsx("span", { className: e, children: l.map((c, d) => /* @__PURE__ */ s.jsxs("span", { children: [
    c,
    a?.[d] && /* @__PURE__ */ s.jsx("em", { className: f(MD.highlight, n), children: a[d] })
  ] }, d)) });
}, VD = Kn(zD);
VD.name = "TextWithHighlight";
const KD = "h-timestamp--timestamp__timestamp", UD = {
  timestamp: KD
}, qD = 1e4;
class xT extends _t {
  interval;
  static defaultProps = {
    refreshRate: qD
  };
  constructor(t) {
    super(t);
    const { relative: e, counter: n, initialFormat: o } = t;
    let r = o ?? "absolute";
    e ? r = "ago" : n && (r = "counter"), this.state = {
      format: r,
      pristine: !0
    }, this.handleClick = this.handleClick.bind(this), this.interval = null;
  }
  componentDidMount() {
    const { format: t } = this.state;
    (t === "ago" || t === "counter") && this.startTicker();
  }
  componentDidUpdate(t) {
    const { relative: e, initialFormat: n } = this.props, { pristine: o } = this.state;
    e !== t.relative && o && this.setState({
      format: e ? "ago" : "absolute"
    }), n && n !== t.initialFormat && this.setState({ format: n });
  }
  componentWillUnmount() {
    this.stopTicker();
  }
  startTicker() {
    this.interval = setInterval(() => {
      this.forceUpdate();
    }, this.props.refreshRate ?? 0);
  }
  stopTicker() {
    this.interval && clearInterval(this.interval);
  }
  handleClick(t) {
    const { onClick: e } = this.props, { format: n } = this.state;
    let o = this.state.format;
    n === "ago" ? (o = "full", this.stopTicker()) : n === "full" ? o = "absolute" : n === "absolute" && (o = "ago", this.startTicker()), this.setState({
      pristine: !1,
      format: o
    }), e?.(o, t);
  }
  getTimeString() {
    let { time: t } = this.props;
    const { isSecondsDisplayed: e, customFormatters: n } = this.props, { format: o } = this.state;
    let r = "";
    if (typeof t == "number") {
      const l = /* @__PURE__ */ new Date();
      l.setTime(t * 1e3), t = l;
    }
    const a = j(t).utc().local();
    if (o === "counter") {
      const l = j(t).utc(), d = j().utc().diff(l) / 1e3, h = Math.floor(d / (60 * 60)), u = Math.floor(h / 24), p = h % 24, m = h * 60 * 60, g = Math.floor((d - m) / 60), b = g * 60, x = Math.floor(
        d - m - b
      );
      r = [
        p.toString().padStart(2, "0"),
        g.toString().padStart(2, "0"),
        x.toString().padStart(2, "0")
      ].join(":"), u > 0 && (r = `${u} ${u === 1 ? "DAY" : "DAYS"} ${r}`);
    } else if (o === "full") {
      const l = n?.full ?? (e ? "MMM Do YYYY, hh:mm:ss A" : "lll");
      r = a.format(l);
    } else if (o === "absolute")
      if (j().diff(j(t), "hours") > 12) {
        const l = n?.absolute ?? `D MMMM LT${e ? "S" : ""}`;
        r = a.format(l);
      } else {
        const l = n?.absolute ?? `LT${e ? "S" : ""}`;
        r = a.format(l);
      }
    else
      r = Zh(a);
    return r;
  }
  render() {
    const {
      className: t,
      relative: e,
      time: n,
      refreshRate: o,
      counter: r,
      customFormatters: a,
      isSecondsDisplayed: l,
      initialFormat: c,
      onClick: d,
      ...h
    } = this.props, u = f(
      {
        [UD.timestamp]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsx(
      "span",
      {
        ...h,
        ...Gn(this.handleClick),
        className: u,
        children: this.getTimeString()
      }
    );
  }
}
const GD = "h-token--token__root", YD = "h-token--token__select", XD = "h-token--token__label", QD = "h-token--token__rootReadonly", ZD = "h-token--token__rootPrimary", JD = "h-token--token__rootWithError", tk = "h-token--token__value", ek = "h-token--token__icon", $t = {
  root: GD,
  select: YD,
  label: XD,
  rootReadonly: QD,
  rootPrimary: ZD,
  rootWithError: JD,
  value: tk,
  icon: ek
};
class yT extends D {
  render() {
    const {
      onDelete: t,
      id: e,
      label: n,
      options: o,
      valueLabel: r,
      primary: a,
      input: l,
      meta: c,
      defaultOption: d,
      className: h,
      ...u
    } = this.props, p = f(
      {
        [$t.root]: !0,
        [$t.rootPrimary]: a,
        [$t.rootWithError]: c?.error,
        [$t.rootReadonly]: !o && !t
      },
      h
    );
    let m = r;
    if (!m && l && o && o.length) {
      const g = o.filter(({ value: b }) => l.value === b);
      g.length && (m = g[0].label);
    }
    return !m && d && (m = d), /* @__PURE__ */ s.jsxs("div", { ...u, className: p, children: [
      !!o && /* @__PURE__ */ s.jsxs("select", { ...l, className: $t.select, id: e, children: [
        !!d && /* @__PURE__ */ s.jsx("option", { disabled: !0, hidden: !0, value: "", children: d }),
        o.map((g) => /* @__PURE__ */ s.jsx("option", { value: g.value, children: g.label }, g.value?.toString()))
      ] }),
      /* @__PURE__ */ s.jsxs("label", { className: $t.label, htmlFor: e, children: [
        n,
        /* @__PURE__ */ s.jsx("span", { className: $t.value, children: m }),
        !!o && /* @__PURE__ */ s.jsx(N, { className: $t.icon, name: "angle-down" }),
        !!t && /* @__PURE__ */ s.jsx("span", { ...Gn(t), children: /* @__PURE__ */ s.jsx(N, { className: $t.icon, name: "close", onClick: t }) })
      ] })
    ] });
  }
}
const nk = "h-skeleton--skeleton__root", sk = "h-skeleton--skeleton__rootAnimationPulse", ok = "h-skeleton--skeleton__rootAnimationWave", Ts = {
  root: nk,
  rootAnimationPulse: sk,
  rootAnimationWave: ok
};
function mr({ className: i, animation: t = "pulse", ...e }, n) {
  const o = f(
    {
      [Ts.root]: !0,
      [Ts.rootAnimationPulse]: t === "pulse",
      [Ts.rootAnimationWave]: t === "wave"
    },
    i
  );
  return /* @__PURE__ */ s.jsx(at, { className: o, ...e, ref: n });
}
const _T = Object.assign($(mr), {
  name: mr.name
}), rk = "h-breadcrumbs--breadcrumbs__root", ik = "h-breadcrumbs--breadcrumbs__list", ak = "h-breadcrumbs--breadcrumbs__item", lk = "h-breadcrumbs--breadcrumbs__separator", Pn = {
  root: rk,
  list: ik,
  item: ak,
  separator: lk
}, CT = $(function({
  className: t,
  children: e,
  as: n,
  separator: o = /* @__PURE__ */ s.jsx(N, { name: "angle-right" }),
  "aria-label": r = "breadcrumb",
  ...a
}, l) {
  const c = n ?? "nav", d = Rt.toArray(e).filter(Boolean);
  return /* @__PURE__ */ s.jsx(
    c,
    {
      ...a,
      ref: l,
      className: f(Pn.root, t),
      "aria-label": r,
      children: /* @__PURE__ */ s.jsx("ol", { className: Pn.list, children: d.map((h, u) => {
        const p = u === d.length - 1, m = typeof h == "string" || typeof h == "number" ? /* @__PURE__ */ s.jsx("span", { children: h }) : h;
        return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsx(
            "li",
            {
              className: Pn.item,
              "aria-current": p ? "page" : void 0,
              children: m
            },
            u
          ),
          !p && /* @__PURE__ */ s.jsx(
            "li",
            {
              className: Pn.separator,
              "data-testid": "breadcrumbs-separator",
              "aria-hidden": "true",
              children: o
            }
          )
        ] });
      }) })
    }
  );
});
export {
  Xg as AddonTriggerContext,
  Qg as AddonTriggerEvents,
  yk as Attachment,
  wr as Avatar,
  Yu as AvatarSelectItem,
  _k as Badge,
  Ck as Banner,
  at as Box,
  CT as Breadcrumbs,
  X as Button,
  wk as ButtonGroup,
  po as ButtonList,
  Pk as CheckableAvatarSelectItem,
  Xs as CheckableBaseItem,
  jk as CheckableSelectItem,
  Fk as CheckableTagSelectItem,
  cn as Checkbox,
  gp as Chip,
  Sk as CollapseCard,
  Ik as Collapsible,
  Xn as ColorPicker,
  mt as Column,
  ad as Columns,
  Id as CopyToClipboard,
  Dk as CopyToClipboardButton,
  Qk as CountryFlag,
  kk as DataTable,
  Wm as DatePicker,
  Ze as DatePickerOld,
  Rm as DateRangePicker,
  op as DeselectItem,
  Lk as Dialer,
  qn as Divider,
  Jt as Dropdown,
  le as DropdownButton,
  dn as DropdownButtonContext,
  Ys as DropdownInfinite,
  Fo as DropdownItem,
  Js as DropdownSelect,
  Br as DropdownSelectContainer,
  Ak as DropdownSelectMultiple,
  Hi as EMOJIS,
  ST as EmojiPicker,
  hn as EmptySelectItem,
  Zd as EmptyState,
  zs as ErrorBoundary,
  IT as ErrorBoundaryContext,
  Xk as FieldAddonDropdown,
  Zn as FieldAlert,
  $k as FieldButton,
  Yk as FieldColorPicker,
  Ok as FieldDatePicker,
  Bk as FieldDateRangePicker,
  Gs as FieldLabel,
  Wk as FieldRichText,
  Mk as FieldSelect,
  zk as FieldSelectionList,
  Vk as FieldSlider,
  Kk as FieldSwitch,
  Rs as FieldText,
  Uk as FieldTextarea,
  qk as FieldTimePicker,
  Gk as FieldTimeRangePicker,
  z as FieldWrapper,
  B as FlexBox,
  vr as FocusScope,
  tT as FormField,
  Jk as FormGrid,
  qs as HelpIcon,
  eT as HelperField,
  N as Icon,
  K as IconButton,
  Vs as Image,
  yg as InputDatePicker,
  on as InputDateRangePicker,
  nT as InputDuration,
  io as InputRichText,
  $x as InputSelectionList,
  qt as InputText,
  Et as InputWrapper,
  sT as Lightbox,
  oT as List,
  oT as ListV2,
  rT as MediaPlayer,
  CS as Modal,
  iT as ModalBody,
  TI as ModalFoot,
  aT as ModalHead,
  xk as NavigationButton,
  lT as Page,
  Vd as Pagination,
  pS as Portal,
  Ar as Presets,
  cT as Radio,
  hT as RemovableCard,
  dT as ReverseScroll,
  ti as SandboxIframe,
  pT as ScrollShadow,
  uT as Scrollbar,
  mT as SearchInput,
  Kp as Select,
  $r as SelectItem,
  gT as SelectOption,
  yx as SelectionList,
  Td as SimplePagination,
  fT as SimpleProgressBar,
  _T as Skeleton,
  $s as Slider,
  Un as Spinner,
  ry as Switch,
  gt as Table,
  Qn as TableContext,
  db as Tabs,
  Os as TabsWithContent,
  ke as Tag,
  Ek as TagDeselectItem,
  Nk as TagSelectItem,
  Rk as TagSelectSuggestion,
  bT as TagsInput,
  A as Text,
  VD as TextWithHighlight,
  Xr as Textarea,
  sn as TimePicker,
  Sm as TimeRangePicker,
  xT as Timestamp,
  yT as Token,
  st as Tooltip,
  jT as addSvgIconsToDocument,
  Qa as badgeTestId,
  sd as colorPickerTestId,
  Zk as countryCodes,
  Tk as datepickerDisableWeekends,
  DT as defaultElementType,
  no as formatShortcut,
  Lg as formattingOptions,
  Re as getSelectionListContext,
  kT as iconMeta,
  Uo as inputRichTextCommands,
  Ax as inputSelectionListTestId,
  tD as reverseScrollTestId,
  an as withErrorBoundary
};
//# sourceMappingURL=index.js.map
